module.exports = {
  "1": {
    "place": "١٧١ كم شمال شرق صلالة، عمان",
    "latLng": [
      18.2273,
      55.1027
    ],
    "magnitude": 4.5,
    "depth": 18.227,
    "time": "2025-04-27 10:32:29 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ١٧١ كم شمال شرق صلالة، عمان على عمق 18.227 كم بتاريخ 2025-04-27 10:32:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pvdy"
  },
  "2": {
    "place": "٤٩ كم شمال شرق الجبيل، السعودية",
    "latLng": [
      27.3162,
      49.9956
    ],
    "magnitude": 4.3,
    "depth": 27.316,
    "time": "2025-04-22 16:50:04 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.3 درجة في ٤٩ كم شمال شرق الجبيل، السعودية على عمق 27.316 كم بتاريخ 2025-04-22 16:50:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pua1#dyfi"
  },
  "3": {
    "place": "٤٨ كم شمال شرق الجبيل، السعودية",
    "latLng": [
      27.3434,
      49.9494
    ],
    "magnitude": 4.4,
    "depth": 27.343,
    "time": "2025-04-03 23:39:36 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.4 درجة في ٤٨ كم شمال شرق الجبيل، السعودية على عمق 27.343 كم بتاريخ 2025-04-03 23:39:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000q3ua#dyfi"
  },
  "4": {
    "place": "٦ كم شمال شمال غرب تويجارلي، تركيا",
    "latLng": [
      36.2649,
      36.0502
    ],
    "magnitude": 4.1,
    "depth": 36.265,
    "time": "2025-04-03 21:23:48 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٦ كم شمال شمال غرب تويجارلي، تركيا على عمق 36.265 كم بتاريخ 2025-04-03 21:23:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000q3tk"
  },
  "5": {
    "place": "١٠٢ كم جنوب جنوب غرب أم باب، قطر",
    "latLng": [
      24.4093,
      50.3095
    ],
    "magnitude": 4.1,
    "depth": 24.409,
    "time": "2025-03-31 20:42:24 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ١٠٢ كم جنوب جنوب غرب أم باب، قطر على عمق 24.409 كم بتاريخ 2025-03-31 20:42:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pp4t#dyfi"
  },
  "6": {
    "place": "٩٩ كم جنوب جنوب غرب أم باب، قطر",
    "latLng": [
      24.4418,
      50.2974
    ],
    "magnitude": 4.0,
    "depth": 24.442,
    "time": "2025-03-19 22:42:28 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.0 درجة في ٩٩ كم جنوب جنوب غرب أم باب، قطر على عمق 24.442 كم بتاريخ 2025-03-19 22:42:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pzuw#dyfi"
  },
  "7": {
    "place": "٩٥ كم جنوب جنوب غرب أم باب، قطر",
    "latLng": [
      24.4455,
      50.3869
    ],
    "magnitude": 4.1,
    "depth": 24.446,
    "time": "2025-03-17 19:31:38 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ٩٥ كم جنوب جنوب غرب أم باب، قطر على عمق 24.446 كم بتاريخ 2025-03-17 19:31:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pzeb"
  },
  "8": {
    "place": "٤٨ كم جنوب جنوب غرب الجهراء، الكويت",
    "latLng": [
      28.9517,
      47.4227
    ],
    "magnitude": 4.3,
    "depth": 28.952,
    "time": "2025-03-15 07:21:50 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.3 درجة في ٤٨ كم جنوب جنوب غرب الجهراء، الكويت على عمق 28.952 كم بتاريخ 2025-03-15 07:21:50 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pz09#dyfi"
  },
  "9": {
    "place": "٤٤ كم شمال شرق الجبيل، السعودية",
    "latLng": [
      27.2463,
      49.9939
    ],
    "magnitude": 4.0,
    "depth": 27.246,
    "time": "2025-03-11 21:09:55 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.0 درجة في ٤٤ كم شمال شرق الجبيل، السعودية على عمق 27.246 كم بتاريخ 2025-03-11 21:09:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pld7"
  },
  "10": {
    "place": "٨٣ كم جنوب غرب أم باب، قطر",
    "latLng": [
      24.6002,
      50.3266
    ],
    "magnitude": 4.1,
    "depth": 24.6,
    "time": "2025-03-09 23:27:52 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ٨٣ كم جنوب غرب أم باب، قطر على عمق 24.6 كم بتاريخ 2025-03-09 23:27:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pxv7#dyfi"
  },
  "11": {
    "place": "١٧٣ كم شمال Qalansīyah، اليمن",
    "latLng": [
      14.2456,
      53.6968
    ],
    "magnitude": 4.4,
    "depth": 14.246,
    "time": "2025-03-03 17:04:12 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٧٣ كم شمال Qalansīyah، اليمن على عمق 14.246 كم بتاريخ 2025-03-03 17:04:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwpm"
  },
  "12": {
    "place": "٦٥ كم شرق جنوب شرق أديغرات، إثيوبيا",
    "latLng": [
      14.0116,
      40.0091
    ],
    "magnitude": 4.5,
    "depth": 14.012,
    "time": "2025-03-03 04:37:39 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٦٥ كم شرق جنوب شرق أديغرات، إثيوبيا على عمق 14.012 كم بتاريخ 2025-03-03 04:37:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwjr"
  },
  "13": {
    "place": "٣٩ كم شرق جنوب شرق أديغرات، إثيوبيا",
    "latLng": [
      14.1469,
      39.8074
    ],
    "magnitude": 4.1,
    "depth": 14.147,
    "time": "2025-03-02 20:38:47 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ٣٩ كم شرق جنوب شرق أديغرات، إثيوبيا على عمق 14.147 كم بتاريخ 2025-03-02 20:38:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwhp"
  },
  "14": {
    "place": "٥٥ كم شرق جنوب شرق أديغرات، إثيوبيا",
    "latLng": [
      14.0554,
      39.9193
    ],
    "magnitude": 4.3,
    "depth": 14.055,
    "time": "2025-03-02 15:11:20 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٥٥ كم شرق جنوب شرق أديغرات، إثيوبيا على عمق 14.055 كم بتاريخ 2025-03-02 15:11:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwge"
  },
  "15": {
    "place": "٥٢ كم شرق جنوب شرق أديغرات، إثيوبيا",
    "latLng": [
      14.1721,
      39.9337
    ],
    "magnitude": 5.2,
    "depth": 14.172,
    "time": "2025-03-02 08:14:58 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.2 درجة في ٥٢ كم شرق جنوب شرق أديغرات، إثيوبيا على عمق 14.172 كم بتاريخ 2025-03-02 08:14:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwew#dyfi"
  },
  "16": {
    "place": "٣٣ كم جنوب أديغرات، إثيوبيا",
    "latLng": [
      13.9776,
      39.505
    ],
    "magnitude": 4.1,
    "depth": 13.978,
    "time": "2025-03-02 04:00:57 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ٣٣ كم جنوب أديغرات، إثيوبيا على عمق 13.978 كم بتاريخ 2025-03-02 04:00:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000py5e"
  },
  "17": {
    "place": "٨٦ كم جنوب غرب Umluj، السعودية",
    "latLng": [
      24.4018,
      36.7522
    ],
    "magnitude": 4.1,
    "depth": 24.402,
    "time": "2025-02-23 21:16:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ٨٦ كم جنوب غرب Umluj، السعودية على عمق 24.402 كم بتاريخ 2025-02-23 21:16:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwtu"
  },
  "18": {
    "place": "٣٢ كم غرب شمال غرب مصوع، إريتريا",
    "latLng": [
      15.7042,
      39.1895
    ],
    "magnitude": 4.3,
    "depth": 15.704,
    "time": "2025-02-22 17:31:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٣٢ كم غرب شمال غرب مصوع، إريتريا على عمق 15.704 كم بتاريخ 2025-02-22 17:31:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pwmb"
  },
  "19": {
    "place": "٢٥٨ كم جنوب جنوب شرق هيما، عمان",
    "latLng": [
      17.9924,
      57.5954
    ],
    "magnitude": 4.3,
    "depth": 17.992,
    "time": "2025-02-10 21:06:44 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٥٨ كم جنوب جنوب شرق هيما، عمان على عمق 17.992 كم بتاريخ 2025-02-10 21:06:44 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pcri"
  },
  "20": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.6494,
      57.0364
    ],
    "magnitude": 4.2,
    "depth": 13.649,
    "time": "2025-02-08 15:17:44 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 13.649 كم بتاريخ 2025-02-08 15:17:44 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000pdsp"
  },
  "21": {
    "place": "١٢٤ كم جنوب Al Ghayz̧ah، اليمن",
    "latLng": [
      15.0829,
      52.1191
    ],
    "magnitude": 4.4,
    "depth": 15.083,
    "time": "2025-01-27 00:31:02 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٢٤ كم جنوب Al Ghayz̧ah، اليمن على عمق 15.083 كم بتاريخ 2025-01-27 00:31:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pmhk"
  },
  "22": {
    "place": "٧ كم شرق جنوب شرق As Sulaymānīyah، العراق",
    "latLng": [
      35.5311,
      45.5063
    ],
    "magnitude": 2.7,
    "depth": 35.531,
    "time": "2025-01-10 11:39:52 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 2.7 درجة في ٧ كم شرق جنوب شرق As Sulaymānīyah، العراق على عمق 35.531 كم بتاريخ 2025-01-10 11:39:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pjk2#dyfi"
  },
  "23": {
    "place": "١١ كم جنوب غرب بويوكشات، تركيا",
    "latLng": [
      36.0441,
      35.984
    ],
    "magnitude": 4.2,
    "depth": 36.044,
    "time": "2025-01-10 04:08:52 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١١ كم جنوب غرب بويوكشات، تركيا على عمق 36.044 كم بتاريخ 2025-01-10 04:08:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000pj44#dyfi"
  },
  "24": {
    "place": "٦٨ كم شرق شمال شرق مصوع، إريتريا",
    "latLng": [
      15.9105,
      40.0355
    ],
    "magnitude": 4.4,
    "depth": 15.911,
    "time": "2024-12-23 02:52:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٦٨ كم شرق شمال شرق مصوع، إريتريا على عمق 15.911 كم بتاريخ 2024-12-23 02:52:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000p0ty"
  },
  "25": {
    "place": "١٩٢ كم شمال Qalansīyah، اليمن",
    "latLng": [
      14.4284,
      53.4413
    ],
    "magnitude": 4.4,
    "depth": 14.428,
    "time": "2024-12-15 16:38:25 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٩٢ كم شمال Qalansīyah، اليمن على عمق 14.428 كم بتاريخ 2024-12-15 16:38:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ph7l"
  },
  "26": {
    "place": "١٨٨ كم جنوب شرق Al Ghayz̧ah، اليمن",
    "latLng": [
      14.923,
      53.3253
    ],
    "magnitude": 4.4,
    "depth": 14.923,
    "time": "2024-12-15 07:46:19 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٨٨ كم جنوب شرق Al Ghayz̧ah، اليمن على عمق 14.923 كم بتاريخ 2024-12-15 07:46:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ph7y"
  },
  "27": {
    "place": "٦ كم غرب شمال غرب Hawe Ben Alean، العراق",
    "latLng": [
      35.2913,
      43.3111
    ],
    "magnitude": 4.3,
    "depth": 35.291,
    "time": "2024-12-12 14:20:25 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٦ كم غرب شمال غرب Hawe Ben Alean، العراق على عمق 35.291 كم بتاريخ 2024-12-12 14:20:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ny5a#dyfi"
  },
  "28": {
    "place": "منطقة صدع أوين",
    "latLng": [
      17.5247,
      60.1904
    ],
    "magnitude": 4.5,
    "depth": 17.525,
    "time": "2024-12-05 07:49:50 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 17.525 كم بتاريخ 2024-12-05 07:49:50 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nw2j"
  },
  "29": {
    "place": "١٥٧ كم شمال كالولا، الصومال",
    "latLng": [
      13.3758,
      50.9899
    ],
    "magnitude": 4.3,
    "depth": 13.376,
    "time": "2024-11-23 09:28:38 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.3 درجة في ١٥٧ كم شمال كالولا، الصومال على عمق 13.376 كم بتاريخ 2024-11-23 09:28:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nwmw"
  },
  "30": {
    "place": "١٣٥ كم جنوب غرب Jeddah، السعودية",
    "latLng": [
      20.7567,
      38.1466
    ],
    "magnitude": 4.0,
    "depth": 20.757,
    "time": "2024-11-19 22:23:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.0 درجة في ١٣٥ كم جنوب غرب Jeddah، السعودية على عمق 20.757 كم بتاريخ 2024-11-19 22:23:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nvy5"
  },
  "31": {
    "place": "١٠٩ كم جنوب Al Ghayz̧ah، اليمن",
    "latLng": [
      15.2253,
      52.2791
    ],
    "magnitude": 4.2,
    "depth": 15.225,
    "time": "2024-11-17 22:17:27 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في ١٠٩ كم جنوب Al Ghayz̧ah، اليمن على عمق 15.225 كم بتاريخ 2024-11-17 22:17:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nvp8"
  },
  "32": {
    "place": "٥٣ كم شمال Al Hārithah، العراق",
    "latLng": [
      31.0634,
      47.846
    ],
    "magnitude": 4.0,
    "depth": 31.063,
    "time": "2024-11-14 21:08:22 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.0 درجة في ٥٣ كم شمال Al Hārithah، العراق على عمق 31.063 كم بتاريخ 2024-11-14 21:08:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nuyk"
  },
  "33": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.9147,
      57.0927
    ],
    "magnitude": 4.2,
    "depth": 13.915,
    "time": "2024-11-10 17:23:32 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 13.915 كم بتاريخ 2024-11-10 17:23:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nuhb"
  },
  "34": {
    "place": "٢٦ كم جنوب Dahab، مصر",
    "latLng": [
      28.2482,
      34.471
    ],
    "magnitude": 4.4,
    "depth": 28.248,
    "time": "2024-10-31 04:35:01 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.4 درجة في ٢٦ كم جنوب Dahab، Egypt على عمق 28.248 كم بتاريخ 2024-10-31 04:35:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000np55#dyfi"
  },
  "35": {
    "place": "١٨٨ كم جنوب شرق Al Ghayz̧ah، اليمن",
    "latLng": [
      14.8593,
      53.2533
    ],
    "magnitude": 4.6,
    "depth": 14.859,
    "time": "2024-10-24 05:21:39 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ١٨٨ كم جنوب شرق Al Ghayz̧ah، اليمن على عمق 14.859 كم بتاريخ 2024-10-24 05:21:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nmta"
  },
  "36": {
    "place": "٢٧٥ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.5232,
      55.6979
    ],
    "magnitude": 4.3,
    "depth": 14.523,
    "time": "2024-09-22 13:02:53 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٧٥ كم شمال شرق Hadibu، اليمن على عمق 14.523 كم بتاريخ 2024-09-22 13:02:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ngky"
  },
  "37": {
    "place": "٧٤ كم شرق Makadi Bay، مصر",
    "latLng": [
      26.9879,
      34.6452
    ],
    "magnitude": 4.2,
    "depth": 26.988,
    "time": "2024-09-19 10:55:11 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٧٤ كم شرق Makadi Bay، Egypt على عمق 26.988 كم بتاريخ 2024-09-19 10:55:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ntvq"
  },
  "38": {
    "place": "١٧٣ كم شمال Qalansīyah، اليمن",
    "latLng": [
      14.2482,
      53.3074
    ],
    "magnitude": 4.3,
    "depth": 14.248,
    "time": "2024-09-13 15:47:02 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ١٧٣ كم شمال Qalansīyah، اليمن على عمق 14.248 كم بتاريخ 2024-09-13 15:47:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000nytl"
  },
  "39": {
    "place": "٢٢٥ كم غرب جنوب غرب Bariq، السعودية",
    "latLng": [
      17.9311,
      40.0637
    ],
    "magnitude": 4.9,
    "depth": 17.931,
    "time": "2024-09-12 07:39:53 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.9 درجة في ٢٢٥ كم غرب جنوب غرب Bariq، السعودية على عمق 17.931 كم بتاريخ 2024-09-12 07:39:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nd8g"
  },
  "40": {
    "place": "٢٢٢ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.8004,
      40.1517
    ],
    "magnitude": 4.4,
    "depth": 17.8,
    "time": "2024-09-12 07:39:32 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٢٢٢ كم غرب Ad Darb، السعودية على عمق 17.8 كم بتاريخ 2024-09-12 07:39:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nd8h#dyfi"
  },
  "41": {
    "place": "٢٢٤ كم غرب جنوب غرب Bariq، السعودية",
    "latLng": [
      17.8945,
      40.1074
    ],
    "magnitude": 4.9,
    "depth": 17.895,
    "time": "2024-09-12 06:46:13 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.9 درجة في ٢٢٤ كم غرب جنوب غرب Bariq، السعودية على عمق 17.895 كم بتاريخ 2024-09-12 06:46:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nd8a"
  },
  "42": {
    "place": "٢٢٢ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.8189,
      40.1609
    ],
    "magnitude": 4.7,
    "depth": 17.819,
    "time": "2024-09-12 06:20:56 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٢٢٢ كم غرب Ad Darb، السعودية على عمق 17.819 كم بتاريخ 2024-09-12 06:20:56 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000nd83"
  },
  "43": {
    "place": "٣٠ كم شرق شمال شرق Al ‘Amārah، العراق",
    "latLng": [
      31.9629,
      47.433
    ],
    "magnitude": 4.0,
    "depth": 31.963,
    "time": "2024-09-09 00:03:46 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.0 درجة في ٣٠ كم شرق شمال شرق Al ‘Amārah، العراق على عمق 31.963 كم بتاريخ 2024-09-09 00:03:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000nqje"
  },
  "44": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2961,
      56.5599
    ],
    "magnitude": 4.1,
    "depth": 14.296,
    "time": "2024-09-05 23:11:20 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في منطقة صدع أوين على عمق 14.296 كم بتاريخ 2024-09-05 23:11:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000nxj0"
  },
  "45": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7317,
      55.8083
    ],
    "magnitude": 4.6,
    "depth": 14.732,
    "time": "2024-09-05 17:40:06 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.732 كم بتاريخ 2024-09-05 17:40:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000npwj"
  },
  "46": {
    "place": "٦ كم شرق Kırıkhan، تركيا",
    "latLng": [
      36.503,
      36.428
    ],
    "magnitude": 3.7,
    "depth": 36.503,
    "time": "2024-08-20 00:57:41 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.7 درجة في ٦ كم شرق Kırıkhan، تركيا على عمق 36.503 كم بتاريخ 2024-08-20 00:57:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000n81t#dyfi"
  },
  "47": {
    "place": "١١٨ كم شرق As Saffānīyah، السعودية",
    "latLng": [
      28.1209,
      49.923
    ],
    "magnitude": 4.1,
    "depth": 28.121,
    "time": "2024-08-17 21:13:13 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ١١٨ كم شرق As Saffānīyah، السعودية على عمق 28.121 كم بتاريخ 2024-08-17 21:13:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ncuw"
  },
  "48": {
    "place": "٢٣٤ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.6926,
      54.5942
    ],
    "magnitude": 4.5,
    "depth": 14.693,
    "time": "2024-08-16 22:46:05 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٣٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.693 كم بتاريخ 2024-08-16 22:46:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000nqq7"
  },
  "49": {
    "place": "٥ كم شمال شمال غرب As Salamīyah، سوريا",
    "latLng": [
      35.0598,
      37.0338
    ],
    "magnitude": 4.8,
    "depth": 35.06,
    "time": "2024-08-16 10:15:36 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.8 درجة في ٥ كم شمال شمال غرب As Salamīyah، سوريا على عمق 35.06 كم بتاريخ 2024-08-16 10:15:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000n7dh#dyfi"
  },
  "50": {
    "place": "١٤ كم شمال As Salamīyah، سوريا",
    "latLng": [
      35.1423,
      37.0649
    ],
    "magnitude": 4.5,
    "depth": 35.142,
    "time": "2024-08-13 00:28:38 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ١٤ كم شمال As Salamīyah، سوريا على عمق 35.142 كم بتاريخ 2024-08-13 00:28:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000njrg#dyfi"
  },
  "51": {
    "place": "١٢ كم شمال شمال غرب As Salamīyah، سوريا",
    "latLng": [
      35.1208,
      37.0152
    ],
    "magnitude": 5.2,
    "depth": 35.121,
    "time": "2024-08-12 20:55:59 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 5.2 درجة في ١٢ كم شمال شمال غرب As Salamīyah، سوريا على عمق 35.121 كم بتاريخ 2024-08-12 20:55:59 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000njq1#dyfi"
  },
  "52": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.8088,
      57.1015
    ],
    "magnitude": 4.3,
    "depth": 13.809,
    "time": "2024-08-03 14:14:05 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 13.809 كم بتاريخ 2024-08-03 14:14:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000n8n7"
  },
  "53": {
    "place": "٢٤ كم شرق جنوب شرق Kifrī، العراق",
    "latLng": [
      34.6254,
      45.2133
    ],
    "magnitude": 4.2,
    "depth": 34.625,
    "time": "2024-07-30 19:46:43 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٢٤ كم شرق جنوب شرق Kifrī، العراق على عمق 34.625 كم بتاريخ 2024-07-30 19:46:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000n77b"
  },
  "54": {
    "place": "٤ كم غرب شمال غرب سيرين يول، تركيا",
    "latLng": [
      36.372,
      36.1634
    ],
    "magnitude": 4.3,
    "depth": 36.372,
    "time": "2024-07-28 15:13:05 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٤ كم غرب شمال غرب Serinyol، تركيا على عمق 36.372 كم بتاريخ 2024-07-28 15:13:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ngic"
  },
  "55": {
    "place": "١٦١ كم شرق شمال شرق Tokār، Sudan",
    "latLng": [
      18.75,
      39.2241
    ],
    "magnitude": 4.2,
    "depth": 18.75,
    "time": "2024-07-28 02:40:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ١٦١ كم شرق شمال شرق Tokār، Sudan على عمق 18.75 كم بتاريخ 2024-07-28 02:40:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ngfq"
  },
  "56": {
    "place": "١٧٣ كم شرق شمال شرق Tokār، Sudan",
    "latLng": [
      19.0291,
      39.2486
    ],
    "magnitude": 4.3,
    "depth": 19.029,
    "time": "2024-07-27 00:47:27 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٧٣ كم شرق شمال شرق Tokār، Sudan على عمق 19.029 كم بتاريخ 2024-07-27 00:47:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ng9y"
  },
  "57": {
    "place": "١٧٠ كم شرق شمال شرق Tokār، Sudan",
    "latLng": [
      19.1285,
      39.1639
    ],
    "magnitude": 4.3,
    "depth": 19.129,
    "time": "2024-07-27 00:29:29 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٧٠ كم شرق شمال شرق Tokār، Sudan على عمق 19.129 كم بتاريخ 2024-07-27 00:29:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000njmc"
  },
  "58": {
    "place": "١٩٢ كم شرق شمال شرق Tokār، Sudan",
    "latLng": [
      19.222,
      39.3552
    ],
    "magnitude": 4.7,
    "depth": 19.222,
    "time": "2024-07-26 21:09:57 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ١٩٢ كم شرق شمال شرق Tokār، Sudan على عمق 19.222 كم بتاريخ 2024-07-26 21:09:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ng91"
  },
  "59": {
    "place": "٩ كم شمال شمال شرق Al Hārithah، العراق",
    "latLng": [
      30.6625,
      47.7912
    ],
    "magnitude": 4.0,
    "depth": 30.663,
    "time": "2024-07-25 04:27:01 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.0 درجة في ٩ كم شمال شمال شرق Al Hārithah، العراق على عمق 30.663 كم بتاريخ 2024-07-25 04:27:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000nivx"
  },
  "60": {
    "place": "١٢ كم شمال غرب Denizciler، تركيا",
    "latLng": [
      36.7289,
      36.134
    ],
    "magnitude": 4.1,
    "depth": 36.729,
    "time": "2024-07-14 07:03:48 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٢ كم شمال غرب Denizciler، تركيا على عمق 36.729 كم بتاريخ 2024-07-14 07:03:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000mz60"
  },
  "61": {
    "place": "٢٧٤ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.4708,
      55.7452
    ],
    "magnitude": 5.0,
    "depth": 14.471,
    "time": "2024-07-12 01:51:08 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.0 درجة في ٢٧٤ كم شمال شرق Hadibu، اليمن على عمق 14.471 كم بتاريخ 2024-07-12 01:51:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000myr5"
  },
  "62": {
    "place": "٢٠٩ كم شمال Kilmia، اليمن",
    "latLng": [
      14.0614,
      51.9559
    ],
    "magnitude": 4.6,
    "depth": 14.061,
    "time": "2024-07-01 17:11:01 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.6 درجة في ٢٠٩ كم شمال Kilmia، اليمن على عمق 14.061 كم بتاريخ 2024-07-01 17:11:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000n9m4#dyfi"
  },
  "63": {
    "place": "١٧٢ كم شمال Qalansīyah، اليمن",
    "latLng": [
      14.2411,
      53.6689
    ],
    "magnitude": 4.4,
    "depth": 14.241,
    "time": "2024-06-19 15:54:54 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٧٢ كم شمال Qalansīyah، اليمن على عمق 14.241 كم بتاريخ 2024-06-19 15:54:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000n8kw"
  },
  "64": {
    "place": "١٣٩ كم شرق شمال شرق Port Sudan، Sudan",
    "latLng": [
      20.0936,
      38.4458
    ],
    "magnitude": 4.3,
    "depth": 20.094,
    "time": "2024-06-07 09:11:26 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٣٩ كم شرق شمال شرق Port Sudan، Sudan على عمق 20.094 كم بتاريخ 2024-06-07 09:11:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000msch"
  },
  "65": {
    "place": "١٥ كم غرب جنوب غرب Uzunbağ، تركيا",
    "latLng": [
      36.105,
      35.8681
    ],
    "magnitude": 4.1,
    "depth": 36.105,
    "time": "2024-06-05 07:37:49 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٥ كم غرب جنوب غرب Uzunbağ، تركيا على عمق 36.105 كم بتاريخ 2024-06-05 07:37:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000mqff"
  },
  "66": {
    "place": "١٩٠ كم جنوب Al Ghayz̧ah، اليمن",
    "latLng": [
      14.5093,
      51.9157
    ],
    "magnitude": 4.5,
    "depth": 14.509,
    "time": "2024-06-01 21:59:41 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.5 درجة في ١٩٠ كم جنوب Al Ghayz̧ah، اليمن على عمق 14.509 كم بتاريخ 2024-06-01 21:59:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000mpil"
  },
  "67": {
    "place": "٣٦ كم جنوب جنوب شرق Mandalī، العراق",
    "latLng": [
      33.4375,
      45.6862
    ],
    "magnitude": 4.2,
    "depth": 33.438,
    "time": "2024-05-13 23:59:59 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٣٦ كم جنوب جنوب شرق Mandalī، العراق على عمق 33.438 كم بتاريخ 2024-05-13 23:59:59 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000myej"
  },
  "68": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.9208,
      57.055
    ],
    "magnitude": 4.6,
    "depth": 13.921,
    "time": "2024-05-01 21:21:20 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 13.921 كم بتاريخ 2024-05-01 21:21:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mvjm"
  },
  "69": {
    "place": "١٠٨ كم غرب جنوب غرب Farasān، السعودية",
    "latLng": [
      16.403,
      41.1463
    ],
    "magnitude": 4.2,
    "depth": 16.403,
    "time": "2024-04-29 06:20:48 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ١٠٨ كم غرب جنوب غرب Farasān، السعودية على عمق 16.403 كم بتاريخ 2024-04-29 06:20:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mwzc"
  },
  "70": {
    "place": "١٥٨ كم جنوب شرق صلالة، عمان",
    "latLng": [
      16.0722,
      55.2127
    ],
    "magnitude": 4.4,
    "depth": 16.072,
    "time": "2024-04-28 20:34:39 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٥٨ كم جنوب شرق صلالة، عمان على عمق 16.072 كم بتاريخ 2024-04-28 20:34:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000muqs"
  },
  "71": {
    "place": "٢٥ كم شرق شمال شرق مصوع، إريتريا",
    "latLng": [
      15.7251,
      39.6764
    ],
    "magnitude": 4.4,
    "depth": 15.725,
    "time": "2024-04-28 00:43:07 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٢٥ كم شرق شمال شرق مصوع، إريتريا على عمق 15.725 كم بتاريخ 2024-04-28 00:43:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mwqg"
  },
  "72": {
    "place": "٣٥ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      15.8351,
      39.7125
    ],
    "magnitude": 4.2,
    "depth": 15.835,
    "time": "2024-04-28 00:42:02 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٣٥ كم شمال شرق مصوع، إريتريا على عمق 15.835 كم بتاريخ 2024-04-28 00:42:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mwqt"
  },
  "73": {
    "place": "٣٠ كم شرق شمال شرق مصوع، إريتريا",
    "latLng": [
      15.753,
      39.7214
    ],
    "magnitude": 5.0,
    "depth": 15.753,
    "time": "2024-04-28 00:37:18 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.0 درجة في ٣٠ كم شرق شمال شرق مصوع، إريتريا على عمق 15.753 كم بتاريخ 2024-04-28 00:37:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000muif"
  },
  "74": {
    "place": "٢٦ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      15.8037,
      39.6219
    ],
    "magnitude": 4.7,
    "depth": 15.804,
    "time": "2024-04-27 20:44:40 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٢٦ كم شمال شرق مصوع، إريتريا على عمق 15.804 كم بتاريخ 2024-04-27 20:44:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mugq"
  },
  "75": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7407,
      55.9018
    ],
    "magnitude": 4.5,
    "depth": 14.741,
    "time": "2024-04-23 05:20:20 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.741 كم بتاريخ 2024-04-23 05:20:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mv8a"
  },
  "76": {
    "place": "٥٩ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      15.9496,
      39.9037
    ],
    "magnitude": 4.1,
    "depth": 15.95,
    "time": "2024-04-19 12:59:38 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ٥٩ كم شمال شرق مصوع، إريتريا على عمق 15.95 كم بتاريخ 2024-04-19 12:59:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mtzv"
  },
  "77": {
    "place": "٢٧ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      15.7601,
      39.6821
    ],
    "magnitude": 4.4,
    "depth": 15.76,
    "time": "2024-04-19 09:19:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٢٧ كم شمال شرق مصوع، إريتريا على عمق 15.76 كم بتاريخ 2024-04-19 09:19:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000md3v"
  },
  "78": {
    "place": "١٨١ كم غرب شمال غرب Farasān، السعودية",
    "latLng": [
      17.3593,
      40.5542
    ],
    "magnitude": 4.4,
    "depth": 17.359,
    "time": "2024-03-23 01:26:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ١٨١ كم غرب شمال غرب Farasān، السعودية على عمق 17.359 كم بتاريخ 2024-03-23 01:26:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mkms"
  },
  "79": {
    "place": "١٧٤ كم غرب شمال غرب Farasān، السعودية",
    "latLng": [
      17.2652,
      40.5913
    ],
    "magnitude": 4.6,
    "depth": 17.265,
    "time": "2024-03-22 23:57:26 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ١٧٤ كم غرب شمال غرب Farasān، السعودية على عمق 17.265 كم بتاريخ 2024-03-22 23:57:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mkmh"
  },
  "80": {
    "place": "١٨٢ كم غرب شمال غرب Farasān، السعودية",
    "latLng": [
      17.1911,
      40.4859
    ],
    "magnitude": 4.5,
    "depth": 17.191,
    "time": "2024-03-22 23:10:33 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٨٢ كم غرب شمال غرب Farasān، السعودية على عمق 17.191 كم بتاريخ 2024-03-22 23:10:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mkly"
  },
  "81": {
    "place": "٥٦ كم غرب شمال غرب Edd، إريتريا",
    "latLng": [
      14.0351,
      41.1815
    ],
    "magnitude": 4.5,
    "depth": 14.035,
    "time": "2024-03-16 07:09:30 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٥٦ كم غرب شمال غرب Edd، إريتريا على عمق 14.035 كم بتاريخ 2024-03-16 07:09:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mj8r"
  },
  "82": {
    "place": "٦٣ كم غرب شمال غرب Edd، إريتريا",
    "latLng": [
      14.0645,
      41.1232
    ],
    "magnitude": 4.6,
    "depth": 14.065,
    "time": "2024-03-14 09:50:33 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٦٣ كم غرب شمال غرب Edd، إريتريا على عمق 14.065 كم بتاريخ 2024-03-14 09:50:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mit2"
  },
  "83": {
    "place": "سقطرى منطقة",
    "latLng": [
      13.9993,
      56.9753
    ],
    "magnitude": 4.1,
    "depth": 13.999,
    "time": "2024-03-03 00:10:12 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في Socotra region على عمق 13.999 كم بتاريخ 2024-03-03 00:10:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000m3xj"
  },
  "84": {
    "place": "٣٥ كم شمال شرق Al Kūt، العراق",
    "latLng": [
      32.7241,
      46.1082
    ],
    "magnitude": 4.3,
    "depth": 32.724,
    "time": "2024-02-24 00:47:10 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٥ كم شمال شرق Al Kūt، العراق على عمق 32.724 كم بتاريخ 2024-02-24 00:47:10 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000mfu1"
  },
  "85": {
    "place": "٣٣ كم شمال شرق Mandalī، العراق",
    "latLng": [
      33.9307,
      45.8412
    ],
    "magnitude": 4.2,
    "depth": 33.931,
    "time": "2024-02-22 00:06:12 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٣٣ كم شمال شرق Mandalī، العراق على عمق 33.931 كم بتاريخ 2024-02-22 00:06:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000m0ns#dyfi"
  },
  "86": {
    "place": "١٨٩ كم غرب شمال غرب Farasān، السعودية",
    "latLng": [
      17.3413,
      40.465
    ],
    "magnitude": 4.5,
    "depth": 17.341,
    "time": "2024-02-15 03:52:32 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٨٩ كم غرب شمال غرب Farasān، السعودية على عمق 17.341 كم بتاريخ 2024-02-15 03:52:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000lzbe"
  },
  "87": {
    "place": "٨ كم جنوب جنوب غرب Yayladağı، تركيا",
    "latLng": [
      35.8327,
      36.0287
    ],
    "magnitude": 4.2,
    "depth": 35.833,
    "time": "2024-02-14 08:56:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٨ كم جنوب جنوب غرب Yayladağı، تركيا على عمق 35.833 كم بتاريخ 2024-02-14 08:56:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000lz4z"
  },
  "88": {
    "place": "٢١ كم غرب شمال غرب Az Zubayr، العراق",
    "latLng": [
      30.4408,
      47.4905
    ],
    "magnitude": 4.1,
    "depth": 30.441,
    "time": "2024-01-25 06:39:11 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ٢١ كم غرب شمال غرب Az Zubayr، العراق على عمق 30.441 كم بتاريخ 2024-01-25 06:39:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000lv0j#dyfi"
  },
  "89": {
    "place": "٧ كم غرب Uzunbağ، تركيا",
    "latLng": [
      36.1511,
      35.9488
    ],
    "magnitude": 4.2,
    "depth": 36.151,
    "time": "2024-01-10 19:38:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٧ كم غرب Uzunbağ، تركيا على عمق 36.151 كم بتاريخ 2024-01-10 19:38:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000m2yc#dyfi"
  },
  "90": {
    "place": "٢٧٧ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.6855,
      55.5107
    ],
    "magnitude": 4.7,
    "depth": 14.686,
    "time": "2023-12-26 12:38:19 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٧٧ كم شمال شرق Hadibu، اليمن على عمق 14.686 كم بتاريخ 2023-12-26 12:38:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000llht"
  },
  "91": {
    "place": "منطقة صدع أوين",
    "latLng": [
      17.1945,
      59.8471
    ],
    "magnitude": 4.6,
    "depth": 17.195,
    "time": "2023-12-23 19:24:11 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 17.195 كم بتاريخ 2023-12-23 19:24:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ll4h"
  },
  "92": {
    "place": "١ كم شمال شمال غرب أنايازي، تركيا",
    "latLng": [
      36.3343,
      36.1845
    ],
    "magnitude": 4.2,
    "depth": 36.334,
    "time": "2023-12-21 18:24:33 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١ كم شمال شمال غرب Anayazı، تركيا على عمق 36.334 كم بتاريخ 2023-12-21 18:24:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000lkpq"
  },
  "93": {
    "place": "٢ كم جنوب جنوب غرب تويجارلي، تركيا",
    "latLng": [
      36.1922,
      36.0589
    ],
    "magnitude": 4.6,
    "depth": 36.192,
    "time": "2023-12-14 22:32:58 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٢ كم جنوب جنوب غرب تويجارلي، تركيا على عمق 36.192 كم بتاريخ 2023-12-14 22:32:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000lj55#dyfi"
  },
  "94": {
    "place": "١٩٧ كم شمال شرق صلالة، عمان",
    "latLng": [
      18.4187,
      55.2419
    ],
    "magnitude": 4.8,
    "depth": 18.419,
    "time": "2023-11-28 21:05:57 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.8 درجة في ١٩٧ كم شمال شرق صلالة، عمان على عمق 18.419 كم بتاريخ 2023-11-28 21:05:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000leee#dyfi"
  },
  "95": {
    "place": "٢٣٧ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.694,
      54.6739
    ],
    "magnitude": 4.7,
    "depth": 14.694,
    "time": "2023-11-16 06:19:57 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٣٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.694 كم بتاريخ 2023-11-16 06:19:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lnrs"
  },
  "96": {
    "place": "١٢ كم شمال شمال شرق Kırıkhan، تركيا",
    "latLng": [
      36.5969,
      36.4173
    ],
    "magnitude": 4.6,
    "depth": 36.597,
    "time": "2023-11-09 02:32:14 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ١٢ كم شمال شمال شرق Kırıkhan، تركيا على عمق 36.597 كم بتاريخ 2023-11-09 02:32:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000l9r5#dyfi"
  },
  "97": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2048,
      57.8279
    ],
    "magnitude": 4.3,
    "depth": 14.205,
    "time": "2023-10-30 00:13:52 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.205 كم بتاريخ 2023-10-30 00:13:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000l7g1"
  },
  "98": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2306,
      57.6139
    ],
    "magnitude": 4.4,
    "depth": 14.231,
    "time": "2023-10-28 02:06:25 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.231 كم بتاريخ 2023-10-28 02:06:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000l727"
  },
  "99": {
    "place": "٢٧ كم شرق شمال شرق Sur، عمان",
    "latLng": [
      22.6691,
      59.7778
    ],
    "magnitude": 4.9,
    "depth": 22.669,
    "time": "2023-10-21 06:00:36 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.9 درجة في ٢٧ كم شرق شمال شرق Sur، عمان على عمق 22.669 كم بتاريخ 2023-10-21 06:00:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lh3y#dyfi"
  },
  "100": {
    "place": "١٣٠ كم شرق شمال شرق أديغرات، إثيوبيا",
    "latLng": [
      14.6162,
      40.6242
    ],
    "magnitude": 4.5,
    "depth": 14.616,
    "time": "2023-10-19 05:30:47 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٣٠ كم شرق شمال شرق أديغرات، إثيوبيا على عمق 14.616 كم بتاريخ 2023-10-19 05:30:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lgih"
  },
  "101": {
    "place": "١٢ كم شمال شمال غرب Yayladağı، تركيا",
    "latLng": [
      36.0004,
      35.9839
    ],
    "magnitude": 4.1,
    "depth": 36.0,
    "time": "2023-10-04 07:58:15 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٢ كم شمال شمال غرب Yayladağı، تركيا على عمق 36.0 كم بتاريخ 2023-10-04 07:58:15 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lcqq#dyfi"
  },
  "102": {
    "place": "١٦١ كم شمال شمال شرق كالولا، الصومال",
    "latLng": [
      13.3777,
      51.1205
    ],
    "magnitude": 4.4,
    "depth": 13.378,
    "time": "2023-09-15 11:44:35 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.4 درجة في ١٦١ كم شمال شمال شرق كالولا، الصومال على عمق 13.378 كم بتاريخ 2023-09-15 11:44:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kwxm"
  },
  "103": {
    "place": "٤٢ كم جنوب مصوع، إريتريا",
    "latLng": [
      15.2251,
      39.473
    ],
    "magnitude": 5.0,
    "depth": 15.225,
    "time": "2023-09-13 17:51:07 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.0 درجة في ٤٢ كم جنوب مصوع، إريتريا على عمق 15.225 كم بتاريخ 2023-09-13 17:51:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kvkg"
  },
  "104": {
    "place": "٢٠ كم شمال شمال شرق Ţūz Khūrmātū، العراق",
    "latLng": [
      35.0542,
      44.7295
    ],
    "magnitude": 4.7,
    "depth": 35.054,
    "time": "2023-09-10 21:43:49 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.7 درجة في ٢٠ كم شمال شمال شرق Ţūz Khūrmātū، العراق على عمق 35.054 كم بتاريخ 2023-09-10 21:43:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kuw4#dyfi"
  },
  "105": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.9084,
      57.0218
    ],
    "magnitude": 4.4,
    "depth": 13.908,
    "time": "2023-08-28 23:20:34 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 13.908 كم بتاريخ 2023-08-28 23:20:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ksne"
  },
  "106": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.8127,
      36.8093
    ],
    "magnitude": 3.3,
    "depth": 36.813,
    "time": "2023-08-11 16:24:02 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.3 درجة في تركيا-سوريا border region على عمق 36.813 كم بتاريخ 2023-08-11 16:24:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kzia#dyfi"
  },
  "107": {
    "place": "٨ كم جنوب غرب بويوكشات، تركيا",
    "latLng": [
      36.0569,
      36.018
    ],
    "magnitude": 4.3,
    "depth": 36.057,
    "time": "2023-08-07 08:09:24 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٨ كم جنوب غرب بويوكشات، تركيا على عمق 36.057 كم بتاريخ 2023-08-07 08:09:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kye4"
  },
  "108": {
    "place": "١٨٥ كم جنوب Al Ghayz̧ah، اليمن",
    "latLng": [
      14.5578,
      51.8676
    ],
    "magnitude": 4.4,
    "depth": 14.558,
    "time": "2023-08-06 19:49:50 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.4 درجة في ١٨٥ كم جنوب Al Ghayz̧ah، اليمن على عمق 14.558 كم بتاريخ 2023-08-06 19:49:50 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000l040"
  },
  "109": {
    "place": "٣٦ كم شمال Adi Keyh، إريتريا",
    "latLng": [
      15.1755,
      39.3951
    ],
    "magnitude": 4.6,
    "depth": 15.176,
    "time": "2023-08-03 23:15:39 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٣٦ كم شمال Adi Keyh، إريتريا على عمق 15.176 كم بتاريخ 2023-08-03 23:15:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxnz"
  },
  "110": {
    "place": "٣٦ كم شمال Adi Keyh، إريتريا",
    "latLng": [
      15.1709,
      39.3784
    ],
    "magnitude": 4.6,
    "depth": 15.171,
    "time": "2023-08-03 10:11:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٣٦ كم شمال Adi Keyh، إريتريا على عمق 15.171 كم بتاريخ 2023-08-03 10:11:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxhj"
  },
  "111": {
    "place": "٣٥ كم جنوب مصوع، إريتريا",
    "latLng": [
      15.2895,
      39.4368
    ],
    "magnitude": 4.4,
    "depth": 15.29,
    "time": "2023-08-02 20:33:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٣٥ كم جنوب مصوع، إريتريا على عمق 15.29 كم بتاريخ 2023-08-02 20:33:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxe0"
  },
  "112": {
    "place": "٣٤ كم شرق شمال شرق Dek’emhāre، إريتريا",
    "latLng": [
      15.2157,
      39.3303
    ],
    "magnitude": 4.7,
    "depth": 15.216,
    "time": "2023-08-02 05:13:30 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٣٤ كم شرق شمال شرق Dek’emhāre، إريتريا على عمق 15.216 كم بتاريخ 2023-08-02 05:13:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx90#dyfi"
  },
  "113": {
    "place": "٣١ كم جنوب جنوب غرب مصوع، إريتريا",
    "latLng": [
      15.347,
      39.357
    ],
    "magnitude": 4.5,
    "depth": 15.347,
    "time": "2023-08-02 05:09:34 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٣١ كم جنوب جنوب غرب مصوع، إريتريا على عمق 15.347 كم بتاريخ 2023-08-02 05:09:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kzbw"
  },
  "114": {
    "place": "٣٣ كم شرق شمال شرق Dek’emhāre، إريتريا",
    "latLng": [
      15.1591,
      39.3496
    ],
    "magnitude": 4.8,
    "depth": 15.159,
    "time": "2023-08-02 03:36:22 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.8 درجة في ٣٣ كم شرق شمال شرق Dek’emhāre، إريتريا على عمق 15.159 كم بتاريخ 2023-08-02 03:36:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx8b"
  },
  "115": {
    "place": "٣٩ كم جنوب جنوب غرب مصوع، إريتريا",
    "latLng": [
      15.2573,
      39.3998
    ],
    "magnitude": 4.2,
    "depth": 15.257,
    "time": "2023-08-01 21:06:29 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٣٩ كم جنوب جنوب غرب مصوع، إريتريا على عمق 15.257 كم بتاريخ 2023-08-01 21:06:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxcd"
  },
  "116": {
    "place": "٣٧ كم شمال شمال شرق Adi Keyh، إريتريا",
    "latLng": [
      15.1663,
      39.4813
    ],
    "magnitude": 4.4,
    "depth": 15.166,
    "time": "2023-08-01 19:37:58 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٣٧ كم شمال شمال شرق Adi Keyh، إريتريا على عمق 15.166 كم بتاريخ 2023-08-01 19:37:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx4n"
  },
  "117": {
    "place": "إريتريا",
    "latLng": [
      15.2211,
      39.5264
    ],
    "magnitude": 5.6,
    "depth": 15.221,
    "time": "2023-08-01 17:15:25 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.6 درجة في إريتريا على عمق 15.221 كم بتاريخ 2023-08-01 17:15:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx3e#dyfi"
  },
  "118": {
    "place": "١٥٥ كم شمال شمال شرق كالولا، الصومال",
    "latLng": [
      13.332,
      51.082
    ],
    "magnitude": 4.2,
    "depth": 13.332,
    "time": "2023-07-23 08:19:16 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.2 درجة في ١٥٥ كم شمال شمال شرق كالولا، الصومال على عمق 13.332 كم بتاريخ 2023-07-23 08:19:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx1v"
  },
  "119": {
    "place": "Gulf of عدن",
    "latLng": [
      14.091,
      51.7484
    ],
    "magnitude": 4.1,
    "depth": 14.091,
    "time": "2023-07-21 15:38:38 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.1 درجة في Gulf of عدن على عمق 14.091 كم بتاريخ 2023-07-21 15:38:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kw8a"
  },
  "120": {
    "place": "١٥٨ كم شمال كالولا، الصومال",
    "latLng": [
      13.3951,
      50.6223
    ],
    "magnitude": 4.2,
    "depth": 13.395,
    "time": "2023-07-20 09:26:19 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.2 درجة في ١٥٨ كم شمال كالولا، الصومال على عمق 13.395 كم بتاريخ 2023-07-20 09:26:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kw61"
  },
  "121": {
    "place": "إريتريا-إثيوبيا حدود منطقة",
    "latLng": [
      14.5505,
      39.9141
    ],
    "magnitude": 4.3,
    "depth": 14.551,
    "time": "2023-07-05 22:52:09 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في إريتريا-إثيوبيا border region على عمق 14.551 كم بتاريخ 2023-07-05 22:52:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kfeu"
  },
  "122": {
    "place": "٤٤ كم شمال شرق أديغرات، إثيوبيا",
    "latLng": [
      14.5513,
      39.7597
    ],
    "magnitude": 4.2,
    "depth": 14.551,
    "time": "2023-07-02 19:58:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٤٤ كم شمال شرق أديغرات، إثيوبيا على عمق 14.551 كم بتاريخ 2023-07-02 19:58:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kew3"
  },
  "123": {
    "place": "٧١ كم شمال شرق أديغرات، إثيوبيا",
    "latLng": [
      14.6374,
      40.011
    ],
    "magnitude": 4.2,
    "depth": 14.637,
    "time": "2023-07-02 16:51:18 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٧١ كم شمال شرق أديغرات، إثيوبيا على عمق 14.637 كم بتاريخ 2023-07-02 16:51:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kppd"
  },
  "124": {
    "place": "٧٠ كم شرق جنوب شرق Adi Keyh، إريتريا",
    "latLng": [
      14.6721,
      40.0081
    ],
    "magnitude": 4.0,
    "depth": 14.672,
    "time": "2023-07-02 10:11:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.0 درجة في ٧٠ كم شرق جنوب شرق Adi Keyh، إريتريا على عمق 14.672 كم بتاريخ 2023-07-02 10:11:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kevp"
  },
  "125": {
    "place": "٦١ كم شرق جنوب شرق Adi Keyh، إريتريا",
    "latLng": [
      14.6607,
      39.9127
    ],
    "magnitude": 4.3,
    "depth": 14.661,
    "time": "2023-07-02 07:17:00 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٦١ كم شرق جنوب شرق Adi Keyh، إريتريا على عمق 14.661 كم بتاريخ 2023-07-02 07:17:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kevs"
  },
  "126": {
    "place": "٥٣ كم شرق شمال شرق أديغرات، إثيوبيا",
    "latLng": [
      14.5343,
      39.8828
    ],
    "magnitude": 4.7,
    "depth": 14.534,
    "time": "2023-06-04 04:14:47 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٥٣ كم شرق شمال شرق أديغرات، إثيوبيا على عمق 14.534 كم بتاريخ 2023-06-04 04:14:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k679#dyfi"
  },
  "127": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4998,
      56.3603
    ],
    "magnitude": 4.5,
    "depth": 14.5,
    "time": "2023-05-29 02:58:08 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.5 كم بتاريخ 2023-05-29 02:58:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k4q5"
  },
  "128": {
    "place": "٢٠ كم شمال غرب Latakia، سوريا",
    "latLng": [
      35.6694,
      35.6427
    ],
    "magnitude": 4.1,
    "depth": 35.669,
    "time": "2023-05-25 07:21:31 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٢٠ كم شمال غرب Latakia، سوريا على عمق 35.669 كم بتاريخ 2023-05-25 07:21:31 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k3p9"
  },
  "129": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.3492,
      57.4312
    ],
    "magnitude": 4.6,
    "depth": 13.349,
    "time": "2023-05-21 11:50:06 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 13.349 كم بتاريخ 2023-05-21 11:50:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kdlr"
  },
  "130": {
    "place": "٢٨ كم شمال Adi Keyh، إريتريا",
    "latLng": [
      15.1044,
      39.411
    ],
    "magnitude": 4.6,
    "depth": 15.104,
    "time": "2023-05-15 19:05:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٢٨ كم شمال Adi Keyh، إريتريا على عمق 15.104 كم بتاريخ 2023-05-15 19:05:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kc4a#dyfi"
  },
  "131": {
    "place": "٥٥ كم شرق As Salamīyah، سوريا",
    "latLng": [
      35.0003,
      37.6611
    ],
    "magnitude": 4.4,
    "depth": 35.0,
    "time": "2023-05-09 03:52:17 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٥٥ كم شرق As Salamīyah، سوريا على عمق 35.0 كم بتاريخ 2023-05-09 03:52:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kaiw"
  },
  "132": {
    "place": "٠ كم جنوب جنوب شرق سيرين يول، تركيا",
    "latLng": [
      36.3545,
      36.2183
    ],
    "magnitude": 4.7,
    "depth": 36.355,
    "time": "2023-05-07 08:36:08 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ٠ كم جنوب جنوب شرق Serinyol، تركيا على عمق 36.355 كم بتاريخ 2023-05-07 08:36:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ka6g#dyfi"
  },
  "133": {
    "place": "٣ كم غرب جنوب غرب بويوكشات، تركيا",
    "latLng": [
      36.1028,
      36.0439
    ],
    "magnitude": 4.1,
    "depth": 36.103,
    "time": "2023-04-28 05:15:44 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٣ كم غرب جنوب غرب بويوكشات، تركيا على عمق 36.103 كم بتاريخ 2023-04-28 05:15:44 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwk7"
  },
  "134": {
    "place": "٤٥ كم جنوب شرق Kifrī، العراق",
    "latLng": [
      34.3892,
      45.2965
    ],
    "magnitude": 4.2,
    "depth": 34.389,
    "time": "2023-04-26 21:06:56 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٤٥ كم جنوب شرق Kifrī، العراق على عمق 34.389 كم بتاريخ 2023-04-26 21:06:56 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jxrp"
  },
  "135": {
    "place": "٢٣٦ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.6903,
      54.6615
    ],
    "magnitude": 4.4,
    "depth": 14.69,
    "time": "2023-04-24 21:07:36 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ٢٣٦ كم شمال شمال شرق Hadibu، اليمن على عمق 14.69 كم بتاريخ 2023-04-24 21:07:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwqz"
  },
  "136": {
    "place": "٣٠ كم شمال شرق Hurghada، مصر",
    "latLng": [
      27.4122,
      34.0681
    ],
    "magnitude": 4.2,
    "depth": 27.412,
    "time": "2023-04-14 23:58:24 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٣٠ كم شمال شرق Hurghada، Egypt على عمق 27.412 كم بتاريخ 2023-04-14 23:58:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k4nd#dyfi"
  },
  "137": {
    "place": "١٢٨ كم شمال غرب Edd، إريتريا",
    "latLng": [
      14.6335,
      40.7493
    ],
    "magnitude": 4.6,
    "depth": 14.634,
    "time": "2023-04-14 22:37:49 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ١٢٨ كم شمال غرب Edd، إريتريا على عمق 14.634 كم بتاريخ 2023-04-14 22:37:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k4ks#dyfi"
  },
  "138": {
    "place": "منطقة صدع أوين",
    "latLng": [
      17.6028,
      60.0233
    ],
    "magnitude": 5.2,
    "depth": 17.603,
    "time": "2023-04-13 03:24:08 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.2 درجة في منطقة صدع أوين على عمق 17.603 كم بتاريخ 2023-04-13 03:24:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k3z2#pager"
  },
  "139": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.5446,
      56.4004
    ],
    "magnitude": 5.3,
    "depth": 14.545,
    "time": "2023-04-03 22:00:22 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.3 درجة في منطقة صدع أوين على عمق 14.545 كم بتاريخ 2023-04-03 22:00:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1u2"
  },
  "140": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4165,
      56.4221
    ],
    "magnitude": 4.8,
    "depth": 14.417,
    "time": "2023-04-03 21:47:03 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.8 درجة في منطقة صدع أوين على عمق 14.417 كم بتاريخ 2023-04-03 21:47:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k2gj"
  },
  "141": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.3888,
      56.3258
    ],
    "magnitude": 5.5,
    "depth": 14.389,
    "time": "2023-04-03 21:44:13 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.5 درجة في منطقة صدع أوين على عمق 14.389 كم بتاريخ 2023-04-03 21:44:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1u1#pager"
  },
  "142": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4822,
      56.2988
    ],
    "magnitude": 5.5,
    "depth": 14.482,
    "time": "2023-04-03 21:34:45 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.5 درجة في منطقة صدع أوين على عمق 14.482 كم بتاريخ 2023-04-03 21:34:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1tw#pager"
  },
  "143": {
    "place": "١٤ كم جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0466,
      35.9161
    ],
    "magnitude": 4.3,
    "depth": 36.047,
    "time": "2023-04-01 12:40:52 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٤ كم جنوب غرب Uzunba?، تركيا على عمق 36.047 كم بتاريخ 2023-04-01 12:40:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1cm"
  },
  "144": {
    "place": "٢١ كم غرب جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0662,
      35.8128
    ],
    "magnitude": 4.3,
    "depth": 36.066,
    "time": "2023-04-01 12:34:36 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٢١ كم غرب جنوب غرب Uzunba?، تركيا على عمق 36.066 كم بتاريخ 2023-04-01 12:34:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1cg"
  },
  "145": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.5484,
      56.1894
    ],
    "magnitude": 4.3,
    "depth": 14.548,
    "time": "2023-03-31 20:53:40 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.548 كم بتاريخ 2023-03-31 20:53:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k187"
  },
  "146": {
    "place": "١٩ كم جنوب جنوب شرق Hasanbeyli، تركيا",
    "latLng": [
      36.9811,
      36.661
    ],
    "magnitude": 4.3,
    "depth": 36.981,
    "time": "2023-03-31 10:56:57 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٩ كم جنوب جنوب شرق Hasanbeyli، تركيا على عمق 36.981 كم بتاريخ 2023-03-31 10:56:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k139"
  },
  "147": {
    "place": "١٠٨ كم جنوب جنوب غرب Al Wajh، السعودية",
    "latLng": [
      25.3304,
      36.0793
    ],
    "magnitude": 4.5,
    "depth": 25.33,
    "time": "2023-03-29 22:55:55 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٠٨ كم جنوب جنوب غرب Al Wajh، السعودية على عمق 25.33 كم بتاريخ 2023-03-29 22:55:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1rt"
  },
  "148": {
    "place": "سقطرى منطقة",
    "latLng": [
      13.7309,
      56.9425
    ],
    "magnitude": 4.2,
    "depth": 13.731,
    "time": "2023-03-21 18:46:16 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في Socotra region على عمق 13.731 كم بتاريخ 2023-03-21 18:46:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jmic"
  },
  "149": {
    "place": "١٤ كم شمال شمال شرق Ḩalabja، العراق",
    "latLng": [
      35.3022,
      46.0259
    ],
    "magnitude": 5.1,
    "depth": 35.302,
    "time": "2023-03-16 18:32:51 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 5.1 درجة في ١٤ كم شمال شمال شرق Ḩalabja، العراق على عمق 35.302 كم بتاريخ 2023-03-16 18:32:51 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jkjc#dyfi"
  },
  "150": {
    "place": "٤ كم شمال شمال شرق Aşağı Karafakılı، تركيا",
    "latLng": [
      36.8216,
      36.5749
    ],
    "magnitude": 4.3,
    "depth": 36.822,
    "time": "2023-03-13 02:23:14 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٤ كم شمال شمال شرق Aşağı Karafakılı، تركيا على عمق 36.822 كم بتاريخ 2023-03-13 02:23:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jjg7#dyfi"
  },
  "151": {
    "place": "١١ كم جنوب غرب Ceyhan، تركيا",
    "latLng": [
      36.9506,
      35.7349
    ],
    "magnitude": 4.3,
    "depth": 36.951,
    "time": "2023-03-11 19:35:16 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١١ كم جنوب غرب Ceyhan، تركيا على عمق 36.951 كم بتاريخ 2023-03-11 19:35:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jj67#dyfi"
  },
  "152": {
    "place": "٢ كم شمال شمال شرق Uzunba?، تركيا",
    "latLng": [
      36.1589,
      36.0428
    ],
    "magnitude": 4.0,
    "depth": 36.159,
    "time": "2023-03-06 22:14:57 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ٢ كم شمال شمال شرق Uzunba?، تركيا على عمق 36.159 كم بتاريخ 2023-03-06 22:14:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhrd"
  },
  "153": {
    "place": "٥ كم غرب Toygarl?، تركيا",
    "latLng": [
      36.2202,
      36.0072
    ],
    "magnitude": 4.0,
    "depth": 36.22,
    "time": "2023-03-06 11:02:56 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ٥ كم غرب Toygarl?، تركيا على عمق 36.22 كم بتاريخ 2023-03-06 11:02:56 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhlx#dyfi"
  },
  "154": {
    "place": "٤ كم جنوب شرق Gümü?göze، تركيا",
    "latLng": [
      36.1213,
      36.1681
    ],
    "magnitude": 4.3,
    "depth": 36.121,
    "time": "2023-03-06 08:14:16 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٤ كم جنوب شرق Gümü?göze، تركيا على عمق 36.121 كم بتاريخ 2023-03-06 08:14:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhl4"
  },
  "155": {
    "place": "٤ كم شمال Uzunba?، تركيا",
    "latLng": [
      36.1816,
      36.0375
    ],
    "magnitude": 4.0,
    "depth": 36.182,
    "time": "2023-03-06 02:16:02 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ٤ كم شمال Uzunba?، تركيا على عمق 36.182 كم بتاريخ 2023-03-06 02:16:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhjt"
  },
  "156": {
    "place": "٧ كم جنوب غرب Dörtyol، تركيا",
    "latLng": [
      36.7867,
      36.1842
    ],
    "magnitude": 4.8,
    "depth": 36.787,
    "time": "2023-03-05 20:49:46 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.8 درجة في ٧ كم جنوب غرب Dörtyol، تركيا على عمق 36.787 كم بتاريخ 2023-03-05 20:49:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhi7#dyfi"
  },
  "157": {
    "place": "٣٢ كم شمال غرب Tadmur، سوريا",
    "latLng": [
      34.7587,
      38.0259
    ],
    "magnitude": 4.0,
    "depth": 34.759,
    "time": "2023-03-05 06:25:43 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٣٢ كم شمال غرب Tadmur، سوريا على عمق 34.759 كم بتاريخ 2023-03-05 06:25:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhfy#dyfi"
  },
  "158": {
    "place": "٧ كم غرب أنايازي، تركيا",
    "latLng": [
      36.3065,
      36.097
    ],
    "magnitude": 4.7,
    "depth": 36.307,
    "time": "2023-03-01 07:20:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ٧ كم غرب Anayazi، تركيا على عمق 36.307 كم بتاريخ 2023-03-01 07:20:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jgic#dyfi"
  },
  "159": {
    "place": "٣٠ كم شرق Karata?، تركيا",
    "latLng": [
      36.6204,
      35.704
    ],
    "magnitude": 4.4,
    "depth": 36.62,
    "time": "2023-02-27 06:29:04 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٣٠ كم شرق Karata?، تركيا على عمق 36.62 كم بتاريخ 2023-02-27 06:29:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhxe"
  },
  "160": {
    "place": "٩ كم جنوب غرب B?y?k?at، تركيا",
    "latLng": [
      36.0535,
      36.012
    ],
    "magnitude": 4.5,
    "depth": 36.054,
    "time": "2023-02-26 02:26:31 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٩ كم جنوب غرب B?y?k?at، تركيا على عمق 36.054 كم بتاريخ 2023-02-26 02:26:31 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jrn1#dyfi"
  },
  "161": {
    "place": "Central تركيا",
    "latLng": [
      36.0592,
      35.9528
    ],
    "magnitude": 4.2,
    "depth": 36.059,
    "time": "2023-02-25 01:12:20 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في Central تركيا على عمق 36.059 كم بتاريخ 2023-02-25 01:12:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jrgg"
  },
  "162": {
    "place": "٥٧ كم غرب جنوب غرب Latakia، سوريا",
    "latLng": [
      35.2752,
      35.239
    ],
    "magnitude": 4.2,
    "depth": 35.275,
    "time": "2023-02-24 20:10:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٥٧ كم غرب جنوب غرب Latakia، سوريا على عمق 35.275 كم بتاريخ 2023-02-24 20:10:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jref"
  },
  "163": {
    "place": "١١ كم شمال غرب G?nyaz?، تركيا",
    "latLng": [
      36.3086,
      36.0365
    ],
    "magnitude": 4.0,
    "depth": 36.309,
    "time": "2023-02-24 05:46:18 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ١١ كم شمال غرب G?nyaz?، تركيا على عمق 36.309 كم بتاريخ 2023-02-24 05:46:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jr79"
  },
  "164": {
    "place": "٦ كم جنوب جنوب شرق بويوكشات، تركيا",
    "latLng": [
      36.0589,
      36.095
    ],
    "magnitude": 4.9,
    "depth": 36.059,
    "time": "2023-02-23 15:53:47 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.9 درجة في ٦ كم جنوب جنوب شرق بويوكشات، تركيا على عمق 36.059 كم بتاريخ 2023-02-23 15:53:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jr1t#dyfi"
  },
  "165": {
    "place": "٣ كم شرق Bal?kl?dere، تركيا",
    "latLng": [
      36.1158,
      36.1459
    ],
    "magnitude": 4.2,
    "depth": 36.116,
    "time": "2023-02-21 16:06:48 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٣ كم شرق Bal?kl?dere، تركيا على عمق 36.116 كم بتاريخ 2023-02-21 16:06:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqkr#dyfi"
  },
  "166": {
    "place": "بالقرب من ساحل سوريا",
    "latLng": [
      35.9531,
      35.9447
    ],
    "magnitude": 4.0,
    "depth": 35.953,
    "time": "2023-02-20 22:56:53 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في Near the coast of سوريا على عمق 35.953 كم بتاريخ 2023-02-20 22:56:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqfm"
  },
  "167": {
    "place": "٢ كم غرب جنوب غرب كوزيتبه، تركيا",
    "latLng": [
      36.2572,
      36.1266
    ],
    "magnitude": 4.2,
    "depth": 36.257,
    "time": "2023-02-20 19:09:20 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٢ كم غرب جنوب غرب Kuzeytepe، تركيا على عمق 36.257 كم بتاريخ 2023-02-20 19:09:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqdp#dyfi"
  },
  "168": {
    "place": "٥ كم جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.105,
      35.9906
    ],
    "magnitude": 4.2,
    "depth": 36.105,
    "time": "2023-02-20 19:00:14 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٥ كم جنوب غرب Uzunba?، تركيا على عمق 36.105 كم بتاريخ 2023-02-20 19:00:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqdn"
  },
  "169": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.2653,
      36.0798
    ],
    "magnitude": 4.6,
    "depth": 36.265,
    "time": "2023-02-20 17:13:18 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في تركيا-سوريا border region على عمق 36.265 كم بتاريخ 2023-02-20 17:13:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jga3"
  },
  "170": {
    "place": "٩ كم غرب شمال غرب Uzunba?، تركيا",
    "latLng": [
      36.159,
      35.9351
    ],
    "magnitude": 5.5,
    "depth": 36.159,
    "time": "2023-02-20 17:07:35 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 5.5 درجة في ٩ كم غرب شمال غرب Uzunba?، تركيا على عمق 36.159 كم بتاريخ 2023-02-20 17:07:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqjc#pager"
  },
  "171": {
    "place": "٢ كم شمال شمال غرب Uzunba?، تركيا",
    "latLng": [
      36.1616,
      36.0251
    ],
    "magnitude": 6.3,
    "depth": 36.162,
    "time": "2023-02-20 17:04:29 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 6.3 درجة في ٢ كم شمال شمال غرب Uzunba?، تركيا على عمق 36.162 كم بتاريخ 2023-02-20 17:04:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqcn#pager"
  },
  "172": {
    "place": "٢١ كم غرب Uzunba?، تركيا",
    "latLng": [
      36.1766,
      35.7967
    ],
    "magnitude": 5.2,
    "depth": 36.177,
    "time": "2023-02-16 19:47:49 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 5.2 درجة في ٢١ كم غرب Uzunba?، تركيا على عمق 36.177 كم بتاريخ 2023-02-16 19:47:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpff#dyfi"
  },
  "173": {
    "place": "٢٤ كم غرب شمال غرب Yaylada??، تركيا",
    "latLng": [
      35.9743,
      35.8103
    ],
    "magnitude": 4.8,
    "depth": 35.974,
    "time": "2023-02-16 11:16:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.8 درجة في ٢٤ كم غرب شمال غرب Yaylada??، تركيا على عمق 35.974 كم بتاريخ 2023-02-16 11:16:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpd5#dyfi"
  },
  "174": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.7937,
      36.5503
    ],
    "magnitude": 4.2,
    "depth": 36.794,
    "time": "2023-02-15 00:06:02 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في تركيا-سوريا border region على عمق 36.794 كم بتاريخ 2023-02-15 00:06:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp0a#dyfi"
  },
  "175": {
    "place": "٣٤ كم غرب Latakia، سوريا",
    "latLng": [
      35.5292,
      35.4049
    ],
    "magnitude": 4.3,
    "depth": 35.529,
    "time": "2023-02-14 13:44:03 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٣٤ كم غرب Latakia، سوريا على عمق 35.529 كم بتاريخ 2023-02-14 13:44:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr1"
  },
  "176": {
    "place": "٦ كم شمال شمال غرب K??lak، تركيا",
    "latLng": [
      36.0172,
      36.1295
    ],
    "magnitude": 4.4,
    "depth": 36.017,
    "time": "2023-02-14 11:54:11 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٦ كم شمال شمال غرب K??lak، تركيا على عمق 36.017 كم بتاريخ 2023-02-14 11:54:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnqt"
  },
  "177": {
    "place": "١٢ كم غرب جنوب غرب Dörtyol، تركيا",
    "latLng": [
      36.781,
      36.1142
    ],
    "magnitude": 4.2,
    "depth": 36.781,
    "time": "2023-02-14 01:56:32 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١٢ كم غرب جنوب غرب Dörtyol، تركيا على عمق 36.781 كم بتاريخ 2023-02-14 01:56:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqtp"
  },
  "178": {
    "place": "١٢ كم شمال شمال شرق A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.8844,
      36.6204
    ],
    "magnitude": 4.5,
    "depth": 36.884,
    "time": "2023-02-13 11:59:17 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ١٢ كم شمال شمال شرق A?a?? Karafak?l?، تركيا على عمق 36.884 كم بتاريخ 2023-02-13 11:59:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnks"
  },
  "179": {
    "place": "٢٠ كم جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0389,
      35.8488
    ],
    "magnitude": 4.0,
    "depth": 36.039,
    "time": "2023-02-12 22:02:06 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ٢٠ كم جنوب غرب Uzunba?، تركيا على عمق 36.039 كم بتاريخ 2023-02-12 22:02:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqc9"
  },
  "180": {
    "place": "٩ كم شمال ‘Afr?n، سوريا",
    "latLng": [
      36.5999,
      36.8854
    ],
    "magnitude": 4.4,
    "depth": 36.6,
    "time": "2023-02-12 21:21:34 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٩ كم شمال ‘Afr?n، سوريا على عمق 36.6 كم بتاريخ 2023-02-12 21:21:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqc3"
  },
  "181": {
    "place": "١٦ كم جنوب غرب Musabeyli، تركيا",
    "latLng": [
      36.7991,
      36.7677
    ],
    "magnitude": 4.2,
    "depth": 36.799,
    "time": "2023-02-12 12:25:22 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١٦ كم جنوب غرب Musabeyli، تركيا على عمق 36.799 كم بتاريخ 2023-02-12 12:25:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnfg#dyfi"
  },
  "182": {
    "place": "٤ كم شرق Alt?nözü، تركيا",
    "latLng": [
      36.1158,
      36.3017
    ],
    "magnitude": 4.2,
    "depth": 36.116,
    "time": "2023-02-12 09:32:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٤ كم شرق Alt?nözü، تركيا على عمق 36.116 كم بتاريخ 2023-02-12 09:32:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnf4"
  },
  "183": {
    "place": "١٥ كم غرب Latakia، سوريا",
    "latLng": [
      35.5279,
      35.6189
    ],
    "magnitude": 4.1,
    "depth": 35.528,
    "time": "2023-02-12 07:12:36 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٥ كم غرب Latakia، سوريا على عمق 35.528 كم بتاريخ 2023-02-12 07:12:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqbn"
  },
  "184": {
    "place": "٩ كم شرق شمال شرق K?r?khan، تركيا",
    "latLng": [
      36.5324,
      36.4568
    ],
    "magnitude": 4.3,
    "depth": 36.532,
    "time": "2023-02-12 04:46:30 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٩ كم شرق شمال شرق K?r?khan، تركيا على عمق 36.532 كم بتاريخ 2023-02-12 04:46:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jndy"
  },
  "185": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.6384,
      36.5737
    ],
    "magnitude": 4.3,
    "depth": 36.638,
    "time": "2023-02-11 22:29:15 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في تركيا-سوريا border region على عمق 36.638 كم بتاريخ 2023-02-11 22:29:15 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jncp"
  },
  "186": {
    "place": "١ كم شرق شمال شرق كوزيتبه، تركيا",
    "latLng": [
      36.268,
      36.171
    ],
    "magnitude": 4.3,
    "depth": 36.268,
    "time": "2023-02-11 17:20:01 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١ كم شرق شمال شرق Kuzeytepe، تركيا على عمق 36.268 كم بتاريخ 2023-02-11 17:20:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnbd#dyfi"
  },
  "187": {
    "place": "٤ كم غرب جنوب غرب K?r?khan، تركيا",
    "latLng": [
      36.4869,
      36.3096
    ],
    "magnitude": 4.4,
    "depth": 36.487,
    "time": "2023-02-11 11:51:41 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٤ كم غرب جنوب غرب K?r?khan، تركيا على عمق 36.487 كم بتاريخ 2023-02-11 11:51:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnam#dyfi"
  },
  "188": {
    "place": "١٩ كم شرق شمال شرق K?r?khan، تركيا",
    "latLng": [
      36.5556,
      36.5606
    ],
    "magnitude": 4.1,
    "depth": 36.556,
    "time": "2023-02-11 00:24:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٩ كم شرق شمال شرق K?r?khan، تركيا على عمق 36.556 كم بتاريخ 2023-02-11 00:24:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jn77"
  },
  "189": {
    "place": "٥٩ كم غرب شمال غرب ?ar??s، سوريا",
    "latLng": [
      35.0684,
      35.2669
    ],
    "magnitude": 4.3,
    "depth": 35.068,
    "time": "2023-02-10 08:17:28 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٥٩ كم غرب شمال غرب ?ar??s، سوريا على عمق 35.068 كم بتاريخ 2023-02-10 08:17:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jn19#dyfi"
  },
  "190": {
    "place": "٢١ كم غرب Uzunba?، تركيا",
    "latLng": [
      36.1764,
      35.7977
    ],
    "magnitude": 4.2,
    "depth": 36.176,
    "time": "2023-02-09 18:49:36 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٢١ كم غرب Uzunba?، تركيا على عمق 36.176 كم بتاريخ 2023-02-09 18:49:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpkt"
  },
  "191": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.9611,
      36.6603
    ],
    "magnitude": 4.6,
    "depth": 36.961,
    "time": "2023-02-09 07:18:17 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في تركيا-سوريا border region على عمق 36.961 كم بتاريخ 2023-02-09 07:18:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmnp#dyfi"
  },
  "192": {
    "place": "٨ كم غرب Hassa، تركيا",
    "latLng": [
      36.8136,
      36.4252
    ],
    "magnitude": 4.3,
    "depth": 36.814,
    "time": "2023-02-09 03:24:55 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٨ كم غرب Hassa، تركيا على عمق 36.814 كم بتاريخ 2023-02-09 03:24:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmmw"
  },
  "193": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.3313,
      36.0996
    ],
    "magnitude": 4.2,
    "depth": 36.331,
    "time": "2023-02-08 19:48:11 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في تركيا-سوريا border region على عمق 36.331 كم بتاريخ 2023-02-08 19:48:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmk7"
  },
  "194": {
    "place": "١٩ كم شرق شمال شرق Bcharré، Lebanon",
    "latLng": [
      34.2985,
      36.2101
    ],
    "magnitude": 4.1,
    "depth": 34.299,
    "time": "2023-02-08 18:58:55 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٩ كم شرق شمال شرق Bcharré، Lebanon على عمق 34.299 كم بتاريخ 2023-02-08 18:58:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmjy#dyfi"
  },
  "195": {
    "place": "١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.6565,
      36.5077
    ],
    "magnitude": 4.3,
    "depth": 36.657,
    "time": "2023-02-08 09:13:07 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا على عمق 36.657 كم بتاريخ 2023-02-08 09:13:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpch"
  },
  "196": {
    "place": "٤ كم جنوب شرق سيرين يول، تركيا",
    "latLng": [
      36.3259,
      36.2434
    ],
    "magnitude": 4.1,
    "depth": 36.326,
    "time": "2023-02-08 07:23:45 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٤ كم جنوب شرق Serinyol، تركيا على عمق 36.326 كم بتاريخ 2023-02-08 07:23:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpce"
  },
  "197": {
    "place": "١٦ كم شرق شمال شرق Denizciler، تركيا",
    "latLng": [
      36.7009,
      36.3794
    ],
    "magnitude": 4.4,
    "depth": 36.701,
    "time": "2023-02-08 07:20:41 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ١٦ كم شرق شمال شرق Denizciler، تركيا على عمق 36.701 كم بتاريخ 2023-02-08 07:20:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpcf"
  },
  "198": {
    "place": "٣ كم شرق Antakya، تركيا",
    "latLng": [
      36.2022,
      36.1959
    ],
    "magnitude": 4.5,
    "depth": 36.202,
    "time": "2023-02-08 06:09:00 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٣ كم شرق Antakya، تركيا على عمق 36.202 كم بتاريخ 2023-02-08 06:09:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmfn#dyfi"
  },
  "199": {
    "place": "Central تركيا",
    "latLng": [
      36.0927,
      35.8637
    ],
    "magnitude": 4.5,
    "depth": 36.093,
    "time": "2023-02-07 23:13:02 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في Central تركيا على عمق 36.093 كم بتاريخ 2023-02-07 23:13:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmdw#dyfi"
  },
  "200": {
    "place": "منطقة البحر الميت",
    "latLng": [
      32.0866,
      35.2415
    ],
    "magnitude": 4.1,
    "depth": 32.087,
    "time": "2023-02-07 21:14:28 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في Dead Sea region على عمق 32.087 كم بتاريخ 2023-02-07 21:14:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmcs#dyfi"
  },
  "201": {
    "place": "Central تركيا",
    "latLng": [
      36.0086,
      35.9967
    ],
    "magnitude": 4.2,
    "depth": 36.009,
    "time": "2023-02-07 16:53:27 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في Central تركيا على عمق 36.009 كم بتاريخ 2023-02-07 16:53:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp56"
  },
  "202": {
    "place": "١٧ كم غرب جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0984,
      35.8449
    ],
    "magnitude": 4.5,
    "depth": 36.098,
    "time": "2023-02-07 13:36:41 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ١٧ كم غرب جنوب غرب Uzunba?، تركيا على عمق 36.098 كم بتاريخ 2023-02-07 13:36:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm84"
  },
  "203": {
    "place": "٩ كم غرب جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0958,
      35.9441
    ],
    "magnitude": 4.6,
    "depth": 36.096,
    "time": "2023-02-07 10:37:17 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٩ كم غرب جنوب غرب Uzunba?، تركيا على عمق 36.096 كم بتاريخ 2023-02-07 10:37:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp45"
  },
  "204": {
    "place": "١٢ كم شمال شرق K?r?khan، تركيا",
    "latLng": [
      36.5768,
      36.4539
    ],
    "magnitude": 4.3,
    "depth": 36.577,
    "time": "2023-02-07 07:54:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٢ كم شمال شرق K?r?khan، تركيا على عمق 36.577 كم بتاريخ 2023-02-07 07:54:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm6x"
  },
  "205": {
    "place": "١٢ كم شمال شرق Hassa، تركيا",
    "latLng": [
      36.8855,
      36.6006
    ],
    "magnitude": 4.2,
    "depth": 36.886,
    "time": "2023-02-07 07:45:06 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١٢ كم شمال شرق Hassa، تركيا على عمق 36.886 كم بتاريخ 2023-02-07 07:45:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp49"
  },
  "206": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.1531,
      36.3488
    ],
    "magnitude": 4.4,
    "depth": 36.153,
    "time": "2023-02-07 05:26:30 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في تركيا-سوريا border region على عمق 36.153 كم بتاريخ 2023-02-07 05:26:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm63#dyfi"
  },
  "207": {
    "place": "٧ كم شرق شمال شرق A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.8131,
      36.6306
    ],
    "magnitude": 4.4,
    "depth": 36.813,
    "time": "2023-02-07 04:42:03 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٧ كم شرق شمال شرق A?a?? Karafak?l?، تركيا على عمق 36.813 كم بتاريخ 2023-02-07 04:42:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm5v"
  },
  "208": {
    "place": "٢ كم جنوب جنوب شرق بويوك داليان، تركيا",
    "latLng": [
      36.2678,
      36.2151
    ],
    "magnitude": 4.3,
    "depth": 36.268,
    "time": "2023-02-07 03:37:00 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٢ كم جنوب جنوب شرق Büyük Dalyan، تركيا على عمق 36.268 كم بتاريخ 2023-02-07 03:37:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm5j"
  },
  "209": {
    "place": "١٠ كم شمال غرب Yaylada??، تركيا",
    "latLng": [
      35.9675,
      35.9849
    ],
    "magnitude": 4.7,
    "depth": 35.968,
    "time": "2023-02-07 02:47:37 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ١٠ كم شمال غرب Yaylada??، تركيا على عمق 35.968 كم بتاريخ 2023-02-07 02:47:37 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm55#dyfi"
  },
  "210": {
    "place": "٣٩ كم غرب شمال غرب Latakia، سوريا",
    "latLng": [
      35.6037,
      35.3598
    ],
    "magnitude": 4.5,
    "depth": 35.604,
    "time": "2023-02-06 23:29:14 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٣٩ كم غرب شمال غرب Latakia، سوريا على عمق 35.604 كم بتاريخ 2023-02-06 23:29:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm3x#dyfi"
  },
  "211": {
    "place": "٦ كم جنوب جنوب غرب Hassa، تركيا",
    "latLng": [
      36.7444,
      36.4904
    ],
    "magnitude": 4.5,
    "depth": 36.744,
    "time": "2023-02-06 21:02:06 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٦ كم جنوب جنوب غرب Hassa، تركيا على عمق 36.744 كم بتاريخ 2023-02-06 21:02:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm2x"
  },
  "212": {
    "place": "٢ كم جنوب شرق Dursunlu، تركيا",
    "latLng": [
      36.1512,
      36.1819
    ],
    "magnitude": 4.3,
    "depth": 36.151,
    "time": "2023-02-06 20:45:42 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٢ كم جنوب شرق Dursunlu، تركيا على عمق 36.151 كم بتاريخ 2023-02-06 20:45:42 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw4"
  },
  "213": {
    "place": "١١ كم شمال شمال غرب Musabeyli، تركيا",
    "latLng": [
      36.9819,
      36.8786
    ],
    "magnitude": 4.3,
    "depth": 36.982,
    "time": "2023-02-06 18:51:18 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١١ كم شمال شمال غرب Musabeyli، تركيا على عمق 36.982 كم بتاريخ 2023-02-06 18:51:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnuk"
  },
  "214": {
    "place": "١٧ كم غرب شمال غرب Musabeyli، تركيا",
    "latLng": [
      36.9291,
      36.7256
    ],
    "magnitude": 4.1,
    "depth": 36.929,
    "time": "2023-02-06 18:49:54 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٧ كم غرب شمال غرب Musabeyli، تركيا على عمق 36.929 كم بتاريخ 2023-02-06 18:49:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw9"
  },
  "215": {
    "place": "١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.6625,
      36.4828
    ],
    "magnitude": 4.9,
    "depth": 36.663,
    "time": "2023-02-06 16:32:11 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.9 درجة في ١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا على عمق 36.663 كم بتاريخ 2023-02-06 16:32:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlt7#dyfi"
  },
  "216": {
    "place": "٢٣ كم غرب Uzunba?، تركيا",
    "latLng": [
      36.1064,
      35.7822
    ],
    "magnitude": 4.5,
    "depth": 36.106,
    "time": "2023-02-06 16:10:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٢٣ كم غرب Uzunba?، تركيا على عمق 36.106 كم بتاريخ 2023-02-06 16:10:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlt0"
  },
  "217": {
    "place": "٢ كم شرق شمال شرق Hassa، تركيا",
    "latLng": [
      36.8097,
      36.5387
    ],
    "magnitude": 4.5,
    "depth": 36.81,
    "time": "2023-02-06 14:27:43 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٢ كم شرق شمال شرق Hassa، تركيا على عمق 36.81 كم بتاريخ 2023-02-06 14:27:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlse"
  },
  "218": {
    "place": "٥ كم شرق Uzunkavak، تركيا",
    "latLng": [
      36.3454,
      36.4775
    ],
    "magnitude": 4.2,
    "depth": 36.345,
    "time": "2023-02-06 13:36:08 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٥ كم شرق Uzunkavak، تركيا على عمق 36.345 كم بتاريخ 2023-02-06 13:36:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntr"
  },
  "219": {
    "place": "٦ كم شمال غرب Uzunkavak، تركيا",
    "latLng": [
      36.3959,
      36.3691
    ],
    "magnitude": 4.5,
    "depth": 36.396,
    "time": "2023-02-06 13:31:39 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٦ كم شمال غرب Uzunkavak، تركيا على عمق 36.396 كم بتاريخ 2023-02-06 13:31:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntn"
  },
  "220": {
    "place": "٤ كم شرق Kastal، تركيا",
    "latLng": [
      36.2541,
      36.2923
    ],
    "magnitude": 4.6,
    "depth": 36.254,
    "time": "2023-02-06 13:09:21 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٤ كم شرق Kastal، تركيا على عمق 36.254 كم بتاريخ 2023-02-06 13:09:21 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntm"
  },
  "221": {
    "place": "١١ كم جنوب شرق Yaylada??، تركيا",
    "latLng": [
      35.8319,
      36.162
    ],
    "magnitude": 4.6,
    "depth": 35.832,
    "time": "2023-02-06 10:07:31 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ١١ كم جنوب شرق Yaylada??، تركيا على عمق 35.832 كم بتاريخ 2023-02-06 10:07:31 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlqc"
  },
  "222": {
    "place": "١٥ كم شمال شمال غرب Hassa، تركيا",
    "latLng": [
      36.9214,
      36.427
    ],
    "magnitude": 4.6,
    "depth": 36.921,
    "time": "2023-02-06 09:23:45 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ١٥ كم شمال شمال غرب Hassa، تركيا على عمق 36.921 كم بتاريخ 2023-02-06 09:23:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlq1"
  },
  "223": {
    "place": "١١ كم غرب شمال غرب Uzunba?، تركيا",
    "latLng": [
      36.1795,
      35.9229
    ],
    "magnitude": 4.0,
    "depth": 36.18,
    "time": "2023-02-06 08:26:39 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ١١ كم غرب شمال غرب Uzunba?، تركيا على عمق 36.18 كم بتاريخ 2023-02-06 08:26:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsq"
  },
  "224": {
    "place": "٤٤ كم غرب Latakia، سوريا",
    "latLng": [
      35.6075,
      35.3088
    ],
    "magnitude": 4.4,
    "depth": 35.608,
    "time": "2023-02-06 08:12:52 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٤٤ كم غرب Latakia، سوريا على عمق 35.608 كم بتاريخ 2023-02-06 08:12:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsl"
  },
  "225": {
    "place": "١٤ كم شمال شمال شرق K?r?khan، تركيا",
    "latLng": [
      36.6219,
      36.4225
    ],
    "magnitude": 4.5,
    "depth": 36.622,
    "time": "2023-02-06 08:01:47 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ١٤ كم شمال شمال شرق K?r?khan، تركيا على عمق 36.622 كم بتاريخ 2023-02-06 08:01:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlpp"
  },
  "226": {
    "place": "١٩ كم غرب شمال غرب Latakia، سوريا",
    "latLng": [
      35.5907,
      35.5841
    ],
    "magnitude": 4.3,
    "depth": 35.591,
    "time": "2023-02-06 07:54:39 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٩ كم غرب شمال غرب Latakia، سوريا على عمق 35.591 كم بتاريخ 2023-02-06 07:54:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsh"
  },
  "227": {
    "place": "٢٨ كم غرب شمال غرب Latakia، سوريا",
    "latLng": [
      35.6445,
      35.5034
    ],
    "magnitude": 4.5,
    "depth": 35.645,
    "time": "2023-02-06 07:29:40 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٢٨ كم غرب شمال غرب Latakia، سوريا على عمق 35.645 كم بتاريخ 2023-02-06 07:29:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsf"
  },
  "228": {
    "place": "٥ كم جنوب جنوب شرق Dörtyol، تركيا",
    "latLng": [
      36.7978,
      36.2602
    ],
    "magnitude": 4.3,
    "depth": 36.798,
    "time": "2023-02-06 07:24:13 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٥ كم جنوب جنوب شرق Dörtyol، تركيا على عمق 36.798 كم بتاريخ 2023-02-06 07:24:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsc"
  },
  "229": {
    "place": "١٠ كم شمال شمال غرب K?r?khan، تركيا",
    "latLng": [
      36.595,
      36.3297
    ],
    "magnitude": 4.2,
    "depth": 36.595,
    "time": "2023-02-06 07:10:09 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١٠ كم شمال شمال غرب K?r?khan، تركيا على عمق 36.595 كم بتاريخ 2023-02-06 07:10:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnte"
  },
  "230": {
    "place": "١١ كم جنوب غرب Hassa، تركيا",
    "latLng": [
      36.7139,
      36.4459
    ],
    "magnitude": 4.5,
    "depth": 36.714,
    "time": "2023-02-06 07:08:32 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ١١ كم جنوب غرب Hassa، تركيا على عمق 36.714 كم بتاريخ 2023-02-06 07:08:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlpb#dyfi"
  },
  "231": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.3265,
      36.4042
    ],
    "magnitude": 4.4,
    "depth": 36.327,
    "time": "2023-02-06 05:44:55 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في تركيا-سوريا border region على عمق 36.327 كم بتاريخ 2023-02-06 05:44:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvf"
  },
  "232": {
    "place": "٣ كم جنوب بويوك داليان، تركيا",
    "latLng": [
      36.2606,
      36.2043
    ],
    "magnitude": 4.6,
    "depth": 36.261,
    "time": "2023-02-06 05:43:49 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٣ كم جنوب Büyük Dalyan، تركيا على عمق 36.261 كم بتاريخ 2023-02-06 05:43:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns1"
  },
  "233": {
    "place": "١ كم شمال بويوك داليان، تركيا",
    "latLng": [
      36.2975,
      36.2085
    ],
    "magnitude": 4.6,
    "depth": 36.298,
    "time": "2023-02-06 05:36:33 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ١ كم شمال Büyük Dalyan، تركيا على عمق 36.298 كم بتاريخ 2023-02-06 05:36:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlp0"
  },
  "234": {
    "place": "٦ كم شمال سيرين يول، تركيا",
    "latLng": [
      36.4188,
      36.2183
    ],
    "magnitude": 4.4,
    "depth": 36.419,
    "time": "2023-02-06 05:35:21 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٦ كم شمال Serinyol، تركيا على عمق 36.419 كم بتاريخ 2023-02-06 05:35:21 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns0"
  },
  "235": {
    "place": "٩ كم جنوب جنوب غرب Hassa، تركيا",
    "latLng": [
      36.7176,
      36.4733
    ],
    "magnitude": 4.5,
    "depth": 36.718,
    "time": "2023-02-06 04:47:57 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٩ كم جنوب جنوب غرب Hassa، تركيا على عمق 36.718 كم بتاريخ 2023-02-06 04:47:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlns"
  },
  "236": {
    "place": "٢ كم شمال شرق Uzunkavak، تركيا",
    "latLng": [
      36.3649,
      36.4413
    ],
    "magnitude": 4.4,
    "depth": 36.365,
    "time": "2023-02-06 04:31:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٢ كم شمال شرق Uzunkavak، تركيا على عمق 36.365 كم بتاريخ 2023-02-06 04:31:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsd"
  },
  "237": {
    "place": "١٧ كم شمال شمال شرق K?r?khan، تركيا",
    "latLng": [
      36.6427,
      36.426
    ],
    "magnitude": 4.3,
    "depth": 36.643,
    "time": "2023-02-06 03:58:19 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٧ كم شمال شمال شرق K?r?khan، تركيا على عمق 36.643 كم بتاريخ 2023-02-06 03:58:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrn#dyfi"
  },
  "238": {
    "place": "١٤ كم شرق شمال شرق Denizciler، تركيا",
    "latLng": [
      36.7084,
      36.3519
    ],
    "magnitude": 4.7,
    "depth": 36.708,
    "time": "2023-02-06 02:54:00 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ١٤ كم شرق شمال شرق Denizciler، تركيا على عمق 36.708 كم بتاريخ 2023-02-06 02:54:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmv#dyfi"
  },
  "239": {
    "place": "١٢ كم غرب شمال غرب Hassa، تركيا",
    "latLng": [
      36.8497,
      36.3895
    ],
    "magnitude": 4.2,
    "depth": 36.85,
    "time": "2023-02-06 02:43:47 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ١٢ كم غرب شمال غرب Hassa، تركيا على عمق 36.85 كم بتاريخ 2023-02-06 02:43:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvz"
  },
  "240": {
    "place": "٥٧ كم غرب B?niy?s، سوريا",
    "latLng": [
      35.1453,
      35.3142
    ],
    "magnitude": 4.7,
    "depth": 35.145,
    "time": "2023-02-06 01:57:26 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ٥٧ كم غرب B?niy?s، سوريا على عمق 35.145 كم بتاريخ 2023-02-06 01:57:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnse"
  },
  "241": {
    "place": "٣ كم غرب سيرين يول، تركيا",
    "latLng": [
      36.3603,
      36.1708
    ],
    "magnitude": 4.4,
    "depth": 36.36,
    "time": "2023-02-06 01:54:36 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٣ كم غرب Serinyol، تركيا على عمق 36.36 كم بتاريخ 2023-02-06 01:54:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr7"
  },
  "242": {
    "place": "٨ كم جنوب شرق A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.7205,
      36.6192
    ],
    "magnitude": 4.5,
    "depth": 36.721,
    "time": "2023-02-06 01:51:19 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٨ كم جنوب شرق A?a?? Karafak?l?، تركيا على عمق 36.721 كم بتاريخ 2023-02-06 01:51:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr6"
  },
  "243": {
    "place": "١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا",
    "latLng": [
      36.6696,
      36.4767
    ],
    "magnitude": 4.7,
    "depth": 36.67,
    "time": "2023-02-06 01:40:48 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ١٤ كم جنوب جنوب غرب A?a?? Karafak?l?، تركيا على عمق 36.67 كم بتاريخ 2023-02-06 01:40:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr5"
  },
  "244": {
    "place": "تركيا-سوريا حدود منطقة",
    "latLng": [
      36.9921,
      36.6832
    ],
    "magnitude": 5.6,
    "depth": 36.992,
    "time": "2023-02-06 01:36:27 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 5.6 درجة في تركيا-سوريا border region على عمق 36.992 كم بتاريخ 2023-02-06 01:36:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlm9#pager"
  },
  "245": {
    "place": "٢٦ كم شمال Latakia، سوريا",
    "latLng": [
      35.7692,
      35.7431
    ],
    "magnitude": 4.3,
    "depth": 35.769,
    "time": "2023-01-29 16:12:38 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ٢٦ كم شمال Latakia، سوريا على عمق 35.769 كم بتاريخ 2023-01-29 16:12:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jk69#dyfi"
  },
  "246": {
    "place": "٢٩ كم جنوب شرق Mandal?، العراق",
    "latLng": [
      33.5843,
      45.8112
    ],
    "magnitude": 4.6,
    "depth": 33.584,
    "time": "2023-01-28 13:53:09 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ٢٩ كم جنوب شرق Mandal?، العراق على عمق 33.584 كم بتاريخ 2023-01-28 13:53:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjzp"
  },
  "247": {
    "place": "١٢ كم شرق شمال شرق Tallkalakh، سوريا",
    "latLng": [
      34.7103,
      36.3823
    ],
    "magnitude": 4.3,
    "depth": 34.71,
    "time": "2023-01-21 13:31:57 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.3 درجة في ١٢ كم شرق شمال شرق Tallkalakh، سوريا على عمق 34.71 كم بتاريخ 2023-01-21 13:31:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j62n#dyfi"
  },
  "248": {
    "place": "٤ كم شمال شمال غرب Erzin، تركيا",
    "latLng": [
      36.9911,
      36.1694
    ],
    "magnitude": 4.1,
    "depth": 36.991,
    "time": "2023-01-18 13:30:47 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٤ كم شمال شمال غرب Erzin، تركيا على عمق 36.991 كم بتاريخ 2023-01-18 13:30:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjfc"
  },
  "249": {
    "place": "٦ كم شمال شمال شرق Kh?n Shaykh?n، سوريا",
    "latLng": [
      35.5003,
      36.6702
    ],
    "magnitude": 4.4,
    "depth": 35.5,
    "time": "2023-01-12 20:40:48 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ٦ كم شمال شمال شرق Kh?n Shaykh?n، سوريا على عمق 35.5 كم بتاريخ 2023-01-12 20:40:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j400"
  },
  "250": {
    "place": "٩٣ كم جنوب جنوب غرب فرسان، السعودية",
    "latLng": [
      15.9298,
      41.7705
    ],
    "magnitude": 4.9,
    "depth": 15.93,
    "time": "2023-01-09 21:28:09 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.9 درجة في ٩٣ كم جنوب جنوب غرب فرسان، السعودية على عمق 15.93 كم بتاريخ 2023-01-09 21:28:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j3a6"
  },
  "251": {
    "place": "٩٠ كم جنوب جنوب غرب فرسان، السعودية",
    "latLng": [
      15.9878,
      41.6999
    ],
    "magnitude": 4.7,
    "depth": 15.988,
    "time": "2023-01-09 17:31:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٩٠ كم جنوب جنوب غرب فرسان، السعودية على عمق 15.988 كم بتاريخ 2023-01-09 17:31:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j36e"
  },
  "252": {
    "place": "٢١٨ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.266,
      51.7999
    ],
    "magnitude": 4.4,
    "depth": 14.266,
    "time": "2023-01-06 17:14:23 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.4 درجة في ٢١٨ كم جنوب Al Ghayz?ah، اليمن على عمق 14.266 كم بتاريخ 2023-01-06 17:14:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j4w6"
  },
  "253": {
    "place": "٦٤ كم شمال شرق ?d?grat، إثيوبيا",
    "latLng": [
      14.6191,
      39.9519
    ],
    "magnitude": 5.1,
    "depth": 14.619,
    "time": "2022-12-28 16:14:56 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.1 درجة في ٦٤ كم شمال شرق ?d?grat، إثيوبيا على عمق 14.619 كم بتاريخ 2022-12-28 16:14:56 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0n0"
  },
  "254": {
    "place": "٥٧ كم شرق جنوب شرق Adi Keyh، إريتريا",
    "latLng": [
      14.6695,
      39.8764
    ],
    "magnitude": 4.4,
    "depth": 14.67,
    "time": "2022-12-28 14:35:17 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٥٧ كم شرق جنوب شرق Adi Keyh، إريتريا على عمق 14.67 كم بتاريخ 2022-12-28 14:35:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0mq"
  },
  "255": {
    "place": "٦١ كم شمال شرق ?d?grat، إثيوبيا",
    "latLng": [
      14.6133,
      39.9196
    ],
    "magnitude": 4.4,
    "depth": 14.613,
    "time": "2022-12-28 14:02:25 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٦١ كم شمال شرق ?d?grat، إثيوبيا على عمق 14.613 كم بتاريخ 2022-12-28 14:02:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0mg"
  },
  "256": {
    "place": "إريتريا-إثيوبيا حدود منطقة",
    "latLng": [
      14.5572,
      39.8087
    ],
    "magnitude": 4.3,
    "depth": 14.557,
    "time": "2022-12-28 02:00:00 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في إريتريا-إثيوبيا border region على عمق 14.557 كم بتاريخ 2022-12-28 02:00:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j3f1"
  },
  "257": {
    "place": "٣١ كم شرق شمال شرق ?d?grat، إثيوبيا",
    "latLng": [
      14.3833,
      39.7343
    ],
    "magnitude": 4.4,
    "depth": 14.383,
    "time": "2022-12-26 16:27:13 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٣١ كم شرق شمال شرق ?d?grat، إثيوبيا على عمق 14.383 كم بتاريخ 2022-12-26 16:27:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbtc"
  },
  "258": {
    "place": "٥٣ كم شرق شمال شرق ?d?grat، إثيوبيا",
    "latLng": [
      14.5316,
      39.8811
    ],
    "magnitude": 4.3,
    "depth": 14.532,
    "time": "2022-12-26 14:09:52 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٥٣ كم شرق شمال شرق ?d?grat، إثيوبيا على عمق 14.532 كم بتاريخ 2022-12-26 14:09:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j2l0"
  },
  "259": {
    "place": "٦٦ كم شرق شمال شرق ?d?grat، إثيوبيا",
    "latLng": [
      14.5212,
      40.0211
    ],
    "magnitude": 5.5,
    "depth": 14.521,
    "time": "2022-12-26 12:21:07 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.5 درجة في ٦٦ كم شرق شمال شرق ?d?grat، إثيوبيا على عمق 14.521 كم بتاريخ 2022-12-26 12:21:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbsk#pager"
  },
  "260": {
    "place": "٧ كم شمال شرق Uzunkavak، تركيا",
    "latLng": [
      36.392,
      36.4912
    ],
    "magnitude": 4.6,
    "depth": 36.392,
    "time": "2022-12-18 18:13:09 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٧ كم شمال شرق Uzunkavak، تركيا على عمق 36.392 كم بتاريخ 2022-12-18 18:13:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ja6e#dyfi"
  },
  "261": {
    "place": "٢٤٤ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.7053,
      54.8516
    ],
    "magnitude": 4.3,
    "depth": 14.705,
    "time": "2022-12-02 23:58:27 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٤٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.705 كم بتاريخ 2022-12-02 23:58:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j7md"
  },
  "262": {
    "place": "٥٧ كم شرق جنوب شرق Adi Keyh، إريتريا",
    "latLng": [
      14.6283,
      39.8617
    ],
    "magnitude": 4.2,
    "depth": 14.628,
    "time": "2022-10-31 00:28:23 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٥٧ كم شرق جنوب شرق Adi Keyh، إريتريا على عمق 14.628 كم بتاريخ 2022-10-31 00:28:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000imhh"
  },
  "263": {
    "place": "٥٥ كم غرب Al ?udaydah، اليمن",
    "latLng": [
      14.8239,
      42.4381
    ],
    "magnitude": 4.4,
    "depth": 14.824,
    "time": "2022-10-16 23:08:00 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٥٥ كم غرب Al ?udaydah، اليمن على عمق 14.824 كم بتاريخ 2022-10-16 23:08:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iu72"
  },
  "264": {
    "place": "بالقرب من ساحل عمان",
    "latLng": [
      21.1335,
      59.5307
    ],
    "magnitude": 4.6,
    "depth": 21.134,
    "time": "2022-09-19 04:26:52 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في Near the coast of عمان على عمق 21.134 كم بتاريخ 2022-09-19 04:26:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i978"
  },
  "265": {
    "place": "٢٠١ كم شمال Qalans?yah، اليمن",
    "latLng": [
      14.5098,
      53.6239
    ],
    "magnitude": 4.8,
    "depth": 14.51,
    "time": "2022-09-16 12:33:09 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.8 درجة في ٢٠١ كم شمال Qalans?yah، اليمن على عمق 14.51 كم بتاريخ 2022-09-16 12:33:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i8id"
  },
  "266": {
    "place": "٢٧٦ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.4879,
      55.7462
    ],
    "magnitude": 4.5,
    "depth": 14.488,
    "time": "2022-09-15 22:01:19 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٧٦ كم شمال شرق Hadibu، اليمن على عمق 14.488 كم بتاريخ 2022-09-15 22:01:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ia5t"
  },
  "267": {
    "place": "١٤٩ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.8564,
      52.2515
    ],
    "magnitude": 4.3,
    "depth": 14.856,
    "time": "2022-08-31 15:11:09 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ١٤٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.856 كم بتاريخ 2022-08-31 15:11:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ii68"
  },
  "268": {
    "place": "٢٨٩ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.5371,
      55.8746
    ],
    "magnitude": 4.5,
    "depth": 14.537,
    "time": "2022-08-30 10:57:02 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٨٩ كم شمال شرق Hadibu، اليمن على عمق 14.537 كم بتاريخ 2022-08-30 10:57:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3n5"
  },
  "269": {
    "place": "١٧٣ كم شمال شمال غرب Qalans?yah، اليمن",
    "latLng": [
      14.1882,
      52.9998
    ],
    "magnitude": 4.3,
    "depth": 14.188,
    "time": "2022-08-15 07:01:45 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ١٧٣ كم شمال شمال غرب Qalans?yah، اليمن على عمق 14.188 كم بتاريخ 2022-08-15 07:01:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i228"
  },
  "270": {
    "place": "١٧٩ كم شمال شمال غرب Qalans?yah، اليمن",
    "latLng": [
      14.2366,
      52.9845
    ],
    "magnitude": 4.5,
    "depth": 14.237,
    "time": "2022-08-15 06:58:35 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ١٧٩ كم شمال شمال غرب Qalans?yah، اليمن على عمق 14.237 كم بتاريخ 2022-08-15 06:58:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iay1"
  },
  "271": {
    "place": "١٤ كم جنوب جنوب شرق Baynjiwayn، العراق",
    "latLng": [
      35.4958,
      45.9901
    ],
    "magnitude": 4.2,
    "depth": 35.496,
    "time": "2022-08-12 08:54:49 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ١٤ كم جنوب جنوب شرق Baynjiwayn، العراق على عمق 35.496 كم بتاريخ 2022-08-12 08:54:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ia6d#dyfi"
  },
  "272": {
    "place": "٣٨ كم شمال شمال شرق Mandal?، العراق",
    "latLng": [
      34.0557,
      45.7388
    ],
    "magnitude": 4.1,
    "depth": 34.056,
    "time": "2022-08-02 17:10:55 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.1 درجة في ٣٨ كم شمال شمال شرق Mandal?، العراق على عمق 34.056 كم بتاريخ 2022-08-02 17:10:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7ie"
  },
  "273": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7415,
      58.0138
    ],
    "magnitude": 4.5,
    "depth": 14.742,
    "time": "2022-07-28 09:12:15 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.742 كم بتاريخ 2022-07-28 09:12:15 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i64d"
  },
  "274": {
    "place": "منطقة صدع أوين",
    "latLng": [
      15.1251,
      59.4649
    ],
    "magnitude": 5.0,
    "depth": 15.125,
    "time": "2022-07-26 09:34:04 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.0 درجة في منطقة صدع أوين على عمق 15.125 كم بتاريخ 2022-07-26 09:34:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hti9"
  },
  "275": {
    "place": "٤١ كم شرق Kifr?، العراق",
    "latLng": [
      34.6372,
      45.4058
    ],
    "magnitude": 4.3,
    "depth": 34.637,
    "time": "2022-07-18 08:04:51 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٤١ كم شرق Kifr?، العراق على عمق 34.637 كم بتاريخ 2022-07-18 08:04:51 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i3dq"
  },
  "276": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.6327,
      57.1097
    ],
    "magnitude": 4.3,
    "depth": 13.633,
    "time": "2022-07-02 00:34:43 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 13.633 كم بتاريخ 2022-07-02 00:34:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0jr"
  },
  "277": {
    "place": "٢٥ كم جنوب جنوب شرق Khasab، عمان",
    "latLng": [
      25.9617,
      56.3116
    ],
    "magnitude": 4.3,
    "depth": 25.962,
    "time": "2022-07-01 21:41:57 UTC",
    "region": "الإمارات",
    "info": "زلزال بقوة 4.3 درجة في ٢٥ كم جنوب جنوب شرق Khasab، عمان على عمق 25.962 كم بتاريخ 2022-07-01 21:41:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0ap#dyfi"
  },
  "278": {
    "place": "٢٠٣ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.9575,
      51.7317
    ],
    "magnitude": 4.6,
    "depth": 13.958,
    "time": "2022-06-23 05:22:03 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.6 درجة في ٢٠٣ كم شمال شمال غرب Kilmia، اليمن على عمق 13.958 كم بتاريخ 2022-06-23 05:22:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hji1"
  },
  "279": {
    "place": "٢١٦ كم جنوب شرق Al Ghayz?ah، اليمن",
    "latLng": [
      14.9738,
      53.7377
    ],
    "magnitude": 4.6,
    "depth": 14.974,
    "time": "2022-06-14 02:38:40 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ٢١٦ كم جنوب شرق Al Ghayz?ah، اليمن على عمق 14.974 كم بتاريخ 2022-06-14 02:38:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hh7y"
  },
  "280": {
    "place": "٥٢ كم شرق شمال شرق Adi Keyh، إريتريا",
    "latLng": [
      14.9667,
      39.8442
    ],
    "magnitude": 4.6,
    "depth": 14.967,
    "time": "2022-06-05 12:38:09 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٥٢ كم شرق شمال شرق Adi Keyh، إريتريا على عمق 14.967 كم بتاريخ 2022-06-05 12:38:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hf59"
  },
  "281": {
    "place": "٢١ كم جنوب جنوب غرب Al A?mad?، الكويت",
    "latLng": [
      28.9103,
      47.972
    ],
    "magnitude": 4.4,
    "depth": 28.91,
    "time": "2022-06-04 01:28:03 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.4 درجة في ٢١ كم جنوب جنوب غرب Al A?mad?، الكويت على عمق 28.91 كم بتاريخ 2022-06-04 01:28:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hets#dyfi"
  },
  "282": {
    "place": "٢١٦ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.262,
      51.9336
    ],
    "magnitude": 4.5,
    "depth": 14.262,
    "time": "2022-04-22 14:18:36 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.5 درجة في ٢١٦ كم جنوب Al Ghayz?ah، اليمن على عمق 14.262 كم بتاريخ 2022-04-22 14:18:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6j7"
  },
  "283": {
    "place": "١٩٩ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.4247,
      51.8718
    ],
    "magnitude": 4.3,
    "depth": 14.425,
    "time": "2022-04-22 13:38:22 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.3 درجة في ١٩٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.425 كم بتاريخ 2022-04-22 13:38:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6j6"
  },
  "284": {
    "place": "١٥٩ كم شمال شمال غرب كالولا، الصومال",
    "latLng": [
      13.3524,
      50.354
    ],
    "magnitude": 4.3,
    "depth": 13.352,
    "time": "2022-04-06 23:21:40 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.3 درجة في ١٥٩ كم شمال شمال غرب كالولا، الصومال على عمق 13.352 كم بتاريخ 2022-04-06 23:21:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h1sh"
  },
  "285": {
    "place": "٤٨ كم جنوب جنوب غرب Jiwani، باكستان",
    "latLng": [
      24.66,
      61.5204
    ],
    "magnitude": 4.1,
    "depth": 24.66,
    "time": "2022-03-25 10:51:33 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في ٤٨ كم جنوب جنوب غرب Jiwani، Pakistan على عمق 24.66 كم بتاريخ 2022-03-25 10:51:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gyhc"
  },
  "286": {
    "place": "١٢٨ كم جنوب غرب Jeddah، السعودية",
    "latLng": [
      20.777,
      38.2049
    ],
    "magnitude": 4.3,
    "depth": 20.777,
    "time": "2022-03-18 17:37:49 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٢٨ كم جنوب غرب Jeddah، السعودية على عمق 20.777 كم بتاريخ 2022-03-18 17:37:49 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gwp0"
  },
  "287": {
    "place": "٣٩ كم شرق جنوب شرق Kifr?، العراق",
    "latLng": [
      34.5734,
      45.3696
    ],
    "magnitude": 4.2,
    "depth": 34.573,
    "time": "2022-03-13 05:04:27 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٣٩ كم شرق جنوب شرق Kifr?، العراق على عمق 34.573 كم بتاريخ 2022-03-13 05:04:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h5g3"
  },
  "288": {
    "place": "٢٣١ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.6095,
      54.7571
    ],
    "magnitude": 4.7,
    "depth": 14.61,
    "time": "2022-02-22 23:16:08 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٣١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.61 كم بتاريخ 2022-02-22 23:16:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gn2w"
  },
  "289": {
    "place": "٣٢ كم شمال شرق Al K?t، العراق",
    "latLng": [
      32.6877,
      46.1011
    ],
    "magnitude": 4.3,
    "depth": 32.688,
    "time": "2022-02-20 12:45:27 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٢ كم شمال شرق Al K?t، العراق على عمق 32.688 كم بتاريخ 2022-02-20 12:45:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gmf6"
  },
  "290": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.3229,
      56.6603
    ],
    "magnitude": 4.3,
    "depth": 14.323,
    "time": "2022-02-08 15:12:25 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.323 كم بتاريخ 2022-02-08 15:12:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gk23"
  },
  "291": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2747,
      56.3762
    ],
    "magnitude": 4.4,
    "depth": 14.275,
    "time": "2022-01-31 13:45:31 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.275 كم بتاريخ 2022-01-31 13:45:31 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gi0d"
  },
  "292": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4513,
      56.3826
    ],
    "magnitude": 5.2,
    "depth": 14.451,
    "time": "2022-01-31 12:42:18 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.2 درجة في منطقة صدع أوين على عمق 14.451 كم بتاريخ 2022-01-31 12:42:18 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gglq"
  },
  "293": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4413,
      56.3354
    ],
    "magnitude": 5.4,
    "depth": 14.441,
    "time": "2022-01-31 12:38:15 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.4 درجة في منطقة صدع أوين على عمق 14.441 كم بتاريخ 2022-01-31 12:38:15 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gglp#pager"
  },
  "294": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.3531,
      56.2208
    ],
    "magnitude": 4.4,
    "depth": 14.353,
    "time": "2022-01-31 12:14:39 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.353 كم بتاريخ 2022-01-31 12:14:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ghzz"
  },
  "295": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4867,
      56.401
    ],
    "magnitude": 5.3,
    "depth": 14.487,
    "time": "2022-01-31 11:56:36 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.3 درجة في منطقة صدع أوين على عمق 14.487 كم بتاريخ 2022-01-31 11:56:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ggl9"
  },
  "296": {
    "place": "٤ كم شرق شمال شرق Kafr Mi?r، إسرائيل",
    "latLng": [
      32.6567,
      35.4637
    ],
    "magnitude": 3.7,
    "depth": 32.657,
    "time": "2022-01-23 10:28:07 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.7 درجة في ٤ كم شرق شمال شرق Kafr Mi?r، Israel على عمق 32.657 كم بتاريخ 2022-01-23 10:28:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gefv#dyfi"
  },
  "297": {
    "place": "٤ كم شرق Taiyiba، إسرائيل",
    "latLng": [
      32.6069,
      35.494
    ],
    "magnitude": 4.1,
    "depth": 32.607,
    "time": "2022-01-22 21:36:54 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ٤ كم شرق Taiyiba، Israel على عمق 32.607 كم بتاريخ 2022-01-22 21:36:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000geaf#dyfi"
  },
  "298": {
    "place": "١٤٠ كم جنوب جنوب شرق Mukalla، اليمن",
    "latLng": [
      13.3464,
      49.5623
    ],
    "magnitude": 4.0,
    "depth": 13.346,
    "time": "2022-01-20 15:23:34 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.0 درجة في ١٤٠ كم جنوب جنوب شرق Mukalla، اليمن على عمق 13.346 كم بتاريخ 2022-01-20 15:23:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gfus"
  },
  "299": {
    "place": "١٠ كم جنوب شرق جمجمال، العراق",
    "latLng": [
      35.4789,
      44.9228
    ],
    "magnitude": 4.6,
    "depth": 35.479,
    "time": "2022-01-10 20:11:16 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ١٠ كم جنوب شرق Jamjam?l، العراق على عمق 35.479 كم بتاريخ 2022-01-10 20:11:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd7k"
  },
  "300": {
    "place": "٨ كم شرق جمجمال، العراق",
    "latLng": [
      35.5272,
      44.9269
    ],
    "magnitude": 4.5,
    "depth": 35.527,
    "time": "2022-01-10 18:29:47 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٨ كم شرق Jamjam?l، العراق على عمق 35.527 كم بتاريخ 2022-01-10 18:29:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gamy#dyfi"
  },
  "301": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.9615,
      57.1801
    ],
    "magnitude": 4.2,
    "depth": 13.962,
    "time": "2021-12-29 03:15:14 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 13.962 كم بتاريخ 2021-12-29 03:15:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gfzz"
  },
  "302": {
    "place": "١٤٩ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.858,
      52.1551
    ],
    "magnitude": 5.3,
    "depth": 14.858,
    "time": "2021-12-24 10:57:42 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.3 درجة في ١٤٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.858 كم بتاريخ 2021-12-24 10:57:42 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gf1c#dyfi"
  },
  "303": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.6618,
      57.394
    ],
    "magnitude": 4.1,
    "depth": 13.662,
    "time": "2021-12-04 09:47:55 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في منطقة صدع أوين على عمق 13.662 كم بتاريخ 2021-12-04 09:47:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gajw"
  },
  "304": {
    "place": "٢٤٤ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.7711,
      54.6492
    ],
    "magnitude": 4.2,
    "depth": 14.771,
    "time": "2021-11-26 12:41:54 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في ٢٤٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.771 كم بتاريخ 2021-11-26 12:41:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g885"
  },
  "305": {
    "place": "١٤٨ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.8819,
      52.3669
    ],
    "magnitude": 4.5,
    "depth": 14.882,
    "time": "2021-11-25 01:36:52 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ١٤٨ كم جنوب Al Ghayz?ah، اليمن على عمق 14.882 كم بتاريخ 2021-11-25 01:36:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fwxc"
  },
  "306": {
    "place": "١٦٢ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.7391,
      52.271
    ],
    "magnitude": 4.6,
    "depth": 14.739,
    "time": "2021-11-25 01:25:10 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ١٦٢ كم جنوب Al Ghayz?ah، اليمن على عمق 14.739 كم بتاريخ 2021-11-25 01:25:10 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fwx3"
  },
  "307": {
    "place": "قبالة سواحل باكستان",
    "latLng": [
      24.6025,
      62.3405
    ],
    "magnitude": 4.3,
    "depth": 24.603,
    "time": "2021-11-12 03:39:54 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في off the coast of Pakistan على عمق 24.603 كم بتاريخ 2021-11-12 03:39:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fuuj"
  },
  "308": {
    "place": "٨٧ كم جنوب Mukalla، اليمن",
    "latLng": [
      13.7512,
      49.1688
    ],
    "magnitude": 4.5,
    "depth": 13.751,
    "time": "2021-11-02 00:35:40 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.5 درجة في ٨٧ كم جنوب Mukalla، اليمن على عمق 13.751 كم بتاريخ 2021-11-02 00:35:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fqns"
  },
  "309": {
    "place": "٢٣٢ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.5774,
      54.8761
    ],
    "magnitude": 4.5,
    "depth": 14.577,
    "time": "2021-10-29 10:10:23 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٣٢ كم شمال شمال شرق Hadibu، اليمن على عمق 14.577 كم بتاريخ 2021-10-29 10:10:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr6c"
  },
  "310": {
    "place": "٢٥١ كم جنوب جنوب شرق ?al?lah، عمان",
    "latLng": [
      14.8891,
      54.9113
    ],
    "magnitude": 4.6,
    "depth": 14.889,
    "time": "2021-10-29 10:06:24 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ٢٥١ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.889 كم بتاريخ 2021-10-29 10:06:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fpq4#dyfi"
  },
  "311": {
    "place": "٢٥٩ كم جنوب جنوب شرق ?al?lah، عمان",
    "latLng": [
      14.8206,
      54.9557
    ],
    "magnitude": 4.3,
    "depth": 14.821,
    "time": "2021-10-29 08:35:35 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٥٩ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.821 كم بتاريخ 2021-10-29 08:35:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr69"
  },
  "312": {
    "place": "٢٥٥ كم جنوب جنوب شرق ?al?lah، عمان",
    "latLng": [
      14.8386,
      54.8819
    ],
    "magnitude": 4.3,
    "depth": 14.839,
    "time": "2021-10-29 07:38:55 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٥٥ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.839 كم بتاريخ 2021-10-29 07:38:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr65"
  },
  "313": {
    "place": "٢٤٥ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.6431,
      55.0195
    ],
    "magnitude": 4.6,
    "depth": 14.643,
    "time": "2021-10-29 06:12:42 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ٢٤٥ كم شمال شمال شرق Hadibu، اليمن على عمق 14.643 كم بتاريخ 2021-10-29 06:12:42 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fpqz"
  },
  "314": {
    "place": "٢٣٥ كم شمال شمال شرق Hadibu، اليمن",
    "latLng": [
      14.616,
      54.8586
    ],
    "magnitude": 4.1,
    "depth": 14.616,
    "time": "2021-10-29 01:06:33 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في ٢٣٥ كم شمال شمال شرق Hadibu، اليمن على عمق 14.616 كم بتاريخ 2021-10-29 01:06:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr5y"
  },
  "315": {
    "place": "٤١ كم شمال شمال شرق مصوع، إريتريا",
    "latLng": [
      15.9647,
      39.6016
    ],
    "magnitude": 4.3,
    "depth": 15.965,
    "time": "2021-10-23 14:20:24 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٤١ كم شمال شمال شرق مصوع، إريتريا على عمق 15.965 كم بتاريخ 2021-10-23 14:20:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fph3#dyfi"
  },
  "316": {
    "place": "٢٩٤ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.3425,
      56.1171
    ],
    "magnitude": 4.4,
    "depth": 14.343,
    "time": "2021-10-21 23:05:34 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ٢٩٤ كم شمال شرق Hadibu، اليمن على عمق 14.343 كم بتاريخ 2021-10-21 23:05:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fp8j"
  },
  "317": {
    "place": "١٦٦ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.6989,
      52.2011
    ],
    "magnitude": 4.4,
    "depth": 14.699,
    "time": "2021-10-07 18:21:34 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٦٦ كم جنوب Al Ghayz?ah، اليمن على عمق 14.699 كم بتاريخ 2021-10-07 18:21:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fu15"
  },
  "318": {
    "place": "٤١ كم شرق جنوب شرق Kifr?، العراق",
    "latLng": [
      34.5294,
      45.3747
    ],
    "magnitude": 4.3,
    "depth": 34.529,
    "time": "2021-09-28 11:46:12 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٤١ كم شرق جنوب شرق Kifr?، العراق على عمق 34.529 كم بتاريخ 2021-09-28 11:46:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqtc"
  },
  "319": {
    "place": "٥١ كم جنوب Çiftlikköyü، تركيا",
    "latLng": [
      36.7164,
      42.4005
    ],
    "magnitude": 4.4,
    "depth": 36.716,
    "time": "2021-09-24 23:43:12 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.4 درجة في ٥١ كم جنوب Çiftlikköyü، تركيا على عمق 36.716 كم بتاريخ 2021-09-24 23:43:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fe95#dyfi"
  },
  "320": {
    "place": "٢٦ كم غرب شمال غرب Toygarl?، تركيا",
    "latLng": [
      36.2823,
      35.7899
    ],
    "magnitude": 4.0,
    "depth": 36.282,
    "time": "2021-09-09 01:42:40 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ٢٦ كم غرب شمال غرب Toygarl?، تركيا على عمق 36.282 كم بتاريخ 2021-09-09 01:42:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9iu"
  },
  "321": {
    "place": "٣٥ كم شرق Kifr?، العراق",
    "latLng": [
      34.6514,
      45.35
    ],
    "magnitude": 4.5,
    "depth": 34.651,
    "time": "2021-09-08 15:43:01 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٣٥ كم شرق Kifr?، العراق على عمق 34.651 كم بتاريخ 2021-09-08 15:43:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9ah"
  },
  "322": {
    "place": "١٥٢ كم شمال كالولا، الصومال",
    "latLng": [
      13.3447,
      50.7099
    ],
    "magnitude": 4.2,
    "depth": 13.345,
    "time": "2021-09-03 07:46:27 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.2 درجة في ١٥٢ كم شمال كالولا، الصومال على عمق 13.345 كم بتاريخ 2021-09-03 07:46:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9ym"
  },
  "323": {
    "place": "١٣٤ كم شرق جنوب شرق Al Ghayz?ah، اليمن",
    "latLng": [
      15.8446,
      53.3708
    ],
    "magnitude": 4.6,
    "depth": 15.845,
    "time": "2021-09-01 02:52:28 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ١٣٤ كم شرق جنوب شرق Al Ghayz?ah، اليمن على عمق 15.845 كم بتاريخ 2021-09-01 02:52:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9pe"
  },
  "324": {
    "place": "٣٤ كم جنوب جنوب غرب Al Jahr?’، الكويت",
    "latLng": [
      29.0413,
      47.5342
    ],
    "magnitude": 4.3,
    "depth": 29.041,
    "time": "2021-08-02 08:31:37 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.3 درجة في ٣٤ كم جنوب جنوب غرب Al Jahr?’، الكويت على عمق 29.041 كم بتاريخ 2021-08-02 08:31:37 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f1m7#dyfi"
  },
  "325": {
    "place": "٤٥ كم جنوب شرق Kifr?، العراق",
    "latLng": [
      34.4176,
      45.3329
    ],
    "magnitude": 4.3,
    "depth": 34.418,
    "time": "2021-07-31 23:41:21 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٤٥ كم جنوب شرق Kifr?، العراق على عمق 34.418 كم بتاريخ 2021-07-31 23:41:21 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f2u7"
  },
  "326": {
    "place": "٧٣ كم غرب جنوب غرب Al May?d?n، سوريا",
    "latLng": [
      34.7738,
      39.6992
    ],
    "magnitude": 4.4,
    "depth": 34.774,
    "time": "2021-07-18 22:09:22 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.4 درجة في ٧٣ كم غرب جنوب غرب Al May?d?n، سوريا على عمق 34.774 كم بتاريخ 2021-07-18 22:09:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000en9w#dyfi"
  },
  "327": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2759,
      56.7423
    ],
    "magnitude": 5.1,
    "depth": 14.276,
    "time": "2021-07-03 17:12:22 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.1 درجة في منطقة صدع أوين على عمق 14.276 كم بتاريخ 2021-07-03 17:12:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000eihi"
  },
  "328": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2788,
      56.7673
    ],
    "magnitude": 5.6,
    "depth": 14.279,
    "time": "2021-07-03 17:04:27 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.6 درجة في منطقة صدع أوين على عمق 14.279 كم بتاريخ 2021-07-03 17:04:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000eihg#pager"
  },
  "329": {
    "place": "٤٠ كم غرب A? ?ayyibah، الأردن",
    "latLng": [
      30.2013,
      35.0504
    ],
    "magnitude": 4.1,
    "depth": 30.201,
    "time": "2021-06-15 23:08:52 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.1 درجة في ٤٠ كم غرب A? ?ayyibah، Jordan على عمق 30.201 كم بتاريخ 2021-06-15 23:08:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000eddk#dyfi"
  },
  "330": {
    "place": "٢١٣ كم جنوب شرق Al Ghayz?ah، اليمن",
    "latLng": [
      14.7588,
      53.4841
    ],
    "magnitude": 4.5,
    "depth": 14.759,
    "time": "2021-05-15 03:40:55 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢١٣ كم جنوب شرق Al Ghayz?ah، اليمن على عمق 14.759 كم بتاريخ 2021-05-15 03:40:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000e3b0"
  },
  "331": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.7703,
      57.1131
    ],
    "magnitude": 5.6,
    "depth": 13.77,
    "time": "2021-04-24 18:00:32 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.6 درجة في منطقة صدع أوين على عمق 13.77 كم بتاريخ 2021-04-24 18:00:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000e4f6#pager"
  },
  "332": {
    "place": "جنوب إيران",
    "latLng": [
      29.5902,
      50.4934
    ],
    "magnitude": 4.0,
    "depth": 29.59,
    "time": "2021-04-21 21:39:16 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.0 درجة في southern إيران على عمق 29.59 كم بتاريخ 2021-04-21 21:39:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000dxx9"
  },
  "333": {
    "place": "٦ كم شمال شرق Baynjiwayn، العراق",
    "latLng": [
      35.6618,
      45.9925
    ],
    "magnitude": 5.2,
    "depth": 35.662,
    "time": "2021-04-06 15:12:25 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 5.2 درجة في ٦ كم شمال شرق Baynjiwayn، العراق على عمق 35.662 كم بتاريخ 2021-04-06 15:12:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000dzgg#dyfi"
  },
  "334": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4958,
      56.2393
    ],
    "magnitude": 4.2,
    "depth": 14.496,
    "time": "2021-03-31 19:28:41 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 14.496 كم بتاريخ 2021-03-31 19:28:41 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000e01d"
  },
  "335": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4222,
      56.2341
    ],
    "magnitude": 4.7,
    "depth": 14.422,
    "time": "2021-03-31 19:19:00 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.422 كم بتاريخ 2021-03-31 19:19:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000e01e"
  },
  "336": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4988,
      56.2582
    ],
    "magnitude": 5.1,
    "depth": 14.499,
    "time": "2021-03-31 19:16:22 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.1 درجة في منطقة صدع أوين على عمق 14.499 كم بتاريخ 2021-03-31 19:16:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000dy0t"
  },
  "337": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.5233,
      57.0518
    ],
    "magnitude": 4.5,
    "depth": 13.523,
    "time": "2021-03-29 00:16:27 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 13.523 كم بتاريخ 2021-03-29 00:16:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000dzmv"
  },
  "338": {
    "place": "٣٤ كم شرق Kifr?، العراق",
    "latLng": [
      34.717,
      45.3393
    ],
    "magnitude": 4.8,
    "depth": 34.717,
    "time": "2021-02-11 22:10:35 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.8 درجة في ٣٤ كم شرق Kifr?، العراق على عمق 34.717 كم بتاريخ 2021-02-11 22:10:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000dgta#dyfi"
  },
  "339": {
    "place": "٤٦ كم جنوب شرق Al ?asakah، سوريا",
    "latLng": [
      36.172,
      41.062
    ],
    "magnitude": 4.9,
    "depth": 36.172,
    "time": "2021-01-26 11:17:40 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.9 درجة في ٤٦ كم جنوب شرق Al ?asakah، سوريا على عمق 36.172 كم بتاريخ 2021-01-26 11:17:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000d3ec#dyfi"
  },
  "340": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.5873,
      56.2762
    ],
    "magnitude": 4.5,
    "depth": 14.587,
    "time": "2021-01-02 18:45:28 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.587 كم بتاريخ 2021-01-02 18:45:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000d7sn"
  },
  "341": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.2272,
      56.78
    ],
    "magnitude": 5.4,
    "depth": 14.227,
    "time": "2020-12-28 05:46:46 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.4 درجة في منطقة صدع أوين على عمق 14.227 كم بتاريخ 2020-12-28 05:46:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000d3kx#pager"
  },
  "342": {
    "place": "٨٨ كم شمال شمال غرب Ak’ordat، إريتريا",
    "latLng": [
      16.2615,
      37.5082
    ],
    "magnitude": 4.4,
    "depth": 16.262,
    "time": "2020-12-24 22:22:45 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٨٨ كم شمال شمال غرب Ak’ordat، إريتريا على عمق 16.262 كم بتاريخ 2020-12-24 22:22:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000d2qn"
  },
  "343": {
    "place": "٤٢ كم جنوب جنوب غرب Al Jahr?’، الكويت",
    "latLng": [
      28.9624,
      47.5725
    ],
    "magnitude": 4.3,
    "depth": 28.962,
    "time": "2020-12-21 03:04:48 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.3 درجة في ٤٢ كم جنوب جنوب غرب Al Jahr?’، الكويت على عمق 28.962 كم بتاريخ 2020-12-21 03:04:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cstn#dyfi"
  },
  "344": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.332,
      56.2108
    ],
    "magnitude": 4.3,
    "depth": 14.332,
    "time": "2020-12-17 21:09:58 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.332 كم بتاريخ 2020-12-17 21:09:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000d1vc"
  },
  "345": {
    "place": "١ كم شمال شمال شرق إيلات، إسرائيل",
    "latLng": [
      29.5749,
      34.9527
    ],
    "magnitude": 3.9,
    "depth": 29.575,
    "time": "2020-12-15 02:30:09 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 3.9 درجة في ١ كم شمال شمال شرق Eilat، Israel على عمق 29.575 كم بتاريخ 2020-12-15 02:30:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cr5v#dyfi"
  },
  "346": {
    "place": "٦ كم غرب Ç?rt?man، تركيا",
    "latLng": [
      36.5155,
      36.1143
    ],
    "magnitude": 3.4,
    "depth": 36.516,
    "time": "2020-12-09 19:22:16 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.4 درجة في ٦ كم غرب Ç?rt?man، تركيا على عمق 36.516 كم بتاريخ 2020-12-09 19:22:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cpl4"
  },
  "347": {
    "place": "١٦ كم شرق جنوب شرق ??r?n، سوريا",
    "latLng": [
      35.223,
      36.9085
    ],
    "magnitude": 4.4,
    "depth": 35.223,
    "time": "2020-11-30 13:47:05 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.4 درجة في ١٦ كم شرق جنوب شرق ??r?n، سوريا على عمق 35.223 كم بتاريخ 2020-11-30 13:47:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cl5n#dyfi"
  },
  "348": {
    "place": "٢٠٦ كم جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      18.0694,
      40.2924
    ],
    "magnitude": 4.1,
    "depth": 18.069,
    "time": "2020-11-28 05:12:45 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ٢٠٦ كم جنوب غرب Al Maj?ridah، السعودية على عمق 18.069 كم بتاريخ 2020-11-28 05:12:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cm5a"
  },
  "349": {
    "place": "٢٢٩ كم غرب جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      18.0499,
      40.0478
    ],
    "magnitude": 4.5,
    "depth": 18.05,
    "time": "2020-11-27 22:41:46 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٢٢٩ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.05 كم بتاريخ 2020-11-27 22:41:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000clq3"
  },
  "350": {
    "place": "١٣ كم جنوب Jayr?d، سوريا",
    "latLng": [
      33.6838,
      36.7479
    ],
    "magnitude": 4.1,
    "depth": 33.684,
    "time": "2020-11-26 22:08:26 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.1 درجة في ١٣ كم جنوب Jayr?d، سوريا على عمق 33.684 كم بتاريخ 2020-11-26 22:08:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ck5y#dyfi"
  },
  "351": {
    "place": "٣٨ كم شمال غرب Al Wafrah، الكويت",
    "latLng": [
      28.92,
      47.6967
    ],
    "magnitude": 4.7,
    "depth": 28.92,
    "time": "2020-11-11 14:56:23 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.7 درجة في ٣٨ كم شمال غرب Al Wafrah، الكويت على عمق 28.92 كم بتاريخ 2020-11-11 14:56:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cdef#shakemap"
  },
  "352": {
    "place": "٢٥ كم شرق جنوب شرق جمجمال، العراق",
    "latLng": [
      35.4692,
      45.1058
    ],
    "magnitude": 4.9,
    "depth": 35.469,
    "time": "2020-11-09 23:18:25 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.9 درجة في ٢٥ كم شرق جنوب شرق Jamjam?l، العراق على عمق 35.469 كم بتاريخ 2020-11-09 23:18:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ccpb#dyfi"
  },
  "353": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.3566,
      57.437
    ],
    "magnitude": 4.5,
    "depth": 13.357,
    "time": "2020-11-07 23:42:06 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 13.357 كم بتاريخ 2020-11-07 23:42:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000cbyf"
  },
  "354": {
    "place": "٢٣٩ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.2491,
      55.5112
    ],
    "magnitude": 4.4,
    "depth": 14.249,
    "time": "2020-10-28 10:06:25 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ٢٣٩ كم شمال شرق Hadibu، اليمن على عمق 14.249 كم بتاريخ 2020-10-28 10:06:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000c9rp"
  },
  "355": {
    "place": "سقطرى منطقة",
    "latLng": [
      13.9738,
      56.9359
    ],
    "magnitude": 5.4,
    "depth": 13.974,
    "time": "2020-10-13 09:29:52 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.4 درجة في Socotra region على عمق 13.974 كم بتاريخ 2020-10-13 09:29:52 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000c7zb#pager"
  },
  "356": {
    "place": "سقطرى منطقة",
    "latLng": [
      13.8857,
      56.8637
    ],
    "magnitude": 4.4,
    "depth": 13.886,
    "time": "2020-10-13 09:03:00 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في Socotra region على عمق 13.886 كم بتاريخ 2020-10-13 09:03:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000c8tf"
  },
  "357": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.6053,
      57.276
    ],
    "magnitude": 4.2,
    "depth": 13.605,
    "time": "2020-10-13 07:22:36 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 13.605 كم بتاريخ 2020-10-13 07:22:36 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000c8th"
  },
  "358": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.4039,
      56.4418
    ],
    "magnitude": 4.5,
    "depth": 14.404,
    "time": "2020-09-03 20:40:43 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.404 كم بتاريخ 2020-09-03 20:40:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000bhg4"
  },
  "359": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.3548,
      56.3405
    ],
    "magnitude": 4.3,
    "depth": 14.355,
    "time": "2020-09-03 20:36:55 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.355 كم بتاريخ 2020-09-03 20:36:55 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000bhg1"
  },
  "360": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.5238,
      56.2428
    ],
    "magnitude": 4.5,
    "depth": 14.524,
    "time": "2020-09-03 20:25:25 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.524 كم بتاريخ 2020-09-03 20:25:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000bhf8"
  },
  "361": {
    "place": "٢٦٩ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.3745,
      55.7717
    ],
    "magnitude": 4.5,
    "depth": 14.375,
    "time": "2020-08-25 15:42:47 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٦٩ كم شمال شرق Hadibu، اليمن على عمق 14.375 كم بتاريخ 2020-08-25 15:42:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000bfb0"
  },
  "362": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7367,
      55.8465
    ],
    "magnitude": 4.4,
    "depth": 14.737,
    "time": "2020-07-29 01:49:57 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.737 كم بتاريخ 2020-07-29 01:49:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000b97k"
  },
  "363": {
    "place": "٢٨ كم شمال شرق Dib Dibba، عمان",
    "latLng": [
      26.3572,
      56.4855
    ],
    "magnitude": 4.0,
    "depth": 26.357,
    "time": "2020-07-25 17:48:01 UTC",
    "region": "الإمارات",
    "info": "زلزال بقوة 4.0 درجة في ٢٨ كم شمال شرق Dib Dibba، عمان على عمق 26.357 كم بتاريخ 2020-07-25 17:48:01 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000bdal"
  },
  "364": {
    "place": "١٢١ كم جنوب جنوب غرب Al Ghayz?ah، اليمن",
    "latLng": [
      15.1352,
      51.9498
    ],
    "magnitude": 4.5,
    "depth": 15.135,
    "time": "2020-07-24 04:09:11 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.5 درجة في ١٢١ كم جنوب جنوب غرب Al Ghayz?ah، اليمن على عمق 15.135 كم بتاريخ 2020-07-24 04:09:11 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000b66p"
  },
  "365": {
    "place": "٢٩٦ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.7194,
      55.7538
    ],
    "magnitude": 4.6,
    "depth": 14.719,
    "time": "2020-07-20 04:26:13 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في ٢٩٦ كم شمال شرق Hadibu، اليمن على عمق 14.719 كم بتاريخ 2020-07-20 04:26:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000arfq"
  },
  "366": {
    "place": "١٧١ كم شمال Qalans?yah، اليمن",
    "latLng": [
      14.2097,
      53.7793
    ],
    "magnitude": 4.5,
    "depth": 14.21,
    "time": "2020-07-19 04:54:13 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ١٧١ كم شمال Qalans?yah، اليمن على عمق 14.21 كم بتاريخ 2020-07-19 04:54:13 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ar49"
  },
  "367": {
    "place": "٤٦ كم شرق مصوع، إريتريا",
    "latLng": [
      15.665,
      39.9018
    ],
    "magnitude": 4.2,
    "depth": 15.665,
    "time": "2020-07-17 18:45:43 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٤٦ كم شرق مصوع، إريتريا على عمق 15.665 كم بتاريخ 2020-07-17 18:45:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000b2u0"
  },
  "368": {
    "place": "٤٨ كم شرق شمال شرق Deir ez-Zor، سوريا",
    "latLng": [
      35.5678,
      40.594
    ],
    "magnitude": 4.2,
    "depth": 35.568,
    "time": "2020-07-16 22:33:29 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٤٨ كم شرق شمال شرق Deir ez-Zor، سوريا على عمق 35.568 كم بتاريخ 2020-07-16 22:33:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000aq0j"
  },
  "369": {
    "place": "٥٠ كم شمال شرق Deir ez-Zor، سوريا",
    "latLng": [
      35.6505,
      40.5391
    ],
    "magnitude": 4.3,
    "depth": 35.651,
    "time": "2020-07-06 22:54:47 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٥٠ كم شمال شرق Deir ez-Zor، سوريا على عمق 35.651 كم بتاريخ 2020-07-06 22:54:47 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000aj3v"
  },
  "370": {
    "place": "٥٢ كم جنوب As Sulaym?n?yah، العراق",
    "latLng": [
      35.0986,
      45.3313
    ],
    "magnitude": 4.0,
    "depth": 35.099,
    "time": "2020-07-03 19:44:28 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٥٢ كم جنوب As Sulaym?n?yah، العراق على عمق 35.099 كم بتاريخ 2020-07-03 19:44:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000akr0"
  },
  "371": {
    "place": "١٨٣ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.7211,
      51.595
    ],
    "magnitude": 4.7,
    "depth": 13.721,
    "time": "2020-06-23 16:31:57 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.7 درجة في ١٨٣ كم شمال شمال غرب Kilmia، اليمن على عمق 13.721 كم بتاريخ 2020-06-23 16:31:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ahbk"
  },
  "372": {
    "place": "٧٤ كم جنوب جنوب شرق Sharm el-Sheikh، مصر",
    "latLng": [
      27.3437,
      34.7204
    ],
    "magnitude": 5.5,
    "depth": 27.344,
    "time": "2020-06-16 14:30:26 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.5 درجة في ٧٤ كم جنوب جنوب شرق Sharm el-Sheikh، Egypt على عمق 27.344 كم بتاريخ 2020-06-16 14:30:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000acva#pager"
  },
  "373": {
    "place": "٣٨ كم شرق جنوب شرق Mandal?، العراق",
    "latLng": [
      33.6298,
      45.951
    ],
    "magnitude": 4.3,
    "depth": 33.63,
    "time": "2020-06-08 03:44:20 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٨ كم شرق جنوب شرق Mandal?، العراق على عمق 33.63 كم بتاريخ 2020-06-08 03:44:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000aawe"
  },
  "374": {
    "place": "٢٢ كم شرق جمجمال، العراق",
    "latLng": [
      35.5681,
      45.0817
    ],
    "magnitude": 4.8,
    "depth": 35.568,
    "time": "2020-04-29 17:01:35 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.8 درجة في ٢٢ كم شرق Jamjam?l، العراق على عمق 35.568 كم بتاريخ 2020-04-29 17:01:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60009ety#dyfi"
  },
  "375": {
    "place": "١٨٢ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.7263,
      51.6392
    ],
    "magnitude": 5.1,
    "depth": 13.726,
    "time": "2020-04-22 20:22:46 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 5.1 درجة في ١٨٢ كم شمال شمال غرب Kilmia، اليمن على عمق 13.726 كم بتاريخ 2020-04-22 20:22:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us700091zf"
  },
  "376": {
    "place": "١٧٩ كم شمال شرق Tok?r، Sudan",
    "latLng": [
      19.5101,
      39.001
    ],
    "magnitude": 4.1,
    "depth": 19.51,
    "time": "2020-04-21 07:59:19 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ١٧٩ كم شمال شرق Tok?r، Sudan على عمق 19.51 كم بتاريخ 2020-04-21 07:59:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60009dbx"
  },
  "377": {
    "place": "٤٠ كم شمال شمال غرب Latakia، سوريا",
    "latLng": [
      35.8341,
      35.545
    ],
    "magnitude": 4.5,
    "depth": 35.834,
    "time": "2020-04-15 08:18:38 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.5 درجة في ٤٠ كم شمال شمال غرب Latakia، سوريا على عمق 35.834 كم بتاريخ 2020-04-15 08:18:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008wl9#dyfi"
  },
  "378": {
    "place": "٤٣ كم شمال شمال غرب Latakia، سوريا",
    "latLng": [
      35.8628,
      35.525
    ],
    "magnitude": 4.6,
    "depth": 35.863,
    "time": "2020-04-15 07:40:05 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.6 درجة في ٤٣ كم شمال شمال غرب Latakia، سوريا على عمق 35.863 كم بتاريخ 2020-04-15 07:40:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008wkw#dyfi"
  },
  "379": {
    "place": "٤٣ كم شمال غرب Latakia، سوريا",
    "latLng": [
      35.8397,
      35.4944
    ],
    "magnitude": 4.2,
    "depth": 35.84,
    "time": "2020-04-14 22:37:56 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.2 درجة في ٤٣ كم شمال غرب Latakia، سوريا على عمق 35.84 كم بتاريخ 2020-04-14 22:37:56 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008wcj#dyfi"
  },
  "380": {
    "place": "٢٥٠ كم جنوب جنوب شرق ?al?lah، عمان",
    "latLng": [
      14.8269,
      54.689
    ],
    "magnitude": 4.4,
    "depth": 14.827,
    "time": "2020-04-12 15:09:43 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ٢٥٠ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.827 كم بتاريخ 2020-04-12 15:09:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008uy2"
  },
  "381": {
    "place": "١٠ كم جنوب جنوب غرب جمجمال، العراق",
    "latLng": [
      35.4534,
      44.7837
    ],
    "magnitude": 4.1,
    "depth": 35.453,
    "time": "2020-04-09 05:36:23 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.1 درجة في ١٠ كم جنوب جنوب غرب Jamjam?l، العراق على عمق 35.453 كم بتاريخ 2020-04-09 05:36:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008xln"
  },
  "382": {
    "place": "١٨ كم جنوب غرب نويبع، مصر",
    "latLng": [
      28.9129,
      34.5466
    ],
    "magnitude": 4.1,
    "depth": 28.913,
    "time": "2020-04-05 05:04:04 UTC",
    "region": "السعودية",
    "info": "زلزال بقوة 4.1 درجة في ١٨ كم جنوب غرب Nuwaybi‘a، Egypt على عمق 28.913 كم بتاريخ 2020-04-05 05:04:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008sgr"
  },
  "383": {
    "place": "٥١ كم غرب Yaylada??، تركيا",
    "latLng": [
      35.9384,
      35.49
    ],
    "magnitude": 4.7,
    "depth": 35.938,
    "time": "2020-04-03 18:15:42 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ٥١ كم غرب Yaylada??، تركيا على عمق 35.938 كم بتاريخ 2020-04-03 18:15:42 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008mx0#dyfi"
  },
  "384": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.505,
      57.7754
    ],
    "magnitude": 4.0,
    "depth": 14.505,
    "time": "2020-03-21 18:18:57 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.0 درجة في منطقة صدع أوين على عمق 14.505 كم بتاريخ 2020-03-21 18:18:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008h1j"
  },
  "385": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.1472,
      56.8547
    ],
    "magnitude": 4.9,
    "depth": 14.147,
    "time": "2020-03-20 07:05:57 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.9 درجة في منطقة صدع أوين على عمق 14.147 كم بتاريخ 2020-03-20 07:05:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70008cqw"
  },
  "386": {
    "place": "٣٢ كم جنوب جنوب غرب Koysinceq، العراق",
    "latLng": [
      35.8099,
      44.4904
    ],
    "magnitude": 4.4,
    "depth": 35.81,
    "time": "2020-03-16 07:13:58 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.4 درجة في ٣٢ كم جنوب جنوب غرب Koysinceq، العراق على عمق 35.81 كم بتاريخ 2020-03-16 07:13:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60008gdm#dyfi"
  },
  "387": {
    "place": "٢٥٦ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.3413,
      55.6366
    ],
    "magnitude": 4.3,
    "depth": 14.341,
    "time": "2020-02-26 08:59:09 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٥٦ كم شمال شرق Hadibu، اليمن على عمق 14.341 كم بتاريخ 2020-02-26 08:59:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us600089hw"
  },
  "388": {
    "place": "١٢٩ كم شمال شمال غرب Qalans?yah، اليمن",
    "latLng": [
      13.7761,
      53.0324
    ],
    "magnitude": 4.3,
    "depth": 13.776,
    "time": "2020-02-16 17:21:43 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ١٢٩ كم شمال شمال غرب Qalans?yah، اليمن على عمق 13.776 كم بتاريخ 2020-02-16 17:21:43 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70007rdv"
  },
  "389": {
    "place": "٢٢١ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.8711,
      40.1719
    ],
    "magnitude": 4.2,
    "depth": 17.871,
    "time": "2020-02-07 15:56:04 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٢٢١ كم غرب Ad Darb، السعودية على عمق 17.871 كم بتاريخ 2020-02-07 15:56:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70007q4f"
  },
  "390": {
    "place": "٢١٩ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.7668,
      40.1795
    ],
    "magnitude": 4.6,
    "depth": 17.767,
    "time": "2020-02-07 04:48:33 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٢١٩ كم غرب Ad Darb، السعودية على عمق 17.767 كم بتاريخ 2020-02-07 04:48:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70007kp0"
  },
  "391": {
    "place": "٢٠ كم شرق جنوب شرق Mandal?، العراق",
    "latLng": [
      33.6467,
      45.7389
    ],
    "magnitude": 4.4,
    "depth": 33.647,
    "time": "2020-01-29 05:02:46 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.4 درجة في ٢٠ كم شرق جنوب شرق Mandal?، العراق على عمق 33.647 كم بتاريخ 2020-01-29 05:02:46 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007isz"
  },
  "392": {
    "place": "٢٢ كم شرق شمال شرق Mandal?، العراق",
    "latLng": [
      33.8191,
      45.7813
    ],
    "magnitude": 4.9,
    "depth": 33.819,
    "time": "2020-01-28 20:37:20 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.9 درجة في ٢٢ كم شرق شمال شرق Mandal?، العراق على عمق 33.819 كم بتاريخ 2020-01-28 20:37:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007ig7"
  },
  "393": {
    "place": "١٦ كم شرق جنوب شرق Mandal?، العراق",
    "latLng": [
      33.6866,
      45.7193
    ],
    "magnitude": 4.8,
    "depth": 33.687,
    "time": "2020-01-28 06:52:03 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.8 درجة في ١٦ كم شرق جنوب شرق Mandal?، العراق على عمق 33.687 كم بتاريخ 2020-01-28 06:52:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007i09"
  },
  "394": {
    "place": "١٦٩ كم غرب شمال غرب فرسان، السعودية",
    "latLng": [
      17.0613,
      40.5713
    ],
    "magnitude": 4.3,
    "depth": 17.061,
    "time": "2020-01-27 13:58:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٦٩ كم غرب شمال غرب فرسان، السعودية على عمق 17.061 كم بتاريخ 2020-01-27 13:58:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70007k1s"
  },
  "395": {
    "place": "١٩٠ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.4858,
      40.4728
    ],
    "magnitude": 4.3,
    "depth": 17.486,
    "time": "2020-01-24 04:58:02 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٩٠ كم غرب Ad Darb، السعودية على عمق 17.486 كم بتاريخ 2020-01-24 04:58:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007piu"
  },
  "396": {
    "place": "١٧٧ كم غرب شمال غرب فرسان، السعودية",
    "latLng": [
      17.1855,
      40.531
    ],
    "magnitude": 4.3,
    "depth": 17.186,
    "time": "2020-01-24 00:41:02 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٧٧ كم غرب شمال غرب فرسان، السعودية على عمق 17.186 كم بتاريخ 2020-01-24 00:41:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007pil"
  },
  "397": {
    "place": "٧٥ كم شرق Makadi Bay، مصر",
    "latLng": [
      26.9764,
      34.6634
    ],
    "magnitude": 4.4,
    "depth": 26.976,
    "time": "2020-01-18 21:46:14 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٧٥ كم شرق Makadi Bay، Egypt على عمق 26.976 كم بتاريخ 2020-01-18 21:46:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60007a9c#dyfi"
  },
  "398": {
    "place": "١٣٣ كم جنوب غرب Jeddah، السعودية",
    "latLng": [
      20.7597,
      38.1672
    ],
    "magnitude": 4.0,
    "depth": 20.76,
    "time": "2019-12-27 19:23:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.0 درجة في ١٣٣ كم جنوب غرب Jeddah، السعودية على عمق 20.76 كم بتاريخ 2019-12-27 19:23:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70006xnf"
  },
  "399": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.0697,
      56.4433
    ],
    "magnitude": 4.3,
    "depth": 14.07,
    "time": "2019-12-25 22:35:48 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.07 كم بتاريخ 2019-12-25 22:35:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70006xtw"
  },
  "400": {
    "place": "٦١ كم غرب جنوب غرب Pasni، باكستان",
    "latLng": [
      24.9861,
      62.9434
    ],
    "magnitude": 4.5,
    "depth": 24.986,
    "time": "2019-12-04 04:15:10 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٦١ كم غرب جنوب غرب Pasni، Pakistan على عمق 24.986 كم بتاريخ 2019-12-04 04:15:10 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60006lv0"
  },
  "401": {
    "place": "٥٤ كم شمال شرق Adi Keyh، إريتريا",
    "latLng": [
      15.1524,
      39.7694
    ],
    "magnitude": 4.5,
    "depth": 15.152,
    "time": "2019-11-25 09:53:00 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٥٤ كم شمال شرق Adi Keyh، إريتريا على عمق 15.152 كم بتاريخ 2019-11-25 09:53:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us60006ib8"
  },
  "402": {
    "place": "١٦٩ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.6747,
      52.0763
    ],
    "magnitude": 4.4,
    "depth": 14.675,
    "time": "2019-11-24 04:51:17 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٦٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.675 كم بتاريخ 2019-11-24 04:51:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70006eij"
  },
  "403": {
    "place": "٤٠ كم جنوب شرق Sharm el-Sheikh، مصر",
    "latLng": [
      27.6261,
      34.5737
    ],
    "magnitude": 4.4,
    "depth": 27.626,
    "time": "2019-11-19 23:04:29 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٤٠ كم جنوب شرق Sharm el-Sheikh، Egypt على عمق 27.626 كم بتاريخ 2019-11-19 23:04:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70006dpe"
  },
  "404": {
    "place": "١٧ كم جنوب غرب Umm Qa?r، العراق",
    "latLng": [
      29.9164,
      47.8006
    ],
    "magnitude": 4.1,
    "depth": 29.916,
    "time": "2019-11-15 20:49:20 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ١٧ كم جنوب غرب Umm Qa?r، العراق على عمق 29.916 كم بتاريخ 2019-11-15 20:49:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us700068m6"
  },
  "405": {
    "place": "٣١ كم جنوب غرب Umm Qa?r، العراق",
    "latLng": [
      29.8401,
      47.683
    ],
    "magnitude": 4.1,
    "depth": 29.84,
    "time": "2019-11-15 11:47:38 UTC",
    "region": "الخليج العربي",
    "info": "زلزال بقوة 4.1 درجة في ٣١ كم جنوب غرب Umm Qa?r، العراق على عمق 29.84 كم بتاريخ 2019-11-15 11:47:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70006bm1"
  },
  "406": {
    "place": "١٤٥ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.9065,
      52.3892
    ],
    "magnitude": 4.9,
    "depth": 14.907,
    "time": "2019-09-27 17:48:27 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.9 درجة في ١٤٥ كم جنوب Al Ghayz?ah، اليمن على عمق 14.907 كم بتاريخ 2019-09-27 17:48:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70005mr0"
  },
  "407": {
    "place": "٢٢٥ كم غرب جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      18.1958,
      40.003
    ],
    "magnitude": 4.5,
    "depth": 18.196,
    "time": "2019-09-24 21:19:50 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٢٢٥ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.196 كم بتاريخ 2019-09-24 21:19:50 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70005px0"
  },
  "408": {
    "place": "منطقة صدع أوين",
    "latLng": [
      19.3582,
      60.7254
    ],
    "magnitude": 4.3,
    "depth": 19.358,
    "time": "2019-09-21 20:24:54 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 19.358 كم بتاريخ 2019-09-21 20:24:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70005ml1"
  },
  "409": {
    "place": "١٢٨ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      16.5746,
      40.1419
    ],
    "magnitude": 5.0,
    "depth": 16.575,
    "time": "2019-09-11 19:06:57 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.0 درجة في ١٢٨ كم شمال شرق مصوع، إريتريا على عمق 16.575 كم بتاريخ 2019-09-11 19:06:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70005ezz"
  },
  "410": {
    "place": "١٤٧ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.8792,
      52.2773
    ],
    "magnitude": 4.2,
    "depth": 14.879,
    "time": "2019-08-26 10:21:29 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في ١٤٧ كم جنوب Al Ghayz?ah، اليمن على عمق 14.879 كم بتاريخ 2019-08-26 10:21:29 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70005a9r"
  },
  "411": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.5606,
      56.2176
    ],
    "magnitude": 4.7,
    "depth": 14.561,
    "time": "2019-07-16 23:49:10 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.561 كم بتاريخ 2019-07-16 23:49:10 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70004ly5"
  },
  "412": {
    "place": "١٥٧ كم شمال شمال غرب كالولا، الصومال",
    "latLng": [
      13.353,
      50.4469
    ],
    "magnitude": 5.1,
    "depth": 13.353,
    "time": "2019-07-14 19:12:24 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 5.1 درجة في ١٥٧ كم شمال شمال غرب كالولا، الصومال على عمق 13.353 كم بتاريخ 2019-07-14 19:12:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70004k5z"
  },
  "413": {
    "place": "٣٣ كم شمال شرق جنوب?nah، العراق",
    "latLng": [
      36.9842,
      43.3415
    ],
    "magnitude": 4.3,
    "depth": 36.984,
    "time": "2019-07-10 10:56:25 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٣ كم شمال شرق S?nah، العراق على عمق 36.984 كم بتاريخ 2019-07-10 10:56:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70004gqm#dyfi"
  },
  "414": {
    "place": "١٥٧ كم شمال شمال شرق Qalans?yah، اليمن",
    "latLng": [
      14.0747,
      53.8392
    ],
    "magnitude": 4.4,
    "depth": 14.075,
    "time": "2019-07-04 04:01:31 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ١٥٧ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.075 كم بتاريخ 2019-07-04 04:01:31 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70004j1v"
  },
  "415": {
    "place": "١٢٤ كم غرب جنوب غرب Edd، إريتريا",
    "latLng": [
      13.4093,
      40.6697
    ],
    "magnitude": 4.5,
    "depth": 13.409,
    "time": "2019-06-30 14:26:32 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٢٤ كم غرب جنوب غرب Edd، إريتريا على عمق 13.409 كم بتاريخ 2019-06-30 14:26:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70004gua"
  },
  "416": {
    "place": "٣٣ كم جنوب غرب ?alabja، العراق",
    "latLng": [
      34.9557,
      45.7333
    ],
    "magnitude": 5.2,
    "depth": 34.956,
    "time": "2019-05-11 10:28:59 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 5.2 درجة في ٣٣ كم جنوب غرب ?alabja، العراق على عمق 34.956 كم بتاريخ 2019-05-11 10:28:59 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003jrw"
  },
  "417": {
    "place": "٢٧٢ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.4522,
      55.7371
    ],
    "magnitude": 4.3,
    "depth": 14.452,
    "time": "2019-05-06 15:14:04 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢٧٢ كم شمال شرق Hadibu، اليمن على عمق 14.452 كم بتاريخ 2019-05-06 15:14:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003llq"
  },
  "418": {
    "place": "٢٨٨ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.7757,
      55.5583
    ],
    "magnitude": 4.7,
    "depth": 14.776,
    "time": "2019-05-06 15:04:59 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٨٨ كم شمال شرق Hadibu، اليمن على عمق 14.776 كم بتاريخ 2019-05-06 15:04:59 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003hf2"
  },
  "419": {
    "place": "٢٩١ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.5766,
      55.8604
    ],
    "magnitude": 4.9,
    "depth": 14.577,
    "time": "2019-05-06 14:47:28 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.9 درجة في ٢٩١ كم شمال شرق Hadibu، اليمن على عمق 14.577 كم بتاريخ 2019-05-06 14:47:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003hdf"
  },
  "420": {
    "place": "٢٨٧ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.4572,
      55.9309
    ],
    "magnitude": 5.0,
    "depth": 14.457,
    "time": "2019-05-02 21:31:19 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.0 درجة في ٢٨٧ كم شمال شرق Hadibu، اليمن على عمق 14.457 كم بتاريخ 2019-05-02 21:31:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003fzr"
  },
  "421": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7763,
      55.987
    ],
    "magnitude": 4.5,
    "depth": 14.776,
    "time": "2019-05-02 07:03:22 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.776 كم بتاريخ 2019-05-02 07:03:22 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003jdi"
  },
  "422": {
    "place": "١٥٦ كم شمال كالولا، الصومال",
    "latLng": [
      13.3638,
      50.5362
    ],
    "magnitude": 4.3,
    "depth": 13.364,
    "time": "2019-04-29 21:56:38 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.3 درجة في ١٥٦ كم شمال كالولا، الصومال على عمق 13.364 كم بتاريخ 2019-04-29 21:56:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003igv"
  },
  "423": {
    "place": "١٦ كم شرق جنوب شرق Bcharré، Lebanon",
    "latLng": [
      34.1756,
      36.1655
    ],
    "magnitude": 3.4,
    "depth": 34.176,
    "time": "2019-04-29 12:07:26 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.4 درجة في ١٦ كم شرق جنوب شرق Bcharré، Lebanon على عمق 34.176 كم بتاريخ 2019-04-29 12:07:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003eac#dyfi"
  },
  "424": {
    "place": "٩٠ كم شرق شمال شرق مصوع، إريتريا",
    "latLng": [
      16.0015,
      40.2128
    ],
    "magnitude": 4.4,
    "depth": 16.002,
    "time": "2019-04-24 12:51:03 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.4 درجة في ٩٠ كم شرق شمال شرق مصوع، إريتريا على عمق 16.002 كم بتاريخ 2019-04-24 12:51:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003gag"
  },
  "425": {
    "place": "٢٥ كم جنوب جنوب شرق Mandal?، العراق",
    "latLng": [
      33.5389,
      45.6743
    ],
    "magnitude": 4.3,
    "depth": 33.539,
    "time": "2019-04-23 10:24:40 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٢٥ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.539 كم بتاريخ 2019-04-23 10:24:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003alr"
  },
  "426": {
    "place": "٢٧٥ كم شرق جنوب شرق Sur، عمان",
    "latLng": [
      21.5653,
      61.9724
    ],
    "magnitude": 4.7,
    "depth": 21.565,
    "time": "2019-04-23 00:36:53 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٧٥ كم شرق جنوب شرق Sur، عمان على عمق 21.565 كم بتاريخ 2019-04-23 00:36:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us70003ahl"
  },
  "427": {
    "place": "١٢ كم شمال غرب Toygarl?، تركيا",
    "latLng": [
      36.2782,
      35.9639
    ],
    "magnitude": 3.0,
    "depth": 36.278,
    "time": "2019-04-15 20:10:58 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.0 درجة في ١٢ كم شمال غرب Toygarl?، تركيا على عمق 36.278 كم بتاريخ 2019-04-15 20:10:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us700036mi#dyfi"
  },
  "428": {
    "place": "٢١٢ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      14.0597,
      51.7917
    ],
    "magnitude": 4.6,
    "depth": 14.06,
    "time": "2019-04-12 14:28:39 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.6 درجة في ٢١٢ كم شمال شمال غرب Kilmia، اليمن على عمق 14.06 كم بتاريخ 2019-04-12 14:28:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us700034zs"
  },
  "429": {
    "place": "٢٥ كم جنوب Mandal?، العراق",
    "latLng": [
      33.5193,
      45.5906
    ],
    "magnitude": 4.1,
    "depth": 33.519,
    "time": "2019-04-01 15:33:48 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.1 درجة في ٢٥ كم جنوب Mandal?، العراق على عمق 33.519 كم بتاريخ 2019-04-01 15:33:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us700033rn"
  },
  "430": {
    "place": "٢٨ كم جنوب جنوب شرق Mandal?، العراق",
    "latLng": [
      33.5222,
      45.69
    ],
    "magnitude": 4.4,
    "depth": 33.522,
    "time": "2019-04-01 10:53:35 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.4 درجة في ٢٨ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.522 كم بتاريخ 2019-04-01 10:53:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000k8gu"
  },
  "431": {
    "place": "٣٥ كم جنوب جنوب شرق Mandal?، العراق",
    "latLng": [
      33.4607,
      45.7308
    ],
    "magnitude": 4.0,
    "depth": 33.461,
    "time": "2019-04-01 10:35:03 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٣٥ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.461 كم بتاريخ 2019-04-01 10:35:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000k8gm"
  },
  "432": {
    "place": "٢٢ كم شرق جنوب شرق Mandal?، العراق",
    "latLng": [
      33.6821,
      45.7837
    ],
    "magnitude": 4.8,
    "depth": 33.682,
    "time": "2019-04-01 10:16:14 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.8 درجة في ٢٢ كم شرق جنوب شرق Mandal?، العراق على عمق 33.682 كم بتاريخ 2019-04-01 10:16:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000k8g1#dyfi"
  },
  "433": {
    "place": "٢٩ كم جنوب شرق Mandal?، العراق",
    "latLng": [
      33.5495,
      45.7739
    ],
    "magnitude": 5.3,
    "depth": 33.55,
    "time": "2019-04-01 10:07:23 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 5.3 درجة في ٢٩ كم جنوب شرق Mandal?، العراق على عمق 33.55 كم بتاريخ 2019-04-01 10:07:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000k8fr#dyfi"
  },
  "434": {
    "place": "٣٤ كم شمال شمال غرب Mandal?، العراق",
    "latLng": [
      34.0432,
      45.425
    ],
    "magnitude": 4.5,
    "depth": 34.043,
    "time": "2019-03-12 12:06:05 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٣٤ كم شمال شمال غرب Mandal?، العراق على عمق 34.043 كم بتاريخ 2019-03-12 12:06:05 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000je35"
  },
  "435": {
    "place": "منطقة صدع أوين",
    "latLng": [
      17.8552,
      59.8352
    ],
    "magnitude": 4.8,
    "depth": 17.855,
    "time": "2019-03-12 03:04:45 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.8 درجة في منطقة صدع أوين على عمق 17.855 كم بتاريخ 2019-03-12 03:04:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jdzt"
  },
  "436": {
    "place": "١٩٠ كم شرق شمال شرق Tok?r، Sudan",
    "latLng": [
      19.1752,
      39.3576
    ],
    "magnitude": 4.3,
    "depth": 19.175,
    "time": "2019-03-10 18:21:57 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ١٩٠ كم شرق شمال شرق Tok?r، Sudan على عمق 19.175 كم بتاريخ 2019-03-10 18:21:57 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jimw"
  },
  "437": {
    "place": "١٨١ كم شرق شمال شرق Tok?r، Sudan",
    "latLng": [
      18.9513,
      39.3622
    ],
    "magnitude": 4.6,
    "depth": 18.951,
    "time": "2019-03-10 12:32:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ١٨١ كم شرق شمال شرق Tok?r، Sudan على عمق 18.951 كم بتاريخ 2019-03-10 12:32:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jd7a"
  },
  "438": {
    "place": "٢١٥ كم غرب جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      18.1088,
      40.1733
    ],
    "magnitude": 4.6,
    "depth": 18.109,
    "time": "2019-03-08 17:20:09 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٢١٥ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.109 كم بتاريخ 2019-03-08 17:20:09 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jcfn"
  },
  "439": {
    "place": "٢١٢ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.8748,
      40.2584
    ],
    "magnitude": 4.5,
    "depth": 17.875,
    "time": "2019-03-06 21:33:45 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ٢١٢ كم غرب Ad Darb، السعودية على عمق 17.875 كم بتاريخ 2019-03-06 21:33:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jbib"
  },
  "440": {
    "place": "٢١٨ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.8965,
      40.1955
    ],
    "magnitude": 4.7,
    "depth": 17.897,
    "time": "2019-03-06 21:24:02 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٢١٨ كم غرب Ad Darb، السعودية على عمق 17.897 كم بتاريخ 2019-03-06 21:24:02 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jbhn"
  },
  "441": {
    "place": "٢١٥ كم غرب Ad Darb، السعودية",
    "latLng": [
      17.9201,
      40.2281
    ],
    "magnitude": 5.0,
    "depth": 17.92,
    "time": "2019-03-06 19:54:12 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.0 درجة في ٢١٥ كم غرب Ad Darb، السعودية على عمق 17.92 كم بتاريخ 2019-03-06 19:54:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jbe5"
  },
  "442": {
    "place": "١٨٩ كم غرب جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      18.2615,
      40.3554
    ],
    "magnitude": 4.1,
    "depth": 18.262,
    "time": "2019-03-06 19:20:58 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.1 درجة في ١٨٩ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.262 كم بتاريخ 2019-03-06 19:20:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jgc4"
  },
  "443": {
    "place": "٢١٦ كم شمال Hadibu، اليمن",
    "latLng": [
      14.6024,
      54.1333
    ],
    "magnitude": 4.3,
    "depth": 14.602,
    "time": "2019-03-02 10:10:24 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ٢١٦ كم شمال Hadibu، اليمن على عمق 14.602 كم بتاريخ 2019-03-02 10:10:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000jdpn"
  },
  "444": {
    "place": "منطقة صدع أوين",
    "latLng": [
      16.9595,
      59.8215
    ],
    "magnitude": 4.4,
    "depth": 16.96,
    "time": "2019-03-02 01:17:40 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 16.96 كم بتاريخ 2019-03-02 01:17:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000j9qb"
  },
  "445": {
    "place": "٢٢٠ كم شمال Qalans?yah، اليمن",
    "latLng": [
      14.6672,
      53.7054
    ],
    "magnitude": 5.3,
    "depth": 14.667,
    "time": "2019-02-20 12:33:17 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 5.3 درجة في ٢٢٠ كم شمال Qalans?yah، اليمن على عمق 14.667 كم بتاريخ 2019-02-20 12:33:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000jkm5"
  },
  "446": {
    "place": "١٨ كم جنوب غرب Uzunba?، تركيا",
    "latLng": [
      36.0449,
      35.8699
    ],
    "magnitude": 4.0,
    "depth": 36.045,
    "time": "2019-02-20 05:35:23 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ١٨ كم جنوب غرب Uzunba?، تركيا على عمق 36.045 كم بتاريخ 2019-02-20 05:35:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000jkgl"
  },
  "447": {
    "place": "٣٥ كم جنوب جنوب شرق Kifr?، العراق",
    "latLng": [
      34.4014,
      45.1199
    ],
    "magnitude": 4.3,
    "depth": 34.401,
    "time": "2019-01-29 05:18:23 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٥ كم جنوب جنوب شرق Kifr?، العراق على عمق 34.401 كم بتاريخ 2019-01-29 05:18:23 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000jhcz"
  },
  "448": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.4332,
      57.401
    ],
    "magnitude": 4.4,
    "depth": 13.433,
    "time": "2019-01-20 12:21:10 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 13.433 كم بتاريخ 2019-01-20 12:21:10 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000jc15"
  },
  "449": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.1919,
      56.6282
    ],
    "magnitude": 4.6,
    "depth": 14.192,
    "time": "2019-01-18 08:37:20 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.192 كم بتاريخ 2019-01-18 08:37:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j5lh"
  },
  "450": {
    "place": "٣٣ كم شمال Mandal?، العراق",
    "latLng": [
      34.0508,
      45.5913
    ],
    "magnitude": 4.0,
    "depth": 34.051,
    "time": "2019-01-15 17:07:00 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٣٣ كم شمال Mandal?، العراق على عمق 34.051 كم بتاريخ 2019-01-15 17:07:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j45j"
  },
  "451": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.7293,
      56.0797
    ],
    "magnitude": 4.6,
    "depth": 14.729,
    "time": "2019-01-15 01:55:53 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.729 كم بتاريخ 2019-01-15 01:55:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j3zx"
  },
  "452": {
    "place": "٣٤ كم شمال شمال شرق Mandal?، العراق",
    "latLng": [
      34.0464,
      45.6698
    ],
    "magnitude": 4.9,
    "depth": 34.046,
    "time": "2019-01-06 14:15:07 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.9 درجة في ٣٤ كم شمال شمال شرق Mandal?، العراق على عمق 34.046 كم بتاريخ 2019-01-06 14:15:07 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j0tq#dyfi"
  },
  "453": {
    "place": "٤٠ كم شمال شمال شرق Mandal?، العراق",
    "latLng": [
      34.064,
      45.7651
    ],
    "magnitude": 4.2,
    "depth": 34.064,
    "time": "2019-01-06 14:03:54 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.2 درجة في ٤٠ كم شمال شمال شرق Mandal?، العراق على عمق 34.064 كم بتاريخ 2019-01-06 14:03:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j7x8"
  },
  "454": {
    "place": "٣٦ كم شمال Mandal?، العراق",
    "latLng": [
      34.0765,
      45.5737
    ],
    "magnitude": 4.6,
    "depth": 34.077,
    "time": "2019-01-06 13:55:06 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ٣٦ كم شمال Mandal?، العراق على عمق 34.077 كم بتاريخ 2019-01-06 13:55:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j7wj"
  },
  "455": {
    "place": "٣٨ كم شمال Mandal?، العراق",
    "latLng": [
      34.0932,
      45.5111
    ],
    "magnitude": 4.6,
    "depth": 34.093,
    "time": "2019-01-06 13:54:19 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ٣٨ كم شمال Mandal?، العراق على عمق 34.093 كم بتاريخ 2019-01-06 13:54:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j7w1"
  },
  "456": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.739,
      56.0903
    ],
    "magnitude": 4.4,
    "depth": 14.739,
    "time": "2018-12-19 09:46:33 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.739 كم بتاريخ 2018-12-19 09:46:33 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000j0ae"
  },
  "457": {
    "place": "٢٣ كم غرب شمال غرب Tripoli، Lebanon",
    "latLng": [
      34.5399,
      35.6202
    ],
    "magnitude": 3.2,
    "depth": 34.54,
    "time": "2018-12-14 15:27:59 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 3.2 درجة في ٢٣ كم غرب شمال غرب Tripoli، Lebanon على عمق 34.54 كم بتاريخ 2018-12-14 15:27:59 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000itsi#dyfi"
  },
  "458": {
    "place": "منطقة صدع أوين",
    "latLng": [
      13.4973,
      57.2089
    ],
    "magnitude": 4.6,
    "depth": 13.497,
    "time": "2018-12-04 08:40:17 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 13.497 كم بتاريخ 2018-12-04 08:40:17 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000i4ag"
  },
  "459": {
    "place": "٤٤ كم شمال Mandal?، العراق",
    "latLng": [
      34.147,
      45.5038
    ],
    "magnitude": 4.5,
    "depth": 34.147,
    "time": "2018-11-25 20:56:37 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٤٤ كم شمال Mandal?، العراق على عمق 34.147 كم بتاريخ 2018-11-25 20:56:37 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hwg9"
  },
  "460": {
    "place": "٣٩ كم شمال شمال شرق Mandal?، العراق",
    "latLng": [
      34.0887,
      45.6969
    ],
    "magnitude": 4.3,
    "depth": 34.089,
    "time": "2018-11-25 20:42:40 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٩ كم شمال شمال شرق Mandal?، العراق على عمق 34.089 كم بتاريخ 2018-11-25 20:42:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hwg1"
  },
  "461": {
    "place": "١٦٧ كم شرق شمال شرق Saw?kin، Sudan",
    "latLng": [
      19.6249,
      38.8314
    ],
    "magnitude": 4.5,
    "depth": 19.625,
    "time": "2018-11-19 01:10:25 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.5 درجة في ١٦٧ كم شرق شمال شرق Saw?kin، Sudan على عمق 19.625 كم بتاريخ 2018-11-19 01:10:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hts6"
  },
  "462": {
    "place": "٢٧١ كم جنوب شرق ?al?lah، عمان",
    "latLng": [
      15.0022,
      55.544
    ],
    "magnitude": 4.1,
    "depth": 15.002,
    "time": "2018-11-09 02:07:39 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.1 درجة في ٢٧١ كم جنوب شرق ?al?lah، عمان على عمق 15.002 كم بتاريخ 2018-11-09 02:07:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hsqj"
  },
  "463": {
    "place": "٢٠٣ كم جنوب جنوب غرب Al Ghayz?ah، اليمن",
    "latLng": [
      14.5368,
      51.383
    ],
    "magnitude": 4.6,
    "depth": 14.537,
    "time": "2018-10-30 08:33:15 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.6 درجة في ٢٠٣ كم جنوب جنوب غرب Al Ghayz?ah، اليمن على عمق 14.537 كم بتاريخ 2018-10-30 08:33:15 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000i7js"
  },
  "464": {
    "place": "١٤٠ كم جنوب غرب Mukalla، اليمن",
    "latLng": [
      13.652,
      48.1971
    ],
    "magnitude": 4.7,
    "depth": 13.652,
    "time": "2018-10-23 22:26:58 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.7 درجة في ١٤٠ كم جنوب غرب Mukalla، اليمن على عمق 13.652 كم بتاريخ 2018-10-23 22:26:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hgb8#dyfi"
  },
  "465": {
    "place": "١٩٠ كم شمال Qalans?yah، اليمن",
    "latLng": [
      14.4117,
      53.5517
    ],
    "magnitude": 4.9,
    "depth": 14.412,
    "time": "2018-10-13 00:12:26 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.9 درجة في ١٩٠ كم شمال Qalans?yah، اليمن على عمق 14.412 كم بتاريخ 2018-10-13 00:12:26 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hbfh"
  },
  "466": {
    "place": "٢٢٦ كم جنوب غرب Al Maj?ridah، السعودية",
    "latLng": [
      17.9898,
      40.1237
    ],
    "magnitude": 4.2,
    "depth": 17.99,
    "time": "2018-10-07 20:30:54 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.2 درجة في ٢٢٦ كم جنوب غرب Al Maj?ridah، السعودية على عمق 17.99 كم بتاريخ 2018-10-07 20:30:54 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000hb4f"
  },
  "467": {
    "place": "٢١ كم جنوب شرق Mandal?، العراق",
    "latLng": [
      33.6162,
      45.7234
    ],
    "magnitude": 4.6,
    "depth": 33.616,
    "time": "2018-09-19 19:29:20 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ٢١ كم جنوب شرق Mandal?، العراق على عمق 33.616 كم بتاريخ 2018-09-19 19:29:20 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000hh9h"
  },
  "468": {
    "place": "٢٤٣ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.4067,
      55.3668
    ],
    "magnitude": 4.5,
    "depth": 14.407,
    "time": "2018-09-13 04:38:14 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.5 درجة في ٢٤٣ كم شمال شرق Hadibu، اليمن على عمق 14.407 كم بتاريخ 2018-09-13 04:38:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000hi4z"
  },
  "469": {
    "place": "منطقة صدع أوين",
    "latLng": [
      14.1733,
      56.6802
    ],
    "magnitude": 4.6,
    "depth": 14.173,
    "time": "2018-08-19 09:07:08 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.173 كم بتاريخ 2018-08-19 09:07:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000giqc"
  },
  "470": {
    "place": "٥٦ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      16.0054,
      39.8077
    ],
    "magnitude": 4.7,
    "depth": 16.005,
    "time": "2018-08-13 13:54:30 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.7 درجة في ٥٦ كم شمال شرق مصوع، إريتريا على عمق 16.005 كم بتاريخ 2018-08-13 13:54:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000g7zy"
  },
  "471": {
    "place": "٢٣٣ كم شمال Hadibu، اليمن",
    "latLng": [
      14.742,
      54.2889
    ],
    "magnitude": 4.7,
    "depth": 14.742,
    "time": "2018-08-10 11:32:04 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ٢٣٣ كم شمال Hadibu، اليمن على عمق 14.742 كم بتاريخ 2018-08-10 11:32:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000gade"
  },
  "472": {
    "place": "٢٠٠ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.8695,
      51.5598
    ],
    "magnitude": 4.2,
    "depth": 13.87,
    "time": "2018-08-01 20:57:03 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.2 درجة في ٢٠٠ كم شمال شمال غرب Kilmia، اليمن على عمق 13.87 كم بتاريخ 2018-08-01 20:57:03 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000g47e"
  },
  "473": {
    "place": "١ كم شرق جنوب شرق مجدال، إسرائيل",
    "latLng": [
      32.8353,
      35.5216
    ],
    "magnitude": 2.9,
    "depth": 32.835,
    "time": "2018-07-27 08:51:19 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 2.9 درجة في ١ كم شرق جنوب شرق Migdal، Israel على عمق 32.835 كم بتاريخ 2018-07-27 08:51:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000gf18#dyfi"
  },
  "474": {
    "place": "٩ كم شرق Tiberias، إسرائيل",
    "latLng": [
      32.7988,
      35.6371
    ],
    "magnitude": 2.9,
    "depth": 32.799,
    "time": "2018-07-22 06:41:25 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 2.9 درجة في ٩ كم شرق Tiberias، Israel على عمق 32.799 كم بتاريخ 2018-07-22 06:41:25 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000gb36#dyfi"
  },
  "475": {
    "place": "٢٠٠ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.9438,
      51.773
    ],
    "magnitude": 5.0,
    "depth": 13.944,
    "time": "2018-07-15 13:16:04 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 5.0 درجة في ٢٠٠ كم شمال شمال غرب Kilmia، اليمن على عمق 13.944 كم بتاريخ 2018-07-15 13:16:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g9n0"
  },
  "476": {
    "place": "١٩٢ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.8484,
      51.717
    ],
    "magnitude": 6.0,
    "depth": 13.848,
    "time": "2018-07-15 13:09:16 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 6.0 درجة في ١٩٢ كم شمال شمال غرب Kilmia، اليمن على عمق 13.848 كم بتاريخ 2018-07-15 13:09:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g5mh#pager"
  },
  "477": {
    "place": "١٨٥ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      13.8182,
      51.8452
    ],
    "magnitude": 4.4,
    "depth": 13.818,
    "time": "2018-07-15 12:59:12 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.4 درجة في ١٨٥ كم شمال شمال غرب Kilmia، اليمن على عمق 13.818 كم بتاريخ 2018-07-15 12:59:12 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g5mb"
  },
  "478": {
    "place": "٢٢٦ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      14.1481,
      51.6354
    ],
    "magnitude": 5.5,
    "depth": 14.148,
    "time": "2018-07-15 01:59:08 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 5.5 درجة في ٢٢٦ كم شمال شمال غرب Kilmia، اليمن على عمق 14.148 كم بتاريخ 2018-07-15 01:59:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g9ms#pager"
  },
  "479": {
    "place": "٢١٤ كم شمال شمال غرب Kilmia، اليمن",
    "latLng": [
      14.0625,
      51.7365
    ],
    "magnitude": 6.0,
    "depth": 14.063,
    "time": "2018-07-15 01:57:19 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 6.0 درجة في ٢١٤ كم شمال شمال غرب Kilmia، اليمن على عمق 14.063 كم بتاريخ 2018-07-15 01:57:19 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g5b4#pager"
  },
  "480": {
    "place": "١٧٥ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.6304,
      52.0589
    ],
    "magnitude": 4.3,
    "depth": 14.63,
    "time": "2018-07-13 11:01:24 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في ١٧٥ كم جنوب Al Ghayz?ah، اليمن على عمق 14.63 كم بتاريخ 2018-07-13 11:01:24 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g8kb"
  },
  "481": {
    "place": "١٣٧ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.9658,
      52.069
    ],
    "magnitude": 4.7,
    "depth": 14.966,
    "time": "2018-07-12 23:34:14 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.7 درجة في ١٣٧ كم جنوب Al Ghayz?ah، اليمن على عمق 14.966 كم بتاريخ 2018-07-12 23:34:14 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000g3ki"
  },
  "482": {
    "place": "٢ كم شمال شمال شرق جفعات أفني، إسرائيل",
    "latLng": [
      32.7972,
      35.4438
    ],
    "magnitude": 4.7,
    "depth": 32.797,
    "time": "2018-07-04 19:45:40 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.7 درجة في ٢ كم شمال شمال شرق Giv‘at Avni، Israel على عمق 32.797 كم بتاريخ 2018-07-04 19:45:40 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000fx3m#dyfi"
  },
  "483": {
    "place": "١ كم شمال جفعات أفني، إسرائيل",
    "latLng": [
      32.786,
      35.4363
    ],
    "magnitude": 4.0,
    "depth": 32.786,
    "time": "2018-07-04 01:50:08 UTC",
    "region": "سوريا",
    "info": "زلزال بقوة 4.0 درجة في ١ كم شمال Giv‘at Avni، Israel على عمق 32.786 كم بتاريخ 2018-07-04 01:50:08 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000fwfr#dyfi"
  },
  "484": {
    "place": "١٩١ كم شرق شمال شرق Tok?r، Sudan",
    "latLng": [
      19.3223,
      39.2838
    ],
    "magnitude": 4.0,
    "depth": 19.322,
    "time": "2018-07-02 00:52:06 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.0 درجة في ١٩١ كم شرق شمال شرق Tok?r، Sudan على عمق 19.322 كم بتاريخ 2018-07-02 00:52:06 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000fyc8"
  },
  "485": {
    "place": "١٥٣ كم شمال كالولا، الصومال",
    "latLng": [
      13.3504,
      50.8006
    ],
    "magnitude": 4.7,
    "depth": 13.35,
    "time": "2018-06-30 01:09:30 UTC",
    "region": "اليمن",
    "info": "زلزال بقوة 4.7 درجة في ١٥٣ كم شمال كالولا، الصومال على عمق 13.35 كم بتاريخ 2018-06-30 01:09:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000fru2"
  },
  "486": {
    "place": "٤٣ كم شرق جنوب شرق مصوع، إريتريا",
    "latLng": [
      15.4068,
      39.8282
    ],
    "magnitude": 4.3,
    "depth": 15.407,
    "time": "2018-06-29 14:45:28 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.3 درجة في ٤٣ كم شرق جنوب شرق مصوع، إريتريا على عمق 15.407 كم بتاريخ 2018-06-29 14:45:28 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000fxjv"
  },
  "487": {
    "place": "٣٠ كم شمال شرق مصوع، إريتريا",
    "latLng": [
      15.7639,
      39.7051
    ],
    "magnitude": 4.6,
    "depth": 15.764,
    "time": "2018-06-19 14:06:27 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 4.6 درجة في ٣٠ كم شمال شرق مصوع، إريتريا على عمق 15.764 كم بتاريخ 2018-06-19 14:06:27 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000evi0#dyfi"
  },
  "488": {
    "place": "١٧٢ كم جنوب Al Ghayz?ah، اليمن",
    "latLng": [
      14.6508,
      52.0792
    ],
    "magnitude": 4.8,
    "depth": 14.651,
    "time": "2018-06-12 04:22:38 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.8 درجة في ١٧٢ كم جنوب Al Ghayz?ah، اليمن على عمق 14.651 كم بتاريخ 2018-06-12 04:22:38 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000envg"
  },
  "489": {
    "place": "سقطرى منطقة",
    "latLng": [
      13.4436,
      56.9177
    ],
    "magnitude": 4.3,
    "depth": 13.444,
    "time": "2018-06-09 12:32:30 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.3 درجة في Socotra region على عمق 13.444 كم بتاريخ 2018-06-09 12:32:30 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000eq44"
  },
  "490": {
    "place": "٧ كم شرق شمال شرق As Sulaym?n?yah، العراق",
    "latLng": [
      35.5896,
      45.5143
    ],
    "magnitude": 3.7,
    "depth": 35.59,
    "time": "2018-06-08 23:42:16 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 3.7 درجة في ٧ كم شرق شمال شرق As Sulaym?n?yah، العراق على عمق 35.59 كم بتاريخ 2018-06-08 23:42:16 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000emv7#dyfi"
  },
  "491": {
    "place": "٣٠ كم جنوب ?alabja، العراق",
    "latLng": [
      34.8994,
      45.9697
    ],
    "magnitude": 4.3,
    "depth": 34.899,
    "time": "2018-05-22 00:35:58 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٠ كم جنوب ?alabja، العراق على عمق 34.899 كم بتاريخ 2018-05-22 00:35:58 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000ec06"
  },
  "492": {
    "place": "٣٦ كم جنوب جنوب غرب ?alabja، العراق",
    "latLng": [
      34.8906,
      45.8006
    ],
    "magnitude": 4.5,
    "depth": 34.891,
    "time": "2018-05-22 00:31:53 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٣٦ كم جنوب جنوب غرب ?alabja، العراق على عمق 34.891 كم بتاريخ 2018-05-22 00:31:53 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000e9mv"
  },
  "493": {
    "place": "٢٧٥ كم جنوب جنوب شرق Sur، عمان",
    "latLng": [
      20.4886,
      60.9855
    ],
    "magnitude": 4.2,
    "depth": 20.489,
    "time": "2018-05-04 12:09:04 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.2 درجة في ٢٧٥ كم جنوب جنوب شرق Sur، عمان على عمق 20.489 كم بتاريخ 2018-05-04 12:09:04 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000dxv0"
  },
  "494": {
    "place": "٢١ كم جنوب جنوب شرق Koysinceq، العراق",
    "latLng": [
      35.8914,
      44.6868
    ],
    "magnitude": 4.6,
    "depth": 35.891,
    "time": "2018-04-16 04:30:35 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.6 درجة في ٢١ كم جنوب جنوب شرق Koysinceq، العراق على عمق 35.891 كم بتاريخ 2018-04-16 04:30:35 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000e0te#dyfi"
  },
  "495": {
    "place": "٥٨ كم شرق Mek'ele، إثيوبيا",
    "latLng": [
      13.4048,
      40.0116
    ],
    "magnitude": 5.2,
    "depth": 13.405,
    "time": "2018-03-24 10:27:32 UTC",
    "region": "البحر الأحمر",
    "info": "زلزال بقوة 5.2 درجة في ٥٨ كم شرق Mek'ele، إثيوبيا على عمق 13.405 كم بتاريخ 2018-03-24 10:27:32 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000d8jy"
  },
  "496": {
    "place": "٢٦ كم شرق جنوب شرق Al Miqd?d?yah، العراق",
    "latLng": [
      33.8472,
      45.1819
    ],
    "magnitude": 4.0,
    "depth": 33.847,
    "time": "2018-02-24 16:26:34 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٢٦ كم شرق جنوب شرق Al Miqd?d?yah، العراق على عمق 33.847 كم بتاريخ 2018-02-24 16:26:34 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000d7f3#dyfi"
  },
  "497": {
    "place": "٣٠ كم شرق شمال شرق Koysinceq، العراق",
    "latLng": [
      36.1491,
      44.9604
    ],
    "magnitude": 4.3,
    "depth": 36.149,
    "time": "2018-02-19 21:31:39 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.3 درجة في ٣٠ كم شرق شمال شرق Koysinceq، العراق على عمق 36.149 كم بتاريخ 2018-02-19 21:31:39 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000d4y8#dyfi"
  },
  "498": {
    "place": "٢٣ كم شرق جنوب شرق Koysinceq، العراق",
    "latLng": [
      35.9968,
      44.8643
    ],
    "magnitude": 4.5,
    "depth": 35.997,
    "time": "2018-02-19 19:20:45 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.5 درجة في ٢٣ كم شرق جنوب شرق Koysinceq، العراق على عمق 35.997 كم بتاريخ 2018-02-19 19:20:45 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000d4wi"
  },
  "499": {
    "place": "٢٨ كم جنوب جنوب شرق Mandal?، العراق",
    "latLng": [
      33.5158,
      45.6954
    ],
    "magnitude": 4.0,
    "depth": 33.516,
    "time": "2018-02-16 18:22:00 UTC",
    "region": "العراق",
    "info": "زلزال بقوة 4.0 درجة في ٢٨ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.516 كم بتاريخ 2018-02-16 18:22:00 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000d897"
  },
  "500": {
    "place": "٢٩٩ كم شمال شرق Hadibu، اليمن",
    "latLng": [
      14.7789,
      55.7296
    ],
    "magnitude": 4.4,
    "depth": 14.779,
    "time": "2018-02-15 06:45:48 UTC",
    "region": "بحر العرب",
    "info": "زلزال بقوة 4.4 درجة في ٢٩٩ كم شمال شرق Hadibu، اليمن على عمق 14.779 كم بتاريخ 2018-02-15 06:45:48 UTC.",
    "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000d700"
  },
  // "501": {
  //   "place": "٢٠ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6345,
  //     45.7253
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 33.635,
  //   "time": "2018-01-31 21:29:11 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٠ كم جنوب شرق Mandal?، العراق على عمق 33.635 كم بتاريخ 2018-01-31 21:29:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000cdef#dyfi"
  // },
  // "502": {
  //   "place": "١٨٩ كم شرق Sur، عمان",
  //   "latLng": [
  //     22.8723,
  //     61.3477
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 22.872,
  //   "time": "2018-01-27 11:01:45 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ١٨٩ كم شرق Sur، عمان على عمق 22.872 كم بتاريخ 2018-01-27 11:01:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cqbs"
  // },
  // "503": {
  //   "place": "٢٤ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6132,
  //     45.759
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 33.613,
  //   "time": "2018-01-26 21:12:58 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٤ كم جنوب شرق Mandal?، العراق على عمق 33.613 كم بتاريخ 2018-01-26 21:12:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000cif2"
  // },
  // "504": {
  //   "place": "٢٠ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5825,
  //     45.6598
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 33.583,
  //   "time": "2018-01-26 20:17:35 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٠ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.583 كم بتاريخ 2018-01-26 20:17:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cq1f#dyfi"
  // },
  // "505": {
  //   "place": "٣٥ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.4388,
  //     45.651
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.439,
  //   "time": "2018-01-21 13:21:30 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٣٥ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.439 كم بتاريخ 2018-01-21 13:21:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000cdsh"
  // },
  // "506": {
  //   "place": "١٥ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7156,
  //     45.7137
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 33.716,
  //   "time": "2018-01-19 22:17:55 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.0 درجة في ١٥ كم شرق جنوب شرق Mandal?، العراق على عمق 33.716 كم بتاريخ 2018-01-19 22:17:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000clji#dyfi"
  // },
  // "507": {
  //   "place": "٢٩٣ كم جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     14.8201,
  //     55.626
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.82,
  //   "time": "2018-01-19 09:37:58 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٩٣ كم جنوب شرق ?al?lah، عمان على عمق 14.82 كم بتاريخ 2018-01-19 09:37:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cl3h"
  // },
  // "508": {
  //   "place": "٣٢ كم جنوب شرق Kifr?، العراق",
  //   "latLng": [
  //     34.4907,
  //     45.2213
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.491,
  //   "time": "2018-01-18 16:48:38 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ٣٢ كم جنوب شرق Kifr?، العراق على عمق 34.491 كم بتاريخ 2018-01-18 16:48:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000crrp"
  // },
  // "509": {
  //   "place": "٣٣ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.4582,
  //     45.6685
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 33.458,
  //   "time": "2018-01-16 15:29:58 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٣٣ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.458 كم بتاريخ 2018-01-16 15:29:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cqy9"
  // },
  // "510": {
  //   "place": "٢١ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5838,
  //     45.6706
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.584,
  //   "time": "2018-01-15 15:04:59 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.584 كم بتاريخ 2018-01-15 15:04:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpye"
  // },
  // "511": {
  //   "place": "٢٧ كم جنوب غرب Al ‘Am?rah، العراق",
  //   "latLng": [
  //     31.6495,
  //     46.961
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 31.65,
  //   "time": "2018-01-15 14:27:45 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٧ كم جنوب غرب Al ‘Am?rah، العراق على عمق 31.65 كم بتاريخ 2018-01-15 14:27:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cjny"
  // },
  // "512": {
  //   "place": "٢٢ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.582,
  //     45.7026
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 33.582,
  //   "time": "2018-01-13 09:31:53 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٢ كم جنوب شرق Mandal?، العراق على عمق 33.582 كم بتاريخ 2018-01-13 09:31:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpuv"
  // },
  // "513": {
  //   "place": "١٦ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6269,
  //     45.653
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 33.627,
  //   "time": "2018-01-13 09:24:19 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ١٦ كم جنوب شرق Mandal?، العراق على عمق 33.627 كم بتاريخ 2018-01-13 09:24:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpuu"
  // },
  // "514": {
  //   "place": "٢٣ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.581,
  //     45.7035
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.581,
  //   "time": "2018-01-13 06:30:30 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٣ كم جنوب شرق Mandal?، العراق على عمق 33.581 كم بتاريخ 2018-01-13 06:30:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cj8q"
  // },
  // "515": {
  //   "place": "٢٥ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5382,
  //     45.663
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.538,
  //   "time": "2018-01-13 00:33:28 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٥ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.538 كم بتاريخ 2018-01-13 00:33:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cj67"
  // },
  // "516": {
  //   "place": "٩ كم شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7338,
  //     45.6574
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.734,
  //   "time": "2018-01-12 19:14:18 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٩ كم شرق Mandal?، العراق على عمق 33.734 كم بتاريخ 2018-01-12 19:14:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cps7"
  // },
  // "517": {
  //   "place": "١٨ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6246,
  //     45.6881
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 33.625,
  //   "time": "2018-01-12 17:50:41 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ١٨ كم جنوب شرق Mandal?، العراق على عمق 33.625 كم بتاريخ 2018-01-12 17:50:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cj0m#dyfi"
  // },
  // "518": {
  //   "place": "٢٨ كم جنوب Mandal?، العراق",
  //   "latLng": [
  //     33.4965,
  //     45.5812
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.497,
  //   "time": "2018-01-12 11:43:47 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٨ كم جنوب Mandal?، العراق على عمق 33.497 كم بتاريخ 2018-01-12 11:43:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cprq"
  // },
  // "519": {
  //   "place": "١١ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6461,
  //     45.5898
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 33.646,
  //   "time": "2018-01-11 21:52:22 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ١١ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.646 كم بتاريخ 2018-01-11 21:52:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpb4"
  // },
  // "520": {
  //   "place": "١٢ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6792,
  //     45.6657
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 33.679,
  //   "time": "2018-01-11 21:50:44 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.7 درجة في ١٢ كم جنوب شرق Mandal?، العراق على عمق 33.679 كم بتاريخ 2018-01-11 21:50:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cikp#dyfi"
  // },
  // "521": {
  //   "place": "٢٥ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5562,
  //     45.7028
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.556,
  //   "time": "2018-01-11 20:19:40 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٥ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.556 كم بتاريخ 2018-01-11 20:19:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpb2"
  // },
  // "522": {
  //   "place": "١٥ كم جنوب Mandal?، العراق",
  //   "latLng": [
  //     33.6076,
  //     45.5355
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 33.608,
  //   "time": "2018-01-11 14:47:17 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ١٥ كم جنوب Mandal?، العراق على عمق 33.608 كم بتاريخ 2018-01-11 14:47:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpaw"
  // },
  // "523": {
  //   "place": "٢٠ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5991,
  //     45.6818
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.599,
  //   "time": "2018-01-11 13:30:46 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٠ كم جنوب شرق Mandal?، العراق على عمق 33.599 كم بتاريخ 2018-01-11 13:30:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci9g"
  // },
  // "524": {
  //   "place": "٤١ كم جنوب جنوب غرب Mandal?، العراق",
  //   "latLng": [
  //     33.3839,
  //     45.4338
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 33.384,
  //   "time": "2018-01-11 13:16:39 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٤١ كم جنوب جنوب غرب Mandal?، العراق على عمق 33.384 كم بتاريخ 2018-01-11 13:16:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci8s"
  // },
  // "525": {
  //   "place": "٣٢ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5063,
  //     45.7503
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 33.506,
  //   "time": "2018-01-11 09:32:24 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ٣٢ كم جنوب شرق Mandal?، العراق على عمق 33.506 كم بتاريخ 2018-01-11 09:32:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci5f"
  // },
  // "526": {
  //   "place": "١٩ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5892,
  //     45.6507
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.589,
  //   "time": "2018-01-11 09:23:56 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ١٩ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.589 كم بتاريخ 2018-01-11 09:23:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci5c"
  // },
  // "527": {
  //   "place": "١٩ كم شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7824,
  //     45.7663
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.782,
  //   "time": "2018-01-11 08:17:58 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ١٩ كم شرق Mandal?، العراق على عمق 33.782 كم بتاريخ 2018-01-11 08:17:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci9w"
  // },
  // "528": {
  //   "place": "١٤ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7205,
  //     45.7027
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 33.721,
  //   "time": "2018-01-11 08:00:39 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.3 درجة في ١٤ كم شرق جنوب شرق Mandal?، العراق على عمق 33.721 كم بتاريخ 2018-01-11 08:00:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci4h#dyfi"
  // },
  // "529": {
  //   "place": "٢٢ كم شرق Mandal?، العراق",
  //   "latLng": [
  //     33.711,
  //     45.7897
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 33.711,
  //   "time": "2018-01-11 07:55:00 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.1 درجة في ٢٢ كم شرق Mandal?، العراق على عمق 33.711 كم بتاريخ 2018-01-11 07:55:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci4f"
  // },
  // "530": {
  //   "place": "٨ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6883,
  //     45.6089
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.688,
  //   "time": "2018-01-11 07:52:47 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٨ كم جنوب شرق Mandal?، العراق على عمق 33.688 كم بتاريخ 2018-01-11 07:52:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci4e"
  // },
  // "531": {
  //   "place": "١٧ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6761,
  //     45.7214
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.676,
  //   "time": "2018-01-11 07:37:08 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ١٧ كم شرق جنوب شرق Mandal?، العراق على عمق 33.676 كم بتاريخ 2018-01-11 07:37:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci49#dyfi"
  // },
  // "532": {
  //   "place": "١٣ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7172,
  //     45.6934
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 33.717,
  //   "time": "2018-01-11 07:21:33 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.7 درجة في ١٣ كم شرق جنوب شرق Mandal?، العراق على عمق 33.717 كم بتاريخ 2018-01-11 07:21:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cpan"
  // },
  // "533": {
  //   "place": "١٧ كم شرق شمال شرق Mandal?، العراق",
  //   "latLng": [
  //     33.8017,
  //     45.7299
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 33.802,
  //   "time": "2018-01-11 07:14:15 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.3 درجة في ١٧ كم شرق شمال شرق Mandal?، العراق على عمق 33.802 كم بتاريخ 2018-01-11 07:14:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci3y#dyfi"
  // },
  // "534": {
  //   "place": "٢٥ كم شرق شمال شرق Mandal?، العراق",
  //   "latLng": [
  //     33.8578,
  //     45.7935
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 33.858,
  //   "time": "2018-01-11 07:00:52 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.3 درجة في ٢٥ كم شرق شمال شرق Mandal?، العراق على عمق 33.858 كم بتاريخ 2018-01-11 07:00:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci3x"
  // },
  // "535": {
  //   "place": "١٦ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7131,
  //     45.7239
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 33.713,
  //   "time": "2018-01-11 06:59:30 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.5 درجة في ١٦ كم شرق جنوب شرق Mandal?، العراق على عمق 33.713 كم بتاريخ 2018-01-11 06:59:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ci3s#pager"
  // },
  // "536": {
  //   "place": "٢٢٨ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.9302,
  //     40.111
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 17.93,
  //   "time": "2018-01-08 15:07:55 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٢٨ كم غرب Ad Darb، السعودية على عمق 17.93 كم بتاريخ 2018-01-08 15:07:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000cmzx"
  // },
  // "537": {
  //   "place": "٣٥ كم جنوب ?alabja، العراق",
  //   "latLng": [
  //     34.858,
  //     46.0246
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.858,
  //   "time": "2017-12-26 09:11:33 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ٣٥ كم جنوب ?alabja، العراق على عمق 34.858 كم بتاريخ 2017-12-26 09:11:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000bwab"
  // },
  // "538": {
  //   "place": "١٢ كم شرق جنوب شرق Al Miqd?d?yah، العراق",
  //   "latLng": [
  //     33.9389,
  //     45.0621
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.939,
  //   "time": "2017-12-19 15:13:14 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ١٢ كم شرق جنوب شرق Al Miqd?d?yah، العراق على عمق 33.939 كم بتاريخ 2017-12-19 15:13:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000bzd4"
  // },
  // "539": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     17.5779,
  //     60.0349
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 17.578,
  //   "time": "2017-12-19 07:44:37 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 17.578 كم بتاريخ 2017-12-19 07:44:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000bzcj"
  // },
  // "540": {
  //   "place": "٢٧ كم جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     35.0283,
  //     45.7471
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.028,
  //   "time": "2017-12-11 14:42:40 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٧ كم جنوب غرب ?alabja، العراق على عمق 35.028 كم بتاريخ 2017-12-11 14:42:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000c2ug#dyfi"
  // },
  // "541": {
  //   "place": "٢٣ كم غرب جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     35.0786,
  //     45.7614
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 35.079,
  //   "time": "2017-12-11 14:09:57 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.4 درجة في ٢٣ كم غرب جنوب غرب ?alabja، العراق على عمق 35.079 كم بتاريخ 2017-12-11 14:09:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000c2ue#pager"
  // },
  // "542": {
  //   "place": "١٨ كم غرب جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     35.1223,
  //     45.7924
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 35.122,
  //   "time": "2017-12-08 01:55:01 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ١٨ كم غرب جنوب غرب ?alabja، العراق على عمق 35.122 كم بتاريخ 2017-12-08 01:55:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000c1x9#dyfi"
  // },
  // "543": {
  //   "place": "٢٢٢ كم شرق شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     13.5441,
  //     55.8554
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.544,
  //   "time": "2017-11-28 05:45:40 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٢٢ كم شرق شمال شرق Hadibu، اليمن على عمق 13.544 كم بتاريخ 2017-11-28 05:45:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000bmqk"
  // },
  // "544": {
  //   "place": "٥٠ كم جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     34.916,
  //     45.5326
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.916,
  //   "time": "2017-11-22 16:42:36 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٥٠ كم جنوب غرب ?alabja، العراق على عمق 34.916 كم بتاريخ 2017-11-22 16:42:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bsx1#dyfi"
  // },
  // "545": {
  //   "place": "١٥٠ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.8457,
  //     52.1347
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.846,
  //   "time": "2017-11-22 03:49:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ١٥٠ كم جنوب Al Ghayz?ah، اليمن على عمق 14.846 كم بتاريخ 2017-11-22 03:49:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bspd"
  // },
  // "546": {
  //   "place": "٤٣ كم شرق جنوب شرق Kifr?، العراق",
  //   "latLng": [
  //     34.5723,
  //     45.4086
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.572,
  //   "time": "2017-11-14 00:06:36 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٤٣ كم شرق جنوب شرق Kifr?، العراق على عمق 34.572 كم بتاريخ 2017-11-14 00:06:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bn02"
  // },
  // "547": {
  //   "place": "٣٣ كم جنوب جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     34.9133,
  //     45.8073
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.913,
  //   "time": "2017-11-13 14:01:48 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ٣٣ كم جنوب جنوب غرب ?alabja، العراق على عمق 34.913 كم بتاريخ 2017-11-13 14:01:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bsyy"
  // },
  // "548": {
  //   "place": "٢٠ كم جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     35.0671,
  //     45.8121
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.067,
  //   "time": "2017-11-13 04:41:42 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٠ كم جنوب غرب ?alabja، العراق على عمق 35.067 كم بتاريخ 2017-11-13 04:41:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bsxg"
  // },
  // "549": {
  //   "place": "٣٥ كم جنوب جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     34.8864,
  //     45.8365
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.886,
  //   "time": "2017-11-13 03:14:36 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٣٥ كم جنوب جنوب غرب ?alabja، العراق على عمق 34.886 كم بتاريخ 2017-11-13 03:14:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bsxn"
  // },
  // "550": {
  //   "place": "٤٦ كم جنوب غرب ?alabja، العراق",
  //   "latLng": [
  //     34.9224,
  //     45.5873
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 34.922,
  //   "time": "2017-11-12 18:29:52 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.3 درجة في ٤٦ كم جنوب غرب ?alabja، العراق على عمق 34.922 كم بتاريخ 2017-11-12 18:29:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bme6#dyfi"
  // },
  // "551": {
  //   "place": "٢٩ كم جنوب ?alabja، العراق",
  //   "latLng": [
  //     34.9109,
  //     45.9592
  //   ],
  //   "magnitude": 7.3,
  //   "depth": 34.911,
  //   "time": "2017-11-12 18:18:17 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 7.3 درجة في ٢٩ كم جنوب ?alabja، العراق على عمق 34.911 كم بتاريخ 2017-11-12 18:18:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000bmcg#pager"
  // },
  // "552": {
  //   "place": "٢٤٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7125,
  //     54.7094
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 14.713,
  //   "time": "2017-09-08 17:35:36 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.1 درجة في ٢٤٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.713 كم بتاريخ 2017-09-08 17:35:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ai7w"
  // },
  // "553": {
  //   "place": "٢٣٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6837,
  //     54.7693
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.684,
  //   "time": "2017-09-08 17:20:19 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٣٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.684 كم بتاريخ 2017-09-08 17:20:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000ars4"
  // },
  // "554": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.7418,
  //     54.8074
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.742,
  //   "time": "2017-09-08 10:08:24 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.742 كم بتاريخ 2017-09-08 10:08:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000arrg"
  // },
  // "555": {
  //   "place": "٢٩ كم شرق شمال شرق Koysinceq، العراق",
  //   "latLng": [
  //     36.1833,
  //     44.9358
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 36.183,
  //   "time": "2017-08-23 13:42:53 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.1 درجة في ٢٩ كم شرق شمال شرق Koysinceq، العراق على عمق 36.183 كم بتاريخ 2017-08-23 13:42:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000aay1#pager"
  // },
  // "556": {
  //   "place": "العراق",
  //   "latLng": [
  //     31.7684,
  //     46.0454
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 31.768,
  //   "time": "2017-08-18 10:18:44 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.7 درجة في العراق على عمق 31.768 كم بتاريخ 2017-08-18 10:18:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000a9bq#shakemap"
  // },
  // "557": {
  //   "place": "٢٤٩ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.0152,
  //     55.8454
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.015,
  //   "time": "2017-07-31 00:08:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٤٩ كم شمال شرق Hadibu، اليمن على عمق 14.015 كم بتاريخ 2017-07-31 00:08:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000a4g5"
  // },
  // "558": {
  //   "place": "١٨٧ كم شرق جنوب شرق Mukalla، اليمن",
  //   "latLng": [
  //     13.6851,
  //     50.625
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.685,
  //   "time": "2017-07-28 04:23:43 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.5 درجة في ١٨٧ كم شرق جنوب شرق Mukalla، اليمن على عمق 13.685 كم بتاريخ 2017-07-28 04:23:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000a22e"
  // },
  // "559": {
  //   "place": "١٤٠ كم غرب جنوب غرب R?bigh، السعودية",
  //   "latLng": [
  //     22.1304,
  //     37.8707
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 22.13,
  //   "time": "2017-06-19 13:42:59 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٤٠ كم غرب جنوب غرب R?bigh، السعودية على عمق 22.13 كم بتاريخ 2017-06-19 13:42:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20009nky"
  // },
  // "560": {
  //   "place": "٢٨ كم شمال Ash Sha?rah، العراق",
  //   "latLng": [
  //     31.6622,
  //     46.1614
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 31.662,
  //   "time": "2017-06-02 16:09:54 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٨ كم شمال Ash Sha?rah، العراق على عمق 31.662 كم بتاريخ 2017-06-02 16:09:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20009ja7#dyfi"
  // },
  // "561": {
  //   "place": "٢٥٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7631,
  //     54.8578
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.763,
  //   "time": "2017-05-30 07:20:32 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٥٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.763 كم بتاريخ 2017-05-30 07:20:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008wcz"
  // },
  // "562": {
  //   "place": "٢٥٣ كم جنوب جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     14.8849,
  //     54.9673
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.885,
  //   "time": "2017-05-24 02:23:08 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٥٣ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.885 كم بتاريخ 2017-05-24 02:23:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008wn0"
  // },
  // "563": {
  //   "place": "٢٥٨ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7887,
  //     54.9813
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.789,
  //   "time": "2017-05-23 19:01:22 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٥٨ كم شمال شمال شرق Hadibu، اليمن على عمق 14.789 كم بتاريخ 2017-05-23 19:01:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008ug1"
  // },
  // "564": {
  //   "place": "٢٥٧ كم جنوب جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     14.8252,
  //     54.9178
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.825,
  //   "time": "2017-05-23 18:41:45 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥٧ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.825 كم بتاريخ 2017-05-23 18:41:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008wjn"
  // },
  // "565": {
  //   "place": "٢١٨ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     14.0746,
  //     51.6302
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.075,
  //   "time": "2017-05-19 09:08:46 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.7 درجة في ٢١٨ كم شمال شمال غرب Kilmia، اليمن على عمق 14.075 كم بتاريخ 2017-05-19 09:08:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008tie"
  // },
  // "566": {
  //   "place": "٢٢٣ كم شرق جنوب شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.0378,
  //     39.802
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 18.038,
  //   "time": "2017-05-08 05:40:47 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٢٣ كم شرق جنوب شرق Tok?r، Sudan على عمق 18.038 كم بتاريخ 2017-05-08 05:40:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008rwr"
  // },
  // "567": {
  //   "place": "٢١٧ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.803,
  //     40.2021
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 17.803,
  //   "time": "2017-05-07 14:23:33 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٢١٧ كم غرب Ad Darb، السعودية على عمق 17.803 كم بتاريخ 2017-05-07 14:23:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008qb8#dyfi"
  // },
  // "568": {
  //   "place": "٢٩٨ كم شرق شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.0952,
  //     56.3416
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.095,
  //   "time": "2017-04-30 15:08:47 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٩٨ كم شرق شمال شرق Hadibu، اليمن على عمق 14.095 كم بتاريخ 2017-04-30 15:08:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008prn"
  // },
  // "569": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.3835,
  //     56.6192
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.384,
  //   "time": "2017-04-30 07:03:21 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.384 كم بتاريخ 2017-04-30 07:03:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008prc"
  // },
  // "570": {
  //   "place": "١٣٥ كم شرق Sur، عمان",
  //   "latLng": [
  //     22.6711,
  //     60.8412
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 22.671,
  //   "time": "2017-04-27 21:27:29 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ١٣٥ كم شرق Sur، عمان على عمق 22.671 كم بتاريخ 2017-04-27 21:27:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008lf3"
  // },
  // "571": {
  //   "place": "سقطرى منطقة",
  //   "latLng": [
  //     13.7807,
  //     56.9205
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.781,
  //   "time": "2017-04-07 09:04:26 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في Socotra region على عمق 13.781 كم بتاريخ 2017-04-07 09:04:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008h76"
  // },
  // "572": {
  //   "place": "١٦ كم شرق جنوب شرق Umm Qa?r، العراق",
  //   "latLng": [
  //     29.978,
  //     48.081
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 29.978,
  //   "time": "2017-04-02 04:39:18 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.0 درجة في ١٦ كم شرق جنوب شرق Umm Qa?r، العراق على عمق 29.978 كم بتاريخ 2017-04-02 04:39:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008fhm#dyfi"
  // },
  // "573": {
  //   "place": "١٦٧ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.6923,
  //     52.2569
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.692,
  //   "time": "2017-03-26 16:08:41 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ١٦٧ كم جنوب Al Ghayz?ah، اليمن على عمق 14.692 كم بتاريخ 2017-03-26 16:08:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10008dkj"
  // },
  // "574": {
  //   "place": "٢٩٣ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6321,
  //     55.8151
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.632,
  //   "time": "2017-02-04 11:20:24 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٩٣ كم شمال شرق Hadibu، اليمن على عمق 14.632 كم بتاريخ 2017-02-04 11:20:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20008kfk"
  // },
  // "575": {
  //   "place": "١٧١ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.925,
  //     39.2728
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 18.925,
  //   "time": "2017-01-24 22:42:43 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ١٧١ كم شرق شمال شرق Tok?r، Sudan على عمق 18.925 كم بتاريخ 2017-01-24 22:42:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20008iha"
  // },
  // "576": {
  //   "place": "٨ كم شمال شمال غرب Dahab، مصر",
  //   "latLng": [
  //     28.5557,
  //     34.458
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.556,
  //   "time": "2016-11-29 17:01:13 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.4 درجة في ٨ كم شمال شمال غرب Dahab، Egypt على عمق 28.556 كم بتاريخ 2016-11-29 17:01:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10007d4k#dyfi"
  // },
  // "577": {
  //   "place": "٢٠٩ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.5659,
  //     53.736
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 14.566,
  //   "time": "2016-11-28 11:26:15 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.4 درجة في ٢٠٩ كم شمال Qalans?yah، اليمن على عمق 14.566 كم بتاريخ 2016-11-28 11:26:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10007cx2"
  // },
  // "578": {
  //   "place": "١٦١ كم شمال كالولا، الصومال",
  //   "latLng": [
  //     13.4256,
  //     50.6556
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.426,
  //   "time": "2016-11-02 21:29:39 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.2 درجة في ١٦١ كم شمال كالولا، الصومال على عمق 13.426 كم بتاريخ 2016-11-02 21:29:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100076h7"
  // },
  // "579": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.4705,
  //     56.6749
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.471,
  //   "time": "2016-11-02 04:41:53 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.471 كم بتاريخ 2016-11-02 04:41:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100076gn"
  // },
  // "580": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.1755,
  //     56.6854
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.176,
  //   "time": "2016-11-02 00:06:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في منطقة صدع أوين على عمق 14.176 كم بتاريخ 2016-11-02 00:06:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100076gk"
  // },
  // "581": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.2837,
  //     56.6997
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.284,
  //   "time": "2016-11-01 23:57:07 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.284 كم بتاريخ 2016-11-01 23:57:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usa001497y"
  // },
  // "582": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.2961,
  //     56.6294
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.296,
  //   "time": "2016-11-01 23:55:25 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 14.296 كم بتاريخ 2016-11-01 23:55:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100073l3#dyfi"
  // },
  // "583": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.2687,
  //     56.6501
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.269,
  //   "time": "2016-11-01 23:29:33 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.269 كم بتاريخ 2016-11-01 23:29:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100073ky"
  // },
  // "584": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.301,
  //     56.5247
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.301,
  //   "time": "2016-11-01 23:18:13 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.301 كم بتاريخ 2016-11-01 23:18:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100073kw"
  // },
  // "585": {
  //   "place": "٢٩٢ كم جنوب شرق Sur، عمان",
  //   "latLng": [
  //     20.8773,
  //     61.6968
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 20.877,
  //   "time": "2016-10-31 16:02:43 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.4 درجة في ٢٩٢ كم جنوب شرق Sur، عمان على عمق 20.877 كم بتاريخ 2016-10-31 16:02:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000739d#pager"
  // },
  // "586": {
  //   "place": "١٥٧ كم شمال كالولا، الصومال",
  //   "latLng": [
  //     13.3793,
  //     50.9174
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.379,
  //   "time": "2016-10-12 04:01:23 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.5 درجة في ١٥٧ كم شمال كالولا، الصومال على عمق 13.379 كم بتاريخ 2016-10-12 04:01:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20007dca"
  // },
  // "587": {
  //   "place": "٣٣ كم شمال شمال غرب Dham?r، اليمن",
  //   "latLng": [
  //     14.8196,
  //     44.2894
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.82,
  //   "time": "2016-09-13 17:08:03 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.0 درجة في ٣٣ كم شمال شمال غرب Dham?r، اليمن على عمق 14.82 كم بتاريخ 2016-09-13 17:08:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10006r4l"
  // },
  // "588": {
  //   "place": "٨ كم شرق شمال شرق Ban? al ‘Aww?m، اليمن",
  //   "latLng": [
  //     15.6092,
  //     43.6599
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 15.609,
  //   "time": "2016-08-09 02:06:22 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٨ كم شرق شمال شرق Ban? al ‘Aww?m، اليمن على عمق 15.609 كم بتاريخ 2016-08-09 02:06:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10006cyn"
  // },
  // "589": {
  //   "place": "٧٧ كم جنوب Ar Raqqah، سوريا",
  //   "latLng": [
  //     35.2548,
  //     39.0853
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.255,
  //   "time": "2016-07-28 16:13:33 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٧٧ كم جنوب Ar Raqqah، سوريا على عمق 35.255 كم بتاريخ 2016-07-28 16:13:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000682z#dyfi"
  // },
  // "590": {
  //   "place": "١١ كم شمال Tadmur، سوريا",
  //   "latLng": [
  //     34.6621,
  //     38.2693
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.662,
  //   "time": "2016-07-24 20:33:40 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ١١ كم شمال Tadmur، سوريا على عمق 34.662 كم بتاريخ 2016-07-24 20:33:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20006haq"
  // },
  // "591": {
  //   "place": "٣٧ كم شمال شمال شرق Ahl Mohammed bin Ahmed، اليمن",
  //   "latLng": [
  //     13.5621,
  //     45.5838
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.562,
  //   "time": "2016-07-19 22:33:06 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.2 درجة في ٣٧ كم شمال شمال شرق Ahl Mohammed bin Ahmed، اليمن على عمق 13.562 كم بتاريخ 2016-07-19 22:33:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20006gt0#dyfi"
  // },
  // "592": {
  //   "place": "١١٠ كم جنوب غرب Umluj، السعودية",
  //   "latLng": [
  //     24.2297,
  //     36.6083
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 24.23,
  //   "time": "2016-07-19 17:05:28 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ١١٠ كم جنوب غرب Umluj، السعودية على عمق 24.23 كم بتاريخ 2016-07-19 17:05:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20006gst"
  // },
  // "593": {
  //   "place": "١٧ كم شمال ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.6165,
  //     46.7198
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 32.617,
  //   "time": "2016-07-15 17:20:13 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ١٧ كم شمال ‘Al? al Gharb?، العراق على عمق 32.617 كم بتاريخ 2016-07-15 17:20:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20006f0m#dyfi"
  // },
  // "594": {
  //   "place": "٢٠٦ كم شمال Kilmia، اليمن",
  //   "latLng": [
  //     14.0179,
  //     51.8713
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.018,
  //   "time": "2016-07-01 01:26:07 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٠٦ كم شمال Kilmia، اليمن على عمق 14.018 كم بتاريخ 2016-07-01 01:26:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100061dg#dyfi"
  // },
  // "595": {
  //   "place": "١٩ كم جنوب غرب Ra’s Bayr?t، Lebanon",
  //   "latLng": [
  //     33.7952,
  //     35.3132
  //   ],
  //   "magnitude": 3.7,
  //   "depth": 33.795,
  //   "time": "2016-06-29 13:24:32 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 3.7 درجة في ١٩ كم جنوب غرب Ra’s Bayr?t، Lebanon على عمق 33.795 كم بتاريخ 2016-06-29 13:24:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005yg6#dyfi"
  // },
  // "596": {
  //   "place": "٣٤ كم شرق شمال شرق Kifr?، العراق",
  //   "latLng": [
  //     34.819,
  //     45.299
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.819,
  //   "time": "2016-06-22 21:05:43 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٣٤ كم شرق شمال شرق Kifr?، العراق على عمق 34.819 كم بتاريخ 2016-06-22 21:05:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000663h"
  // },
  // "597": {
  //   "place": "٢٨ كم غرب شمال غرب Al Bayda، اليمن",
  //   "latLng": [
  //     14.0889,
  //     45.3292
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 14.089,
  //   "time": "2016-05-24 17:43:28 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٨ كم غرب شمال غرب Al Bayda، اليمن على عمق 14.089 كم بتاريخ 2016-05-24 17:43:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005jn7#dyfi"
  // },
  // "598": {
  //   "place": "٢٢ كم شمال شمال شرق Dahab، مصر",
  //   "latLng": [
  //     28.6516,
  //     34.6194
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 28.652,
  //   "time": "2016-05-16 01:45:59 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 5.0 درجة في ٢٢ كم شمال شمال شرق Dahab، Egypt على عمق 28.652 كم بتاريخ 2016-05-16 01:45:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005hn2#dyfi"
  // },
  // "599": {
  //   "place": "١٩٠ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.8754,
  //     51.8826
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 13.875,
  //   "time": "2016-05-07 10:51:48 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.9 درجة في ١٩٠ كم شمال شمال غرب Kilmia، اليمن على عمق 13.875 كم بتاريخ 2016-05-07 10:51:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005fq1#dyfi"
  // },
  // "600": {
  //   "place": "١٨٥ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.7991,
  //     51.7781
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.799,
  //   "time": "2016-05-05 21:57:05 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.2 درجة في ١٨٥ كم شمال شمال غرب Kilmia، اليمن على عمق 13.799 كم بتاريخ 2016-05-05 21:57:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005h2v#dyfi"
  // },
  // "601": {
  //   "place": "١٧٢ كم شمال Kilmia، اليمن",
  //   "latLng": [
  //     13.7129,
  //     51.9332
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.713,
  //   "time": "2016-05-05 18:21:58 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.4 درجة في ١٧٢ كم شمال Kilmia، اليمن على عمق 13.713 كم بتاريخ 2016-05-05 18:21:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005e3m#dyfi"
  // },
  // "602": {
  //   "place": "١٨٨ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.8299,
  //     51.7807
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 13.83,
  //   "time": "2016-05-05 16:59:21 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.1 درجة في ١٨٨ كم شمال شمال غرب Kilmia، اليمن على عمق 13.83 كم بتاريخ 2016-05-05 16:59:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005h2l"
  // },
  // "603": {
  //   "place": "١٨٢ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.7719,
  //     51.7683
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 13.772,
  //   "time": "2016-05-05 07:01:47 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 5.5 درجة في ١٨٢ كم شمال شمال غرب Kilmia، اليمن على عمق 13.772 كم بتاريخ 2016-05-05 07:01:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10005dz1#pager"
  // },
  // "604": {
  //   "place": "٢٨٠ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5551,
  //     55.731
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.555,
  //   "time": "2016-04-16 16:29:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٨٠ كم شمال شرق Hadibu، اليمن على عمق 14.555 كم بتاريخ 2016-04-16 16:29:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20005j1d#dyfi"
  // },
  // "605": {
  //   "place": "١٩٣ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.7752,
  //     39.5244
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 18.775,
  //   "time": "2016-04-09 00:26:50 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٩٣ كم شرق شمال شرق Tok?r، Sudan على عمق 18.775 كم بتاريخ 2016-04-09 00:26:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20005ghx#dyfi"
  // },
  // "606": {
  //   "place": "١١ كم جنوب شرق Ceyhan، تركيا",
  //   "latLng": [
  //     36.94,
  //     35.89
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.94,
  //   "time": "2016-03-31 21:33:22 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.3 درجة في ١١ كم جنوب شرق Ceyhan، تركيا على عمق 36.94 كم بتاريخ 2016-03-31 21:33:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20005dru#dyfi"
  // },
  // "607": {
  //   "place": "١٨٢ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.578,
  //     52.4463
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.578,
  //   "time": "2016-03-22 02:24:02 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ١٨٢ كم جنوب Al Ghayz?ah، اليمن على عمق 14.578 كم بتاريخ 2016-03-22 02:24:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20005bm8"
  // },
  // "608": {
  //   "place": "٢٠٣ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.7165,
  //     40.3359
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 17.717,
  //   "time": "2016-03-07 22:43:24 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٢٠٣ كم غرب Ad Darb، السعودية على عمق 17.717 كم بتاريخ 2016-03-07 22:43:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004vx9#dyfi"
  // },
  // "609": {
  //   "place": "٢١٠ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.5307,
  //     40.2783
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 17.531,
  //   "time": "2016-03-06 21:02:42 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٢١٠ كم غرب Ad Darb، السعودية على عمق 17.531 كم بتاريخ 2016-03-06 21:02:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004vqg"
  // },
  // "610": {
  //   "place": "١٠٧ كم شمال شمال شرق مصوع، إريتريا",
  //   "latLng": [
  //     16.5036,
  //     39.862
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 16.504,
  //   "time": "2016-03-06 04:38:18 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٠٧ كم شمال شمال شرق مصوع، إريتريا على عمق 16.504 كم بتاريخ 2016-03-06 04:38:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004vlf#dyfi"
  // },
  // "611": {
  //   "place": "٢٠٣ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.9024,
  //     40.3383
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 17.902,
  //   "time": "2016-03-06 00:05:02 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٠٣ كم غرب Ad Darb، السعودية على عمق 17.902 كم بتاريخ 2016-03-06 00:05:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004vkr"
  // },
  // "612": {
  //   "place": "٢٢٢ كم غرب جنوب غرب Al Maj?ridah، السعودية",
  //   "latLng": [
  //     18.275,
  //     40.0013
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 18.275,
  //   "time": "2016-03-05 20:08:54 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢٢ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.275 كم بتاريخ 2016-03-05 20:08:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004uyp#dyfi"
  // },
  // "613": {
  //   "place": "٢٠٤ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.6255,
  //     40.3319
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 17.626,
  //   "time": "2016-03-05 19:41:16 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٠٤ كم غرب Ad Darb، السعودية على عمق 17.626 كم بتاريخ 2016-03-05 19:41:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004wby#dyfi"
  // },
  // "614": {
  //   "place": "٢١ كم غرب جنوب غرب Al ?ayy، العراق",
  //   "latLng": [
  //     32.0788,
  //     45.8397
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.079,
  //   "time": "2016-02-19 17:08:52 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١ كم غرب جنوب غرب Al ?ayy، العراق على عمق 32.079 كم بتاريخ 2016-02-19 17:08:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004s20#dyfi"
  // },
  // "615": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     17.2102,
  //     60.0573
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 17.21,
  //   "time": "2016-02-18 20:29:39 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.0 درجة في منطقة صدع أوين على عمق 17.21 كم بتاريخ 2016-02-18 20:29:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004qvv#dyfi"
  // },
  // "616": {
  //   "place": "١٨١ كم شمال Hadibu، اليمن",
  //   "latLng": [
  //     14.2927,
  //     54.0466
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.293,
  //   "time": "2016-02-09 06:14:52 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ١٨١ كم شمال Hadibu، اليمن على عمق 14.293 كم بتاريخ 2016-02-09 06:14:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20004yxs"
  // },
  // "617": {
  //   "place": "١٤٥ كم جنوب Jiwani، باكستان",
  //   "latLng": [
  //     23.7497,
  //     61.9799
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 23.75,
  //   "time": "2016-01-25 21:51:45 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ١٤٥ كم جنوب Jiwani، Pakistan على عمق 23.75 كم بتاريخ 2016-01-25 21:51:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20004uhm#dyfi"
  // },
  // "618": {
  //   "place": "٢٤٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.567,
  //     55.1395
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.567,
  //   "time": "2016-01-25 06:48:42 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٤٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.567 كم بتاريخ 2016-01-25 06:48:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20004vjj"
  // },
  // "619": {
  //   "place": "٢٣٢ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.8277,
  //     40.0606
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 17.828,
  //   "time": "2016-01-03 14:58:05 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣٢ كم غرب Ad Darb، السعودية على عمق 17.828 كم بتاريخ 2016-01-03 14:58:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10004dz8#dyfi"
  // },
  // "620": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.135,
  //     56.5035
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.135,
  //   "time": "2015-12-18 17:12:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.135 كم بتاريخ 2015-12-18 17:12:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100048t8"
  // },
  // "621": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     15.2277,
  //     59.5266
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 15.228,
  //   "time": "2015-11-28 13:11:38 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.4 درجة في منطقة صدع أوين على عمق 15.228 كم بتاريخ 2015-11-28 13:11:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041vv#pager"
  // },
  // "622": {
  //   "place": "٢٣٦ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5326,
  //     55.0494
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 14.533,
  //   "time": "2015-11-26 18:41:55 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٣٦ كم شمال شمال شرق Hadibu، اليمن على عمق 14.533 كم بتاريخ 2015-11-26 18:41:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041ka"
  // },
  // "623": {
  //   "place": "٢٤٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6729,
  //     54.9941
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.673,
  //   "time": "2015-11-26 18:41:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٤٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.673 كم بتاريخ 2015-11-26 18:41:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000427y"
  // },
  // "624": {
  //   "place": "٢٥٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6905,
  //     55.0227
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.691,
  //   "time": "2015-11-26 18:40:31 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٥٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.691 كم بتاريخ 2015-11-26 18:40:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041k8"
  // },
  // "625": {
  //   "place": "٢٣٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5926,
  //     54.7799
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.593,
  //   "time": "2015-11-26 18:29:48 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٣٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.593 كم بتاريخ 2015-11-26 18:29:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000427e"
  // },
  // "626": {
  //   "place": "٢٣٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5557,
  //     54.9615
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.556,
  //   "time": "2015-11-25 17:58:40 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٣٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.556 كم بتاريخ 2015-11-25 17:58:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041s8#dyfi"
  // },
  // "627": {
  //   "place": "٢٣٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6239,
  //     54.882
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.624,
  //   "time": "2015-11-25 17:48:11 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.624 كم بتاريخ 2015-11-25 17:48:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041ru#dyfi"
  // },
  // "628": {
  //   "place": "٢٥٥ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6995,
  //     55.1088
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.7,
  //   "time": "2015-11-25 11:06:16 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥٥ كم شمال شمال شرق Hadibu، اليمن على عمق 14.7 كم بتاريخ 2015-11-25 11:06:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041re"
  // },
  // "629": {
  //   "place": "٢٥١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6933,
  //     55.025
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.693,
  //   "time": "2015-11-25 10:15:20 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.693 كم بتاريخ 2015-11-25 10:15:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041rb"
  // },
  // "630": {
  //   "place": "٢٣١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.4852,
  //     55.0477
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.485,
  //   "time": "2015-11-25 09:43:33 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.485 كم بتاريخ 2015-11-25 09:43:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100041ra"
  // },
  // "631": {
  //   "place": "١٩٢ كم جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     15.8257,
  //     55.4034
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 15.826,
  //   "time": "2015-11-21 04:55:01 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ١٩٢ كم جنوب شرق ?al?lah، عمان على عمق 15.826 كم بتاريخ 2015-11-21 04:55:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000418k"
  // },
  // "632": {
  //   "place": "٢٥١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7403,
  //     54.9245
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.74,
  //   "time": "2015-11-21 04:31:06 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٥١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.74 كم بتاريخ 2015-11-21 04:31:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000417t"
  // },
  // "633": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.0489,
  //     56.8554
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.049,
  //   "time": "2015-10-23 06:30:32 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 14.049 كم بتاريخ 2015-10-23 06:30:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20004067#dyfi"
  // },
  // "634": {
  //   "place": "٣٦ كم شمال شمال غرب ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.7512,
  //     46.5066
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.751,
  //   "time": "2015-09-25 09:28:02 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٣٦ كم شمال شمال غرب ‘Al? al Gharb?، العراق على عمق 32.751 كم بتاريخ 2015-09-25 09:28:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003nzs"
  // },
  // "635": {
  //   "place": "٤١ كم شمال شمال غرب ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.8324,
  //     46.5999
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 32.832,
  //   "time": "2015-09-25 06:10:24 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.9 درجة في ٤١ كم شمال شمال غرب ‘Al? al Gharb?، العراق على عمق 32.832 كم بتاريخ 2015-09-25 06:10:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003nxf#dyfi"
  // },
  // "636": {
  //   "place": "٢٣١ كم شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.1922,
  //     39.908
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 18.192,
  //   "time": "2015-09-04 19:44:49 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٣١ كم شرق Tok?r، Sudan على عمق 18.192 كم بتاريخ 2015-09-04 19:44:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003k14"
  // },
  // "637": {
  //   "place": "١٦٣ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.1344,
  //     53.7851
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 14.134,
  //   "time": "2015-09-02 07:20:30 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.0 درجة في ١٦٣ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.134 كم بتاريخ 2015-09-02 07:20:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003fmm"
  // },
  // "638": {
  //   "place": "١٧٢ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.2456,
  //     53.5724
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.246,
  //   "time": "2015-09-02 01:17:03 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ١٧٢ كم شمال Qalans?yah، اليمن على عمق 14.246 كم بتاريخ 2015-09-02 01:17:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003jme#dyfi"
  // },
  // "639": {
  //   "place": "١٥٤ كم شمال Hadibu، اليمن",
  //   "latLng": [
  //     14.0422,
  //     53.9077
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 14.042,
  //   "time": "2015-09-02 01:13:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.3 درجة في ١٥٤ كم شمال Hadibu، اليمن على عمق 14.042 كم بتاريخ 2015-09-02 01:13:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003fka#dyfi"
  // },
  // "640": {
  //   "place": "٥٣ كم شمال غرب Dib Dibba، عمان",
  //   "latLng": [
  //     26.541,
  //     55.877
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.541,
  //   "time": "2015-08-27 00:24:22 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ٥٣ كم شمال غرب Dib Dibba، عمان على عمق 26.541 كم بتاريخ 2015-08-27 00:24:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10003573#dyfi"
  // },
  // "641": {
  //   "place": "١٥٨ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.0831,
  //     39.0594
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 19.083,
  //   "time": "2015-08-24 21:23:46 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٥٨ كم شرق شمال شرق Tok?r، Sudan على عمق 19.083 كم بتاريخ 2015-08-24 21:23:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003hb2#dyfi"
  // },
  // "642": {
  //   "place": "٣٦ كم شمال Al Jahr?’، الكويت",
  //   "latLng": [
  //     29.666,
  //     47.6767
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 29.666,
  //   "time": "2015-08-18 11:26:20 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.4 درجة في ٣٦ كم شمال Al Jahr?’، الكويت على عمق 29.666 كم بتاريخ 2015-08-18 11:26:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10003347"
  // },
  // "643": {
  //   "place": "١٧٥ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.7124,
  //     51.7823
  //   ],
  //   "magnitude": 5.7,
  //   "depth": 13.712,
  //   "time": "2015-08-17 16:16:59 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 5.7 درجة في ١٧٥ كم شمال شمال غرب Kilmia، اليمن على عمق 13.712 كم بتاريخ 2015-08-17 16:16:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100032x1#pager"
  // },
  // "644": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.0546,
  //     56.4132
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.055,
  //   "time": "2015-08-15 04:59:01 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.055 كم بتاريخ 2015-08-15 04:59:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20003fb1#dyfi"
  // },
  // "645": {
  //   "place": "٢٤ كم شمال شمال شرق ‘En Boqeq، إسرائيل",
  //   "latLng": [
  //     31.3971,
  //     35.4781
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 31.397,
  //   "time": "2015-07-30 02:39:05 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٤ كم شمال شمال شرق ‘En Boqeq، Israel على عمق 31.397 كم بتاريخ 2015-07-30 02:39:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10002w9d#dyfi"
  // },
  // "646": {
  //   "place": "٢٥ كم شمال شمال غرب جمجمال، العراق",
  //   "latLng": [
  //     35.753,
  //     44.754
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.753,
  //   "time": "2015-07-11 18:27:39 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥ كم شمال شمال غرب Jamjam?l، العراق على عمق 35.753 كم بتاريخ 2015-07-11 18:27:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002wtt"
  // },
  // "647": {
  //   "place": "٣٣ كم جنوب جنوب شرق نويبع، مصر",
  //   "latLng": [
  //     28.7532,
  //     34.7315
  //   ],
  //   "magnitude": 3.7,
  //   "depth": 28.753,
  //   "time": "2015-07-08 02:15:28 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 3.7 درجة في ٣٣ كم جنوب جنوب شرق Nuwaybi‘a، Egypt على عمق 28.753 كم بتاريخ 2015-07-08 02:15:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002w5q#dyfi"
  // },
  // "648": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.5325,
  //     56.2512
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.533,
  //   "time": "2015-07-04 02:01:09 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 14.533 كم بتاريخ 2015-07-04 02:01:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002z6p#dyfi"
  // },
  // "649": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.4013,
  //     56.2778
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.401,
  //   "time": "2015-07-04 00:44:37 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.401 كم بتاريخ 2015-07-04 00:44:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10002ncq#dyfi"
  // },
  // "650": {
  //   "place": "٠ كم جنوب جنوب شرق نويبع، مصر",
  //   "latLng": [
  //     29.0402,
  //     34.6672
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 29.04,
  //   "time": "2015-06-27 15:34:03 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 5.5 درجة في ٠ كم جنوب جنوب شرق Nuwaybi‘a، Egypt على عمق 29.04 كم بتاريخ 2015-06-27 15:34:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10002m3f#pager"
  // },
  // "651": {
  //   "place": "١٨٨ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.4624,
  //     40.4967
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 17.462,
  //   "time": "2015-06-25 01:21:25 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.7 درجة في ١٨٨ كم غرب Ad Darb، السعودية على عمق 17.462 كم بتاريخ 2015-06-25 01:21:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10002lhg"
  // },
  // "652": {
  //   "place": "١٩٩ كم غرب شمال غرب فرسان، السعودية",
  //   "latLng": [
  //     17.3687,
  //     40.377
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 17.369,
  //   "time": "2015-06-24 21:05:25 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٩٩ كم غرب شمال غرب فرسان، السعودية على عمق 17.369 كم بتاريخ 2015-06-24 21:05:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10002lg0#dyfi"
  // },
  // "653": {
  //   "place": "١٣٦ كم شمال شمال شرق Keren، إريتريا",
  //   "latLng": [
  //     16.9204,
  //     38.9316
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 16.92,
  //   "time": "2015-06-09 02:22:55 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٣٦ كم شمال شمال شرق Keren، إريتريا على عمق 16.92 كم بتاريخ 2015-06-09 02:22:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002n5f#dyfi"
  // },
  // "654": {
  //   "place": "١٦٥ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.7357,
  //     52.4687
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.736,
  //   "time": "2015-05-25 01:01:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ١٦٥ كم جنوب Al Ghayz?ah، اليمن على عمق 14.736 كم بتاريخ 2015-05-25 01:01:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002m0v#dyfi"
  // },
  // "655": {
  //   "place": "١٢٢ كم جنوب جنوب غرب Jiwani، باكستان",
  //   "latLng": [
  //     24.0405,
  //     61.2598
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 24.041,
  //   "time": "2015-05-17 11:16:53 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.1 درجة في ١٢٢ كم جنوب جنوب غرب Jiwani، Pakistan على عمق 24.041 كم بتاريخ 2015-05-17 11:16:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100029ys#dyfi"
  // },
  // "656": {
  //   "place": "١٢٥ كم جنوب جنوب غرب Jiwani، باكستان",
  //   "latLng": [
  //     24.0224,
  //     61.2092
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 24.022,
  //   "time": "2015-05-14 16:01:21 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.3 درجة في ١٢٥ كم جنوب جنوب غرب Jiwani، Pakistan على عمق 24.022 كم بتاريخ 2015-05-14 16:01:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us100028z8#dyfi"
  // },
  // "657": {
  //   "place": "١٥١ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.0279,
  //     53.7933
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.028,
  //   "time": "2015-04-25 18:56:05 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ١٥١ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.028 كم بتاريخ 2015-04-25 18:56:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002bhf"
  // },
  // "658": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.4248,
  //     56.2668
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.425,
  //   "time": "2015-04-21 16:10:36 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.425 كم بتاريخ 2015-04-21 16:10:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us20002857"
  // },
  // "659": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.3292,
  //     56.2069
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.329,
  //   "time": "2015-04-21 13:06:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 14.329 كم بتاريخ 2015-04-21 13:06:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us200029vd"
  // },
  // "660": {
  //   "place": "١٩٤ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.8346,
  //     51.6042
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.835,
  //   "time": "2015-04-03 08:20:01 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.4 درجة في ١٩٤ كم شمال شمال غرب Kilmia، اليمن على عمق 13.835 كم بتاريخ 2015-04-03 08:20:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10001tit#dyfi"
  // },
  // "661": {
  //   "place": "٤٢ كم جنوب جنوب غرب Al Jahr?’، الكويت",
  //   "latLng": [
  //     28.9932,
  //     47.475
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.993,
  //   "time": "2015-03-21 11:23:35 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.3 درجة في ٤٢ كم جنوب جنوب غرب Al Jahr?’، الكويت على عمق 28.993 كم بتاريخ 2015-03-21 11:23:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10001pn3#dyfi"
  // },
  // "662": {
  //   "place": "١٨ كم شمال شمال شرق Jawf al Maqb?bah، اليمن",
  //   "latLng": [
  //     13.9749,
  //     45.9273
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.975,
  //   "time": "2015-03-18 01:09:18 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.4 درجة في ١٨ كم شمال شمال شرق Jawf al Maqb?bah، اليمن على عمق 13.975 كم بتاريخ 2015-03-18 01:09:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10001pt2#dyfi"
  // },
  // "663": {
  //   "place": "٢٤٨ كم جنوب جنوب شرق Haym?’، عمان",
  //   "latLng": [
  //     18.0092,
  //     57.4373
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 18.009,
  //   "time": "2015-03-13 02:03:10 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٤٨ كم جنوب جنوب شرق Haym?’، عمان على عمق 18.009 كم بتاريخ 2015-03-13 02:03:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10001n3z#dyfi"
  // },
  // "664": {
  //   "place": "١١ كم جنوب جنوب غرب Uzunba?، تركيا",
  //   "latLng": [
  //     36.0495,
  //     35.9713
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.05,
  //   "time": "2015-02-10 04:01:54 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.4 درجة في ١١ كم جنوب جنوب غرب Uzunba?، تركيا على عمق 36.05 كم بتاريخ 2015-02-10 04:01:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us10000a0d#dyfi"
  // },
  // "665": {
  //   "place": "١٩٤ كم جنوب جنوب غرب الهفوف، السعودية",
  //   "latLng": [
  //     23.6431,
  //     49.1942
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 23.643,
  //   "time": "2015-01-29 19:12:25 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ١٩٤ كم جنوب جنوب غرب الهفوف، السعودية على عمق 23.643 كم بتاريخ 2015-01-29 19:12:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000tk5g"
  // },
  // "666": {
  //   "place": "٢٥٩ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.4793,
  //     55.5206
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.479,
  //   "time": "2015-01-18 09:41:53 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٥٩ كم شمال شرق Hadibu، اليمن على عمق 14.479 كم بتاريخ 2015-01-18 09:41:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000tgxt#dyfi"
  // },
  // "667": {
  //   "place": "٩٦ كم غرب Umluj، السعودية",
  //   "latLng": [
  //     25.0545,
  //     36.3086
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 25.055,
  //   "time": "2015-01-12 21:39:16 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٩٦ كم غرب Umluj، السعودية على عمق 25.055 كم بتاريخ 2015-01-12 21:39:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000tile#dyfi"
  // },
  // "668": {
  //   "place": "٢٢٣ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5483,
  //     54.7261
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.548,
  //   "time": "2015-01-09 23:44:18 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢٣ كم شمال شمال شرق Hadibu، اليمن على عمق 14.548 كم بتاريخ 2015-01-09 23:44:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000ths4#dyfi"
  // },
  // "669": {
  //   "place": "٢٥١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7751,
  //     54.8514
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.775,
  //   "time": "2014-12-18 22:00:14 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.775 كم بتاريخ 2014-12-18 22:00:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000tcqq#dyfi"
  // },
  // "670": {
  //   "place": "٢٣٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6257,
  //     54.9225
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.626,
  //   "time": "2014-12-18 21:58:50 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٣٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.626 كم بتاريخ 2014-12-18 21:58:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000t80p#dyfi"
  // },
  // "671": {
  //   "place": "٢٧٢ كم شرق جنوب شرق Sur، عمان",
  //   "latLng": [
  //     21.9927,
  //     62.0976
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 21.993,
  //   "time": "2014-12-10 16:32:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٧٢ كم شرق جنوب شرق Sur، عمان على عمق 21.993 كم بتاريخ 2014-12-10 16:32:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000t58v#dyfi"
  // },
  // "672": {
  //   "place": "١٥٤ كم شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.3767,
  //     38.8076
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 19.377,
  //   "time": "2014-11-28 01:31:41 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ١٥٤ كم شمال شرق Tok?r، Sudan على عمق 19.377 كم بتاريخ 2014-11-28 01:31:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000t5zv#dyfi"
  // },
  // "673": {
  //   "place": "٤٤ كم شمال شرق Dib Dibba، عمان",
  //   "latLng": [
  //     26.47,
  //     56.59
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 26.47,
  //   "time": "2014-11-23 13:17:59 UTC",
  //   "region": "عمان",
  //   "info": "زلزال بقوة 4.9 درجة في ٤٤ كم شمال شرق Dib Dibba، عمان على عمق 26.47 كم بتاريخ 2014-11-23 13:17:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000szau#dyfi"
  // },
  // "674": {
  //   "place": "١٤٠ كم شرق شمال شرق Port Sudan، Sudan",
  //   "latLng": [
  //     19.896,
  //     38.523
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 19.896,
  //   "time": "2014-10-26 16:22:51 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٤٠ كم شرق شمال شرق Port Sudan، Sudan على عمق 19.896 كم بتاريخ 2014-10-26 16:22:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000svdx#dyfi"
  // },
  // "675": {
  //   "place": "سقطرى منطقة",
  //   "latLng": [
  //     13.9317,
  //     56.9783
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.932,
  //   "time": "2014-10-23 14:53:19 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في Socotra region على عمق 13.932 كم بتاريخ 2014-10-23 14:53:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000sukw#dyfi"
  // },
  // "676": {
  //   "place": "٢٧٧ كم شرق جنوب شرق Sur، عمان",
  //   "latLng": [
  //     21.6424,
  //     62.0318
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 21.642,
  //   "time": "2014-10-22 01:22:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٧٧ كم شرق جنوب شرق Sur، عمان على عمق 21.642 كم بتاريخ 2014-10-22 01:22:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000sunr#dyfi"
  // },
  // "677": {
  //   "place": "٢٤ كم جنوب غرب Latakia، سوريا",
  //   "latLng": [
  //     35.3715,
  //     35.6011
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.372,
  //   "time": "2014-09-22 07:25:36 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٤ كم جنوب غرب Latakia، سوريا على عمق 35.372 كم بتاريخ 2014-09-22 07:25:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000shrx"
  // },
  // "678": {
  //   "place": "٢٣٦ كم غرب جنوب غرب Al Maj?ridah، السعودية",
  //   "latLng": [
  //     18.0171,
  //     39.9979
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 18.017,
  //   "time": "2014-09-08 10:49:51 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٣٦ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.017 كم بتاريخ 2014-09-08 10:49:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000sdj4"
  // },
  // "679": {
  //   "place": "٢٢١ كم غرب جنوب غرب Al Maj?ridah، السعودية",
  //   "latLng": [
  //     18.2198,
  //     40.0378
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 18.22,
  //   "time": "2014-09-08 08:46:19 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢١ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.22 كم بتاريخ 2014-09-08 08:46:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000sdja"
  // },
  // "680": {
  //   "place": "٧ كم شمال شرق Az Zabad?n?، سوريا",
  //   "latLng": [
  //     33.7734,
  //     36.1504
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 33.773,
  //   "time": "2014-09-01 20:50:06 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.4 درجة في ٧ كم شمال شرق Az Zabad?n?، سوريا على عمق 33.773 كم بتاريخ 2014-09-01 20:50:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000s9vd#dyfi"
  // },
  // "681": {
  //   "place": "٢٧ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5743,
  //     45.7674
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 33.574,
  //   "time": "2014-08-31 15:07:18 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٧ كم جنوب شرق Mandal?، العراق على عمق 33.574 كم بتاريخ 2014-08-31 15:07:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000s8hn"
  // },
  // "682": {
  //   "place": "٢٦ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6233,
  //     45.8027
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 33.623,
  //   "time": "2014-08-31 14:44:34 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.0 درجة في ٢٦ كم شرق جنوب شرق Mandal?، العراق على عمق 33.623 كم بتاريخ 2014-08-31 14:44:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000s8hi"
  // },
  // "683": {
  //   "place": "٢٢ كم شرق Mandal?، العراق",
  //   "latLng": [
  //     33.752,
  //     45.801
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.752,
  //   "time": "2014-08-24 23:21:19 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٢ كم شرق Mandal?، العراق على عمق 33.752 كم بتاريخ 2014-08-24 23:21:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000s9p3#dyfi"
  // },
  // "684": {
  //   "place": "١٩ كم جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.6312,
  //     45.7066
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.631,
  //   "time": "2014-08-24 23:17:01 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ١٩ كم جنوب شرق Mandal?، العراق على عمق 33.631 كم بتاريخ 2014-08-24 23:17:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000s5wz"
  // },
  // "685": {
  //   "place": "٢٠ كم شرق جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.7003,
  //     45.7728
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 33.7,
  //   "time": "2014-08-22 20:06:04 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.1 درجة في ٢٠ كم شرق جنوب شرق Mandal?، العراق على عمق 33.7 كم بتاريخ 2014-08-22 20:06:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000s5h3#dyfi"
  // },
  // "686": {
  //   "place": "٢١ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.5804,
  //     45.676
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 33.58,
  //   "time": "2014-08-22 17:55:59 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.7 درجة في ٢١ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.58 كم بتاريخ 2014-08-22 17:55:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000s5fb"
  // },
  // "687": {
  //   "place": "٥٢ كم شرق شمال شرق ?d?grat، إثيوبيا",
  //   "latLng": [
  //     14.5128,
  //     39.8855
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.513,
  //   "time": "2014-08-22 08:42:29 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٥٢ كم شرق شمال شرق ?d?grat، إثيوبيا على عمق 14.513 كم بتاريخ 2014-08-22 08:42:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000s9am"
  // },
  // "688": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.5495,
  //     57.0533
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.55,
  //   "time": "2014-08-06 03:23:38 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 13.55 كم بتاريخ 2014-08-06 03:23:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000s43e"
  // },
  // "689": {
  //   "place": "١٤ كم جنوب جنوب شرق Mandal?، العراق",
  //   "latLng": [
  //     33.62,
  //     45.59
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.62,
  //   "time": "2014-07-28 05:14:57 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ١٤ كم جنوب جنوب شرق Mandal?، العراق على عمق 33.62 كم بتاريخ 2014-07-28 05:14:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rxup"
  // },
  // "690": {
  //   "place": "١٦٢ كم جنوب غرب Umluj، السعودية",
  //   "latLng": [
  //     23.8371,
  //     36.3299
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 23.837,
  //   "time": "2014-07-15 11:33:03 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٦٢ كم جنوب غرب Umluj، السعودية على عمق 23.837 كم بتاريخ 2014-07-15 11:33:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rx40"
  // },
  // "691": {
  //   "place": "٢٢٣ كم شمال Kilmia، اليمن",
  //   "latLng": [
  //     14.1816,
  //     51.9053
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.182,
  //   "time": "2014-07-12 01:35:02 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢٣ كم شمال Kilmia، اليمن على عمق 14.182 كم بتاريخ 2014-07-12 01:35:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rwhu"
  // },
  // "692": {
  //   "place": "٢٠٨ كم شمال شمال شرق مصوع، إريتريا",
  //   "latLng": [
  //     17.336,
  //     40.2618
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 17.336,
  //   "time": "2014-07-10 22:10:37 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٠٨ كم شمال شمال شرق مصوع، إريتريا على عمق 17.336 كم بتاريخ 2014-07-10 22:10:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rubh"
  // },
  // "693": {
  //   "place": "٢٢٤ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.7472,
  //     40.1372
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 17.747,
  //   "time": "2014-07-10 21:53:58 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٢٤ كم غرب Ad Darb، السعودية على عمق 17.747 كم بتاريخ 2014-07-10 21:53:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rrqs"
  // },
  // "694": {
  //   "place": "٢١٨ كم شمال شمال شرق مصوع، إريتريا",
  //   "latLng": [
  //     17.5148,
  //     40.0237
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 17.515,
  //   "time": "2014-07-10 21:28:04 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٢١٨ كم شمال شمال شرق مصوع، إريتريا على عمق 17.515 كم بتاريخ 2014-07-10 21:28:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rub4"
  // },
  // "695": {
  //   "place": "٢٣٧ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.8345,
  //     40.0173
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 17.835,
  //   "time": "2014-07-10 18:57:03 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٣٧ كم غرب Ad Darb، السعودية على عمق 17.835 كم بتاريخ 2014-07-10 18:57:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rub2"
  // },
  // "696": {
  //   "place": "٤ كم شمال شرق Sidon، Lebanon",
  //   "latLng": [
  //     33.5865,
  //     35.3975
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 33.587,
  //   "time": "2014-07-05 21:41:35 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.0 درجة في ٤ كم شمال شرق Sidon، Lebanon على عمق 33.587 كم بتاريخ 2014-07-05 21:41:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rqvn#dyfi"
  // },
  // "697": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.2965,
  //     56.3101
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.297,
  //   "time": "2014-06-27 09:44:03 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.297 كم بتاريخ 2014-06-27 09:44:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000rvlg"
  // },
  // "698": {
  //   "place": "٢٦٨ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6194,
  //     55.4687
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.619,
  //   "time": "2014-06-26 08:49:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٦٨ كم شمال شرق Hadibu، اليمن على عمق 14.619 كم بتاريخ 2014-06-26 08:49:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rmbg"
  // },
  // "699": {
  //   "place": "١٢١ كم شمال شمال شرق Keren، إريتريا",
  //   "latLng": [
  //     16.8259,
  //     38.7969
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 16.826,
  //   "time": "2014-06-16 05:56:08 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٢١ كم شمال شمال شرق Keren، إريتريا على عمق 16.826 كم بتاريخ 2014-06-16 05:56:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rms3"
  // },
  // "700": {
  //   "place": "٢١٩ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.2244,
  //     52.1283
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.224,
  //   "time": "2014-06-14 01:22:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.224 كم بتاريخ 2014-06-14 01:22:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rmmz"
  // },
  // "701": {
  //   "place": "٢١٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5341,
  //     54.586
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.534,
  //   "time": "2014-06-10 08:29:02 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢١٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.534 كم بتاريخ 2014-06-10 08:29:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rlqa"
  // },
  // "702": {
  //   "place": "٢٢٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6038,
  //     54.7325
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.604,
  //   "time": "2014-06-10 04:38:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.604 كم بتاريخ 2014-06-10 04:38:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rlqc"
  // },
  // "703": {
  //   "place": "٢١٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5178,
  //     54.7017
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.518,
  //   "time": "2014-06-10 04:33:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢١٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.518 كم بتاريخ 2014-06-10 04:33:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rlqd"
  // },
  // "704": {
  //   "place": "١٨ كم شمال غرب Denizciler، تركيا",
  //   "latLng": [
  //     36.7453,
  //     36.0505
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.745,
  //   "time": "2014-06-09 03:38:34 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.6 درجة في ١٨ كم شمال غرب Denizciler، تركيا على عمق 36.745 كم بتاريخ 2014-06-09 03:38:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rctx"
  // },
  // "705": {
  //   "place": "٢٣٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7124,
  //     54.6302
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.712,
  //   "time": "2014-06-09 01:43:29 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٣٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.712 كم بتاريخ 2014-06-09 01:43:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn25"
  // },
  // "706": {
  //   "place": "٢٢٨ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6263,
  //     54.6282
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.626,
  //   "time": "2014-06-09 01:28:58 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢٨ كم شمال شمال شرق Hadibu، اليمن على عمق 14.626 كم بتاريخ 2014-06-09 01:28:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn2a"
  // },
  // "707": {
  //   "place": "٢٢٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6542,
  //     54.5577
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.654,
  //   "time": "2014-06-07 09:04:04 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.654 كم بتاريخ 2014-06-07 09:04:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rcga"
  // },
  // "708": {
  //   "place": "٢١٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5585,
  //     54.4985
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.559,
  //   "time": "2014-06-07 04:38:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢١٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.559 كم بتاريخ 2014-06-07 04:38:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rit9"
  // },
  // "709": {
  //   "place": "٢٣٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6294,
  //     54.685
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.629,
  //   "time": "2014-06-07 04:35:27 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.629 كم بتاريخ 2014-06-07 04:35:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rit8"
  // },
  // "710": {
  //   "place": "٢٣٢ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5935,
  //     54.8443
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 14.594,
  //   "time": "2014-06-07 04:19:35 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٣٢ كم شمال شمال شرق Hadibu، اليمن على عمق 14.594 كم بتاريخ 2014-06-07 04:19:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rce2"
  // },
  // "711": {
  //   "place": "٢٠٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.3297,
  //     54.8111
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.33,
  //   "time": "2014-06-07 04:15:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٠٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.33 كم بتاريخ 2014-06-07 04:15:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rce0"
  // },
  // "712": {
  //   "place": "٢٢١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5746,
  //     54.5944
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.575,
  //   "time": "2014-06-07 04:11:11 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٢١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.575 كم بتاريخ 2014-06-07 04:11:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000risv"
  // },
  // "713": {
  //   "place": "٢٤٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7121,
  //     54.8286
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.712,
  //   "time": "2014-06-06 15:31:11 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٤٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.712 كم بتاريخ 2014-06-06 15:31:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rc5t"
  // },
  // "714": {
  //   "place": "٢١٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.4606,
  //     54.6228
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.461,
  //   "time": "2014-06-06 10:14:10 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.461 كم بتاريخ 2014-06-06 10:14:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn1e"
  // },
  // "715": {
  //   "place": "٢٣٢ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6567,
  //     54.6658
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.657,
  //   "time": "2014-06-06 07:29:53 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٣٢ كم شمال شمال شرق Hadibu، اليمن على عمق 14.657 كم بتاريخ 2014-06-06 07:29:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0k"
  // },
  // "716": {
  //   "place": "٢٢٨ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6017,
  //     54.6962
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.602,
  //   "time": "2014-06-06 06:43:52 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٢٨ كم شمال شمال شرق Hadibu، اليمن على عمق 14.602 كم بتاريخ 2014-06-06 06:43:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0j"
  // },
  // "717": {
  //   "place": "٢٣٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6187,
  //     54.8135
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.619,
  //   "time": "2014-06-06 06:38:34 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٣٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.619 كم بتاريخ 2014-06-06 06:38:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0i"
  // },
  // "718": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.5848,
  //     54.708
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.585,
  //   "time": "2014-06-06 04:20:23 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في منطقة صدع أوين على عمق 14.585 كم بتاريخ 2014-06-06 04:20:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0e"
  // },
  // "719": {
  //   "place": "٢٢٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.4979,
  //     54.7709
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.498,
  //   "time": "2014-06-06 04:03:03 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.498 كم بتاريخ 2014-06-06 04:03:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0d"
  // },
  // "720": {
  //   "place": "٢٣٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6697,
  //     54.7646
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.67,
  //   "time": "2014-06-06 03:43:55 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٣٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.67 كم بتاريخ 2014-06-06 03:43:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn0a"
  // },
  // "721": {
  //   "place": "٢٣٣ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6365,
  //     54.7348
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.637,
  //   "time": "2014-06-06 03:43:02 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٣٣ كم شمال شمال شرق Hadibu، اليمن على عمق 14.637 كم بتاريخ 2014-06-06 03:43:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn1h"
  // },
  // "722": {
  //   "place": "٢١٨ كم جنوب جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     15.1325,
  //     54.7166
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 15.133,
  //   "time": "2014-06-06 03:42:04 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١٨ كم جنوب جنوب شرق ?al?lah، عمان على عمق 15.133 كم بتاريخ 2014-06-06 03:42:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn09"
  // },
  // "723": {
  //   "place": "٢٣١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6295,
  //     54.7022
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.63,
  //   "time": "2014-06-06 03:38:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٣١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.63 كم بتاريخ 2014-06-06 03:38:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rbxh"
  // },
  // "724": {
  //   "place": "٢٣٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6302,
  //     54.6696
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.63,
  //   "time": "2014-06-06 03:35:26 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٣٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.63 كم بتاريخ 2014-06-06 03:35:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rbxi"
  // },
  // "725": {
  //   "place": "٢٣٨ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6862,
  //     54.733
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.686,
  //   "time": "2014-06-06 02:58:36 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٣٨ كم شمال شمال شرق Hadibu، اليمن على عمق 14.686 كم بتاريخ 2014-06-06 02:58:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rbxa"
  // },
  // "726": {
  //   "place": "٢٢٧ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6126,
  //     54.6469
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.613,
  //   "time": "2014-06-06 02:55:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٢٧ كم شمال شمال شرق Hadibu، اليمن على عمق 14.613 كم بتاريخ 2014-06-06 02:55:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rn07"
  // },
  // "727": {
  //   "place": "٢٢٦ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.6112,
  //     54.6251
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.611,
  //   "time": "2014-06-05 18:23:09 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢٦ كم شمال شمال شرق Hadibu، اليمن على عمق 14.611 كم بتاريخ 2014-06-05 18:23:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rmzh"
  // },
  // "728": {
  //   "place": "٢٢٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.5519,
  //     54.7299
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.552,
  //   "time": "2014-06-05 11:57:15 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٢٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.552 كم بتاريخ 2014-06-05 11:57:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000rmz6"
  // },
  // "729": {
  //   "place": "٥١ كم شمال غرب Dib Dibba، عمان",
  //   "latLng": [
  //     26.543,
  //     55.905
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 26.543,
  //   "time": "2014-05-27 05:44:29 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 5.1 درجة في ٥١ كم شمال غرب Dib Dibba، عمان على عمق 26.543 كم بتاريخ 2014-05-27 05:44:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000r505#dyfi"
  // },
  // "730": {
  //   "place": "١٦ كم غرب شمال غرب Jbaïl، Lebanon",
  //   "latLng": [
  //     34.1525,
  //     35.4736
  //   ],
  //   "magnitude": 3.8,
  //   "depth": 34.153,
  //   "time": "2014-05-25 12:22:55 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 3.8 درجة في ١٦ كم غرب شمال غرب Jbaïl، Lebanon على عمق 34.153 كم بتاريخ 2014-05-25 12:22:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000r6bz#dyfi"
  // },
  // "731": {
  //   "place": "٢٤ كم شمال غرب غرب?d? M?sá، الأردن",
  //   "latLng": [
  //     30.4765,
  //     35.3005
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 30.477,
  //   "time": "2014-05-24 07:27:30 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٤ كم شمال غرب W?d? M?sá، Jordan على عمق 30.477 كم بتاريخ 2014-05-24 07:27:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000r2f5#dyfi"
  // },
  // "732": {
  //   "place": "٢٦ كم غرب شمال غرب As Sulaym?n?yah، العراق",
  //   "latLng": [
  //     35.69,
  //     45.19
  //   ],
  //   "magnitude": 3.8,
  //   "depth": 35.69,
  //   "time": "2014-04-16 01:14:08 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 3.8 درجة في ٢٦ كم غرب شمال غرب As Sulaym?n?yah، العراق على عمق 35.69 كم بتاريخ 2014-04-16 01:14:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000pm1h"
  // },
  // "733": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.4444,
  //     56.1888
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.444,
  //   "time": "2014-04-02 11:43:14 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 14.444 كم بتاريخ 2014-04-02 11:43:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000pmn0"
  // },
  // "734": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.3639,
  //     56.3302
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 14.364,
  //   "time": "2014-04-02 10:36:41 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.9 درجة في منطقة صدع أوين على عمق 14.364 كم بتاريخ 2014-04-02 10:36:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000p0ij"
  // },
  // "735": {
  //   "place": "٣٦ كم شمال شرق ?d?grat، إثيوبيا",
  //   "latLng": [
  //     14.4812,
  //     39.73
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.481,
  //   "time": "2014-03-30 03:53:50 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٦ كم شمال شرق ?d?grat، إثيوبيا على عمق 14.481 كم بتاريخ 2014-03-30 03:53:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000pmh7"
  // },
  // "736": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.6961,
  //     57.0254
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.696,
  //   "time": "2014-03-21 10:41:12 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 13.696 كم بتاريخ 2014-03-21 10:41:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000nuxl"
  // },
  // "737": {
  //   "place": "٦٦ كم جنوب جنوب شرق Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     27.4077,
  //     34.6904
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.408,
  //   "time": "2014-03-15 11:57:48 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.0 درجة في ٦٦ كم جنوب جنوب شرق Sharm el-Sheikh، Egypt على عمق 27.408 كم بتاريخ 2014-03-15 11:57:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000nnze"
  // },
  // "738": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.6934,
  //     57.0652
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 13.693,
  //   "time": "2014-03-15 04:05:14 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في منطقة صدع أوين على عمق 13.693 كم بتاريخ 2014-03-15 04:05:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000nnyi"
  // },
  // "739": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.7669,
  //     57.1116
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 13.767,
  //   "time": "2014-03-15 02:59:28 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.2 درجة في منطقة صدع أوين على عمق 13.767 كم بتاريخ 2014-03-15 02:59:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000nc7i"
  // },
  // "740": {
  //   "place": "٢٦ كم جنوب جنوب غرب Adana، تركيا",
  //   "latLng": [
  //     36.785,
  //     35.175
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.785,
  //   "time": "2014-03-02 04:25:57 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٦ كم جنوب جنوب غرب Adana، تركيا على عمق 36.785 كم بتاريخ 2014-03-02 04:25:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000mzbv"
  // },
  // "741": {
  //   "place": "٢٩٩ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.377,
  //     56.1539
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.377,
  //   "time": "2014-02-26 01:03:30 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٩٩ كم شمال شرق Hadibu، اليمن على عمق 14.377 كم بتاريخ 2014-02-26 01:03:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000n4ye"
  // },
  // "742": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.409,
  //     56.3071
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.409,
  //   "time": "2014-02-26 00:55:40 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.409 كم بتاريخ 2014-02-26 00:55:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000my9m"
  // },
  // "743": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.3647,
  //     56.2648
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.365,
  //   "time": "2014-02-26 00:53:25 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.365 كم بتاريخ 2014-02-26 00:53:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000my9j"
  // },
  // "744": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.0389,
  //     56.6696
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.039,
  //   "time": "2014-02-22 16:13:57 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.039 كم بتاريخ 2014-02-22 16:13:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000n453"
  // },
  // "745": {
  //   "place": "١٦ كم شمال غرب Denizciler، تركيا",
  //   "latLng": [
  //     36.74,
  //     36.08
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.74,
  //   "time": "2014-02-14 00:33:40 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.7 درجة في ١٦ كم شمال غرب Denizciler، تركيا على عمق 36.74 كم بتاريخ 2014-02-14 00:33:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000mq8w#dyfi"
  // },
  // "746": {
  //   "place": "٢٦ كم شمال شرق ?aby?، السعودية",
  //   "latLng": [
  //     17.315,
  //     42.8044
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 17.315,
  //   "time": "2014-01-23 15:00:41 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٦ كم شمال شرق ?aby?، السعودية على عمق 17.315 كم بتاريخ 2014-01-23 15:00:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000m6ni#shakemap"
  // },
  // "747": {
  //   "place": "١٧٥ كم غرب جنوب غرب Yanbu، السعودية",
  //   "latLng": [
  //     23.6427,
  //     36.4081
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 23.643,
  //   "time": "2014-01-16 13:02:36 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٧٥ كم غرب جنوب غرب Yanbu، السعودية على عمق 23.643 كم بتاريخ 2014-01-16 13:02:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000meil"
  // },
  // "748": {
  //   "place": "٢١٧ كم شمال شمال شرق مصوع، إريتريا",
  //   "latLng": [
  //     17.4721,
  //     40.1323
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 17.472,
  //   "time": "2014-01-15 23:54:40 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٢١٧ كم شمال شمال شرق مصوع، إريتريا على عمق 17.472 كم بتاريخ 2014-01-15 23:54:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000mehl"
  // },
  // "749": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.524,
  //     55.5914
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.524,
  //   "time": "2013-12-27 19:10:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.524 كم بتاريخ 2013-12-27 19:10:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lsvv"
  // },
  // "750": {
  //   "place": "٢٦٤ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.4821,
  //     55.5883
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.482,
  //   "time": "2013-12-27 18:58:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٦٤ كم شمال شرق Hadibu، اليمن على عمق 14.482 كم بتاريخ 2013-12-27 18:58:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000m05q"
  // },
  // "751": {
  //   "place": "١٦٣ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.9052,
  //     39.19
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 18.905,
  //   "time": "2013-12-23 23:54:02 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٦٣ كم شرق شمال شرق Tok?r، Sudan على عمق 18.905 كم بتاريخ 2013-12-23 23:54:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lxp7"
  // },
  // "752": {
  //   "place": "البحر الأحمر",
  //   "latLng": [
  //     19.0344,
  //     39.2276
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 19.034,
  //   "time": "2013-12-23 19:01:53 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في البحر الأحمر على عمق 19.034 كم بتاريخ 2013-12-23 19:01:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lqhk"
  // },
  // "753": {
  //   "place": "١٧٩ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.1788,
  //     39.2366
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 19.179,
  //   "time": "2013-12-23 18:44:21 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.3 درجة في ١٧٩ كم شرق شمال شرق Tok?r، Sudan على عمق 19.179 كم بتاريخ 2013-12-23 18:44:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lqgp"
  // },
  // "754": {
  //   "place": "١٧٦ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.0947,
  //     39.2431
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 19.095,
  //   "time": "2013-12-23 18:41:36 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٦ كم شرق شمال شرق Tok?r، Sudan على عمق 19.095 كم بتاريخ 2013-12-23 18:41:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lqhs"
  // },
  // "755": {
  //   "place": "١٨٥ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.9876,
  //     39.3901
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 18.988,
  //   "time": "2013-12-20 16:28:47 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٨٥ كم شرق شمال شرق Tok?r، Sudan على عمق 18.988 كم بتاريخ 2013-12-20 16:28:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lvqy"
  // },
  // "756": {
  //   "place": "٤٨ كم شمال غرب Ash Sha?rah، العراق",
  //   "latLng": [
  //     31.7563,
  //     45.8704
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 31.756,
  //   "time": "2013-12-20 07:29:11 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.0 درجة في ٤٨ كم شمال غرب Ash Sha?rah، العراق على عمق 31.756 كم بتاريخ 2013-12-20 07:29:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lvqc"
  // },
  // "757": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.0656,
  //     56.8516
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.066,
  //   "time": "2013-12-14 00:12:05 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.066 كم بتاريخ 2013-12-14 00:12:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000lmrl"
  // },
  // "758": {
  //   "place": "٢٩ كم شمال شمال شرق Mandal?، العراق",
  //   "latLng": [
  //     34.0056,
  //     45.6456
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.006,
  //   "time": "2013-11-22 20:43:46 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٩ كم شمال شمال شرق Mandal?، العراق على عمق 34.006 كم بتاريخ 2013-11-22 20:43:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000l7ea"
  // },
  // "759": {
  //   "place": "٢٣ كم شمال شرق Mandal?، العراق",
  //   "latLng": [
  //     33.9256,
  //     45.6973
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 33.926,
  //   "time": "2013-11-22 18:44:00 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٣ كم شمال شرق Mandal?، العراق على عمق 33.926 كم بتاريخ 2013-11-22 18:44:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000l7dz"
  // },
  // "760": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     19.0903,
  //     60.793
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 19.09,
  //   "time": "2013-11-11 19:02:32 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 19.09 كم بتاريخ 2013-11-11 19:02:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000kz5b"
  // },
  // "761": {
  //   "place": "٢٥ كم شمال شمال شرق Kifr?، العراق",
  //   "latLng": [
  //     34.896,
  //     45.083
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.896,
  //   "time": "2013-11-05 04:03:39 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٥ كم شمال شمال شرق Kifr?، العراق على عمق 34.896 كم بتاريخ 2013-11-05 04:03:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000ksp1"
  // },
  // "762": {
  //   "place": "٢٤٢ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7116,
  //     54.7648
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.712,
  //   "time": "2013-10-29 20:35:59 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٤٢ كم شمال شمال شرق Hadibu، اليمن على عمق 14.712 كم بتاريخ 2013-10-29 20:35:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000kr2b"
  // },
  // "763": {
  //   "place": "٦ كم شرق شمال شرق مجدال، إسرائيل",
  //   "latLng": [
  //     32.857,
  //     35.571
  //   ],
  //   "magnitude": 3.5,
  //   "depth": 32.857,
  //   "time": "2013-10-20 12:54:05 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 3.5 درجة في ٦ كم شرق شمال شرق Migdal، Israel على عمق 32.857 كم بتاريخ 2013-10-20 12:54:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000khl6#dyfi"
  // },
  // "764": {
  //   "place": "١٨١ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.7065,
  //     51.6148
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.707,
  //   "time": "2013-10-14 10:42:32 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.6 درجة في ١٨١ كم شمال شمال غرب Kilmia، اليمن على عمق 13.707 كم بتاريخ 2013-10-14 10:42:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000kcsj"
  // },
  // "765": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     19.2203,
  //     60.8257
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 19.22,
  //   "time": "2013-10-04 19:45:10 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 19.22 كم بتاريخ 2013-10-04 19:45:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000kacp"
  // },
  // "766": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     19.2171,
  //     60.8652
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 19.217,
  //   "time": "2013-09-30 12:58:14 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في منطقة صدع أوين على عمق 19.217 كم بتاريخ 2013-09-30 12:58:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000k2lt"
  // },
  // "767": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     18.998,
  //     60.9332
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 18.998,
  //   "time": "2013-09-28 09:47:15 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 18.998 كم بتاريخ 2013-09-28 09:47:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000k1hl"
  // },
  // "768": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     19.1228,
  //     60.972
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 19.123,
  //   "time": "2013-09-28 08:32:42 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 19.123 كم بتاريخ 2013-09-28 08:32:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000k629"
  // },
  // "769": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     18.9643,
  //     60.9078
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 18.964,
  //   "time": "2013-09-28 08:31:43 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 18.964 كم بتاريخ 2013-09-28 08:31:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000k628"
  // },
  // "770": {
  //   "place": "١٧ كم شمال غرب مصوع، إريتريا",
  //   "latLng": [
  //     15.7293,
  //     39.3681
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 15.729,
  //   "time": "2013-09-18 09:04:22 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.0 درجة في ١٧ كم شمال غرب مصوع، إريتريا على عمق 15.729 كم بتاريخ 2013-09-18 09:04:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000jwzc"
  // },
  // "771": {
  //   "place": "٦٦ كم شمال غرب Dib Dibba، عمان",
  //   "latLng": [
  //     26.5581,
  //     55.7239
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.558,
  //   "time": "2013-09-17 16:19:40 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ٦٦ كم شمال غرب Dib Dibba، عمان على عمق 26.558 كم بتاريخ 2013-09-17 16:19:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000jyf7"
  // },
  // "772": {
  //   "place": "٢٥٩ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.7238,
  //     55.13
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.724,
  //   "time": "2013-08-24 19:32:52 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٥٩ كم شمال شمال شرق Hadibu، اليمن على عمق 14.724 كم بتاريخ 2013-08-24 19:32:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000jgmj"
  // },
  // "773": {
  //   "place": "٢٥٠ كم جنوب جنوب شرق ?al?lah، عمان",
  //   "latLng": [
  //     14.8525,
  //     54.7923
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.853,
  //   "time": "2013-08-15 03:53:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٥٠ كم جنوب جنوب شرق ?al?lah، عمان على عمق 14.853 كم بتاريخ 2013-08-15 03:53:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000ja8y"
  // },
  // "774": {
  //   "place": "٤٩ كم شرق جنوب شرق Gwadar، باكستان",
  //   "latLng": [
  //     24.9876,
  //     62.7959
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 24.988,
  //   "time": "2013-08-13 13:03:48 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في ٤٩ كم شرق جنوب شرق Gwadar، Pakistan على عمق 24.988 كم بتاريخ 2013-08-13 13:03:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000j7r1"
  // },
  // "775": {
  //   "place": "١٧ كم شرق Tallkayf، العراق",
  //   "latLng": [
  //     36.4883,
  //     43.3152
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.488,
  //   "time": "2013-08-02 01:10:29 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ١٧ كم شرق Tallkayf، العراق على عمق 36.488 كم بتاريخ 2013-08-02 01:10:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000itv8"
  // },
  // "776": {
  //   "place": "١٥٤ كم شمال كالولا، الصومال",
  //   "latLng": [
  //     13.356,
  //     50.871
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.356,
  //   "time": "2013-07-31 11:48:51 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.4 درجة في ١٥٤ كم شمال كالولا، الصومال على عمق 13.356 كم بتاريخ 2013-07-31 11:48:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000itcu"
  // },
  // "777": {
  //   "place": "٥٠ كم جنوب Gwadar، باكستان",
  //   "latLng": [
  //     24.6677,
  //     62.3725
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 24.668,
  //   "time": "2013-07-29 14:53:34 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٥٠ كم جنوب Gwadar، Pakistan على عمق 24.668 كم بتاريخ 2013-07-29 14:53:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000irpf"
  // },
  // "778": {
  //   "place": "٢٠ كم غرب جنوب غرب Ceyhan، تركيا",
  //   "latLng": [
  //     36.935,
  //     35.613
  //   ],
  //   "magnitude": 3.7,
  //   "depth": 36.935,
  //   "time": "2013-07-27 20:13:53 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 3.7 درجة في ٢٠ كم غرب جنوب غرب Ceyhan، تركيا على عمق 36.935 كم بتاريخ 2013-07-27 20:13:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000it7a"
  // },
  // "779": {
  //   "place": "١٧ كم جنوب غرب Uzunba?، تركيا",
  //   "latLng": [
  //     36.03,
  //     35.89
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.03,
  //   "time": "2013-07-26 00:22:55 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.0 درجة في ١٧ كم جنوب غرب Uzunba?، تركيا على عمق 36.03 كم بتاريخ 2013-07-26 00:22:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000ipge#dyfi"
  // },
  // "780": {
  //   "place": "٢٩٤ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.672,
  //     55.784
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.672,
  //   "time": "2013-07-25 02:24:21 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٩٤ كم شمال شرق Hadibu، اليمن على عمق 14.672 كم بتاريخ 2013-07-25 02:24:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000iszd"
  // },
  // "781": {
  //   "place": "١٥٣ كم شمال كالولا، الصومال",
  //   "latLng": [
  //     13.336,
  //     50.522
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.336,
  //   "time": "2013-07-11 20:26:51 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.8 درجة في ١٥٣ كم شمال كالولا، الصومال على عمق 13.336 كم بتاريخ 2013-07-11 20:26:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1wy"
  // },
  // "782": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.053,
  //     56.824
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.053,
  //   "time": "2013-07-10 01:44:35 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.053 كم بتاريخ 2013-07-10 01:44:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1vd"
  // },
  // "783": {
  //   "place": "١٤١ كم غرب فرسان، السعودية",
  //   "latLng": [
  //     16.681,
  //     40.793
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 16.681,
  //   "time": "2013-07-09 05:33:58 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٤١ كم غرب فرسان، السعودية على عمق 16.681 كم بتاريخ 2013-07-09 05:33:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000i9sd"
  // },
  // "784": {
  //   "place": "١٤٥ كم غرب فرسان، السعودية",
  //   "latLng": [
  //     16.724,
  //     40.755
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 16.724,
  //   "time": "2013-07-08 21:03:07 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ١٤٥ كم غرب فرسان، السعودية على عمق 16.724 كم بتاريخ 2013-07-08 21:03:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1u7"
  // },
  // "785": {
  //   "place": "١٥٨ كم شمال شرق مصوع، إريتريا",
  //   "latLng": [
  //     16.469,
  //     40.653
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 16.469,
  //   "time": "2013-07-08 15:47:12 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٥٨ كم شمال شرق مصوع، إريتريا على عمق 16.469 كم بتاريخ 2013-07-08 15:47:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1u2"
  // },
  // "786": {
  //   "place": "١٣٧ كم غرب فرسان، السعودية",
  //   "latLng": [
  //     16.707,
  //     40.831
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 16.707,
  //   "time": "2013-07-08 15:30:28 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.5 درجة في ١٣٧ كم غرب فرسان، السعودية على عمق 16.707 كم بتاريخ 2013-07-08 15:30:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000i8xl#pager"
  // },
  // "787": {
  //   "place": "١٥٨ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.796,
  //     52.447
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.796,
  //   "time": "2013-07-05 14:25:22 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ١٥٨ كم جنوب Al Ghayz?ah، اليمن على عمق 14.796 كم بتاريخ 2013-07-05 14:25:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1r2"
  // },
  // "788": {
  //   "place": "١٦٢ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.742,
  //     52.201
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.742,
  //   "time": "2013-07-05 13:51:56 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ١٦٢ كم جنوب Al Ghayz?ah، اليمن على عمق 14.742 كم بتاريخ 2013-07-05 13:51:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000i755"
  // },
  // "789": {
  //   "place": "١٦٤ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.721,
  //     52.272
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.721,
  //   "time": "2013-07-05 13:20:25 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ١٦٤ كم جنوب Al Ghayz?ah، اليمن على عمق 14.721 كم بتاريخ 2013-07-05 13:20:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000i74u"
  // },
  // "790": {
  //   "place": "١٤٢ كم غرب فرسان، السعودية",
  //   "latLng": [
  //     16.844,
  //     40.787
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 16.844,
  //   "time": "2013-07-02 16:13:20 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٤٢ كم غرب فرسان، السعودية على عمق 16.844 كم بتاريخ 2013-07-02 16:13:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k1nc"
  // },
  // "791": {
  //   "place": "١٨٧ كم جنوب شرق Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     15.24,
  //     53.616
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 15.24,
  //   "time": "2013-05-27 04:15:31 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في ١٨٧ كم جنوب شرق Al Ghayz?ah، اليمن على عمق 15.24 كم بتاريخ 2013-05-27 04:15:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k0zg"
  // },
  // "792": {
  //   "place": "٢١٠ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.553,
  //     53.892
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 14.553,
  //   "time": "2013-05-27 03:36:30 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.9 درجة في ٢١٠ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.553 كم بتاريخ 2013-05-27 03:36:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000h6w1#pager"
  // },
  // "793": {
  //   "place": "١٧٢ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.881,
  //     39.294
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 18.881,
  //   "time": "2013-05-16 20:21:30 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٧٢ كم شرق شمال شرق Tok?r، Sudan على عمق 18.881 كم بتاريخ 2013-05-16 20:21:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k0r7"
  // },
  // "794": {
  //   "place": "Gulf of عدن",
  //   "latLng": [
  //     13.464,
  //     50.373
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.464,
  //   "time": "2013-05-16 15:03:50 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.5 درجة في Gulf of عدن على عمق 13.464 كم بتاريخ 2013-05-16 15:03:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000gx0h"
  // },
  // "795": {
  //   "place": "٨١ كم غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.788,
  //     42.196
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.788,
  //   "time": "2013-05-10 21:56:22 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٨١ كم غرب Al ?udaydah، اليمن على عمق 14.788 كم بتاريخ 2013-05-10 21:56:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2013qac8"
  // },
  // "796": {
  //   "place": "١٦٩ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.675,
  //     52.258
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.675,
  //   "time": "2013-05-04 05:21:25 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ١٦٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.675 كم بتاريخ 2013-05-04 05:21:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2013pucp"
  // },
  // "797": {
  //   "place": "٢٤٠ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.685,
  //     54.795
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.685,
  //   "time": "2013-04-16 10:07:18 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٤٠ كم شمال شمال شرق Hadibu، اليمن على عمق 14.685 كم بتاريخ 2013-04-16 10:07:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k08g"
  // },
  // "798": {
  //   "place": "٢٩٦ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.506,
  //     55.997
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.506,
  //   "time": "2013-04-12 01:58:13 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢٩٦ كم شمال شرق Hadibu، اليمن على عمق 14.506 كم بتاريخ 2013-04-12 01:58:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2013nxdm"
  // },
  // "799": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.495,
  //     56.109
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.495,
  //   "time": "2013-04-11 21:02:25 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في منطقة صدع أوين على عمق 14.495 كم بتاريخ 2013-04-11 21:02:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000g59h"
  // },
  // "800": {
  //   "place": "٢٩١ كم شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.552,
  //     55.88
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.552,
  //   "time": "2013-04-11 20:53:13 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٩١ كم شمال شرق Hadibu، اليمن على عمق 14.552 كم بتاريخ 2013-04-11 20:53:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000k068"
  // },
  // "801": {
  //   "place": "٣٨ كم غرب جنوب غرب Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     27.831,
  //     33.953
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.831,
  //   "time": "2013-04-07 15:58:01 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٣٨ كم غرب جنوب غرب Sharm el-Sheikh، Egypt على عمق 27.831 كم بتاريخ 2013-04-07 15:58:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2013nscw"
  // },
  // "802": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     15.085,
  //     59.501
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 15.085,
  //   "time": "2013-03-27 10:38:13 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 15.085 كم بتاريخ 2013-03-27 10:38:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jzya"
  // },
  // "803": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.007,
  //     56.602
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.007,
  //   "time": "2013-03-20 14:56:15 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.007 كم بتاريخ 2013-03-20 14:56:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us2013mzcw"
  // },
  // "804": {
  //   "place": "٢٨ كم شمال شرق Tallkayf، العراق",
  //   "latLng": [
  //     36.676,
  //     43.34
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.676,
  //   "time": "2013-03-13 06:23:04 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٨ كم شمال شرق Tallkayf، العراق على عمق 36.676 كم بتاريخ 2013-03-13 06:23:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000fk2p"
  // },
  // "805": {
  //   "place": "٣٤ كم شمال شرق Tallkayf، العراق",
  //   "latLng": [
  //     36.67,
  //     43.44
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.67,
  //   "time": "2013-03-11 14:57:07 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.9 درجة في ٣٤ كم شمال شرق Tallkayf، العراق على عمق 36.67 كم بتاريخ 2013-03-11 14:57:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usb000fisx#dyfi"
  // },
  // "806": {
  //   "place": "١٧٣ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.673,
  //     51.725
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.673,
  //   "time": "2013-02-23 00:04:33 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٣ كم شمال شمال غرب Kilmia، اليمن على عمق 13.673 كم بتاريخ 2013-02-23 00:04:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usc000fc1k"
  // },
  // "807": {
  //   "place": "٣٩ كم شمال شمال غرب Ash Sha?rah، العراق",
  //   "latLng": [
  //     31.756,
  //     46.087
  //   ],
  //   "magnitude": 3.6,
  //   "depth": 31.756,
  //   "time": "2013-01-21 18:50:47 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 3.6 درجة في ٣٩ كم شمال شمال غرب Ash Sha?rah، العراق على عمق 31.756 كم بتاريخ 2013-01-21 18:50:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jypb"
  // },
  // "808": {
  //   "place": "٢٦ كم شمال شمال غرب Ash Sha?rah، العراق",
  //   "latLng": [
  //     31.621,
  //     46.054
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 31.621,
  //   "time": "2013-01-20 17:12:32 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٦ كم شمال شمال غرب Ash Sha?rah، العراق على عمق 31.621 كم بتاريخ 2013-01-20 17:12:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jymk"
  // },
  // "809": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     22.446,
  //     62.99
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 22.446,
  //   "time": "2013-01-05 22:54:34 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 22.446 كم بتاريخ 2013-01-05 22:54:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jxxu"
  // },
  // "810": {
  //   "place": "٧٢ كم جنوب جنوب شرق Jiwani، باكستان",
  //   "latLng": [
  //     24.423,
  //     61.941
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 24.423,
  //   "time": "2013-01-05 05:58:20 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٧٢ كم جنوب جنوب شرق Jiwani، Pakistan على عمق 24.423 كم بتاريخ 2013-01-05 05:58:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jxue"
  // },
  // "811": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.501,
  //     56.265
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.501,
  //   "time": "2012-12-11 05:37:01 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.501 كم بتاريخ 2012-12-11 05:37:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jwu1"
  // },
  // "812": {
  //   "place": "٨١ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.972,
  //     42.216
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.972,
  //   "time": "2012-12-03 23:56:05 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٨١ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 14.972 كم بتاريخ 2012-12-03 23:56:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jwdr"
  // },
  // "813": {
  //   "place": "٧٨ كم غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.875,
  //     42.229
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.875,
  //   "time": "2012-12-03 17:52:17 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.7 درجة في ٧٨ كم غرب Al ?udaydah، اليمن على عمق 14.875 كم بتاريخ 2012-12-03 17:52:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jwdc"
  // },
  // "814": {
  //   "place": "٤٠ كم جنوب جنوب غرب Al Jahr?’، الكويت",
  //   "latLng": [
  //     28.988,
  //     47.555
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.988,
  //   "time": "2012-11-12 03:46:03 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ٤٠ كم جنوب جنوب غرب Al Jahr?’، الكويت على عمق 28.988 كم بتاريخ 2012-11-12 03:46:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jve4"
  // },
  // "815": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.448,
  //     56.429
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.448,
  //   "time": "2012-11-09 06:54:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 14.448 كم بتاريخ 2012-11-09 06:54:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jv8q"
  // },
  // "816": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.24,
  //     57.64
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.24,
  //   "time": "2012-11-03 08:17:41 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.1 درجة في منطقة صدع أوين على عمق 14.24 كم بتاريخ 2012-11-03 08:17:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000juyy"
  // },
  // "817": {
  //   "place": "١١ كم غرب جنوب غرب Reef Al Fujairah City، United Arab Emirates",
  //   "latLng": [
  //     25.114,
  //     56.138
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 25.114,
  //   "time": "2012-10-21 16:13:22 UTC",
  //   "region": "الإمارات",
  //   "info": "زلزال بقوة 4.5 درجة في ١١ كم غرب جنوب غرب Reef Al Fujairah City، United Arab Emirates على عمق 25.114 كم بتاريخ 2012-10-21 16:13:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000ju98#dyfi"
  // },
  // "818": {
  //   "place": "العراق",
  //   "latLng": [
  //     36.961,
  //     43.655
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.961,
  //   "time": "2012-09-13 02:42:20 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في العراق على عمق 36.961 كم بتاريخ 2012-09-13 02:42:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000js8e"
  // },
  // "819": {
  //   "place": "١٩٠ كم غرب جنوب غرب Yanbu، السعودية",
  //   "latLng": [
  //     23.421,
  //     36.342
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 23.421,
  //   "time": "2012-09-09 10:02:08 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ١٩٠ كم غرب جنوب غرب Yanbu، السعودية على عمق 23.421 كم بتاريخ 2012-09-09 10:02:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000js1k"
  // },
  // "820": {
  //   "place": "١٨٤ كم غرب شمال غرب فرسان، السعودية",
  //   "latLng": [
  //     17.23,
  //     40.479
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 17.23,
  //   "time": "2012-09-02 07:17:47 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٨٤ كم غرب شمال غرب فرسان، السعودية على عمق 17.23 كم بتاريخ 2012-09-02 07:17:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jrg6"
  // },
  // "821": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.648,
  //     55.913
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.648,
  //   "time": "2012-08-05 23:02:13 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في منطقة صدع أوين على عمق 14.648 كم بتاريخ 2012-08-05 23:02:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jpxu"
  // },
  // "822": {
  //   "place": "٣٦ كم جنوب جنوب غرب Umm Qa?r، العراق",
  //   "latLng": [
  //     29.717,
  //     47.822
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.717,
  //   "time": "2012-08-02 16:47:59 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ٣٦ كم جنوب جنوب غرب Umm Qa?r، العراق على عمق 29.717 كم بتاريخ 2012-08-02 16:47:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jpsu"
  // },
  // "823": {
  //   "place": "٣٢ كم جنوب جنوب غرب Umm Qa?r، العراق",
  //   "latLng": [
  //     29.76,
  //     47.821
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.76,
  //   "time": "2012-08-02 04:32:37 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.2 درجة في ٣٢ كم جنوب جنوب غرب Umm Qa?r، العراق على عمق 29.76 كم بتاريخ 2012-08-02 04:32:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jpru"
  // },
  // "824": {
  //   "place": "٦٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.347,
  //     41.787
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.347,
  //   "time": "2012-07-01 16:19:13 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٦٥ كم جنوب Edd، إريتريا على عمق 13.347 كم بتاريخ 2012-07-01 16:19:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jnfg"
  // },
  // "825": {
  //   "place": "١٧٦ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.894,
  //     39.324
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 18.894,
  //   "time": "2012-06-03 14:10:34 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٦ كم شرق شمال شرق Tok?r، Sudan على عمق 18.894 كم بتاريخ 2012-06-03 14:10:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jm9e"
  // },
  // "826": {
  //   "place": "١٨٠ كم شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.731,
  //     39.407
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 18.731,
  //   "time": "2012-06-03 11:00:54 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٨٠ كم شرق Tok?r، Sudan على عمق 18.731 كم بتاريخ 2012-06-03 11:00:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jm94"
  // },
  // "827": {
  //   "place": "١٥٢ كم جنوب Jiwani، باكستان",
  //   "latLng": [
  //     23.692,
  //     62.021
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 23.692,
  //   "time": "2012-06-01 11:03:40 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.9 درجة في ١٥٢ كم جنوب Jiwani، Pakistan على عمق 23.692 كم بتاريخ 2012-06-01 11:03:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jm6w"
  // },
  // "828": {
  //   "place": "١٦٨ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.081,
  //     39.168
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 19.081,
  //   "time": "2012-05-24 23:05:04 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٦٨ كم شرق شمال شرق Tok?r، Sudan على عمق 19.081 كم بتاريخ 2012-05-24 23:05:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jkw9"
  // },
  // "829": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     15.823,
  //     59.668
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 15.823,
  //   "time": "2012-05-24 14:22:10 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في منطقة صدع أوين على عمق 15.823 كم بتاريخ 2012-05-24 14:22:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jkvr"
  // },
  // "830": {
  //   "place": "١٦٦ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.133,
  //     39.121
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 19.133,
  //   "time": "2012-05-24 08:27:46 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ١٦٦ كم شرق شمال شرق Tok?r، Sudan على عمق 19.133 كم بتاريخ 2012-05-24 08:27:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jkv9"
  // },
  // "831": {
  //   "place": "١٧٩ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     19.164,
  //     39.242
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 19.164,
  //   "time": "2012-05-23 16:08:33 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٩ كم شرق شمال شرق Tok?r، Sudan على عمق 19.164 كم بتاريخ 2012-05-23 16:08:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jku2"
  // },
  // "832": {
  //   "place": "٢٠ كم شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.614,
  //     46.81
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.614,
  //   "time": "2012-05-19 18:21:26 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٠ كم شمال شرق ‘Al? al Gharb?، العراق على عمق 32.614 كم بتاريخ 2012-05-19 18:21:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jkmh"
  // },
  // "833": {
  //   "place": "٢٢ كم شمال شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.634,
  //     46.811
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.634,
  //   "time": "2012-05-19 17:02:41 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٢ كم شمال شمال شرق ‘Al? al Gharb?، العراق على عمق 32.634 كم بتاريخ 2012-05-19 17:02:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jkme"
  // },
  // "834": {
  //   "place": "٥٠ كم جنوب جنوب غرب Kirkuk، العراق",
  //   "latLng": [
  //     35.088,
  //     44.096
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.088,
  //   "time": "2012-05-05 01:57:11 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٥٠ كم جنوب جنوب غرب Kirkuk، العراق على عمق 35.088 كم بتاريخ 2012-05-05 01:57:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jk0s"
  // },
  // "835": {
  //   "place": "٢١ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.434,
  //     46.915
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.434,
  //   "time": "2012-04-28 00:34:06 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٢١ كم شرق ‘Al? al Gharb?، العراق على عمق 32.434 كم بتاريخ 2012-04-28 00:34:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjpw"
  // },
  // "836": {
  //   "place": "٢٥ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.42,
  //     46.958
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.42,
  //   "time": "2012-04-24 18:16:36 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٥ كم شرق ‘Al? al Gharb?، العراق على عمق 32.42 كم بتاريخ 2012-04-24 18:16:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjhn"
  // },
  // "837": {
  //   "place": "٣٦ كم شمال شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.78,
  //     46.78
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.78,
  //   "time": "2012-04-23 23:00:37 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٦ كم شمال شمال شرق ‘Al? al Gharb?، العراق على عمق 32.78 كم بتاريخ 2012-04-23 23:00:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjg3"
  // },
  // "838": {
  //   "place": "٣٣ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.411,
  //     47.039
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.411,
  //   "time": "2012-04-22 08:13:52 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٣ كم شرق ‘Al? al Gharb?، العراق على عمق 32.411 كم بتاريخ 2012-04-22 08:13:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjd8#shakemap"
  // },
  // "839": {
  //   "place": "٣٤ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.407,
  //     47.049
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 32.407,
  //   "time": "2012-04-21 05:25:08 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.0 درجة في ٣٤ كم شرق ‘Al? al Gharb?، العراق على عمق 32.407 كم بتاريخ 2012-04-21 05:25:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjba#shakemap"
  // },
  // "840": {
  //   "place": "٣٤ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.407,
  //     47.046
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.407,
  //   "time": "2012-04-21 02:39:13 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٤ كم شرق ‘Al? al Gharb?، العراق على عمق 32.407 كم بتاريخ 2012-04-21 02:39:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jjb0"
  // },
  // "841": {
  //   "place": "٣٠ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.505,
  //     47.012
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.505,
  //   "time": "2012-04-20 17:19:48 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٠ كم شرق ‘Al? al Gharb?، العراق على عمق 32.505 كم بتاريخ 2012-04-20 17:19:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jja0"
  // },
  // "842": {
  //   "place": "٢٧ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.432,
  //     46.983
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.432,
  //   "time": "2012-04-20 16:32:52 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٧ كم شرق ‘Al? al Gharb?، العراق على عمق 32.432 كم بتاريخ 2012-04-20 16:32:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj9z"
  // },
  // "843": {
  //   "place": "١٦ كم شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.579,
  //     46.801
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 32.579,
  //   "time": "2012-04-20 04:11:50 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ١٦ كم شمال شرق ‘Al? al Gharb?، العراق على عمق 32.579 كم بتاريخ 2012-04-20 04:11:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj99"
  // },
  // "844": {
  //   "place": "٢٧ كم شرق شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.527,
  //     46.973
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.527,
  //   "time": "2012-04-20 03:57:51 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٧ كم شرق شمال شرق ‘Al? al Gharb?، العراق على عمق 32.527 كم بتاريخ 2012-04-20 03:57:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj97"
  // },
  // "845": {
  //   "place": "١٦ كم شرق شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.524,
  //     46.849
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.524,
  //   "time": "2012-04-20 03:56:25 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ١٦ كم شرق شمال شرق ‘Al? al Gharb?، العراق على عمق 32.524 كم بتاريخ 2012-04-20 03:56:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj96"
  // },
  // "846": {
  //   "place": "٢٦ كم شرق جنوب شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.381,
  //     46.958
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.381,
  //   "time": "2012-04-20 03:52:36 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٦ كم شرق جنوب شرق ‘Al? al Gharb?، العراق على عمق 32.381 كم بتاريخ 2012-04-20 03:52:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj95"
  // },
  // "847": {
  //   "place": "٢٤ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.477,
  //     46.949
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.477,
  //   "time": "2012-04-20 03:43:17 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٤ كم شرق ‘Al? al Gharb?، العراق على عمق 32.477 كم بتاريخ 2012-04-20 03:43:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj92"
  // },
  // "848": {
  //   "place": "١٨ كم شرق جنوب شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.374,
  //     46.853
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.374,
  //   "time": "2012-04-20 03:31:41 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ١٨ كم شرق جنوب شرق ‘Al? al Gharb?، العراق على عمق 32.374 كم بتاريخ 2012-04-20 03:31:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj90"
  // },
  // "849": {
  //   "place": "٢٨ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.453,
  //     46.99
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 32.453,
  //   "time": "2012-04-20 03:05:41 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.0 درجة في ٢٨ كم شرق ‘Al? al Gharb?، العراق على عمق 32.453 كم بتاريخ 2012-04-20 03:05:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj8y"
  // },
  // "850": {
  //   "place": "٢٦ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.422,
  //     46.962
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.422,
  //   "time": "2012-04-20 01:48:39 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.1 درجة في ٢٦ كم شرق ‘Al? al Gharb?، العراق على عمق 32.422 كم بتاريخ 2012-04-20 01:48:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj8t"
  // },
  // "851": {
  //   "place": "٢٦ كم شرق جنوب شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.39,
  //     46.954
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.39,
  //   "time": "2012-04-19 07:42:51 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٦ كم شرق جنوب شرق ‘Al? al Gharb?، العراق على عمق 32.39 كم بتاريخ 2012-04-19 07:42:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj7v"
  // },
  // "852": {
  //   "place": "٣٠ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.506,
  //     47.004
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 32.506,
  //   "time": "2012-04-18 18:42:57 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 5.1 درجة في ٣٠ كم شرق ‘Al? al Gharb?، العراق على عمق 32.506 كم بتاريخ 2012-04-18 18:42:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jj6u"
  // },
  // "853": {
  //   "place": "١٢ كم شرق شمال شرق Musabeyli، تركيا",
  //   "latLng": [
  //     36.926,
  //     37.046
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.926,
  //   "time": "2012-04-04 11:05:16 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.0 درجة في ١٢ كم شرق شمال شرق Musabeyli، تركيا على عمق 36.926 كم بتاريخ 2012-04-04 11:05:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jh80"
  // },
  // "854": {
  //   "place": "٢٥ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.456,
  //     46.957
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.456,
  //   "time": "2012-03-25 12:28:54 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٥ كم شرق ‘Al? al Gharb?، العراق على عمق 32.456 كم بتاريخ 2012-03-25 12:28:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jgrx"
  // },
  // "855": {
  //   "place": "٢٩ كم شرق شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.554,
  //     46.978
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 32.554,
  //   "time": "2012-03-24 05:25:38 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٩ كم شرق شمال شرق ‘Al? al Gharb?، العراق على عمق 32.554 كم بتاريخ 2012-03-24 05:25:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jgq2#shakemap"
  // },
  // "856": {
  //   "place": "٢٦ كم شرق شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.589,
  //     46.932
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.589,
  //   "time": "2012-03-10 21:41:07 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٦ كم شرق شمال شرق ‘Al? al Gharb?، العراق على عمق 32.589 كم بتاريخ 2012-03-10 21:41:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jg2d"
  // },
  // "857": {
  //   "place": "٥١ كم غرب شمال غرب ??z Kh?rm?t?، العراق",
  //   "latLng": [
  //     35.042,
  //     44.095
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 35.042,
  //   "time": "2012-03-05 06:50:37 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.6 درجة في ٥١ كم غرب شمال غرب ??z Kh?rm?t?، العراق على عمق 35.042 كم بتاريخ 2012-03-05 06:50:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jftc#shakemap"
  // },
  // "858": {
  //   "place": "٢٢ كم شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.457,
  //     46.93
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 32.457,
  //   "time": "2012-02-29 05:10:43 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٢ كم شرق ‘Al? al Gharb?، العراق على عمق 32.457 كم بتاريخ 2012-02-29 05:10:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jfjz"
  // },
  // "859": {
  //   "place": "٢١ كم شرق شمال شرق ‘Al? al Gharb?، العراق",
  //   "latLng": [
  //     32.503,
  //     46.913
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 32.503,
  //   "time": "2012-02-28 23:18:53 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.5 درجة في ٢١ كم شرق شمال شرق ‘Al? al Gharb?، العراق على عمق 32.503 كم بتاريخ 2012-02-28 23:18:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jfjj#dyfi"
  // },
  // "860": {
  //   "place": "٢٣٢ كم شرق Mukalla، اليمن",
  //   "latLng": [
  //     14.214,
  //     51.249
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.214,
  //   "time": "2012-02-25 02:01:04 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.7 درجة في ٢٣٢ كم شرق Mukalla، اليمن على عمق 14.214 كم بتاريخ 2012-02-25 02:01:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jfbk"
  // },
  // "861": {
  //   "place": "٣٦ كم غرب جنوب غرب Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     27.787,
  //     33.985
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.787,
  //   "time": "2012-01-30 17:04:28 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٣٦ كم غرب جنوب غرب Sharm el-Sheikh، Egypt على عمق 27.787 كم بتاريخ 2012-01-30 17:04:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000je6a"
  // },
  // "862": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.331,
  //     57.421
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.331,
  //   "time": "2011-12-30 07:58:54 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في منطقة صدع أوين على عمق 13.331 كم بتاريخ 2011-12-30 07:58:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jcu0"
  // },
  // "863": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.485,
  //     57.542
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.485,
  //   "time": "2011-12-27 23:02:18 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 13.485 كم بتاريخ 2011-12-27 23:02:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jcqw"
  // },
  // "864": {
  //   "place": "١٠٩ كم غرب جنوب غرب Edd، إريتريا",
  //   "latLng": [
  //     13.452,
  //     40.806
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.452,
  //   "time": "2011-12-25 10:48:20 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٠٩ كم غرب جنوب غرب Edd، إريتريا على عمق 13.452 كم بتاريخ 2011-12-25 10:48:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jcmh"
  // },
  // "865": {
  //   "place": "٢٤٥ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.775,
  //     54.66
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.775,
  //   "time": "2011-12-18 20:21:59 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٤٥ كم شمال شمال شرق Hadibu، اليمن على عمق 14.775 كم بتاريخ 2011-12-18 20:21:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jccm"
  // },
  // "866": {
  //   "place": "١٦٩ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.679,
  //     52.177
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.679,
  //   "time": "2011-11-30 01:11:58 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ١٦٩ كم جنوب Al Ghayz?ah، اليمن على عمق 14.679 كم بتاريخ 2011-11-30 01:11:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jbmp"
  // },
  // "867": {
  //   "place": "٢٥ كم شرق شمال شرق Kifr?، العراق",
  //   "latLng": [
  //     34.76,
  //     45.23
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.76,
  //   "time": "2011-11-29 07:58:15 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٥ كم شرق شمال شرق Kifr?، العراق على عمق 34.76 كم بتاريخ 2011-11-29 07:58:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jbk7"
  // },
  // "868": {
  //   "place": "٢٤٤ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.698,
  //     54.86
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 14.698,
  //   "time": "2011-11-25 08:39:33 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.9 درجة في ٢٤٤ كم شمال شمال شرق Hadibu، اليمن على عمق 14.698 كم بتاريخ 2011-11-25 08:39:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jbcm"
  // },
  // "869": {
  //   "place": "٢٩ كم غرب جنوب غرب Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     27.768,
  //     34.077
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.768,
  //   "time": "2011-11-19 07:12:15 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٢٩ كم غرب جنوب غرب Sharm el-Sheikh، Egypt على عمق 27.768 كم بتاريخ 2011-11-19 07:12:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000jb3p"
  // },
  // "870": {
  //   "place": "١٧٣ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.22,
  //     53.832
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 14.22,
  //   "time": "2011-10-26 20:31:43 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.3 درجة في ١٧٣ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.22 كم بتاريخ 2011-10-26 20:31:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9yc"
  // },
  // "871": {
  //   "place": "١٧٤ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.253,
  //     53.685
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.253,
  //   "time": "2011-10-26 20:05:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٤ كم شمال Qalans?yah، اليمن على عمق 14.253 كم بتاريخ 2011-10-26 20:05:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9ya"
  // },
  // "872": {
  //   "place": "١٧٢ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.228,
  //     53.773
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.228,
  //   "time": "2011-10-26 19:58:51 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ١٧٢ كم شمال Qalans?yah، اليمن على عمق 14.228 كم بتاريخ 2011-10-26 19:58:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y8"
  // },
  // "873": {
  //   "place": "١٨٠ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.28,
  //     53.86
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 14.28,
  //   "time": "2011-10-26 19:54:08 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.1 درجة في ١٨٠ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.28 كم بتاريخ 2011-10-26 19:54:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y7"
  // },
  // "874": {
  //   "place": "١٧٦ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.256,
  //     53.79
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.256,
  //   "time": "2011-10-26 19:53:30 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ١٧٦ كم شمال Qalans?yah، اليمن على عمق 14.256 كم بتاريخ 2011-10-26 19:53:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y6"
  // },
  // "875": {
  //   "place": "١٦٨ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.188,
  //     53.744
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.188,
  //   "time": "2011-10-26 19:38:15 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ١٦٨ كم شمال Qalans?yah، اليمن على عمق 14.188 كم بتاريخ 2011-10-26 19:38:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y3"
  // },
  // "876": {
  //   "place": "١٦٣ كم شمال شمال شرق Qalans?yah، اليمن",
  //   "latLng": [
  //     14.14,
  //     53.783
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.14,
  //   "time": "2011-10-26 19:33:17 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ١٦٣ كم شمال شمال شرق Qalans?yah، اليمن على عمق 14.14 كم بتاريخ 2011-10-26 19:33:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y2"
  // },
  // "877": {
  //   "place": "١٧٠ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.205,
  //     53.763
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.205,
  //   "time": "2011-10-26 19:33:02 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.5 درجة في ١٧٠ كم شمال Qalans?yah، اليمن على عمق 14.205 كم بتاريخ 2011-10-26 19:33:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j9y1"
  // },
  // "878": {
  //   "place": "١٨٤ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.778,
  //     51.721
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.778,
  //   "time": "2011-09-24 10:55:45 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 4.4 درجة في ١٨٤ كم شمال شمال غرب Kilmia، اليمن على عمق 13.778 كم بتاريخ 2011-09-24 10:55:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j8gh"
  // },
  // "879": {
  //   "place": "١٠٩ كم جنوب جنوب غرب فرسان، السعودية",
  //   "latLng": [
  //     15.872,
  //     41.562
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.872,
  //   "time": "2011-09-05 17:56:38 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٠٩ كم جنوب جنوب غرب فرسان، السعودية على عمق 15.872 كم بتاريخ 2011-09-05 17:56:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j7np"
  // },
  // "880": {
  //   "place": "٩٧ كم غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.965,
  //     42.064
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.965,
  //   "time": "2011-08-22 05:56:48 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٩٧ كم غرب Al ?udaydah، اليمن على عمق 14.965 كم بتاريخ 2011-08-22 05:56:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j6ut"
  // },
  // "881": {
  //   "place": "١٠٣ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.04,
  //     42.025
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 15.04,
  //   "time": "2011-08-21 04:25:49 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ١٠٣ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.04 كم بتاريخ 2011-08-21 04:25:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j6sy"
  // },
  // "882": {
  //   "place": "٨٢ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.97,
  //     42.212
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.97,
  //   "time": "2011-08-20 14:29:05 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.0 درجة في ٨٢ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 14.97 كم بتاريخ 2011-08-20 14:29:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j6qy"
  // },
  // "883": {
  //   "place": "١٠٩ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.088,
  //     41.98
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 15.088,
  //   "time": "2011-08-20 09:38:37 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ١٠٩ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.088 كم بتاريخ 2011-08-20 09:38:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j6qj"
  // },
  // "884": {
  //   "place": "٥٧ كم شرق جنوب شرق Gwadar، باكستان",
  //   "latLng": [
  //     24.934,
  //     62.859
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 24.934,
  //   "time": "2011-08-08 04:07:21 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ٥٧ كم شرق جنوب شرق Gwadar، Pakistan على عمق 24.934 كم بتاريخ 2011-08-08 04:07:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j65p"
  // },
  // "885": {
  //   "place": "٩٢ كم جنوب غرب Duba، السعودية",
  //   "latLng": [
  //     26.802,
  //     34.994
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.802,
  //   "time": "2011-06-22 23:43:15 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٩٢ كم جنوب غرب Duba، السعودية على عمق 26.802 كم بتاريخ 2011-06-22 23:43:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j3kc"
  // },
  // "886": {
  //   "place": "٦١ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.377,
  //     41.62
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.377,
  //   "time": "2011-06-12 21:41:55 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٦١ كم جنوب Edd، إريتريا على عمق 13.377 كم بتاريخ 2011-06-12 21:41:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j332"
  // },
  // "887": {
  //   "place": "٦٧ كم جنوب جنوب غرب Edd، إريتريا",
  //   "latLng": [
  //     13.34,
  //     41.542
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.34,
  //   "time": "2011-06-12 21:31:08 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٦٧ كم جنوب جنوب غرب Edd، إريتريا على عمق 13.34 كم بتاريخ 2011-06-12 21:31:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j330"
  // },
  // "888": {
  //   "place": "٥٩ كم جنوب جنوب غرب Edd، إريتريا",
  //   "latLng": [
  //     13.408,
  //     41.548
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.408,
  //   "time": "2011-06-12 21:17:11 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٥٩ كم جنوب جنوب غرب Edd، إريتريا على عمق 13.408 كم بتاريخ 2011-06-12 21:17:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32z"
  // },
  // "889": {
  //   "place": "٤٤ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.53,
  //     41.641
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 13.53,
  //   "time": "2011-06-12 21:03:23 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.4 درجة في ٤٤ كم جنوب Edd، إريتريا على عمق 13.53 كم بتاريخ 2011-06-12 21:03:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32y#dyfi"
  // },
  // "890": {
  //   "place": "٥٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.433,
  //     41.682
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 13.433,
  //   "time": "2011-06-12 20:58:18 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.0 درجة في ٥٥ كم جنوب Edd، إريتريا على عمق 13.433 كم بتاريخ 2011-06-12 20:58:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32w"
  // },
  // "891": {
  //   "place": "٥٧ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.414,
  //     41.735
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 13.414,
  //   "time": "2011-06-12 20:32:40 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.6 درجة في ٥٧ كم جنوب Edd، إريتريا على عمق 13.414 كم بتاريخ 2011-06-12 20:32:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32u#shakemap"
  // },
  // "892": {
  //   "place": "٦٠ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.392,
  //     41.62
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.392,
  //   "time": "2011-06-12 20:23:06 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٦٠ كم جنوب Edd، إريتريا على عمق 13.392 كم بتاريخ 2011-06-12 20:23:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32s"
  // },
  // "893": {
  //   "place": "٦١ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.377,
  //     41.665
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.377,
  //   "time": "2011-06-12 19:57:43 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٦١ كم جنوب Edd، إريتريا على عمق 13.377 كم بتاريخ 2011-06-12 19:57:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32q"
  // },
  // "894": {
  //   "place": "٥٧ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.409,
  //     41.711
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.409,
  //   "time": "2011-06-12 19:44:16 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٥٧ كم جنوب Edd، إريتريا على عمق 13.409 كم بتاريخ 2011-06-12 19:44:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32n"
  // },
  // "895": {
  //   "place": "٥٤ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.441,
  //     41.667
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.441,
  //   "time": "2011-06-12 19:37:43 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٥٤ كم جنوب Edd، إريتريا على عمق 13.441 كم بتاريخ 2011-06-12 19:37:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32k"
  // },
  // "896": {
  //   "place": "٥٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.428,
  //     41.727
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.428,
  //   "time": "2011-06-12 19:03:37 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٥٥ كم جنوب Edd، إريتريا على عمق 13.428 كم بتاريخ 2011-06-12 19:03:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32e"
  // },
  // "897": {
  //   "place": "٦٥ كم جنوب جنوب شرق Edd، إريتريا",
  //   "latLng": [
  //     13.353,
  //     41.818
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 13.353,
  //   "time": "2011-06-12 18:48:51 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.0 درجة في ٦٥ كم جنوب جنوب شرق Edd، إريتريا على عمق 13.353 كم بتاريخ 2011-06-12 18:48:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j32c"
  // },
  // "898": {
  //   "place": "٦٦ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.332,
  //     41.693
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 13.332,
  //   "time": "2011-06-12 17:47:20 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.7 درجة في ٦٦ كم جنوب Edd، إريتريا على عمق 13.332 كم بتاريخ 2011-06-12 17:47:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j327"
  // },
  // "899": {
  //   "place": "٦٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.344,
  //     41.766
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.344,
  //   "time": "2011-06-12 17:18:09 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٦٥ كم جنوب Edd، إريتريا على عمق 13.344 كم بتاريخ 2011-06-12 17:18:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j324"
  // },
  // "900": {
  //   "place": "٦٤ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.349,
  //     41.763
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.349,
  //   "time": "2011-06-12 16:51:00 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٦٤ كم جنوب Edd، إريتريا على عمق 13.349 كم بتاريخ 2011-06-12 16:51:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31x"
  // },
  // "901": {
  //   "place": "٦٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.337,
  //     41.659
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 13.337,
  //   "time": "2011-06-12 16:44:40 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.7 درجة في ٦٥ كم جنوب Edd، إريتريا على عمق 13.337 كم بتاريخ 2011-06-12 16:44:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31w"
  // },
  // "902": {
  //   "place": "٥٩ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.398,
  //     41.726
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.398,
  //   "time": "2011-06-12 16:24:44 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٥٩ كم جنوب Edd، إريتريا على عمق 13.398 كم بتاريخ 2011-06-12 16:24:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31s"
  // },
  // "903": {
  //   "place": "٦٦ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.331,
  //     41.76
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.331,
  //   "time": "2011-06-12 16:09:30 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٦٦ كم جنوب Edd، إريتريا على عمق 13.331 كم بتاريخ 2011-06-12 16:09:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31n"
  // },
  // "904": {
  //   "place": "٦٥ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.339,
  //     41.637
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 13.339,
  //   "time": "2011-06-12 15:38:52 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.0 درجة في ٦٥ كم جنوب Edd، إريتريا على عمق 13.339 كم بتاريخ 2011-06-12 15:38:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31j"
  // },
  // "905": {
  //   "place": "٥٦ كم جنوب Edd، إريتريا",
  //   "latLng": [
  //     13.42,
  //     41.694
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 13.42,
  //   "time": "2011-06-12 15:37:04 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.1 درجة في ٥٦ كم جنوب Edd، إريتريا على عمق 13.42 كم بتاريخ 2011-06-12 15:37:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j31h"
  // },
  // "906": {
  //   "place": "٢١٢ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.497,
  //     40.268
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 17.497,
  //   "time": "2011-06-08 11:19:11 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ٢١٢ كم غرب Ad Darb، السعودية على عمق 17.497 كم بتاريخ 2011-06-08 11:19:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j2vn"
  // },
  // "907": {
  //   "place": "٢١١ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.738,
  //     40.254
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 17.738,
  //   "time": "2011-06-08 02:29:43 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.2 درجة في ٢١١ كم غرب Ad Darb، السعودية على عمق 17.738 كم بتاريخ 2011-06-08 02:29:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j2v4"
  // },
  // "908": {
  //   "place": "٢٠٤ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.823,
  //     40.329
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 17.823,
  //   "time": "2011-06-08 02:02:00 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٠٤ كم غرب Ad Darb، السعودية على عمق 17.823 كم بتاريخ 2011-06-08 02:02:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j2v3"
  // },
  // "909": {
  //   "place": "١٠٠ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.054,
  //     42.063
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 15.054,
  //   "time": "2011-05-03 18:50:31 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٠٠ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.054 كم بتاريخ 2011-05-03 18:50:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0yx"
  // },
  // "910": {
  //   "place": "٧٥ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     14.964,
  //     42.274
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.964,
  //   "time": "2011-05-03 15:12:10 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٧٥ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 14.964 كم بتاريخ 2011-05-03 15:12:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0ym"
  // },
  // "911": {
  //   "place": "٨٨ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.196,
  //     42.242
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 15.196,
  //   "time": "2011-04-30 22:36:01 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٨٨ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.196 كم بتاريخ 2011-04-30 22:36:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0u9"
  // },
  // "912": {
  //   "place": "٩١ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.044,
  //     42.14
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 15.044,
  //   "time": "2011-04-30 13:48:48 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٩١ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.044 كم بتاريخ 2011-04-30 13:48:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0tx"
  // },
  // "913": {
  //   "place": "٩٨ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.001,
  //     42.063
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.001,
  //   "time": "2011-04-30 06:39:55 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٩٨ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.001 كم بتاريخ 2011-04-30 06:39:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0t8"
  // },
  // "914": {
  //   "place": "١٠٥ كم غرب شمال غرب Al ?udaydah، اليمن",
  //   "latLng": [
  //     15.094,
  //     42.027
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.094,
  //   "time": "2011-04-29 16:41:32 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٠٥ كم غرب شمال غرب Al ?udaydah، اليمن على عمق 15.094 كم بتاريخ 2011-04-29 16:41:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000j0s3"
  // },
  // "915": {
  //   "place": "٤٥ كم جنوب شرق مصوع، إريتريا",
  //   "latLng": [
  //     15.289,
  //     39.736
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 15.289,
  //   "time": "2011-03-25 05:21:33 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.8 درجة في ٤٥ كم جنوب شرق مصوع، إريتريا على عمق 15.289 كم بتاريخ 2011-03-25 05:21:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hyhv#dyfi"
  // },
  // "916": {
  //   "place": "١٧٦ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.674,
  //     51.636
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 13.674,
  //   "time": "2011-02-20 09:09:58 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 5.4 درجة في ١٧٦ كم شمال شمال غرب Kilmia، اليمن على عمق 13.674 كم بتاريخ 2011-02-20 09:09:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000husx"
  // },
  // "917": {
  //   "place": "٢٣ كم غرب شمال غرب Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     28.031,
  //     34.129
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.031,
  //   "time": "2011-02-20 04:52:37 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣ كم غرب شمال غرب Sharm el-Sheikh، Egypt على عمق 28.031 كم بتاريخ 2011-02-20 04:52:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000husq"
  // },
  // "918": {
  //   "place": "٣٢ كم غرب جنوب غرب Sharm el-Sheikh، مصر",
  //   "latLng": [
  //     27.819,
  //     34.019
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.819,
  //   "time": "2011-02-20 01:27:04 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.5 درجة في ٣٢ كم غرب جنوب غرب Sharm el-Sheikh، Egypt على عمق 27.819 كم بتاريخ 2011-02-20 01:27:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000husm"
  // },
  // "919": {
  //   "place": "٥٧ كم شمال شمال غرب Al H?rithah، العراق",
  //   "latLng": [
  //     31.07,
  //     47.56
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.07,
  //   "time": "2011-02-07 02:38:27 UTC",
  //   "region": "السعودية",
  //   "info": "زلزال بقوة 4.3 درجة في ٥٧ كم شمال شمال غرب Al H?rithah، العراق على عمق 31.07 كم بتاريخ 2011-02-07 02:38:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hu6c"
  // },
  // "920": {
  //   "place": "٢١١ كم شمال شمال شرق Hadibu، اليمن",
  //   "latLng": [
  //     14.454,
  //     54.666
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.454,
  //   "time": "2011-02-05 21:47:03 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.0 درجة في ٢١١ كم شمال شمال شرق Hadibu، اليمن على عمق 14.454 كم بتاريخ 2011-02-05 21:47:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hu50"
  // },
  // "921": {
  //   "place": "٢٢٠ كم شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.516,
  //     39.811
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 18.516,
  //   "time": "2011-02-04 11:11:26 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢٠ كم شرق Tok?r، Sudan على عمق 18.516 كم بتاريخ 2011-02-04 11:11:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hu2m"
  // },
  // "922": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.026,
  //     56.744
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.026,
  //   "time": "2011-02-02 13:57:33 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.026 كم بتاريخ 2011-02-02 13:57:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000htzu"
  // },
  // "923": {
  //   "place": "٢٣ كم شمال شرق Tallkayf، العراق",
  //   "latLng": [
  //     36.657,
  //     43.277
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.657,
  //   "time": "2011-01-02 13:14:21 UTC",
  //   "region": "العراق",
  //   "info": "زلزال بقوة 4.2 درجة في ٢٣ كم شمال شرق Tallkayf، العراق على عمق 36.657 كم بتاريخ 2011-01-02 13:14:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hsf5"
  // },
  // "924": {
  //   "place": "٢٣١ كم غرب Ad Darb، السعودية",
  //   "latLng": [
  //     17.889,
  //     40.08
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 17.889,
  //   "time": "2010-12-16 18:23:09 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٣١ كم غرب Ad Darb، السعودية على عمق 17.889 كم بتاريخ 2010-12-16 18:23:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hqzz"
  // },
  // "925": {
  //   "place": "٨٩ كم شرق Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     16.26,
  //     53.015
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 16.26,
  //   "time": "2010-12-02 09:58:50 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٨٩ كم شرق Al Ghayz?ah، اليمن على عمق 16.26 كم بتاريخ 2010-12-02 09:58:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hqe9"
  // },
  // "926": {
  //   "place": "١٤ كم غرب ?skenderun، تركيا",
  //   "latLng": [
  //     36.585,
  //     36.007
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.585,
  //   "time": "2010-11-14 23:08:25 UTC",
  //   "region": "سوريا",
  //   "info": "زلزال بقوة 4.9 درجة في ١٤ كم غرب ?skenderun، تركيا على عمق 36.585 كم بتاريخ 2010-11-14 23:08:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hpnf#dyfi"
  // },
  // "927": {
  //   "place": "١٤٤ كم شرق شمال شرق Port Sudan، Sudan",
  //   "latLng": [
  //     20.148,
  //     38.481
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 20.148,
  //   "time": "2010-11-05 01:12:58 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ١٤٤ كم شرق شمال شرق Port Sudan، Sudan على عمق 20.148 كم بتاريخ 2010-11-05 01:12:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hp34"
  // },
  // "928": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.513,
  //     56.065
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.513,
  //   "time": "2010-09-23 01:58:59 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 14.513 كم بتاريخ 2010-09-23 01:58:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hm31"
  // },
  // "929": {
  //   "place": "١٩١ كم شمال شمال غرب Kilmia، اليمن",
  //   "latLng": [
  //     13.864,
  //     51.795
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 13.864,
  //   "time": "2010-09-18 09:57:58 UTC",
  //   "region": "اليمن",
  //   "info": "زلزال بقوة 5.2 درجة في ١٩١ كم شمال شمال غرب Kilmia، اليمن على عمق 13.864 كم بتاريخ 2010-09-18 09:57:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hkwe"
  // },
  // "930": {
  //   "place": "١٧١ كم غرب شمال غرب فرسان، السعودية",
  //   "latLng": [
  //     17.129,
  //     40.572
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 17.129,
  //   "time": "2010-09-13 01:35:23 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.6 درجة في ١٧١ كم غرب شمال غرب فرسان، السعودية على عمق 17.129 كم بتاريخ 2010-09-13 01:35:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hkn1"
  // },
  // "931": {
  //   "place": "١٨١ كم غرب شمال غرب فرسان، السعودية",
  //   "latLng": [
  //     17.175,
  //     40.487
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 17.175,
  //   "time": "2010-09-12 13:11:03 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ١٨١ كم غرب شمال غرب فرسان، السعودية على عمق 17.175 كم بتاريخ 2010-09-12 13:11:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hkmf"
  // },
  // "932": {
  //   "place": "١٨٨ كم جنوب جنوب غرب الهفوف، السعودية",
  //   "latLng": [
  //     23.706,
  //     49.156
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 23.706,
  //   "time": "2010-08-22 15:48:27 UTC",
  //   "region": "الخليج العربي",
  //   "info": "زلزال بقوة 4.0 درجة في ١٨٨ كم جنوب جنوب غرب الهفوف، السعودية على عمق 23.706 كم بتاريخ 2010-08-22 15:48:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hjmc"
  // },
  // "933": {
  //   "place": "١٢٤ كم غرب فرسان، السعودية",
  //   "latLng": [
  //     16.649,
  //     40.952
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 16.649,
  //   "time": "2010-08-17 05:46:05 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.1 درجة في ١٢٤ كم غرب فرسان، السعودية على عمق 16.649 كم بتاريخ 2010-08-17 05:46:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hjaz"
  // },
  // "934": {
  //   "place": "١٧١ كم شرق شمال شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.944,
  //     39.262
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 18.944,
  //   "time": "2010-08-09 09:11:06 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 5.0 درجة في ١٧١ كم شرق شمال شرق Tok?r، Sudan على عمق 18.944 كم بتاريخ 2010-08-09 09:11:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hhta"
  // },
  // "935": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     15.812,
  //     59.642
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 15.812,
  //   "time": "2010-07-22 15:20:03 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.3 درجة في منطقة صدع أوين على عمق 15.812 كم بتاريخ 2010-07-22 15:20:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hgg4"
  // },
  // "936": {
  //   "place": "٢٧٨ كم شرق جنوب شرق Sur، عمان",
  //   "latLng": [
  //     21.747,
  //     62.079
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 21.747,
  //   "time": "2010-07-06 02:56:59 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في ٢٧٨ كم شرق جنوب شرق Sur، عمان على عمق 21.747 كم بتاريخ 2010-07-06 02:56:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hey9"
  // },
  // "937": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.418,
  //     56.388
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 14.418,
  //   "time": "2010-06-17 11:30:27 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 5.1 درجة في منطقة صدع أوين على عمق 14.418 كم بتاريخ 2010-06-17 11:30:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000he6w"
  // },
  // "938": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     14.484,
  //     56.359
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.484,
  //   "time": "2010-06-17 04:30:05 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.7 درجة في منطقة صدع أوين على عمق 14.484 كم بتاريخ 2010-06-17 04:30:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000he6c"
  // },
  // "939": {
  //   "place": "٢١٩ كم شمال Hadibu، اليمن",
  //   "latLng": [
  //     14.606,
  //     54.371
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.606,
  //   "time": "2010-06-10 07:38:44 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.8 درجة في ٢١٩ كم شمال Hadibu، اليمن على عمق 14.606 كم بتاريخ 2010-06-10 07:38:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000hdt5"
  // },
  // "940": {
  //   "place": "٢٣٦ كم شرق Tok?r، Sudan",
  //   "latLng": [
  //     18.056,
  //     39.934
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 18.056,
  //   "time": "2010-03-12 17:44:57 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٢٣٦ كم شرق Tok?r، Sudan على عمق 18.056 كم بتاريخ 2010-03-12 17:44:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h98z"
  // },
  // "941": {
  //   "place": "٢٢٩ كم غرب جنوب غرب Al Maj?ridah، السعودية",
  //   "latLng": [
  //     18.019,
  //     40.069
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 18.019,
  //   "time": "2010-03-12 17:16:56 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.3 درجة في ٢٢٩ كم غرب جنوب غرب Al Maj?ridah، السعودية على عمق 18.019 كم بتاريخ 2010-03-12 17:16:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h98w"
  // },
  // "942": {
  //   "place": "١٧٧ كم جنوب Al Ghayz?ah، اليمن",
  //   "latLng": [
  //     14.601,
  //     52.179
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.601,
  //   "time": "2010-03-09 08:03:57 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.2 درجة في ١٧٧ كم جنوب Al Ghayz?ah، اليمن على عمق 14.601 كم بتاريخ 2010-03-09 08:03:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h906"
  // },
  // "943": {
  //   "place": "منطقة صدع أوين",
  //   "latLng": [
  //     13.987,
  //     57.685
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.987,
  //   "time": "2010-02-10 21:36:49 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.6 درجة في منطقة صدع أوين على عمق 13.987 كم بتاريخ 2010-02-10 21:36:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h75k"
  // },
  // "944": {
  //   "place": "١٩٩ كم شمال Qalans?yah، اليمن",
  //   "latLng": [
  //     14.466,
  //     53.787
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.466,
  //   "time": "2010-02-06 08:00:16 UTC",
  //   "region": "بحر العرب",
  //   "info": "زلزال بقوة 4.4 درجة في ١٩٩ كم شمال Qalans?yah، اليمن على عمق 14.466 كم بتاريخ 2010-02-06 08:00:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h70g"
  // },
  // "945": {
  //   "place": "٧٩ كم شرق ?d?grat، إثيوبيا",
  //   "latLng": [
  //     14.185,
  //     40.188
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.185,
  //   "time": "2010-01-09 20:34:39 UTC",
  //   "region": "البحر الأحمر",
  //   "info": "زلزال بقوة 4.4 درجة في ٧٩ كم شرق ?d?grat، إثيوبيا على عمق 14.185 كم بتاريخ 2010-01-09 20:34:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/usp000h5wb"
  // } ,
  // "946": {
  //   "place": "32 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.6105,
  //     62.0424
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.611,
  //   "time": "2023-10-11 05:59:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 32 km NNW of Herāt, Afghanistan على عمق 34.611 كم بتاريخ 2023-10-11 05:59:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leq2#dyfi"
  // },
  // "947": {
  //   "place": "18 km WNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.4204,
  //     62.0239
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.42,
  //   "time": "2023-10-11 02:38:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 18 km WNW of Herāt, Afghanistan على عمق 34.42 كم بتاريخ 2023-10-11 02:38:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lg58"
  // },
  // "948": {
  //   "place": "5 km NE of Chahār Burj, Afghanistan",
  //   "latLng": [
  //     34.2871,
  //     62.2304
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.287,
  //   "time": "2023-10-11 02:03:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 5 km NE of Chahār Burj, Afghanistan على عمق 34.287 كم بتاريخ 2023-10-11 02:03:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lg62"
  // },
  // "949": {
  //   "place": "28 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5181,
  //     61.9662
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.518,
  //   "time": "2023-10-11 01:41:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 28 km NE of Zindah Jān, Afghanistan على عمق 34.518 كم بتاريخ 2023-10-11 01:41:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leny"
  // },
  // "950": {
  //   "place": "18 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.4867,
  //     62.0896
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.487,
  //   "time": "2023-10-11 01:13:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 18 km NNW of Herāt, Afghanistan على عمق 34.487 كم بتاريخ 2023-10-11 01:13:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lenq"
  // },
  // "951": {
  //   "place": "27 km NW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.5482,
  //     62.0195
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.548,
  //   "time": "2023-10-11 00:58:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 27 km NW of Herāt, Afghanistan على عمق 34.548 كم بتاريخ 2023-10-11 00:58:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lg54"
  // },
  // "952": {
  //   "place": "24 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.5654,
  //     62.1362
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 34.565,
  //   "time": "2023-10-11 00:52:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 24 km NNW of Herāt, Afghanistan على عمق 34.565 كم بتاريخ 2023-10-11 00:52:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leng#dyfi"
  // },
  // "953": {
  //   "place": "24 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.5364,
  //     62.0509
  //   ],
  //   "magnitude": 6.3,
  //   "depth": 34.536,
  //   "time": "2023-10-11 00:41:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.3 درجة في 24 km NNW of Herāt, Afghanistan على عمق 34.536 كم بتاريخ 2023-10-11 00:41:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000len8#pager"
  // },
  // "954": {
  //   "place": "33 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.6202,
  //     62.0531
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 34.62,
  //   "time": "2023-10-09 13:30:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 33 km NNW of Herāt, Afghanistan على عمق 34.62 كم بتاريخ 2023-10-09 13:30:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000le8s#dyfi"
  // },
  // "955": {
  //   "place": "35 km SE of Qarah Bāgh, Afghanistan",
  //   "latLng": [
  //     34.6878,
  //     62.016
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.688,
  //   "time": "2023-10-09 09:46:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 35 km SE of Qarah Bāgh, Afghanistan على عمق 34.688 كم بتاريخ 2023-10-09 09:46:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000le7q#dyfi"
  // },
  // "956": {
  //   "place": "36 km S of Sarpol-e Z̄ahāb, Iran",
  //   "latLng": [
  //     34.1329,
  //     45.8087
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.133,
  //   "time": "2023-10-09 07:07:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 36 km S of Sarpol-e Z̄ahāb, Iran على عمق 34.133 كم بتاريخ 2023-10-09 07:07:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000le73#dyfi"
  // },
  // "957": {
  //   "place": "29 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.5885,
  //     62.0577
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 34.589,
  //   "time": "2023-10-09 06:54:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 29 km NNW of Herāt, Afghanistan على عمق 34.589 كم بتاريخ 2023-10-09 06:54:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000le6y#dyfi"
  // },
  // "958": {
  //   "place": "34 km NNE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.6199,
  //     61.9139
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.62,
  //   "time": "2023-10-08 14:58:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 34 km NNE of Zindah Jān, Afghanistan على عمق 34.62 كم بتاريخ 2023-10-08 14:58:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000le1k#dyfi"
  // },
  // "959": {
  //   "place": "11 km NNW of Metahāra, Ethiopia",
  //   "latLng": [
  //     8.9936,
  //     39.8814
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 8.994,
  //   "time": "2023-10-08 04:37:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 11 km NNW of Metahāra, Ethiopia على عمق 8.994 كم بتاريخ 2023-10-08 04:37:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldyw"
  // },
  // "960": {
  //   "place": "16 km NW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.4456,
  //     62.0623
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.446,
  //   "time": "2023-10-08 02:47:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km NW of Herāt, Afghanistan على عمق 34.446 كم بتاريخ 2023-10-08 02:47:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldxr#dyfi"
  // },
  // "961": {
  //   "place": "32 km SSE of Qarah Bāgh, Afghanistan",
  //   "latLng": [
  //     34.6739,
  //     61.9172
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.674,
  //   "time": "2023-10-07 18:32:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 32 km SSE of Qarah Bāgh, Afghanistan على عمق 34.674 كم بتاريخ 2023-10-07 18:32:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldvn"
  // },
  // "962": {
  //   "place": "31 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.5865,
  //     62.0108
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.587,
  //   "time": "2023-10-07 11:27:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 31 km NNW of Herāt, Afghanistan على عمق 34.587 كم بتاريخ 2023-10-07 11:27:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldts#dyfi"
  // },
  // "963": {
  //   "place": "29 km NW of Karukh, Afghanistan",
  //   "latLng": [
  //     34.688,
  //     62.3786
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.688,
  //   "time": "2023-10-07 10:05:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 29 km NW of Karukh, Afghanistan على عمق 34.688 كم بتاريخ 2023-10-07 10:05:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leu1"
  // },
  // "964": {
  //   "place": "37 km SSE of Qarah Bāgh, Afghanistan",
  //   "latLng": [
  //     34.6444,
  //     61.9701
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 34.644,
  //   "time": "2023-10-07 09:40:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 37 km SSE of Qarah Bāgh, Afghanistan على عمق 34.644 كم بتاريخ 2023-10-07 09:40:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldt7#dyfi"
  // },
  // "965": {
  //   "place": "28 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5319,
  //     61.9591
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 34.532,
  //   "time": "2023-10-07 09:27:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 28 km NE of Zindah Jān, Afghanistan على عمق 34.532 كم بتاريخ 2023-10-07 09:27:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldsx"
  // },
  // "966": {
  //   "place": "12 km ENE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.3833,
  //     61.8769
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.383,
  //   "time": "2023-10-07 09:08:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 12 km ENE of Zindah Jān, Afghanistan على عمق 34.383 كم بتاريخ 2023-10-07 09:08:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lev4"
  // },
  // "967": {
  //   "place": "25 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5314,
  //     61.9026
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.531,
  //   "time": "2023-10-07 09:05:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 25 km NE of Zindah Jān, Afghanistan على عمق 34.531 كم بتاريخ 2023-10-07 09:05:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leu6"
  // },
  // "968": {
  //   "place": "36 km SSE of Qarah Bāgh, Afghanistan",
  //   "latLng": [
  //     34.639,
  //     61.9339
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 34.639,
  //   "time": "2023-10-07 08:06:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 36 km SSE of Qarah Bāgh, Afghanistan على عمق 34.639 كم بتاريخ 2023-10-07 08:06:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldq8"
  // },
  // "969": {
  //   "place": "35 km NNW of Herāt, Afghanistan",
  //   "latLng": [
  //     34.6262,
  //     62.0006
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 34.626,
  //   "time": "2023-10-07 07:40:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.9 درجة في 35 km NNW of Herāt, Afghanistan على عمق 34.626 كم بتاريخ 2023-10-07 07:40:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldpv#pager"
  // },
  // "970": {
  //   "place": "31 km N of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.6253,
  //     61.7599
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.625,
  //   "time": "2023-10-07 07:28:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 31 km N of Zindah Jān, Afghanistan على عمق 34.625 كم بتاريخ 2023-10-07 07:28:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lety"
  // },
  // "971": {
  //   "place": "21 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.4905,
  //     61.8943
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 34.491,
  //   "time": "2023-10-07 07:16:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في 21 km NE of Zindah Jān, Afghanistan على عمق 34.491 كم بتاريخ 2023-10-07 07:16:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000leu2"
  // },
  // "972": {
  //   "place": "25 km NNE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5442,
  //     61.8891
  //   ],
  //   "magnitude": 6.3,
  //   "depth": 34.544,
  //   "time": "2023-10-07 07:12:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.3 درجة في 25 km NNE of Zindah Jān, Afghanistan على عمق 34.544 كم بتاريخ 2023-10-07 07:12:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldpm#pager"
  // },
  // "973": {
  //   "place": "29 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5509,
  //     61.9397
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.551,
  //   "time": "2023-10-07 07:10:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 29 km NE of Zindah Jān, Afghanistan على عمق 34.551 كم بتاريخ 2023-10-07 07:10:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldpl#dyfi"
  // },
  // "974": {
  //   "place": "26 km NE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5167,
  //     61.9462
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 34.517,
  //   "time": "2023-10-07 06:49:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في 26 km NE of Zindah Jān, Afghanistan على عمق 34.517 كم بتاريخ 2023-10-07 06:49:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldph#pager"
  // },
  // "975": {
  //   "place": "32 km NNE of Zindah Jān, Afghanistan",
  //   "latLng": [
  //     34.5982,
  //     61.9263
  //   ],
  //   "magnitude": 6.3,
  //   "depth": 34.598,
  //   "time": "2023-10-07 06:41:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.3 درجة في 32 km NNE of Zindah Jān, Afghanistan على عمق 34.598 كم بتاريخ 2023-10-07 06:41:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldpg#pager"
  // },
  // "976": {
  //   "place": "12 km NNW of Yayladağı, Turkey",
  //   "latLng": [
  //     36.0004,
  //     35.9839
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.0,
  //   "time": "2023-10-04 07:58:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 12 km NNW of Yayladağı, Turkey على عمق 36.0 كم بتاريخ 2023-10-04 07:58:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lcqq#dyfi"
  // },
  // "977": {
  //   "place": "14 km N of Sarpol-e Z̄ahāb, Iran",
  //   "latLng": [
  //     34.5893,
  //     45.8706
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.589,
  //   "time": "2023-10-03 05:57:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 14 km N of Sarpol-e Z̄ahāb, Iran على عمق 34.589 كم بتاريخ 2023-10-03 05:57:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ldif"
  // },
  // "978": {
  //   "place": "4 km E of Kálymnos, Greece",
  //   "latLng": [
  //     36.9464,
  //     27.0389
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.946,
  //   "time": "2023-09-30 09:38:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 4 km E of Kálymnos, Greece على عمق 36.946 كم بتاريخ 2023-09-30 09:38:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lbw5#dyfi"
  // },
  // "979": {
  //   "place": "45 km W of Bojnūrd, Iran",
  //   "latLng": [
  //     37.5392,
  //     56.8228
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.539,
  //   "time": "2023-09-29 12:25:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 45 km W of Bojnūrd, Iran على عمق 37.539 كم بتاريخ 2023-09-29 12:25:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lbnm"
  // },
  // "980": {
  //   "place": "22 km N of Djibouti, Djibouti",
  //   "latLng": [
  //     11.7873,
  //     43.1156
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 11.787,
  //   "time": "2023-09-29 00:25:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 22 km N of Djibouti, Djibouti على عمق 11.787 كم بتاريخ 2023-09-29 00:25:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ld28"
  // },
  // "981": {
  //   "place": "10 km ENE of Djibouti, Djibouti",
  //   "latLng": [
  //     11.6384,
  //     43.23
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 11.638,
  //   "time": "2023-09-28 05:53:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 10 km ENE of Djibouti, Djibouti على عمق 11.638 كم بتاريخ 2023-09-28 05:53:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lbb5#dyfi"
  // },
  // "982": {
  //   "place": "13 km N of Djibouti, Djibouti",
  //   "latLng": [
  //     11.7134,
  //     43.1605
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 11.713,
  //   "time": "2023-09-28 01:22:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 13 km N of Djibouti, Djibouti على عمق 11.713 كم بتاريخ 2023-09-28 01:22:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lbab#dyfi"
  // },
  // "983": {
  //   "place": "25 km ENE of Kīsh, Iran",
  //   "latLng": [
  //     26.6641,
  //     54.2468
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.664,
  //   "time": "2023-09-27 08:10:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 25 km ENE of Kīsh, Iran على عمق 26.664 كم بتاريخ 2023-09-27 08:10:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lcfs"
  // },
  // "984": {
  //   "place": "167 km NW of Caluula, Somalia",
  //   "latLng": [
  //     13.0911,
  //     49.7232
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.091,
  //   "time": "2023-09-27 02:18:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 167 km NW of Caluula, Somalia على عمق 13.091 كم بتاريخ 2023-09-27 02:18:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lcfk"
  // },
  // "985": {
  //   "place": "118 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.0231,
  //     26.2175
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.023,
  //   "time": "2023-09-25 08:52:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 118 km SSE of Ierápetra, Greece على عمق 34.023 كم بتاريخ 2023-09-25 08:52:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lbpr"
  // },
  // "986": {
  //   "place": "115 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.0196,
  //     26.1069
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.02,
  //   "time": "2023-09-24 02:12:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 115 km SSE of Ierápetra, Greece على عمق 34.02 كم بتاريخ 2023-09-24 02:12:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kxr4"
  // },
  // "987": {
  //   "place": "23 km W of Baghlān, Afghanistan",
  //   "latLng": [
  //     36.1509,
  //     68.4533
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.151,
  //   "time": "2023-09-21 06:34:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 23 km W of Baghlān, Afghanistan على عمق 36.151 كم بتاريخ 2023-09-21 06:34:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kx1q"
  // },
  // "988": {
  //   "place": "13 km W of Dogonbadan, Iran",
  //   "latLng": [
  //     30.368,
  //     50.6539
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 30.368,
  //   "time": "2023-09-21 04:02:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 13 km W of Dogonbadan, Iran على عمق 30.368 كم بتاريخ 2023-09-21 04:02:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000lb2m"
  // },
  // "989": {
  //   "place": "Northeastern Iran",
  //   "latLng": [
  //     36.3164,
  //     59.5396
  //   ],
  //   "magnitude": 3.8,
  //   "depth": 36.316,
  //   "time": "2023-09-18 16:32:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.8 درجة في Northeastern Iran على عمق 36.316 كم بتاريخ 2023-09-18 16:32:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kwhq#dyfi"
  // },
  // "990": {
  //   "place": "161 km NNE of Caluula, Somalia",
  //   "latLng": [
  //     13.3777,
  //     51.1205
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.378,
  //   "time": "2023-09-15 11:44:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 161 km NNE of Caluula, Somalia على عمق 13.378 كم بتاريخ 2023-09-15 11:44:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kwxm"
  // },
  // "991": {
  //   "place": "16 km ESE of Fīrūzābād, Iran",
  //   "latLng": [
  //     28.8055,
  //     52.7385
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.806,
  //   "time": "2023-09-15 10:01:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km ESE of Fīrūzābād, Iran على عمق 28.806 كم بتاريخ 2023-09-15 10:01:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kwxb"
  // },
  // "992": {
  //   "place": "42 km S of Massawa, Eritrea",
  //   "latLng": [
  //     15.2251,
  //     39.473
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 15.225,
  //   "time": "2023-09-13 17:51:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 42 km S of Massawa, Eritrea على عمق 15.225 كم بتاريخ 2023-09-13 17:51:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kvkg"
  // },
  // "993": {
  //   "place": "20 km NNE of Ţūz Khūrmātū, Iraq",
  //   "latLng": [
  //     35.0542,
  //     44.7295
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.054,
  //   "time": "2023-09-10 21:43:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 20 km NNE of Ţūz Khūrmātū, Iraq على عمق 35.054 كم بتاريخ 2023-09-10 21:43:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kuw4#dyfi"
  // },
  // "994": {
  //   "place": "167 km NNW of Caluula, Somalia",
  //   "latLng": [
  //     13.2491,
  //     49.9413
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.249,
  //   "time": "2023-09-08 12:41:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 167 km NNW of Caluula, Somalia على عمق 13.249 كم بتاريخ 2023-09-08 12:41:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ku6y"
  // },
  // "995": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.2827,
  //     57.5508
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 11.283,
  //   "time": "2023-09-08 07:37:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Owen Fracture Zone region على عمق 11.283 كم بتاريخ 2023-09-08 07:37:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kvjg"
  // },
  // "996": {
  //   "place": "23 km W of Bandar-e Genāveh, Iran",
  //   "latLng": [
  //     29.5595,
  //     50.2722
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 29.56,
  //   "time": "2023-09-05 07:28:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 23 km W of Bandar-e Genāveh, Iran على عمق 29.56 كم بتاريخ 2023-09-05 07:28:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kua5"
  // },
  // "997": {
  //   "place": "87 km WNW of Mohr, Iran",
  //   "latLng": [
  //     27.962,
  //     52.1223
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.962,
  //   "time": "2023-09-04 19:57:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 87 km WNW of Mohr, Iran على عمق 27.962 كم بتاريخ 2023-09-04 19:57:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kt8d"
  // },
  // "998": {
  //   "place": "111 km NNE of Mīnāb, Iran",
  //   "latLng": [
  //     28.0603,
  //     57.5235
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.06,
  //   "time": "2023-09-02 14:30:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 111 km NNE of Mīnāb, Iran على عمق 28.06 كم بتاريخ 2023-09-02 14:30:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ksvk"
  // },
  // "999": {
  //   "place": "28 km NE of Kīsh, Iran",
  //   "latLng": [
  //     26.7107,
  //     54.2544
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 26.711,
  //   "time": "2023-09-02 01:55:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 28 km NE of Kīsh, Iran على عمق 26.711 كم بتاريخ 2023-09-02 01:55:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kssx#dyfi"
  // },
  // "1000": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.9084,
  //     57.0218
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.908,
  //   "time": "2023-08-28 23:20:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 13.908 كم بتاريخ 2023-08-28 23:20:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ksne"
  // },
  // "1001": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     8.4414,
  //     58.5003
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 8.441,
  //   "time": "2023-08-28 13:04:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Carlsberg Ridge على عمق 8.441 كم بتاريخ 2023-08-28 13:04:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ksn3"
  // },
  // "1002": {
  //   "place": "11 km NNW of Émponas, Greece",
  //   "latLng": [
  //     36.3227,
  //     27.8094
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.323,
  //   "time": "2023-08-27 03:09:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 11 km NNW of Émponas, Greece على عمق 36.323 كم بتاريخ 2023-08-27 03:09:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kr9m#dyfi"
  // },
  // "1003": {
  //   "place": "103 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.142,
  //     26.1494
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.142,
  //   "time": "2023-08-25 14:50:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 103 km SSE of Ierápetra, Greece على عمق 34.142 كم بتاريخ 2023-08-25 14:50:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kqze"
  // },
  // "1004": {
  //   "place": "10 km SW of İçmeler, Turkey",
  //   "latLng": [
  //     36.7359,
  //     28.1337
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.736,
  //   "time": "2023-08-21 15:45:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 10 km SW of İçmeler, Turkey على عمق 36.736 كم بتاريخ 2023-08-21 15:45:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kpx5#dyfi"
  // },
  // "1005": {
  //   "place": "79 km E of Gerāsh, Iran",
  //   "latLng": [
  //     27.6787,
  //     54.9418
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.679,
  //   "time": "2023-08-20 08:48:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 79 km E of Gerāsh, Iran على عمق 27.679 كم بتاريخ 2023-08-20 08:48:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kpl8"
  // },
  // "1006": {
  //   "place": "18 km NE of Sharīfābād, Iran",
  //   "latLng": [
  //     35.5468,
  //     51.9214
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 35.547,
  //   "time": "2023-08-19 10:18:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 18 km NE of Sharīfābād, Iran على عمق 35.547 كم بتاريخ 2023-08-19 10:18:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kpk6#dyfi"
  // },
  // "1007": {
  //   "place": "30 km NW of Gerāsh, Iran",
  //   "latLng": [
  //     27.8701,
  //     53.9308
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 27.87,
  //   "time": "2023-08-18 16:10:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 30 km NW of Gerāsh, Iran على عمق 27.87 كم بتاريخ 2023-08-18 16:10:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kp9x#dyfi"
  // },
  // "1008": {
  //   "place": "10 km NNE of Aladağ, Turkey",
  //   "latLng": [
  //     37.6374,
  //     35.4222
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.637,
  //   "time": "2023-08-16 14:36:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 10 km NNE of Aladağ, Turkey على عمق 37.637 كم بتاريخ 2023-08-16 14:36:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000knrn"
  // },
  // "1009": {
  //   "place": "17 km NW of Esfarāyen, Iran",
  //   "latLng": [
  //     37.1883,
  //     57.3773
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.188,
  //   "time": "2023-08-15 13:05:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 17 km NW of Esfarāyen, Iran على عمق 37.188 كم بتاريخ 2023-08-15 13:05:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kqg1"
  // },
  // "1010": {
  //   "place": "144 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4678,
  //     48.1268
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.468,
  //   "time": "2023-08-13 10:10:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 144 km N of Las Khorey, Somalia على عمق 12.468 كم بتاريخ 2023-08-13 10:10:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kzp2"
  // },
  // "1011": {
  //   "place": "30 km E of Shahrak-e Kūlūrī, Iran",
  //   "latLng": [
  //     32.4017,
  //     48.7864
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.402,
  //   "time": "2023-08-12 00:27:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km E of Shahrak-e Kūlūrī, Iran على عمق 32.402 كم بتاريخ 2023-08-12 00:27:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kp8k"
  // },
  // "1012": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.8127,
  //     36.8093
  //   ],
  //   "magnitude": 3.3,
  //   "depth": 36.813,
  //   "time": "2023-08-11 16:24:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.3 درجة في Turkey-Syria border region على عمق 36.813 كم بتاريخ 2023-08-11 16:24:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kzia#dyfi"
  // },
  // "1013": {
  //   "place": "Cyprus region",
  //   "latLng": [
  //     35.7902,
  //     31.3781
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 35.79,
  //   "time": "2023-08-10 13:16:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في Cyprus region على عمق 35.79 كم بتاريخ 2023-08-10 13:16:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kz22#dyfi"
  // },
  // "1014": {
  //   "place": "16 km N of Masjed Soleymān, Iran",
  //   "latLng": [
  //     32.0874,
  //     49.3232
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.087,
  //   "time": "2023-08-09 21:57:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km N of Masjed Soleymān, Iran على عمق 32.087 كم بتاريخ 2023-08-09 21:57:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kyyh#dyfi"
  // },
  // "1015": {
  //   "place": "90 km SSW of Bam, Iran",
  //   "latLng": [
  //     28.3977,
  //     57.8889
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.398,
  //   "time": "2023-08-08 04:05:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 90 km SSW of Bam, Iran على عمق 28.398 كم بتاريخ 2023-08-08 04:05:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kykf"
  // },
  // "1016": {
  //   "place": "8 km SW of Büyükçat, Turkey",
  //   "latLng": [
  //     36.0569,
  //     36.018
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.057,
  //   "time": "2023-08-07 08:09:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 8 km SW of Büyükçat, Turkey على عمق 36.057 كم بتاريخ 2023-08-07 08:09:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kye4"
  // },
  // "1017": {
  //   "place": "185 km S of Al Ghayz̧ah, Yemen",
  //   "latLng": [
  //     14.5578,
  //     51.8676
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.558,
  //   "time": "2023-08-06 19:49:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 185 km S of Al Ghayz̧ah, Yemen على عمق 14.558 كم بتاريخ 2023-08-06 19:49:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000l040"
  // },
  // "1018": {
  //   "place": "52 km SSW of Side, Turkey",
  //   "latLng": [
  //     36.3607,
  //     31.0965
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.361,
  //   "time": "2023-08-04 06:18:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 52 km SSW of Side, Turkey على عمق 36.361 كم بتاريخ 2023-08-04 06:18:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxrb"
  // },
  // "1019": {
  //   "place": "36 km N of Adi Keyh, Eritrea",
  //   "latLng": [
  //     15.1755,
  //     39.3951
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.176,
  //   "time": "2023-08-03 23:15:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 36 km N of Adi Keyh, Eritrea على عمق 15.176 كم بتاريخ 2023-08-03 23:15:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxnz"
  // },
  // "1020": {
  //   "place": "36 km N of Adi Keyh, Eritrea",
  //   "latLng": [
  //     15.1709,
  //     39.3784
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.171,
  //   "time": "2023-08-03 10:11:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 36 km N of Adi Keyh, Eritrea على عمق 15.171 كم بتاريخ 2023-08-03 10:11:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxhj"
  // },
  // "1021": {
  //   "place": "54 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.7042,
  //     26.2947
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.704,
  //   "time": "2023-08-03 02:18:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 54 km S of Palekastro, Greece على عمق 34.704 كم بتاريخ 2023-08-03 02:18:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxfq"
  // },
  // "1022": {
  //   "place": "35 km S of Massawa, Eritrea",
  //   "latLng": [
  //     15.2895,
  //     39.4368
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 15.29,
  //   "time": "2023-08-02 20:33:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 35 km S of Massawa, Eritrea على عمق 15.29 كم بتاريخ 2023-08-02 20:33:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxe0"
  // },
  // "1023": {
  //   "place": "34 km ENE of Dek’emhāre, Eritrea",
  //   "latLng": [
  //     15.2157,
  //     39.3303
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 15.216,
  //   "time": "2023-08-02 05:13:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 34 km ENE of Dek’emhāre, Eritrea على عمق 15.216 كم بتاريخ 2023-08-02 05:13:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx90#dyfi"
  // },
  // "1024": {
  //   "place": "31 km SSW of Massawa, Eritrea",
  //   "latLng": [
  //     15.347,
  //     39.357
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 15.347,
  //   "time": "2023-08-02 05:09:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 31 km SSW of Massawa, Eritrea على عمق 15.347 كم بتاريخ 2023-08-02 05:09:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kzbw"
  // },
  // "1025": {
  //   "place": "33 km ENE of Dek’emhāre, Eritrea",
  //   "latLng": [
  //     15.1591,
  //     39.3496
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 15.159,
  //   "time": "2023-08-02 03:36:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 33 km ENE of Dek’emhāre, Eritrea على عمق 15.159 كم بتاريخ 2023-08-02 03:36:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx8b"
  // },
  // "1026": {
  //   "place": "29 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.9358,
  //     26.2338
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.936,
  //   "time": "2023-08-01 21:52:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 29 km S of Palekastro, Greece على عمق 34.936 كم بتاريخ 2023-08-01 21:52:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx6d"
  // },
  // "1027": {
  //   "place": "39 km SSW of Massawa, Eritrea",
  //   "latLng": [
  //     15.2573,
  //     39.3998
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 15.257,
  //   "time": "2023-08-01 21:06:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 39 km SSW of Massawa, Eritrea على عمق 15.257 كم بتاريخ 2023-08-01 21:06:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxcd"
  // },
  // "1028": {
  //   "place": "37 km NNE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     15.1663,
  //     39.4813
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 15.166,
  //   "time": "2023-08-01 19:37:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 37 km NNE of Adi Keyh, Eritrea على عمق 15.166 كم بتاريخ 2023-08-01 19:37:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx4n"
  // },
  // "1029": {
  //   "place": "Eritrea",
  //   "latLng": [
  //     15.2211,
  //     39.5264
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 15.221,
  //   "time": "2023-08-01 17:15:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في Eritrea على عمق 15.221 كم بتاريخ 2023-08-01 17:15:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx3e#dyfi"
  // },
  // "1030": {
  //   "place": "98 km S of Mohr, Iran",
  //   "latLng": [
  //     26.6733,
  //     52.9883
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.673,
  //   "time": "2023-07-29 03:31:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 98 km S of Mohr, Iran على عمق 26.673 كم بتاريخ 2023-07-29 03:31:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kwg3"
  // },
  // "1031": {
  //   "place": "70 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.0266,
  //     53.2781
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.027,
  //   "time": "2023-07-25 10:23:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 70 km SSE of Mohr, Iran على عمق 27.027 كم بتاريخ 2023-07-25 10:23:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ki6l"
  // },
  // "1032": {
  //   "place": "23 km SSE of Feke, Turkey",
  //   "latLng": [
  //     37.6148,
  //     36.0103
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.615,
  //   "time": "2023-07-25 07:57:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 23 km SSE of Feke, Turkey على عمق 37.615 كم بتاريخ 2023-07-25 07:57:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ki64"
  // },
  // "1033": {
  //   "place": "18 km NE of Kozan, Turkey",
  //   "latLng": [
  //     37.5794,
  //     35.9482
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 37.579,
  //   "time": "2023-07-25 05:44:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 18 km NE of Kozan, Turkey على عمق 37.579 كم بتاريخ 2023-07-25 05:44:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ki5u#pager"
  // },
  // "1034": {
  //   "place": "11 km E of Rāmhormoz, Iran",
  //   "latLng": [
  //     31.2791,
  //     49.7242
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 31.279,
  //   "time": "2023-07-24 02:55:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 11 km E of Rāmhormoz, Iran على عمق 31.279 كم بتاريخ 2023-07-24 02:55:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kxa5"
  // },
  // "1035": {
  //   "place": "155 km NNE of Caluula, Somalia",
  //   "latLng": [
  //     13.332,
  //     51.082
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.332,
  //   "time": "2023-07-23 08:19:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 155 km NNE of Caluula, Somalia على عمق 13.332 كم بتاريخ 2023-07-23 08:19:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kx1v"
  // },
  // "1036": {
  //   "place": "54 km WSW of Fārsān, Iran",
  //   "latLng": [
  //     32.0132,
  //     50.0619
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.013,
  //   "time": "2023-07-22 10:54:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 54 km WSW of Fārsān, Iran على عمق 32.013 كم بتاريخ 2023-07-22 10:54:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000khlf"
  // },
  // "1037": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     14.091,
  //     51.7484
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.091,
  //   "time": "2023-07-21 15:38:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Gulf of Aden على عمق 14.091 كم بتاريخ 2023-07-21 15:38:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kw8a"
  // },
  // "1038": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     12.8252,
  //     57.6718
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.825,
  //   "time": "2023-07-21 09:32:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 12.825 كم بتاريخ 2023-07-21 09:32:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kw80"
  // },
  // "1039": {
  //   "place": "39 km NNW of Dāmghān, Iran",
  //   "latLng": [
  //     36.5168,
  //     54.2404
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.517,
  //   "time": "2023-07-21 07:59:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 39 km NNW of Dāmghān, Iran على عمق 36.517 كم بتاريخ 2023-07-21 07:59:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000khcq"
  // },
  // "1040": {
  //   "place": "38 km E of Ḩājjīābād, Iran",
  //   "latLng": [
  //     28.2624,
  //     56.2866
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.262,
  //   "time": "2023-07-21 00:38:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 38 km E of Ḩājjīābād, Iran على عمق 28.262 كم بتاريخ 2023-07-21 00:38:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000khb0#dyfi"
  // },
  // "1041": {
  //   "place": "158 km N of Caluula, Somalia",
  //   "latLng": [
  //     13.3951,
  //     50.6223
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.395,
  //   "time": "2023-07-20 09:26:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 158 km N of Caluula, Somalia على عمق 13.395 كم بتاريخ 2023-07-20 09:26:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kw61"
  // },
  // "1042": {
  //   "place": "23 km W of Āzādshahr, Iran",
  //   "latLng": [
  //     37.0547,
  //     54.914
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.055,
  //   "time": "2023-07-20 03:05:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 23 km W of Āzādshahr, Iran على عمق 37.055 كم بتاريخ 2023-07-20 03:05:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kh0s"
  // },
  // "1043": {
  //   "place": "26 km SE of Behshahr, Iran",
  //   "latLng": [
  //     36.5396,
  //     53.7826
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.54,
  //   "time": "2023-07-19 14:14:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 26 km SE of Behshahr, Iran على عمق 36.54 كم بتاريخ 2023-07-19 14:14:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kgw7"
  // },
  // "1044": {
  //   "place": "44 km SSE of Gerāsh, Iran",
  //   "latLng": [
  //     27.318,
  //     54.35
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.318,
  //   "time": "2023-07-16 19:25:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 44 km SSE of Gerāsh, Iran على عمق 27.318 كم بتاريخ 2023-07-16 19:25:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kg6y"
  // },
  // "1045": {
  //   "place": "158 km NNW of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5646,
  //     47.899
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.565,
  //   "time": "2023-07-12 22:51:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 158 km NNW of Las Khorey, Somalia على عمق 12.565 كم بتاريخ 2023-07-12 22:51:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kfa4"
  // },
  // "1046": {
  //   "place": "20 km NE of Kīsh, Iran",
  //   "latLng": [
  //     26.6737,
  //     54.178
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.674,
  //   "time": "2023-07-08 19:16:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 20 km NE of Kīsh, Iran على عمق 26.674 كم بتاريخ 2023-07-08 19:16:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kr07"
  // },
  // "1047": {
  //   "place": "Eritrea-Ethiopia border region",
  //   "latLng": [
  //     14.5505,
  //     39.9141
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.551,
  //   "time": "2023-07-05 22:52:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Eritrea-Ethiopia border region على عمق 14.551 كم بتاريخ 2023-07-05 22:52:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kfeu"
  // },
  // "1048": {
  //   "place": "10 km ESE of Baghlān, Afghanistan",
  //   "latLng": [
  //     36.1005,
  //     68.8223
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.101,
  //   "time": "2023-07-05 13:42:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 10 km ESE of Baghlān, Afghanistan على عمق 36.101 كم بتاريخ 2023-07-05 13:42:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kq7l"
  // },
  // "1049": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     27.0059,
  //     54.4276
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 27.006,
  //   "time": "2023-07-04 02:20:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في southern Iran على عمق 27.006 كم بتاريخ 2023-07-04 02:20:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kpz0"
  // },
  // "1050": {
  //   "place": "31 km SSE of Dehlorān, Iran",
  //   "latLng": [
  //     32.4203,
  //     47.3544
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.42,
  //   "time": "2023-07-02 21:51:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 31 km SSE of Dehlorān, Iran على عمق 32.42 كم بتاريخ 2023-07-02 21:51:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kpqc"
  // },
  // "1051": {
  //   "place": "44 km NE of Ādīgrat, Ethiopia",
  //   "latLng": [
  //     14.5513,
  //     39.7597
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.551,
  //   "time": "2023-07-02 19:58:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 44 km NE of Ādīgrat, Ethiopia على عمق 14.551 كم بتاريخ 2023-07-02 19:58:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kew3"
  // },
  // "1052": {
  //   "place": "71 km NE of Ādīgrat, Ethiopia",
  //   "latLng": [
  //     14.6374,
  //     40.011
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.637,
  //   "time": "2023-07-02 16:51:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 71 km NE of Ādīgrat, Ethiopia على عمق 14.637 كم بتاريخ 2023-07-02 16:51:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kppd"
  // },
  // "1053": {
  //   "place": "70 km ESE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     14.6721,
  //     40.0081
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 14.672,
  //   "time": "2023-07-02 10:11:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 70 km ESE of Adi Keyh, Eritrea على عمق 14.672 كم بتاريخ 2023-07-02 10:11:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kevp"
  // },
  // "1054": {
  //   "place": "46 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8765,
  //     55.183
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.877,
  //   "time": "2023-07-02 09:07:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 46 km NE of Bandar-e Lengeh, Iran على عمق 26.877 كم بتاريخ 2023-07-02 09:07:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kpl2#dyfi"
  // },
  // "1055": {
  //   "place": "61 km ESE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     14.6607,
  //     39.9127
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.661,
  //   "time": "2023-07-02 07:17:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 61 km ESE of Adi Keyh, Eritrea على عمق 14.661 كم بتاريخ 2023-07-02 07:17:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kevs"
  // },
  // "1056": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.4597,
  //     57.8606
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 11.46,
  //   "time": "2023-06-30 09:34:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Owen Fracture Zone region على عمق 11.46 كم بتاريخ 2023-06-30 09:34:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kqr3"
  // },
  // "1057": {
  //   "place": "Iran-Iraq border region",
  //   "latLng": [
  //     32.5094,
  //     47.3286
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 32.509,
  //   "time": "2023-06-28 19:08:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Iran-Iraq border region على عمق 32.509 كم بتاريخ 2023-06-28 19:08:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000knqa#dyfi"
  // },
  // "1058": {
  //   "place": "17 km SW of Çukurca, Turkey",
  //   "latLng": [
  //     37.1215,
  //     43.492
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.122,
  //   "time": "2023-06-26 06:41:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 17 km SW of Çukurca, Turkey على عمق 37.122 كم بتاريخ 2023-06-26 06:41:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kb3b"
  // },
  // "1059": {
  //   "place": "70 km SSE of Fīrūzābād, Iran",
  //   "latLng": [
  //     28.2558,
  //     52.8501
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.256,
  //   "time": "2023-06-25 18:48:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 70 km SSE of Fīrūzābād, Iran على عمق 28.256 كم بتاريخ 2023-06-25 18:48:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kb0q"
  // },
  // "1060": {
  //   "place": "119 km NNE of Mīnāb, Iran",
  //   "latLng": [
  //     28.1832,
  //     57.3512
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.183,
  //   "time": "2023-06-23 05:17:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 119 km NNE of Mīnāb, Iran على عمق 28.183 كم بتاريخ 2023-06-23 05:17:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kp6y"
  // },
  // "1061": {
  //   "place": "71 km ESE of Gerāsh, Iran",
  //   "latLng": [
  //     27.5072,
  //     54.8386
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.507,
  //   "time": "2023-06-22 11:55:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 71 km ESE of Gerāsh, Iran على عمق 27.507 كم بتاريخ 2023-06-22 11:55:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000kaay"
  // },
  // "1062": {
  //   "place": "36 km SSE of Ḩājjīābād, Iran",
  //   "latLng": [
  //     28.0017,
  //     56.0478
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 28.002,
  //   "time": "2023-06-21 05:12:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 36 km SSE of Ḩājjīābād, Iran على عمق 28.002 كم بتاريخ 2023-06-21 05:12:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ka13#dyfi"
  // },
  // "1063": {
  //   "place": "39 km SSW of Duki, Pakistan",
  //   "latLng": [
  //     29.8241,
  //     68.4073
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.824,
  //   "time": "2023-06-18 16:34:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 39 km SSW of Duki, Pakistan على عمق 29.824 كم بتاريخ 2023-06-18 16:34:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k9e3"
  // },
  // "1064": {
  //   "place": "16 km SE of Çağlayancerit, Turkey",
  //   "latLng": [
  //     37.6295,
  //     37.4085
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.63,
  //   "time": "2023-06-17 22:02:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 16 km SE of Çağlayancerit, Turkey على عمق 37.63 كم بتاريخ 2023-06-17 22:02:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k999"
  // },
  // "1065": {
  //   "place": "153 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5438,
  //     48.224
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 12.544,
  //   "time": "2023-06-17 01:55:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 153 km N of Las Khorey, Somalia على عمق 12.544 كم بتاريخ 2023-06-17 01:55:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k955"
  // },
  // "1066": {
  //   "place": "58 km SSW of Fīrūzābād, Iran",
  //   "latLng": [
  //     28.3524,
  //     52.3563
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.352,
  //   "time": "2023-06-15 17:20:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 58 km SSW of Fīrūzābād, Iran على عمق 28.352 كم بتاريخ 2023-06-15 17:20:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k8q0"
  // },
  // "1067": {
  //   "place": "184 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.8066,
  //     47.9474
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 12.807,
  //   "time": "2023-06-15 15:40:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 184 km N of Las Khorey, Somalia على عمق 12.807 كم بتاريخ 2023-06-15 15:40:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k8nx"
  // },
  // "1068": {
  //   "place": "146 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4594,
  //     47.9566
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.459,
  //   "time": "2023-06-15 05:54:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 146 km N of Las Khorey, Somalia على عمق 12.459 كم بتاريخ 2023-06-15 05:54:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k8lq"
  // },
  // "1069": {
  //   "place": "59 km SE of Kūh Sefīd, Iran",
  //   "latLng": [
  //     28.8497,
  //     57.1709
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.85,
  //   "time": "2023-06-12 09:10:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 59 km SE of Kūh Sefīd, Iran على عمق 28.85 كم بتاريخ 2023-06-12 09:10:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k9li"
  // },
  // "1070": {
  //   "place": "Pakistan",
  //   "latLng": [
  //     28.0367,
  //     66.4
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.037,
  //   "time": "2023-06-06 18:06:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Pakistan على عمق 28.037 كم بتاريخ 2023-06-06 18:06:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k6p6"
  // },
  // "1071": {
  //   "place": "40 km E of Dehlorān, Iran",
  //   "latLng": [
  //     32.6386,
  //     47.6964
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.639,
  //   "time": "2023-06-06 13:24:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 40 km E of Dehlorān, Iran على عمق 32.639 كم بتاريخ 2023-06-06 13:24:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k86z"
  // },
  // "1072": {
  //   "place": "32 km W of Kāzerūn, Iran",
  //   "latLng": [
  //     29.6036,
  //     51.3176
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 29.604,
  //   "time": "2023-06-05 09:58:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 32 km W of Kāzerūn, Iran على عمق 29.604 كم بتاريخ 2023-06-05 09:58:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7zu"
  // },
  // "1073": {
  //   "place": "164 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6288,
  //     47.9576
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.629,
  //   "time": "2023-06-05 01:43:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 164 km N of Las Khorey, Somalia على عمق 12.629 كم بتاريخ 2023-06-05 01:43:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k6bp"
  // },
  // "1074": {
  //   "place": "160 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5989,
  //     48.0296
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.599,
  //   "time": "2023-06-04 07:13:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 160 km N of Las Khorey, Somalia على عمق 12.599 كم بتاريخ 2023-06-04 07:13:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k67w"
  // },
  // "1075": {
  //   "place": "52 km N of Īlām, Iran",
  //   "latLng": [
  //     34.1091,
  //     46.4188
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.109,
  //   "time": "2023-06-04 04:51:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 52 km N of Īlām, Iran على عمق 34.109 كم بتاريخ 2023-06-04 04:51:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k67c#dyfi"
  // },
  // "1076": {
  //   "place": "53 km ENE of Ādīgrat, Ethiopia",
  //   "latLng": [
  //     14.5343,
  //     39.8828
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.534,
  //   "time": "2023-06-04 04:14:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 53 km ENE of Ādīgrat, Ethiopia على عمق 14.534 كم بتاريخ 2023-06-04 04:14:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k679#dyfi"
  // },
  // "1077": {
  //   "place": "166 km NNW of Bosaso, Somalia",
  //   "latLng": [
  //     12.6474,
  //     48.5285
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.647,
  //   "time": "2023-06-03 18:53:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 166 km NNW of Bosaso, Somalia على عمق 12.647 كم بتاريخ 2023-06-03 18:53:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7e8"
  // },
  // "1078": {
  //   "place": "152 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.534,
  //     48.2455
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 12.534,
  //   "time": "2023-06-03 18:47:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 152 km N of Las Khorey, Somalia على عمق 12.534 كم بتاريخ 2023-06-03 18:47:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7e7"
  // },
  // "1079": {
  //   "place": "134 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.3763,
  //     48.2867
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.376,
  //   "time": "2023-06-03 17:55:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 134 km N of Las Khorey, Somalia على عمق 12.376 كم بتاريخ 2023-06-03 17:55:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7e5"
  // },
  // "1080": {
  //   "place": "140 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4312,
  //     48.2633
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 12.431,
  //   "time": "2023-06-03 14:10:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 140 km N of Las Khorey, Somalia على عمق 12.431 كم بتاريخ 2023-06-03 14:10:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k63r"
  // },
  // "1081": {
  //   "place": "155 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5626,
  //     48.0922
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 12.563,
  //   "time": "2023-06-03 13:58:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 155 km N of Las Khorey, Somalia على عمق 12.563 كم بتاريخ 2023-06-03 13:58:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k63p#pager"
  // },
  // "1082": {
  //   "place": "161 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6194,
  //     48.2622
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 12.619,
  //   "time": "2023-06-03 13:18:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 161 km N of Las Khorey, Somalia على عمق 12.619 كم بتاريخ 2023-06-03 13:18:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7e6"
  // },
  // "1083": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     12.6207,
  //     48.0472
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.621,
  //   "time": "2023-06-03 10:53:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Gulf of Aden على عمق 12.621 كم بتاريخ 2023-06-03 10:53:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k62t"
  // },
  // "1084": {
  //   "place": "145 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4675,
  //     48.0564
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.468,
  //   "time": "2023-06-03 10:45:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 145 km N of Las Khorey, Somalia على عمق 12.468 كم بتاريخ 2023-06-03 10:45:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k62r"
  // },
  // "1085": {
  //   "place": "162 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6289,
  //     48.1236
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.629,
  //   "time": "2023-06-03 10:35:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 162 km N of Las Khorey, Somalia على عمق 12.629 كم بتاريخ 2023-06-03 10:35:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7dj"
  // },
  // "1086": {
  //   "place": "159 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5875,
  //     48.0291
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 12.588,
  //   "time": "2023-06-03 10:32:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 159 km N of Las Khorey, Somalia على عمق 12.588 كم بتاريخ 2023-06-03 10:32:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k62k"
  // },
  // "1087": {
  //   "place": "145 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4621,
  //     47.9835
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 12.462,
  //   "time": "2023-06-03 10:15:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في 145 km N of Las Khorey, Somalia على عمق 12.462 كم بتاريخ 2023-06-03 10:15:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k62h#pager"
  // },
  // "1088": {
  //   "place": "173 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.7078,
  //     47.9368
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.708,
  //   "time": "2023-06-03 09:43:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 173 km N of Las Khorey, Somalia على عمق 12.708 كم بتاريخ 2023-06-03 09:43:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k62c"
  // },
  // "1089": {
  //   "place": "157 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5774,
  //     48.2719
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 12.577,
  //   "time": "2023-06-03 09:36:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 157 km N of Las Khorey, Somalia على عمق 12.577 كم بتاريخ 2023-06-03 09:36:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7df"
  // },
  // "1090": {
  //   "place": "152 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5382,
  //     48.1389
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.538,
  //   "time": "2023-06-03 09:34:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 152 km N of Las Khorey, Somalia على عمق 12.538 كم بتاريخ 2023-06-03 09:34:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7de"
  // },
  // "1091": {
  //   "place": "51 km W of Bojnūrd, Iran",
  //   "latLng": [
  //     37.5223,
  //     56.7446
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.522,
  //   "time": "2023-06-03 09:23:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 51 km W of Bojnūrd, Iran على عمق 37.522 كم بتاريخ 2023-06-03 09:23:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k625"
  // },
  // "1092": {
  //   "place": "157 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.558,
  //     47.9369
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.558,
  //   "time": "2023-06-03 08:56:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 157 km N of Las Khorey, Somalia على عمق 12.558 كم بتاريخ 2023-06-03 08:56:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k622"
  // },
  // "1093": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     12.4789,
  //     48.2459
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 12.479,
  //   "time": "2023-06-03 08:31:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Gulf of Aden على عمق 12.479 كم بتاريخ 2023-06-03 08:31:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7db"
  // },
  // "1094": {
  //   "place": "49 km NE of Sarakhs, Iran",
  //   "latLng": [
  //     36.7948,
  //     61.6165
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.795,
  //   "time": "2023-06-03 07:48:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 49 km NE of Sarakhs, Iran على عمق 36.795 كم بتاريخ 2023-06-03 07:48:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k61n"
  // },
  // "1095": {
  //   "place": "158 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5952,
  //     48.2107
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 12.595,
  //   "time": "2023-06-03 07:31:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 158 km N of Las Khorey, Somalia على عمق 12.595 كم بتاريخ 2023-06-03 07:31:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7d8"
  // },
  // "1096": {
  //   "place": "164 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6434,
  //     48.1757
  //   ],
  //   "magnitude": 5.8,
  //   "depth": 12.643,
  //   "time": "2023-06-03 07:17:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.8 درجة في 164 km N of Las Khorey, Somalia على عمق 12.643 كم بتاريخ 2023-06-03 07:17:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k61e#pager"
  // },
  // "1097": {
  //   "place": "166 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6654,
  //     48.1216
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.665,
  //   "time": "2023-06-03 07:15:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 166 km N of Las Khorey, Somalia على عمق 12.665 كم بتاريخ 2023-06-03 07:15:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7d7"
  // },
  // "1098": {
  //   "place": "166 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6663,
  //     48.1101
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.666,
  //   "time": "2023-06-03 07:08:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 166 km N of Las Khorey, Somalia على عمق 12.666 كم بتاريخ 2023-06-03 07:08:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7dt"
  // },
  // "1099": {
  //   "place": "135 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.3849,
  //     48.1537
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 12.385,
  //   "time": "2023-06-03 07:04:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 135 km N of Las Khorey, Somalia على عمق 12.385 كم بتاريخ 2023-06-03 07:04:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k61b"
  // },
  // "1100": {
  //   "place": "175 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.7435,
  //     48.1642
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 12.744,
  //   "time": "2023-06-03 07:04:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 175 km N of Las Khorey, Somalia على عمق 12.744 كم بتاريخ 2023-06-03 07:04:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7ej"
  // },
  // "1101": {
  //   "place": "157 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5774,
  //     48.1301
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.577,
  //   "time": "2023-06-03 07:03:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 157 km N of Las Khorey, Somalia على عمق 12.577 كم بتاريخ 2023-06-03 07:03:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7d5"
  // },
  // "1102": {
  //   "place": "173 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.7242,
  //     48.1352
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 12.724,
  //   "time": "2023-06-03 06:58:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 173 km N of Las Khorey, Somalia على عمق 12.724 كم بتاريخ 2023-06-03 06:58:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7d6"
  // },
  // "1103": {
  //   "place": "112 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.1785,
  //     48.1589
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.179,
  //   "time": "2023-06-03 06:49:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 112 km N of Las Khorey, Somalia على عمق 12.179 كم بتاريخ 2023-06-03 06:49:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k618"
  // },
  // "1104": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     12.5434,
  //     48.2403
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 12.543,
  //   "time": "2023-06-03 06:37:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في Gulf of Aden على عمق 12.543 كم بتاريخ 2023-06-03 06:37:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k615"
  // },
  // "1105": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     12.4693,
  //     48.188
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 12.469,
  //   "time": "2023-06-03 06:30:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في Gulf of Aden على عمق 12.469 كم بتاريخ 2023-06-03 06:30:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7dp"
  // },
  // "1106": {
  //   "place": "142 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4315,
  //     48.3762
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 12.432,
  //   "time": "2023-06-03 06:29:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 142 km N of Las Khorey, Somalia على عمق 12.432 كم بتاريخ 2023-06-03 06:29:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k613"
  // },
  // "1107": {
  //   "place": "130 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.3344,
  //     48.2515
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 12.334,
  //   "time": "2023-06-03 06:25:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 130 km N of Las Khorey, Somalia على عمق 12.334 كم بتاريخ 2023-06-03 06:25:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7d3"
  // },
  // "1108": {
  //   "place": "144 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4599,
  //     48.2599
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 12.46,
  //   "time": "2023-06-03 06:23:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في 144 km N of Las Khorey, Somalia على عمق 12.46 كم بتاريخ 2023-06-03 06:23:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k612"
  // },
  // "1109": {
  //   "place": "139 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4157,
  //     48.2381
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.416,
  //   "time": "2023-06-03 06:22:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 139 km N of Las Khorey, Somalia على عمق 12.416 كم بتاريخ 2023-06-03 06:22:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k616"
  // },
  // "1110": {
  //   "place": "133 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.3626,
  //     48.3064
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.363,
  //   "time": "2023-06-03 06:18:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 133 km N of Las Khorey, Somalia على عمق 12.363 كم بتاريخ 2023-06-03 06:18:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7dd"
  // },
  // "1111": {
  //   "place": "141 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.4356,
  //     48.2347
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.436,
  //   "time": "2023-06-03 06:17:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 141 km N of Las Khorey, Somalia على عمق 12.436 كم بتاريخ 2023-06-03 06:17:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k7cz"
  // },
  // "1112": {
  //   "place": "45 km SW of Borūjen, Iran",
  //   "latLng": [
  //     31.6961,
  //     50.9183
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.696,
  //   "time": "2023-05-31 15:22:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 45 km SW of Borūjen, Iran على عمق 31.696 كم بتاريخ 2023-05-31 15:22:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k59l"
  // },
  // "1113": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4998,
  //     56.3603
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.5,
  //   "time": "2023-05-29 02:58:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Owen Fracture Zone region على عمق 14.5 كم بتاريخ 2023-05-29 02:58:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k4q5"
  // },
  // "1114": {
  //   "place": "20 km NW of Latakia, Syria",
  //   "latLng": [
  //     35.6694,
  //     35.6427
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.669,
  //   "time": "2023-05-25 07:21:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 20 km NW of Latakia, Syria على عمق 35.669 كم بتاريخ 2023-05-25 07:21:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k3p9"
  // },
  // "1115": {
  //   "place": "50 km E of Hashtrūd, Iran",
  //   "latLng": [
  //     37.5455,
  //     47.612
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.546,
  //   "time": "2023-05-22 17:36:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 50 km E of Hashtrūd, Iran على عمق 37.546 كم بتاريخ 2023-05-22 17:36:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k30u#dyfi"
  // },
  // "1116": {
  //   "place": "39 km SSW of Side, Turkey",
  //   "latLng": [
  //     36.4601,
  //     31.1573
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.46,
  //   "time": "2023-05-22 04:51:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 39 km SSW of Side, Turkey على عمق 36.46 كم بتاريخ 2023-05-22 04:51:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kdtf"
  // },
  // "1117": {
  //   "place": "68 km N of Torbat-e Jām, Iran",
  //   "latLng": [
  //     35.8576,
  //     60.5366
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.858,
  //   "time": "2023-05-21 21:45:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 68 km N of Torbat-e Jām, Iran على عمق 35.858 كم بتاريخ 2023-05-21 21:45:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kdrl#dyfi"
  // },
  // "1118": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.3492,
  //     57.4312
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.349,
  //   "time": "2023-05-21 11:50:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Owen Fracture Zone region على عمق 13.349 كم بتاريخ 2023-05-21 11:50:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kdlr"
  // },
  // "1119": {
  //   "place": "66 km ENE of Yazd, Iran",
  //   "latLng": [
  //     32.2117,
  //     54.9655
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.212,
  //   "time": "2023-05-20 18:32:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 66 km ENE of Yazd, Iran على عمق 32.212 كم بتاريخ 2023-05-20 18:32:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kdhd"
  // },
  // "1120": {
  //   "place": "163 km NNW of Qandala, Somalia",
  //   "latLng": [
  //     12.7964,
  //     49.2049
  //   ],
  //   "magnitude": 5.8,
  //   "depth": 12.796,
  //   "time": "2023-05-19 15:15:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.8 درجة في 163 km NNW of Qandala, Somalia على عمق 12.796 كم بتاريخ 2023-05-19 15:15:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kd6s#pager"
  // },
  // "1121": {
  //   "place": "170 km NNW of Qandala, Somalia",
  //   "latLng": [
  //     12.8281,
  //     49.1214
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.828,
  //   "time": "2023-05-19 05:37:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 170 km NNW of Qandala, Somalia على عمق 12.828 كم بتاريخ 2023-05-19 05:37:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000k3qa"
  // },
  // "1122": {
  //   "place": "169 km NNW of Qandala, Somalia",
  //   "latLng": [
  //     12.8308,
  //     49.1511
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.831,
  //   "time": "2023-05-19 01:58:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 169 km NNW of Qandala, Somalia على عمق 12.831 كم بتاريخ 2023-05-19 01:58:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kd0a"
  // },
  // "1123": {
  //   "place": "163 km N of Bosaso, Somalia",
  //   "latLng": [
  //     12.7568,
  //     49.0733
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 12.757,
  //   "time": "2023-05-18 16:57:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 163 km N of Bosaso, Somalia على عمق 12.757 كم بتاريخ 2023-05-18 16:57:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kcvd"
  // },
  // "1124": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.5322,
  //     57.9795
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 9.532,
  //   "time": "2023-05-18 01:53:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Carlsberg Ridge على عمق 9.532 كم بتاريخ 2023-05-18 01:53:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kcqx"
  // },
  // "1125": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.5438,
  //     57.8414
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 9.544,
  //   "time": "2023-05-18 00:18:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في Carlsberg Ridge على عمق 9.544 كم بتاريخ 2023-05-18 00:18:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kcpt"
  // },
  // "1126": {
  //   "place": "28 km N of Adi Keyh, Eritrea",
  //   "latLng": [
  //     15.1044,
  //     39.411
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.104,
  //   "time": "2023-05-15 19:05:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 28 km N of Adi Keyh, Eritrea على عمق 15.104 كم بتاريخ 2023-05-15 19:05:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kc4a#dyfi"
  // },
  // "1127": {
  //   "place": "Iran-Iraq border region",
  //   "latLng": [
  //     34.3139,
  //     45.5703
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.314,
  //   "time": "2023-05-13 14:18:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Iran-Iraq border region على عمق 34.314 كم بتاريخ 2023-05-13 14:18:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kbpi#dyfi"
  // },
  // "1128": {
  //   "place": "126 km SSE of Aden, Yemen",
  //   "latLng": [
  //     11.6893,
  //     45.3895
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 11.689,
  //   "time": "2023-05-12 02:08:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 126 km SSE of Aden, Yemen على عمق 11.689 كم بتاريخ 2023-05-12 02:08:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kbai"
  // },
  // "1129": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     6.053,
  //     60.5788
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 6.053,
  //   "time": "2023-05-11 15:29:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في Carlsberg Ridge على عمق 6.053 كم بتاريخ 2023-05-11 15:29:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kcb0"
  // },
  // "1130": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     6.1173,
  //     60.6678
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 6.117,
  //   "time": "2023-05-11 13:10:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Carlsberg Ridge على عمق 6.117 كم بتاريخ 2023-05-11 13:10:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kcb3"
  // },
  // "1131": {
  //   "place": "30 km WSW of Ölüdeniz, Turkey",
  //   "latLng": [
  //     36.4169,
  //     28.8622
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.417,
  //   "time": "2023-05-09 15:22:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km WSW of Ölüdeniz, Turkey على عمق 36.417 كم بتاريخ 2023-05-09 15:22:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kan7#dyfi"
  // },
  // "1132": {
  //   "place": "42 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8606,
  //     55.1496
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.861,
  //   "time": "2023-05-09 10:11:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 42 km NE of Bandar-e Lengeh, Iran على عمق 26.861 كم بتاريخ 2023-05-09 10:11:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kaki#dyfi"
  // },
  // "1133": {
  //   "place": "55 km E of As Salamīyah, Syria",
  //   "latLng": [
  //     35.0003,
  //     37.6611
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.0,
  //   "time": "2023-05-09 03:52:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 55 km E of As Salamīyah, Syria على عمق 35.0 كم بتاريخ 2023-05-09 03:52:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kaiw"
  // },
  // "1134": {
  //   "place": "Ethiopia",
  //   "latLng": [
  //     11.696,
  //     35.9852
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 11.696,
  //   "time": "2023-05-08 11:36:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Ethiopia على عمق 11.696 كم بتاريخ 2023-05-08 11:36:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kacz"
  // },
  // "1135": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.0045,
  //     57.9513
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.005,
  //   "time": "2023-05-08 04:03:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Owen Fracture Zone region على عمق 13.005 كم بتاريخ 2023-05-08 04:03:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kabb"
  // },
  // "1136": {
  //   "place": "16 km W of pamas, Iran",
  //   "latLng": [
  //     34.0236,
  //     48.2838
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.024,
  //   "time": "2023-05-07 19:34:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km W of pamas, Iran على عمق 34.024 كم بتاريخ 2023-05-07 19:34:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kb5l"
  // },
  // "1137": {
  //   "place": "0 km SSE of Serinyol, Turkey",
  //   "latLng": [
  //     36.3545,
  //     36.2183
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.355,
  //   "time": "2023-05-07 08:36:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 0 km SSE of Serinyol, Turkey على عمق 36.355 كم بتاريخ 2023-05-07 08:36:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ka6g#dyfi"
  // },
  // "1138": {
  //   "place": "37 km ESE of Gewanē, Ethiopia",
  //   "latLng": [
  //     10.0216,
  //     40.9514
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 10.022,
  //   "time": "2023-05-07 02:51:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 37 km ESE of Gewanē, Ethiopia على عمق 10.022 كم بتاريخ 2023-05-07 02:51:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kb56"
  // },
  // "1139": {
  //   "place": "18 km E of Aladağ, Turkey",
  //   "latLng": [
  //     37.5767,
  //     35.6059
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.577,
  //   "time": "2023-05-03 06:20:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 18 km E of Aladağ, Turkey على عمق 37.577 كم بتاريخ 2023-05-03 06:20:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jxph"
  // },
  // "1140": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     8.3543,
  //     58.5651
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 8.354,
  //   "time": "2023-05-02 21:17:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Carlsberg Ridge على عمق 8.354 كم بتاريخ 2023-05-02 21:17:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000kaej"
  // },
  // "1141": {
  //   "place": "67 km NE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6679,
  //     56.6955
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.668,
  //   "time": "2023-05-01 00:13:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 67 km NE of Bandar Abbas, Iran على عمق 27.668 كم بتاريخ 2023-05-01 00:13:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jx9i"
  // },
  // "1142": {
  //   "place": "139 km N of Caluula, Somalia",
  //   "latLng": [
  //     13.2039,
  //     51.0051
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 13.204,
  //   "time": "2023-04-29 14:07:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 139 km N of Caluula, Somalia على عمق 13.204 كم بتاريخ 2023-04-29 14:07:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwyx"
  // },
  // "1143": {
  //   "place": "3 km WSW of Büyükçat, Turkey",
  //   "latLng": [
  //     36.1028,
  //     36.0439
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.103,
  //   "time": "2023-04-28 05:15:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 3 km WSW of Büyükçat, Turkey على عمق 36.103 كم بتاريخ 2023-04-28 05:15:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwk7"
  // },
  // "1144": {
  //   "place": "41 km SW of Mashhad, Iran",
  //   "latLng": [
  //     35.9918,
  //     59.3364
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 35.992,
  //   "time": "2023-04-27 22:39:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 41 km SW of Mashhad, Iran على عمق 35.992 كم بتاريخ 2023-04-27 22:39:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwf5#dyfi"
  // },
  // "1145": {
  //   "place": "80 km SW of Ḩājjīābād, Iran",
  //   "latLng": [
  //     27.774,
  //     55.3531
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 27.774,
  //   "time": "2023-04-27 10:20:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 80 km SW of Ḩājjīābād, Iran على عمق 27.774 كم بتاريخ 2023-04-27 10:20:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jw88"
  // },
  // "1146": {
  //   "place": "45 km SE of Kifrī, Iraq",
  //   "latLng": [
  //     34.3892,
  //     45.2965
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.389,
  //   "time": "2023-04-26 21:06:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 45 km SE of Kifrī, Iraq على عمق 34.389 كم بتاريخ 2023-04-26 21:06:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jxrp"
  // },
  // "1147": {
  //   "place": "13 km SSW of Astyp?laia, Greece",
  //   "latLng": [
  //     36.4294,
  //     26.3159
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 36.429,
  //   "time": "2023-04-26 20:00:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 13 km SSW of Astyp?laia, Greece على عمق 36.429 كم بتاريخ 2023-04-26 20:00:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jw42#dyfi"
  // },
  // "1148": {
  //   "place": "51 km NW of Mohr, Iran",
  //   "latLng": [
  //     27.9202,
  //     52.5614
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.92,
  //   "time": "2023-04-26 18:12:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 51 km NW of Mohr, Iran على عمق 27.92 كم بتاريخ 2023-04-26 18:12:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jw3k"
  // },
  // "1149": {
  //   "place": "44 km W of Sarpol-e Z̄ahāb, Iran",
  //   "latLng": [
  //     34.3883,
  //     45.3815
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.388,
  //   "time": "2023-04-26 05:18:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 44 km W of Sarpol-e Z̄ahāb, Iran على عمق 34.388 كم بتاريخ 2023-04-26 05:18:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jvyb"
  // },
  // "1150": {
  //   "place": "236 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.6903,
  //     54.6615
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.69,
  //   "time": "2023-04-24 21:07:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 236 km NNE of Hadibu, Yemen على عمق 14.69 كم بتاريخ 2023-04-24 21:07:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwqz"
  // },
  // "1151": {
  //   "place": "58 km N of Abadeh, Iran",
  //   "latLng": [
  //     31.6883,
  //     52.6357
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 31.688,
  //   "time": "2023-04-24 10:02:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 58 km N of Abadeh, Iran على عمق 31.688 كم بتاريخ 2023-04-24 10:02:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jwqj"
  // },
  // "1152": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     37.0767,
  //     28.4647
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.077,
  //   "time": "2023-04-23 03:40:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Western Turkey على عمق 37.077 كم بتاريخ 2023-04-23 03:40:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k6hp#dyfi"
  // },
  // "1153": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     37.065,
  //     28.4103
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.065,
  //   "time": "2023-04-22 20:38:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Western Turkey على عمق 37.065 كم بتاريخ 2023-04-22 20:38:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k6fj"
  // },
  // "1154": {
  //   "place": "68 km WNW of Mohr, Iran",
  //   "latLng": [
  //     27.7866,
  //     52.2402
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.787,
  //   "time": "2023-04-18 05:26:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 68 km WNW of Mohr, Iran على عمق 27.787 كم بتاريخ 2023-04-18 05:26:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jvts"
  // },
  // "1155": {
  //   "place": "82 km SSE of Karpathos, Greece",
  //   "latLng": [
  //     34.8759,
  //     27.6968
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.876,
  //   "time": "2023-04-17 22:17:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 82 km SSE of Karpathos, Greece على عمق 34.876 كم بتاريخ 2023-04-17 22:17:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k56v"
  // },
  // "1156": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.6037,
  //     37.1654
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.604,
  //   "time": "2023-04-15 21:51:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Central Turkey على عمق 37.604 كم بتاريخ 2023-04-15 21:51:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k4sz"
  // },
  // "1157": {
  //   "place": "30 km NE of Hurghada, Egypt",
  //   "latLng": [
  //     27.4122,
  //     34.0681
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.412,
  //   "time": "2023-04-14 23:58:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 30 km NE of Hurghada, Egypt على عمق 27.412 كم بتاريخ 2023-04-14 23:58:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k4nd#dyfi"
  // },
  // "1158": {
  //   "place": "128 km NW of Edd, Eritrea",
  //   "latLng": [
  //     14.6335,
  //     40.7493
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.634,
  //   "time": "2023-04-14 22:37:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 128 km NW of Edd, Eritrea على عمق 14.634 كم بتاريخ 2023-04-14 22:37:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k4ks#dyfi"
  // },
  // "1159": {
  //   "place": "50 km WSW of Fārsān, Iran",
  //   "latLng": [
  //     32.0897,
  //     50.0651
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 32.09,
  //   "time": "2023-04-14 03:45:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 50 km WSW of Fārsān, Iran على عمق 32.09 كم بتاريخ 2023-04-14 03:45:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k48e"
  // },
  // "1160": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     17.6028,
  //     60.0233
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 17.603,
  //   "time": "2023-04-13 03:24:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في Owen Fracture Zone region على عمق 17.603 كم بتاريخ 2023-04-13 03:24:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k3z2#pager"
  // },
  // "1161": {
  //   "place": "15 km WSW of Pazarcık, Turkey",
  //   "latLng": [
  //     37.4535,
  //     37.1254
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.454,
  //   "time": "2023-04-10 22:45:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 15 km WSW of Pazarcık, Turkey على عمق 37.454 كم بتاريخ 2023-04-10 22:45:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k3dd"
  // },
  // "1162": {
  //   "place": "46 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.7857,
  //     26.3309
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.786,
  //   "time": "2023-04-10 22:35:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 46 km S of Palekastro, Greece على عمق 34.786 كم بتاريخ 2023-04-10 22:35:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k3d9"
  // },
  // "1163": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     28.1032,
  //     56.9952
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.103,
  //   "time": "2023-04-07 23:38:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في southern Iran على عمق 28.103 كم بتاريخ 2023-04-07 23:38:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k43x"
  // },
  // "1164": {
  //   "place": "13 km NNE of Aladağ, Turkey",
  //   "latLng": [
  //     37.6604,
  //     35.4674
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.66,
  //   "time": "2023-04-06 00:57:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 13 km NNE of Aladağ, Turkey على عمق 37.66 كم بتاريخ 2023-04-06 00:57:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k29p"
  // },
  // "1165": {
  //   "place": "56 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.1047,
  //     53.154
  //   ],
  //   "magnitude": 3.8,
  //   "depth": 27.105,
  //   "time": "2023-04-04 20:08:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.8 درجة في 56 km SSE of Mohr, Iran على عمق 27.105 كم بتاريخ 2023-04-04 20:08:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k3jm"
  // },
  // "1166": {
  //   "place": "108 km ESE of Ḩājjīābād, Iran",
  //   "latLng": [
  //     28.1076,
  //     56.9831
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 28.108,
  //   "time": "2023-04-04 14:53:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 108 km ESE of Ḩājjīābād, Iran على عمق 28.108 كم بتاريخ 2023-04-04 14:53:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1xv"
  // },
  // "1167": {
  //   "place": "12 km SSE of Kızılkaya, Turkey",
  //   "latLng": [
  //     37.1977,
  //     30.48
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.198,
  //   "time": "2023-04-04 08:54:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 12 km SSE of Kızılkaya, Turkey على عمق 37.198 كم بتاريخ 2023-04-04 08:54:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1w6"
  // },
  // "1168": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.5446,
  //     56.4004
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 14.545,
  //   "time": "2023-04-03 22:00:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في Owen Fracture Zone region على عمق 14.545 كم بتاريخ 2023-04-03 22:00:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1u2"
  // },
  // "1169": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4165,
  //     56.4221
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.417,
  //   "time": "2023-04-03 21:47:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في Owen Fracture Zone region على عمق 14.417 كم بتاريخ 2023-04-03 21:47:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k2gj"
  // },
  // "1170": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.3888,
  //     56.3258
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 14.389,
  //   "time": "2023-04-03 21:44:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في Owen Fracture Zone region على عمق 14.389 كم بتاريخ 2023-04-03 21:44:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1u1#pager"
  // },
  // "1171": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4822,
  //     56.2988
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 14.482,
  //   "time": "2023-04-03 21:34:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في Owen Fracture Zone region على عمق 14.482 كم بتاريخ 2023-04-03 21:34:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1tw#pager"
  // },
  // "1172": {
  //   "place": "99 km N of Mīnāb, Iran",
  //   "latLng": [
  //     28.0164,
  //     56.8966
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.016,
  //   "time": "2023-04-03 03:55:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 99 km N of Mīnāb, Iran على عمق 28.016 كم بتاريخ 2023-04-03 03:55:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1n3"
  // },
  // "1173": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     27.1882,
  //     52.9982
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.188,
  //   "time": "2023-04-02 07:55:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في southern Iran على عمق 27.188 كم بتاريخ 2023-04-02 07:55:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1gg"
  // },
  // "1174": {
  //   "place": "36 km NE of Gerāsh, Iran",
  //   "latLng": [
  //     27.917,
  //     54.3749
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.917,
  //   "time": "2023-04-01 19:56:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 36 km NE of Gerāsh, Iran على عمق 27.917 كم بتاريخ 2023-04-01 19:56:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1ec"
  // },
  // "1175": {
  //   "place": "29 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.3091,
  //     52.9937
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.309,
  //   "time": "2023-04-01 19:43:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 29 km SSE of Mohr, Iran على عمق 27.309 كم بتاريخ 2023-04-01 19:43:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k2de"
  // },
  // "1176": {
  //   "place": "34 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.2714,
  //     53.0322
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 27.271,
  //   "time": "2023-04-01 15:57:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 34 km SSE of Mohr, Iran على عمق 27.271 كم بتاريخ 2023-04-01 15:57:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1d6#dyfi"
  // },
  // "1177": {
  //   "place": "14 km SW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.0466,
  //     35.9161
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.047,
  //   "time": "2023-04-01 12:40:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 14 km SW of Uzunba?, Turkey على عمق 36.047 كم بتاريخ 2023-04-01 12:40:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1cm"
  // },
  // "1178": {
  //   "place": "21 km WSW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.0662,
  //     35.8128
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.066,
  //   "time": "2023-04-01 12:34:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 21 km WSW of Uzunba?, Turkey على عمق 36.066 كم بتاريخ 2023-04-01 12:34:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1cg"
  // },
  // "1179": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.5484,
  //     56.1894
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.548,
  //   "time": "2023-03-31 20:53:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Owen Fracture Zone region على عمق 14.548 كم بتاريخ 2023-03-31 20:53:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k187"
  // },
  // "1180": {
  //   "place": "29 km NW of Kot Malik Barkhurdar, Pakistan",
  //   "latLng": [
  //     30.3652,
  //     66.7484
  //   ],
  //   "magnitude": 3.4,
  //   "depth": 30.365,
  //   "time": "2023-03-31 17:01:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.4 درجة في 29 km NW of Kot Malik Barkhurdar, Pakistan على عمق 30.365 كم بتاريخ 2023-03-31 17:01:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k5wm#dyfi"
  // },
  // "1181": {
  //   "place": "19 km SSE of Hasanbeyli, Turkey",
  //   "latLng": [
  //     36.9811,
  //     36.661
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.981,
  //   "time": "2023-03-31 10:56:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km SSE of Hasanbeyli, Turkey على عمق 36.981 كم بتاريخ 2023-03-31 10:56:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k139"
  // },
  // "1182": {
  //   "place": "108 km SSW of Al Wajh, Saudi Arabia",
  //   "latLng": [
  //     25.3304,
  //     36.0793
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 25.33,
  //   "time": "2023-03-29 22:55:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 108 km SSW of Al Wajh, Saudi Arabia على عمق 25.33 كم بتاريخ 2023-03-29 22:55:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k1rt"
  // },
  // "1183": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.3405,
  //     36.8426
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.341,
  //   "time": "2023-03-29 20:08:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Central Turkey على عمق 37.341 كم بتاريخ 2023-03-29 20:08:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k0qm"
  // },
  // "1184": {
  //   "place": "24 km WNW of Qūchān, Iran",
  //   "latLng": [
  //     37.2236,
  //     58.2827
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.224,
  //   "time": "2023-03-29 14:08:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 24 km WNW of Qūchān, Iran على عمق 37.224 كم بتاريخ 2023-03-29 14:08:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k0k1"
  // },
  // "1185": {
  //   "place": "Southern Iran",
  //   "latLng": [
  //     30.2791,
  //     51.7852
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 30.279,
  //   "time": "2023-03-28 17:05:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Southern Iran على عمق 30.279 كم بتاريخ 2023-03-28 17:05:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k0e3"
  // },
  // "1186": {
  //   "place": "75 km WNW of Chowki Jamali, Pakistan",
  //   "latLng": [
  //     28.278,
  //     67.2063
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 28.278,
  //   "time": "2023-03-25 20:49:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 75 km WNW of Chowki Jamali, Pakistan على عمق 28.278 كم بتاريخ 2023-03-25 20:49:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000k0n6"
  // },
  // "1187": {
  //   "place": "36 km ESE of Dehlorān, Iran",
  //   "latLng": [
  //     32.6182,
  //     47.6519
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 32.618,
  //   "time": "2023-03-25 19:13:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 36 km ESE of Dehlorān, Iran على عمق 32.618 كم بتاريخ 2023-03-25 19:13:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jmqd"
  // },
  // "1188": {
  //   "place": "24 km W of Kāzerūn, Iran",
  //   "latLng": [
  //     29.6097,
  //     51.3958
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 29.61,
  //   "time": "2023-03-25 18:13:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 24 km W of Kāzerūn, Iran على عمق 29.61 كم بتاريخ 2023-03-25 18:13:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jmq5"
  // },
  // "1189": {
  //   "place": "31 km N of Qarnābād, Iran",
  //   "latLng": [
  //     37.1019,
  //     54.6552
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 37.102,
  //   "time": "2023-03-22 10:38:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 31 km N of Qarnābād, Iran على عمق 37.102 كم بتاريخ 2023-03-22 10:38:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jlww#dyfi"
  // },
  // "1190": {
  //   "place": "Socotra region",
  //   "latLng": [
  //     13.7309,
  //     56.9425
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.731,
  //   "time": "2023-03-21 18:46:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Socotra region على عمق 13.731 كم بتاريخ 2023-03-21 18:46:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jmic"
  // },
  // "1191": {
  //   "place": "21 km N of Nurdağı, Turkey",
  //   "latLng": [
  //     37.3664,
  //     36.7383
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.366,
  //   "time": "2023-03-20 15:40:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 21 km N of Nurdağı, Turkey على عمق 37.366 كم بتاريخ 2023-03-20 15:40:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jlfv"
  // },
  // "1192": {
  //   "place": "81 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.2647,
  //     55.0965
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.265,
  //   "time": "2023-03-20 01:49:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 81 km NNE of Bandar-e Lengeh, Iran على عمق 27.265 كم بتاريخ 2023-03-20 01:49:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jlcm"
  // },
  // "1193": {
  //   "place": "35 km ENE of Bandar-e Genāveh, Iran",
  //   "latLng": [
  //     29.6454,
  //     50.871
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.645,
  //   "time": "2023-03-19 08:28:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 35 km ENE of Bandar-e Genāveh, Iran على عمق 29.645 كم بتاريخ 2023-03-19 08:28:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jl7u"
  // },
  // "1194": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.1129,
  //     36.3047
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.113,
  //   "time": "2023-03-18 09:31:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Central Turkey على عمق 37.113 كم بتاريخ 2023-03-18 09:31:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jm77"
  // },
  // "1195": {
  //   "place": "77 km N of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.2477,
  //     55.0236
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.248,
  //   "time": "2023-03-18 06:39:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 77 km N of Bandar-e Lengeh, Iran على عمق 27.248 كم بتاريخ 2023-03-18 06:39:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jl1b"
  // },
  // "1196": {
  //   "place": "17 km NNW of Behbahān, Iran",
  //   "latLng": [
  //     30.7312,
  //     50.1542
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 30.731,
  //   "time": "2023-03-16 20:41:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 17 km NNW of Behbahān, Iran على عمق 30.731 كم بتاريخ 2023-03-16 20:41:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jklj"
  // },
  // "1197": {
  //   "place": "30 km SE of Kızkalesi, Turkey",
  //   "latLng": [
  //     36.2558,
  //     34.3695
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.256,
  //   "time": "2023-03-16 19:59:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km SE of Kızkalesi, Turkey على عمق 36.256 كم بتاريخ 2023-03-16 19:59:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jkk9#dyfi"
  // },
  // "1198": {
  //   "place": "14 km NNE of Ḩalabja, Iraq",
  //   "latLng": [
  //     35.3022,
  //     46.0259
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 35.302,
  //   "time": "2023-03-16 18:32:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 14 km NNE of Ḩalabja, Iraq على عمق 35.302 كم بتاريخ 2023-03-16 18:32:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jkjc#dyfi"
  // },
  // "1199": {
  //   "place": "17 km S of Koloni, Cyprus",
  //   "latLng": [
  //     34.5912,
  //     32.5012
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.591,
  //   "time": "2023-03-15 06:27:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 17 km S of Koloni, Cyprus على عمق 34.591 كم بتاريخ 2023-03-15 06:27:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jk0j#dyfi"
  // },
  // "1200": {
  //   "place": "14 km W of Hasanbeyli, Turkey",
  //   "latLng": [
  //     37.1468,
  //     36.3894
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.147,
  //   "time": "2023-03-15 03:29:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 14 km W of Hasanbeyli, Turkey على عمق 37.147 كم بتاريخ 2023-03-15 03:29:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jjzy"
  // },
  // "1201": {
  //   "place": "41 km ENE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.6744,
  //     55.2733
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.674,
  //   "time": "2023-03-13 09:09:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 41 km ENE of Bandar-e Lengeh, Iran على عمق 26.674 كم بتاريخ 2023-03-13 09:09:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jkuz"
  // },
  // "1202": {
  //   "place": "30 km ENE of Mohr, Iran",
  //   "latLng": [
  //     27.6205,
  //     53.1796
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.621,
  //   "time": "2023-03-13 08:59:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 30 km ENE of Mohr, Iran على عمق 27.621 كم بتاريخ 2023-03-13 08:59:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jjhu"
  // },
  // "1203": {
  //   "place": "4 km NNE of Aşağı Karafakılı, Turkey",
  //   "latLng": [
  //     36.8216,
  //     36.5749
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.822,
  //   "time": "2023-03-13 02:23:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 4 km NNE of Aşağı Karafakılı, Turkey على عمق 36.822 كم بتاريخ 2023-03-13 02:23:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jjg7#dyfi"
  // },
  // "1204": {
  //   "place": "29 km SW of Sarpol-e Z̄ahāb, Iran",
  //   "latLng": [
  //     34.2696,
  //     45.6421
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.27,
  //   "time": "2023-03-12 06:35:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 29 km SW of Sarpol-e Z̄ahāb, Iran على عمق 34.27 كم بتاريخ 2023-03-12 06:35:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jksa"
  // },
  // "1205": {
  //   "place": "11 km SW of Ceyhan, Turkey",
  //   "latLng": [
  //     36.9506,
  //     35.7349
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.951,
  //   "time": "2023-03-11 19:35:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 11 km SW of Ceyhan, Turkey على عمق 36.951 كم بتاريخ 2023-03-11 19:35:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jj67#dyfi"
  // },
  // "1206": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     10.2138,
  //     56.9362
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 10.214,
  //   "time": "2023-03-08 00:45:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Carlsberg Ridge على عمق 10.214 كم بتاريخ 2023-03-08 00:45:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jjtt"
  // },
  // "1207": {
  //   "place": "24 km ENE of And?r?n, Turkey",
  //   "latLng": [
  //     37.6641,
  //     36.608
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.664,
  //   "time": "2023-03-07 09:40:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 24 km ENE of And?r?n, Turkey على عمق 37.664 كم بتاريخ 2023-03-07 09:40:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhv7"
  // },
  // "1208": {
  //   "place": "2 km NNE of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1589,
  //     36.0428
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.159,
  //   "time": "2023-03-06 22:14:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 2 km NNE of Uzunba?, Turkey على عمق 36.159 كم بتاريخ 2023-03-06 22:14:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhrd"
  // },
  // "1209": {
  //   "place": "5 km W of Toygarl?, Turkey",
  //   "latLng": [
  //     36.2202,
  //     36.0072
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.22,
  //   "time": "2023-03-06 11:02:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 5 km W of Toygarl?, Turkey على عمق 36.22 كم بتاريخ 2023-03-06 11:02:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhlx#dyfi"
  // },
  // "1210": {
  //   "place": "4 km SE of Gümü?göze, Turkey",
  //   "latLng": [
  //     36.1213,
  //     36.1681
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.121,
  //   "time": "2023-03-06 08:14:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 4 km SE of Gümü?göze, Turkey على عمق 36.121 كم بتاريخ 2023-03-06 08:14:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhl4"
  // },
  // "1211": {
  //   "place": "4 km N of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1816,
  //     36.0375
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.182,
  //   "time": "2023-03-06 02:16:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 4 km N of Uzunba?, Turkey على عمق 36.182 كم بتاريخ 2023-03-06 02:16:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhjt"
  // },
  // "1212": {
  //   "place": "45 km WSW of Sehwan, Pakistan",
  //   "latLng": [
  //     26.2173,
  //     67.4737
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.217,
  //   "time": "2023-03-06 01:01:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 45 km WSW of Sehwan, Pakistan على عمق 26.217 كم بتاريخ 2023-03-06 01:01:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhji"
  // },
  // "1213": {
  //   "place": "7 km SW of Dörtyol, Turkey",
  //   "latLng": [
  //     36.7867,
  //     36.1842
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 36.787,
  //   "time": "2023-03-05 20:49:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 7 km SW of Dörtyol, Turkey على عمق 36.787 كم بتاريخ 2023-03-05 20:49:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhi7#dyfi"
  // },
  // "1214": {
  //   "place": "32 km NW of Tadmur, Syria",
  //   "latLng": [
  //     34.7587,
  //     38.0259
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.759,
  //   "time": "2023-03-05 06:25:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 32 km NW of Tadmur, Syria على عمق 34.759 كم بتاريخ 2023-03-05 06:25:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhfy#dyfi"
  // },
  // "1215": {
  //   "place": "31 km ENE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2659,
  //     37.0676
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.266,
  //   "time": "2023-03-01 16:37:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 31 km ENE of Nurda??, Turkey على عمق 37.266 كم بتاريخ 2023-03-01 16:37:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jgly"
  // },
  // "1216": {
  //   "place": "7 km W of Anayazi, Turkey",
  //   "latLng": [
  //     36.3065,
  //     36.097
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.307,
  //   "time": "2023-03-01 07:20:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 7 km W of Anayazi, Turkey على عمق 36.307 كم بتاريخ 2023-03-01 07:20:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jgic#dyfi"
  // },
  // "1217": {
  //   "place": "29 km ENE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2808,
  //     37.0318
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.281,
  //   "time": "2023-02-28 23:32:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 29 km ENE of Nurda??, Turkey على عمق 37.281 كم بتاريخ 2023-02-28 23:32:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jgdf"
  // },
  // "1218": {
  //   "place": "24 km ENE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2588,
  //     36.992
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.259,
  //   "time": "2023-02-28 18:51:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 24 km ENE of Nurda??, Turkey على عمق 37.259 كم بتاريخ 2023-02-28 18:51:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jgbe"
  // },
  // "1219": {
  //   "place": "80 km SW of ??jj??b?d, Iran",
  //   "latLng": [
  //     27.8012,
  //     55.3104
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.801,
  //   "time": "2023-02-28 15:58:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 80 km SW of ??jj??b?d, Iran على عمق 27.801 كم بتاريخ 2023-02-28 15:58:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jg9f"
  // },
  // "1220": {
  //   "place": "17 km SSE of And?r?n, Turkey",
  //   "latLng": [
  //     37.4289,
  //     36.4287
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.429,
  //   "time": "2023-02-28 12:42:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 17 km SSE of And?r?n, Turkey على عمق 37.429 كم بتاريخ 2023-02-28 12:42:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jg8e"
  // },
  // "1221": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     6.6808,
  //     60.2231
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 6.681,
  //   "time": "2023-02-28 12:07:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في Carlsberg Ridge على عمق 6.681 كم بتاريخ 2023-02-28 12:07:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jg89#pager"
  // },
  // "1222": {
  //   "place": "30 km E of Karata?, Turkey",
  //   "latLng": [
  //     36.6204,
  //     35.704
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.62,
  //   "time": "2023-02-27 06:29:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 30 km E of Karata?, Turkey على عمق 36.62 كم بتاريخ 2023-02-27 06:29:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jhxe"
  // },
  // "1223": {
  //   "place": "9 km SW of B?y?k?at, Turkey",
  //   "latLng": [
  //     36.0535,
  //     36.012
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.054,
  //   "time": "2023-02-26 02:26:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 9 km SW of B?y?k?at, Turkey على عمق 36.054 كم بتاريخ 2023-02-26 02:26:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jrn1#dyfi"
  // },
  // "1224": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     36.0592,
  //     35.9528
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.059,
  //   "time": "2023-02-25 01:12:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Central Turkey على عمق 36.059 كم بتاريخ 2023-02-25 01:12:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jrgg"
  // },
  // "1225": {
  //   "place": "57 km WSW of Latakia, Syria",
  //   "latLng": [
  //     35.2752,
  //     35.239
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 35.275,
  //   "time": "2023-02-24 20:10:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 57 km WSW of Latakia, Syria على عمق 35.275 كم بتاريخ 2023-02-24 20:10:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jref"
  // },
  // "1226": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.6508,
  //     57.9175
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 9.651,
  //   "time": "2023-02-24 13:08:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Carlsberg Ridge على عمق 9.651 كم بتاريخ 2023-02-24 13:08:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jh2a"
  // },
  // "1227": {
  //   "place": "11 km NW of G?nyaz?, Turkey",
  //   "latLng": [
  //     36.3086,
  //     36.0365
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.309,
  //   "time": "2023-02-24 05:46:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 11 km NW of G?nyaz?, Turkey على عمق 36.309 كم بتاريخ 2023-02-24 05:46:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jr79"
  // },
  // "1228": {
  //   "place": "23 km NNW of Suez, Egypt",
  //   "latLng": [
  //     30.1565,
  //     32.3957
  //   ],
  //   "magnitude": 3.8,
  //   "depth": 30.157,
  //   "time": "2023-02-23 22:25:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.8 درجة في 23 km NNW of Suez, Egypt على عمق 30.157 كم بتاريخ 2023-02-23 22:25:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jrr9#dyfi"
  // },
  // "1229": {
  //   "place": "6 km SSE of Büyükçat, Turkey",
  //   "latLng": [
  //     36.0589,
  //     36.095
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.059,
  //   "time": "2023-02-23 15:53:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 6 km SSE of Büyükçat, Turkey على عمق 36.059 كم بتاريخ 2023-02-23 15:53:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jr1t#dyfi"
  // },
  // "1230": {
  //   "place": "31 km NW of Gaziantep, Turkey",
  //   "latLng": [
  //     37.2286,
  //     37.0909
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.229,
  //   "time": "2023-02-23 03:23:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 31 km NW of Gaziantep, Turkey على عمق 37.229 كم بتاريخ 2023-02-23 03:23:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqyd"
  // },
  // "1231": {
  //   "place": "65 km NW of Tyre, Lebanon",
  //   "latLng": [
  //     33.6342,
  //     34.6394
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 33.634,
  //   "time": "2023-02-22 06:01:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 65 km NW of Tyre, Lebanon على عمق 33.634 كم بتاريخ 2023-02-22 06:01:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqqe#dyfi"
  // },
  // "1232": {
  //   "place": "86 km SW of ??jj??b?d, Iran",
  //   "latLng": [
  //     27.7531,
  //     55.2852
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 27.753,
  //   "time": "2023-02-22 01:11:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 86 km SW of ??jj??b?d, Iran على عمق 27.753 كم بتاريخ 2023-02-22 01:11:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqp6"
  // },
  // "1233": {
  //   "place": "3 km E of Bal?kl?dere, Turkey",
  //   "latLng": [
  //     36.1158,
  //     36.1459
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.116,
  //   "time": "2023-02-21 16:06:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 3 km E of Bal?kl?dere, Turkey على عمق 36.116 كم بتاريخ 2023-02-21 16:06:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqkr#dyfi"
  // },
  // "1234": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.4411,
  //     37.2074
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.441,
  //   "time": "2023-02-21 10:09:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Central Turkey على عمق 37.441 كم بتاريخ 2023-02-21 10:09:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqim"
  // },
  // "1235": {
  //   "place": "79 km SW of ??jj??b?d, Iran",
  //   "latLng": [
  //     27.7828,
  //     55.3567
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 27.783,
  //   "time": "2023-02-21 06:05:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 79 km SW of ??jj??b?d, Iran على عمق 27.783 كم بتاريخ 2023-02-21 06:05:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqhr#dyfi"
  // },
  // "1236": {
  //   "place": "Near the coast of Syria",
  //   "latLng": [
  //     35.9531,
  //     35.9447
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 35.953,
  //   "time": "2023-02-20 22:56:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في Near the coast of Syria على عمق 35.953 كم بتاريخ 2023-02-20 22:56:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqfm"
  // },
  // "1237": {
  //   "place": "2 km WSW of Kuzeytepe, Turkey",
  //   "latLng": [
  //     36.2572,
  //     36.1266
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.257,
  //   "time": "2023-02-20 19:09:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 2 km WSW of Kuzeytepe, Turkey على عمق 36.257 كم بتاريخ 2023-02-20 19:09:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqdp#dyfi"
  // },
  // "1238": {
  //   "place": "5 km SW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.105,
  //     35.9906
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.105,
  //   "time": "2023-02-20 19:00:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 5 km SW of Uzunba?, Turkey على عمق 36.105 كم بتاريخ 2023-02-20 19:00:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqdn"
  // },
  // "1239": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.2653,
  //     36.0798
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.265,
  //   "time": "2023-02-20 17:13:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Turkey-Syria border region على عمق 36.265 كم بتاريخ 2023-02-20 17:13:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000jga3"
  // },
  // "1240": {
  //   "place": "9 km WNW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.159,
  //     35.9351
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 36.159,
  //   "time": "2023-02-20 17:07:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 9 km WNW of Uzunba?, Turkey على عمق 36.159 كم بتاريخ 2023-02-20 17:07:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqjc#pager"
  // },
  // "1241": {
  //   "place": "2 km NNW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1616,
  //     36.0251
  //   ],
  //   "magnitude": 6.3,
  //   "depth": 36.162,
  //   "time": "2023-02-20 17:04:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.3 درجة في 2 km NNW of Uzunba?, Turkey على عمق 36.162 كم بتاريخ 2023-02-20 17:04:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqcn#pager"
  // },
  // "1242": {
  //   "place": "24 km SSW of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.3725,
  //     36.8705
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 37.373,
  //   "time": "2023-02-19 21:30:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 24 km SSW of Kahramanmara?, Turkey على عمق 37.373 كم بتاريخ 2023-02-19 21:30:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jq69#dyfi"
  // },
  // "1243": {
  //   "place": "0 km SE of Páno Polemídia, Cyprus",
  //   "latLng": [
  //     34.699,
  //     32.9989
  //   ],
  //   "magnitude": 3.6,
  //   "depth": 34.699,
  //   "time": "2023-02-19 14:26:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.6 درجة في 0 km SE of Páno Polemídia, Cyprus على عمق 34.699 كم بتاريخ 2023-02-19 14:26:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jq4g#dyfi"
  // },
  // "1244": {
  //   "place": "19 km NE of Nurda??, Turkey",
  //   "latLng": [
  //     37.3021,
  //     36.8869
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.302,
  //   "time": "2023-02-19 04:07:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km NE of Nurda??, Turkey على عمق 37.302 كم بتاريخ 2023-02-19 04:07:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jq1g"
  // },
  // "1245": {
  //   "place": "14 km NE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2737,
  //     36.8291
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.274,
  //   "time": "2023-02-19 04:06:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 14 km NE of Nurda??, Turkey على عمق 37.274 كم بتاريخ 2023-02-19 04:06:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jq1h"
  // },
  // "1246": {
  //   "place": "9 km ESE of Nurda??, Turkey",
  //   "latLng": [
  //     37.1416,
  //     36.8384
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.142,
  //   "time": "2023-02-19 03:59:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 9 km ESE of Nurda??, Turkey على عمق 37.142 كم بتاريخ 2023-02-19 03:59:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jq1d#dyfi"
  // },
  // "1247": {
  //   "place": "21 km W of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1766,
  //     35.7967
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 36.177,
  //   "time": "2023-02-16 19:47:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في 21 km W of Uzunba?, Turkey على عمق 36.177 كم بتاريخ 2023-02-16 19:47:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpff#dyfi"
  // },
  // "1248": {
  //   "place": "24 km WNW of Yaylada??, Turkey",
  //   "latLng": [
  //     35.9743,
  //     35.8103
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 35.974,
  //   "time": "2023-02-16 11:16:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 24 km WNW of Yaylada??, Turkey على عمق 35.974 كم بتاريخ 2023-02-16 11:16:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpd5#dyfi"
  // },
  // "1249": {
  //   "place": "24 km NNE of Nurda??, Turkey",
  //   "latLng": [
  //     37.3595,
  //     36.8701
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 37.36,
  //   "time": "2023-02-15 23:43:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 24 km NNE of Nurda??, Turkey على عمق 37.36 كم بتاريخ 2023-02-15 23:43:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp9e"
  // },
  // "1250": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.7937,
  //     36.5503
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.794,
  //   "time": "2023-02-15 00:06:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Turkey-Syria border region على عمق 36.794 كم بتاريخ 2023-02-15 00:06:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp0a#dyfi"
  // },
  // "1251": {
  //   "place": "34 km W of Latakia, Syria",
  //   "latLng": [
  //     35.5292,
  //     35.4049
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.529,
  //   "time": "2023-02-14 13:44:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 34 km W of Latakia, Syria على عمق 35.529 كم بتاريخ 2023-02-14 13:44:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr1"
  // },
  // "1252": {
  //   "place": "6 km NNW of K??lak, Turkey",
  //   "latLng": [
  //     36.0172,
  //     36.1295
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.017,
  //   "time": "2023-02-14 11:54:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 6 km NNW of K??lak, Turkey على عمق 36.017 كم بتاريخ 2023-02-14 11:54:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnqt"
  // },
  // "1253": {
  //   "place": "12 km WSW of Dörtyol, Turkey",
  //   "latLng": [
  //     36.781,
  //     36.1142
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.781,
  //   "time": "2023-02-14 01:56:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 12 km WSW of Dörtyol, Turkey على عمق 36.781 كم بتاريخ 2023-02-14 01:56:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqtp"
  // },
  // "1254": {
  //   "place": "12 km NNE of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.8844,
  //     36.6204
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.884,
  //   "time": "2023-02-13 11:59:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 12 km NNE of A?a?? Karafak?l?, Turkey على عمق 36.884 كم بتاريخ 2023-02-13 11:59:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnks"
  // },
  // "1255": {
  //   "place": "58 km WSW of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.6125,
  //     52.0362
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.613,
  //   "time": "2023-02-13 01:43:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 58 km WSW of F?r?z?b?d, Iran على عمق 28.613 كم بتاريخ 2023-02-13 01:43:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqjr"
  // },
  // "1256": {
  //   "place": "20 km SW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.0389,
  //     35.8488
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.039,
  //   "time": "2023-02-12 22:02:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 20 km SW of Uzunba?, Turkey على عمق 36.039 كم بتاريخ 2023-02-12 22:02:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqc9"
  // },
  // "1257": {
  //   "place": "9 km N of ‘Afr?n, Syria",
  //   "latLng": [
  //     36.5999,
  //     36.8854
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.6,
  //   "time": "2023-02-12 21:21:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 9 km N of ‘Afr?n, Syria على عمق 36.6 كم بتاريخ 2023-02-12 21:21:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqc3"
  // },
  // "1258": {
  //   "place": "31 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.2623,
  //     37.0849
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.262,
  //   "time": "2023-02-12 19:02:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 31 km SW of Pazarc?k, Turkey على عمق 37.262 كم بتاريخ 2023-02-12 19:02:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnh5"
  // },
  // "1259": {
  //   "place": "27 km SSE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.3429,
  //     36.9989
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.343,
  //   "time": "2023-02-12 18:33:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 27 km SSE of Kahramanmara?, Turkey على عمق 37.343 كم بتاريخ 2023-02-12 18:33:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnh1#dyfi"
  // },
  // "1260": {
  //   "place": "40 km NW of Ger?sh, Iran",
  //   "latLng": [
  //     27.9015,
  //     53.8188
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.902,
  //   "time": "2023-02-12 18:21:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NW of Ger?sh, Iran على عمق 27.902 كم بتاريخ 2023-02-12 18:21:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jngz#dyfi"
  // },
  // "1261": {
  //   "place": "16 km SW of Musabeyli, Turkey",
  //   "latLng": [
  //     36.7991,
  //     36.7677
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.799,
  //   "time": "2023-02-12 12:25:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km SW of Musabeyli, Turkey على عمق 36.799 كم بتاريخ 2023-02-12 12:25:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnfg#dyfi"
  // },
  // "1262": {
  //   "place": "4 km E of Alt?nözü, Turkey",
  //   "latLng": [
  //     36.1158,
  //     36.3017
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.116,
  //   "time": "2023-02-12 09:32:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 4 km E of Alt?nözü, Turkey على عمق 36.116 كم بتاريخ 2023-02-12 09:32:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnf4"
  // },
  // "1263": {
  //   "place": "15 km W of Latakia, Syria",
  //   "latLng": [
  //     35.5279,
  //     35.6189
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.528,
  //   "time": "2023-02-12 07:12:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 15 km W of Latakia, Syria على عمق 35.528 كم بتاريخ 2023-02-12 07:12:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jqbn"
  // },
  // "1264": {
  //   "place": "9 km ENE of K?r?khan, Turkey",
  //   "latLng": [
  //     36.5324,
  //     36.4568
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.532,
  //   "time": "2023-02-12 04:46:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 9 km ENE of K?r?khan, Turkey على عمق 36.532 كم بتاريخ 2023-02-12 04:46:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jndy"
  // },
  // "1265": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.6384,
  //     36.5737
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.638,
  //   "time": "2023-02-11 22:29:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Turkey-Syria border region على عمق 36.638 كم بتاريخ 2023-02-11 22:29:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jncp"
  // },
  // "1266": {
  //   "place": "1 km ENE of Kuzeytepe, Turkey",
  //   "latLng": [
  //     36.268,
  //     36.171
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.268,
  //   "time": "2023-02-11 17:20:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 1 km ENE of Kuzeytepe, Turkey على عمق 36.268 كم بتاريخ 2023-02-11 17:20:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnbd#dyfi"
  // },
  // "1267": {
  //   "place": "4 km WSW of K?r?khan, Turkey",
  //   "latLng": [
  //     36.4869,
  //     36.3096
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.487,
  //   "time": "2023-02-11 11:51:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 4 km WSW of K?r?khan, Turkey على عمق 36.487 كم بتاريخ 2023-02-11 11:51:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnam#dyfi"
  // },
  // "1268": {
  //   "place": "19 km N of Musabeyli, Turkey",
  //   "latLng": [
  //     37.0598,
  //     36.95
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.06,
  //   "time": "2023-02-11 07:55:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 19 km N of Musabeyli, Turkey على عمق 37.06 كم بتاريخ 2023-02-11 07:55:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jn9a"
  // },
  // "1269": {
  //   "place": "110 km S of K?h Sef?d, Iran",
  //   "latLng": [
  //     28.2808,
  //     56.8276
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.281,
  //   "time": "2023-02-11 03:12:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 110 km S of K?h Sef?d, Iran على عمق 28.281 كم بتاريخ 2023-02-11 03:12:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpnu"
  // },
  // "1270": {
  //   "place": "19 km ENE of K?r?khan, Turkey",
  //   "latLng": [
  //     36.5556,
  //     36.5606
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.556,
  //   "time": "2023-02-11 00:24:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 19 km ENE of K?r?khan, Turkey على عمق 36.556 كم بتاريخ 2023-02-11 00:24:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jn77"
  // },
  // "1271": {
  //   "place": "59 km WNW of ?ar??s, Syria",
  //   "latLng": [
  //     35.0684,
  //     35.2669
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.068,
  //   "time": "2023-02-10 08:17:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 59 km WNW of ?ar??s, Syria على عمق 35.068 كم بتاريخ 2023-02-10 08:17:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jn19#dyfi"
  // },
  // "1272": {
  //   "place": "8 km ESE of Hasanbeyli, Turkey",
  //   "latLng": [
  //     37.1058,
  //     36.6317
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.106,
  //   "time": "2023-02-09 22:06:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 8 km ESE of Hasanbeyli, Turkey على عمق 37.106 كم بتاريخ 2023-02-09 22:06:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmvs"
  // },
  // "1273": {
  //   "place": "10 km E of Nurda??, Turkey",
  //   "latLng": [
  //     37.1694,
  //     36.8496
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.169,
  //   "time": "2023-02-09 21:46:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 10 km E of Nurda??, Turkey على عمق 37.169 كم بتاريخ 2023-02-09 21:46:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmvn"
  // },
  // "1274": {
  //   "place": "21 km W of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1764,
  //     35.7977
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.176,
  //   "time": "2023-02-09 18:49:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 21 km W of Uzunba?, Turkey على عمق 36.176 كم بتاريخ 2023-02-09 18:49:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpkt"
  // },
  // "1275": {
  //   "place": "19 km ENE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2659,
  //     36.9198
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.266,
  //   "time": "2023-02-09 10:42:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km ENE of Nurda??, Turkey على عمق 37.266 كم بتاريخ 2023-02-09 10:42:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmpu"
  // },
  // "1276": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.9611,
  //     36.6603
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.961,
  //   "time": "2023-02-09 07:18:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Turkey-Syria border region على عمق 36.961 كم بتاريخ 2023-02-09 07:18:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmnp#dyfi"
  // },
  // "1277": {
  //   "place": "8 km W of Hassa, Turkey",
  //   "latLng": [
  //     36.8136,
  //     36.4252
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.814,
  //   "time": "2023-02-09 03:24:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 8 km W of Hassa, Turkey على عمق 36.814 كم بتاريخ 2023-02-09 03:24:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmmw"
  // },
  // "1278": {
  //   "place": "100 km S of K?h Sef?d, Iran",
  //   "latLng": [
  //     28.3652,
  //     56.7895
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.365,
  //   "time": "2023-02-08 23:25:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 100 km S of K?h Sef?d, Iran على عمق 28.365 كم بتاريخ 2023-02-08 23:25:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpd4"
  // },
  // "1279": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.3313,
  //     36.0996
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.331,
  //   "time": "2023-02-08 19:48:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Turkey-Syria border region على عمق 36.331 كم بتاريخ 2023-02-08 19:48:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmk7"
  // },
  // "1280": {
  //   "place": "19 km ENE of Bcharré, Lebanon",
  //   "latLng": [
  //     34.2985,
  //     36.2101
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.299,
  //   "time": "2023-02-08 18:58:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 19 km ENE of Bcharré, Lebanon على عمق 34.299 كم بتاريخ 2023-02-08 18:58:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmjy#dyfi"
  // },
  // "1281": {
  //   "place": "16 km W of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.5096,
  //     37.116
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.51,
  //   "time": "2023-02-08 18:35:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 16 km W of Pazarc?k, Turkey على عمق 37.51 كم بتاريخ 2023-02-08 18:35:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpcx"
  // },
  // "1282": {
  //   "place": "23 km E of Nurda??, Turkey",
  //   "latLng": [
  //     37.1554,
  //     37.0022
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.155,
  //   "time": "2023-02-08 10:26:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 23 km E of Nurda??, Turkey على عمق 37.155 كم بتاريخ 2023-02-08 10:26:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmg9#dyfi"
  // },
  // "1283": {
  //   "place": "14 km SSW of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.6565,
  //     36.5077
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.657,
  //   "time": "2023-02-08 09:13:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 14 km SSW of A?a?? Karafak?l?, Turkey على عمق 36.657 كم بتاريخ 2023-02-08 09:13:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpch"
  // },
  // "1284": {
  //   "place": "4 km SE of Serinyol, Turkey",
  //   "latLng": [
  //     36.3259,
  //     36.2434
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.326,
  //   "time": "2023-02-08 07:23:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 4 km SE of Serinyol, Turkey على عمق 36.326 كم بتاريخ 2023-02-08 07:23:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpce"
  // },
  // "1285": {
  //   "place": "16 km ENE of Denizciler, Turkey",
  //   "latLng": [
  //     36.7009,
  //     36.3794
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.701,
  //   "time": "2023-02-08 07:20:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 16 km ENE of Denizciler, Turkey على عمق 36.701 كم بتاريخ 2023-02-08 07:20:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpcf"
  // },
  // "1286": {
  //   "place": "3 km E of Antakya, Turkey",
  //   "latLng": [
  //     36.2022,
  //     36.1959
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.202,
  //   "time": "2023-02-08 06:09:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 3 km E of Antakya, Turkey على عمق 36.202 كم بتاريخ 2023-02-08 06:09:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmfn#dyfi"
  // },
  // "1287": {
  //   "place": "46 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.2337,
  //     49.651
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.234,
  //   "time": "2023-02-08 04:01:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 46 km NE of Masjed Soleym?n, Iran على عمق 32.234 كم بتاريخ 2023-02-08 04:01:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmfb"
  // },
  // "1288": {
  //   "place": "6 km WSW of Nurda??, Turkey",
  //   "latLng": [
  //     37.1511,
  //     36.671
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.151,
  //   "time": "2023-02-08 03:01:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 6 km WSW of Nurda??, Turkey على عمق 37.151 كم بتاريخ 2023-02-08 03:01:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmer"
  // },
  // "1289": {
  //   "place": "7 km SE of Bahçe, Turkey",
  //   "latLng": [
  //     37.1601,
  //     36.6433
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.16,
  //   "time": "2023-02-08 02:55:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 7 km SE of Bahçe, Turkey على عمق 37.16 كم بتاريخ 2023-02-08 02:55:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jpcg"
  // },
  // "1290": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     36.0927,
  //     35.8637
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.093,
  //   "time": "2023-02-07 23:13:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Central Turkey على عمق 36.093 كم بتاريخ 2023-02-07 23:13:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmdw#dyfi"
  // },
  // "1291": {
  //   "place": "18 km S of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4201,
  //     36.9564
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.42,
  //   "time": "2023-02-07 21:58:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 18 km S of Kahramanmara?, Turkey على عمق 37.42 كم بتاريخ 2023-02-07 21:58:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp4u"
  // },
  // "1292": {
  //   "place": "Dead Sea region",
  //   "latLng": [
  //     32.0866,
  //     35.2415
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.087,
  //   "time": "2023-02-07 21:14:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Dead Sea region على عمق 32.087 كم بتاريخ 2023-02-07 21:14:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmcs#dyfi"
  // },
  // "1293": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     36.0086,
  //     35.9967
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.009,
  //   "time": "2023-02-07 16:53:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Central Turkey على عمق 36.009 كم بتاريخ 2023-02-07 16:53:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp56"
  // },
  // "1294": {
  //   "place": "18 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3758,
  //     37.1447
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.376,
  //   "time": "2023-02-07 15:31:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 18 km SW of Pazarc?k, Turkey على عمق 37.376 كم بتاريخ 2023-02-07 15:31:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm95#dyfi"
  // },
  // "1295": {
  //   "place": "17 km WSW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.0984,
  //     35.8449
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.098,
  //   "time": "2023-02-07 13:36:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 17 km WSW of Uzunba?, Turkey على عمق 36.098 كم بتاريخ 2023-02-07 13:36:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm84"
  // },
  // "1296": {
  //   "place": "9 km WSW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.0958,
  //     35.9441
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.096,
  //   "time": "2023-02-07 10:37:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 9 km WSW of Uzunba?, Turkey على عمق 36.096 كم بتاريخ 2023-02-07 10:37:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp45"
  // },
  // "1297": {
  //   "place": "14 km WNW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.5226,
  //     37.1468
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.523,
  //   "time": "2023-02-07 10:07:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 14 km WNW of Pazarc?k, Turkey على عمق 37.523 كم بتاريخ 2023-02-07 10:07:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp54"
  // },
  // "1298": {
  //   "place": "12 km NE of K?r?khan, Turkey",
  //   "latLng": [
  //     36.5768,
  //     36.4539
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.577,
  //   "time": "2023-02-07 07:54:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 12 km NE of K?r?khan, Turkey على عمق 36.577 كم بتاريخ 2023-02-07 07:54:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm6x"
  // },
  // "1299": {
  //   "place": "12 km NE of Hassa, Turkey",
  //   "latLng": [
  //     36.8855,
  //     36.6006
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.886,
  //   "time": "2023-02-07 07:45:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 12 km NE of Hassa, Turkey على عمق 36.886 كم بتاريخ 2023-02-07 07:45:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp49"
  // },
  // "1300": {
  //   "place": "22 km NE of Nurda??, Turkey",
  //   "latLng": [
  //     37.3357,
  //     36.8762
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.336,
  //   "time": "2023-02-07 06:26:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 22 km NE of Nurda??, Turkey على عمق 37.336 كم بتاريخ 2023-02-07 06:26:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp3v"
  // },
  // "1301": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.1531,
  //     36.3488
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.153,
  //   "time": "2023-02-07 05:26:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Turkey-Syria border region على عمق 36.153 كم بتاريخ 2023-02-07 05:26:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm63#dyfi"
  // },
  // "1302": {
  //   "place": "7 km ENE of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.8131,
  //     36.6306
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.813,
  //   "time": "2023-02-07 04:42:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 7 km ENE of A?a?? Karafak?l?, Turkey على عمق 36.813 كم بتاريخ 2023-02-07 04:42:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm5v"
  // },
  // "1303": {
  //   "place": "6 km WNW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.507,
  //     37.227
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.507,
  //   "time": "2023-02-07 03:58:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 6 km WNW of Pazarc?k, Turkey على عمق 37.507 كم بتاريخ 2023-02-07 03:58:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp3k"
  // },
  // "1304": {
  //   "place": "2 km SSE of Büyük Dalyan, Turkey",
  //   "latLng": [
  //     36.2678,
  //     36.2151
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.268,
  //   "time": "2023-02-07 03:37:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 2 km SSE of Büyük Dalyan, Turkey على عمق 36.268 كم بتاريخ 2023-02-07 03:37:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm5j"
  // },
  // "1305": {
  //   "place": "15 km NNE of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.6089,
  //     37.3755
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.609,
  //   "time": "2023-02-07 03:16:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 15 km NNE of Pazarc?k, Turkey على عمق 37.609 كم بتاريخ 2023-02-07 03:16:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jp3y"
  // },
  // "1306": {
  //   "place": "23 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3373,
  //     37.1197
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.337,
  //   "time": "2023-02-07 03:02:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 23 km SW of Pazarc?k, Turkey على عمق 37.337 كم بتاريخ 2023-02-07 03:02:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm5a"
  // },
  // "1307": {
  //   "place": "10 km NW of Yaylada??, Turkey",
  //   "latLng": [
  //     35.9675,
  //     35.9849
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.968,
  //   "time": "2023-02-07 02:47:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 10 km NW of Yaylada??, Turkey على عمق 35.968 كم بتاريخ 2023-02-07 02:47:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm55#dyfi"
  // },
  // "1308": {
  //   "place": "45 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8303,
  //     55.2235
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.83,
  //   "time": "2023-02-07 02:30:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 45 km NE of Bandar-e Lengeh, Iran على عمق 26.83 كم بتاريخ 2023-02-07 02:30:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm52#dyfi"
  // },
  // "1309": {
  //   "place": "20 km SSE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4326,
  //     37.0521
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.433,
  //   "time": "2023-02-07 01:34:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 20 km SSE of Kahramanmara?, Turkey على عمق 37.433 كم بتاريخ 2023-02-07 01:34:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm4x#dyfi"
  // },
  // "1310": {
  //   "place": "39 km WNW of Latakia, Syria",
  //   "latLng": [
  //     35.6037,
  //     35.3598
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.604,
  //   "time": "2023-02-06 23:29:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 39 km WNW of Latakia, Syria على عمق 35.604 كم بتاريخ 2023-02-06 23:29:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm3x#dyfi"
  // },
  // "1311": {
  //   "place": "6 km SSW of Hassa, Turkey",
  //   "latLng": [
  //     36.7444,
  //     36.4904
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.744,
  //   "time": "2023-02-06 21:02:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 6 km SSW of Hassa, Turkey على عمق 36.744 كم بتاريخ 2023-02-06 21:02:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm2x"
  // },
  // "1312": {
  //   "place": "2 km SE of Dursunlu, Turkey",
  //   "latLng": [
  //     36.1512,
  //     36.1819
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.151,
  //   "time": "2023-02-06 20:45:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 2 km SE of Dursunlu, Turkey على عمق 36.151 كم بتاريخ 2023-02-06 20:45:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw4"
  // },
  // "1313": {
  //   "place": "32 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.2507,
  //     37.0859
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 37.251,
  //   "time": "2023-02-06 20:37:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 32 km SW of Pazarc?k, Turkey على عمق 37.251 كم بتاريخ 2023-02-06 20:37:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm2r#dyfi"
  // },
  // "1314": {
  //   "place": "13 km W of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4801,
  //     37.1528
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.48,
  //   "time": "2023-02-06 19:35:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 13 km W of Pazarc?k, Turkey على عمق 37.48 كم بتاريخ 2023-02-06 19:35:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm21#dyfi"
  // },
  // "1315": {
  //   "place": "11 km NNW of Musabeyli, Turkey",
  //   "latLng": [
  //     36.9819,
  //     36.8786
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.982,
  //   "time": "2023-02-06 18:51:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 11 km NNW of Musabeyli, Turkey على عمق 36.982 كم بتاريخ 2023-02-06 18:51:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnuk"
  // },
  // "1316": {
  //   "place": "17 km WNW of Musabeyli, Turkey",
  //   "latLng": [
  //     36.9291,
  //     36.7256
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.929,
  //   "time": "2023-02-06 18:49:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 17 km WNW of Musabeyli, Turkey على عمق 36.929 كم بتاريخ 2023-02-06 18:49:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw9"
  // },
  // "1317": {
  //   "place": "8 km S of Nurda??, Turkey",
  //   "latLng": [
  //     37.0895,
  //     36.7386
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.09,
  //   "time": "2023-02-06 17:31:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 8 km S of Nurda??, Turkey على عمق 37.09 كم بتاريخ 2023-02-06 17:31:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jly1"
  // },
  // "1318": {
  //   "place": "14 km SSW of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.6625,
  //     36.4828
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.663,
  //   "time": "2023-02-06 16:32:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 14 km SSW of A?a?? Karafak?l?, Turkey على عمق 36.663 كم بتاريخ 2023-02-06 16:32:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlt7#dyfi"
  // },
  // "1319": {
  //   "place": "14 km SSE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4633,
  //     36.981
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.463,
  //   "time": "2023-02-06 16:28:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 14 km SSE of Kahramanmara?, Turkey على عمق 37.463 كم بتاريخ 2023-02-06 16:28:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnu7"
  // },
  // "1320": {
  //   "place": "23 km W of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1064,
  //     35.7822
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.106,
  //   "time": "2023-02-06 16:10:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 23 km W of Uzunba?, Turkey على عمق 36.106 كم بتاريخ 2023-02-06 16:10:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlt0"
  // },
  // "1321": {
  //   "place": "2 km ENE of Hassa, Turkey",
  //   "latLng": [
  //     36.8097,
  //     36.5387
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.81,
  //   "time": "2023-02-06 14:27:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 2 km ENE of Hassa, Turkey على عمق 36.81 كم بتاريخ 2023-02-06 14:27:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlse"
  // },
  // "1322": {
  //   "place": "5 km E of Uzunkavak, Turkey",
  //   "latLng": [
  //     36.3454,
  //     36.4775
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.345,
  //   "time": "2023-02-06 13:36:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 5 km E of Uzunkavak, Turkey على عمق 36.345 كم بتاريخ 2023-02-06 13:36:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntr"
  // },
  // "1323": {
  //   "place": "6 km NW of Uzunkavak, Turkey",
  //   "latLng": [
  //     36.3959,
  //     36.3691
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.396,
  //   "time": "2023-02-06 13:31:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 6 km NW of Uzunkavak, Turkey على عمق 36.396 كم بتاريخ 2023-02-06 13:31:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntn"
  // },
  // "1324": {
  //   "place": "4 km E of Kastal, Turkey",
  //   "latLng": [
  //     36.2541,
  //     36.2923
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.254,
  //   "time": "2023-02-06 13:09:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 4 km E of Kastal, Turkey على عمق 36.254 كم بتاريخ 2023-02-06 13:09:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jntm"
  // },
  // "1325": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.6189,
  //     37.9263
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.619,
  //   "time": "2023-02-06 10:50:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Central Turkey على عمق 37.619 كم بتاريخ 2023-02-06 10:50:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlqm"
  // },
  // "1326": {
  //   "place": "11 km SE of Yaylada??, Turkey",
  //   "latLng": [
  //     35.8319,
  //     36.162
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 35.832,
  //   "time": "2023-02-06 10:07:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 11 km SE of Yaylada??, Turkey على عمق 35.832 كم بتاريخ 2023-02-06 10:07:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlqc"
  // },
  // "1327": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.3147,
  //     36.7946
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.315,
  //   "time": "2023-02-06 09:36:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Central Turkey على عمق 37.315 كم بتاريخ 2023-02-06 09:36:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlq5#dyfi"
  // },
  // "1328": {
  //   "place": "15 km NNW of Hassa, Turkey",
  //   "latLng": [
  //     36.9214,
  //     36.427
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.921,
  //   "time": "2023-02-06 09:23:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 15 km NNW of Hassa, Turkey على عمق 36.921 كم بتاريخ 2023-02-06 09:23:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlq1"
  // },
  // "1329": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.4633,
  //     37.2102
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 37.463,
  //   "time": "2023-02-06 08:52:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في Central Turkey على عمق 37.463 كم بتاريخ 2023-02-06 08:52:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlpv"
  // },
  // "1330": {
  //   "place": "11 km WNW of Uzunba?, Turkey",
  //   "latLng": [
  //     36.1795,
  //     35.9229
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.18,
  //   "time": "2023-02-06 08:26:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 11 km WNW of Uzunba?, Turkey على عمق 36.18 كم بتاريخ 2023-02-06 08:26:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsq"
  // },
  // "1331": {
  //   "place": "44 km W of Latakia, Syria",
  //   "latLng": [
  //     35.6075,
  //     35.3088
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.608,
  //   "time": "2023-02-06 08:12:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 44 km W of Latakia, Syria على عمق 35.608 كم بتاريخ 2023-02-06 08:12:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsl"
  // },
  // "1332": {
  //   "place": "14 km NNE of K?r?khan, Turkey",
  //   "latLng": [
  //     36.6219,
  //     36.4225
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.622,
  //   "time": "2023-02-06 08:01:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 14 km NNE of K?r?khan, Turkey على عمق 36.622 كم بتاريخ 2023-02-06 08:01:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlpp"
  // },
  // "1333": {
  //   "place": "19 km WNW of Latakia, Syria",
  //   "latLng": [
  //     35.5907,
  //     35.5841
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.591,
  //   "time": "2023-02-06 07:54:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km WNW of Latakia, Syria على عمق 35.591 كم بتاريخ 2023-02-06 07:54:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsh"
  // },
  // "1334": {
  //   "place": "28 km WNW of Latakia, Syria",
  //   "latLng": [
  //     35.6445,
  //     35.5034
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.645,
  //   "time": "2023-02-06 07:29:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 28 km WNW of Latakia, Syria على عمق 35.645 كم بتاريخ 2023-02-06 07:29:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsf"
  // },
  // "1335": {
  //   "place": "5 km SSE of Dörtyol, Turkey",
  //   "latLng": [
  //     36.7978,
  //     36.2602
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.798,
  //   "time": "2023-02-06 07:24:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 5 km SSE of Dörtyol, Turkey على عمق 36.798 كم بتاريخ 2023-02-06 07:24:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsc"
  // },
  // "1336": {
  //   "place": "10 km NNW of K?r?khan, Turkey",
  //   "latLng": [
  //     36.595,
  //     36.3297
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.595,
  //   "time": "2023-02-06 07:10:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 10 km NNW of K?r?khan, Turkey على عمق 36.595 كم بتاريخ 2023-02-06 07:10:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnte"
  // },
  // "1337": {
  //   "place": "11 km SW of Hassa, Turkey",
  //   "latLng": [
  //     36.7139,
  //     36.4459
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.714,
  //   "time": "2023-02-06 07:08:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 11 km SW of Hassa, Turkey على عمق 36.714 كم بتاريخ 2023-02-06 07:08:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlpb#dyfi"
  // },
  // "1338": {
  //   "place": "18 km SE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.47,
  //     37.0824
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.47,
  //   "time": "2023-02-06 06:59:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 18 km SE of Kahramanmara?, Turkey على عمق 37.47 كم بتاريخ 2023-02-06 06:59:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns8"
  // },
  // "1339": {
  //   "place": "14 km SE of Ça?layancerit, Turkey",
  //   "latLng": [
  //     37.6427,
  //     37.394
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 37.643,
  //   "time": "2023-02-06 06:54:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 14 km SE of Ça?layancerit, Turkey على عمق 37.643 كم بتاريخ 2023-02-06 06:54:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlp9"
  // },
  // "1340": {
  //   "place": "16 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3961,
  //     37.1506
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.396,
  //   "time": "2023-02-06 06:26:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 16 km SW of Pazarc?k, Turkey على عمق 37.396 كم بتاريخ 2023-02-06 06:26:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlsg"
  // },
  // "1341": {
  //   "place": "19 km S of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4072,
  //     36.9513
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.407,
  //   "time": "2023-02-06 06:14:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km S of Kahramanmara?, Turkey على عمق 37.407 كم بتاريخ 2023-02-06 06:14:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns3"
  // },
  // "1342": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.3265,
  //     36.4042
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.327,
  //   "time": "2023-02-06 05:44:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Turkey-Syria border region على عمق 36.327 كم بتاريخ 2023-02-06 05:44:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvf"
  // },
  // "1343": {
  //   "place": "3 km S of Büyük Dalyan, Turkey",
  //   "latLng": [
  //     36.2606,
  //     36.2043
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.261,
  //   "time": "2023-02-06 05:43:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 3 km S of Büyük Dalyan, Turkey على عمق 36.261 كم بتاريخ 2023-02-06 05:43:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns1"
  // },
  // "1344": {
  //   "place": "1 km N of Büyük Dalyan, Turkey",
  //   "latLng": [
  //     36.2975,
  //     36.2085
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.298,
  //   "time": "2023-02-06 05:36:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 1 km N of Büyük Dalyan, Turkey على عمق 36.298 كم بتاريخ 2023-02-06 05:36:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlp0"
  // },
  // "1345": {
  //   "place": "6 km N of Serinyol, Turkey",
  //   "latLng": [
  //     36.4188,
  //     36.2183
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.419,
  //   "time": "2023-02-06 05:35:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 6 km N of Serinyol, Turkey على عمق 36.419 كم بتاريخ 2023-02-06 05:35:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jns0"
  // },
  // "1346": {
  //   "place": "12 km E of Yavuzeli, Turkey",
  //   "latLng": [
  //     37.3082,
  //     37.7106
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.308,
  //   "time": "2023-02-06 05:22:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 12 km E of Yavuzeli, Turkey على عمق 37.308 كم بتاريخ 2023-02-06 05:22:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlnx"
  // },
  // "1347": {
  //   "place": "9 km W of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4966,
  //     37.1888
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.497,
  //   "time": "2023-02-06 05:12:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 9 km W of Pazarc?k, Turkey على عمق 37.497 كم بتاريخ 2023-02-06 05:12:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrx"
  // },
  // "1348": {
  //   "place": "23 km WSW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3768,
  //     37.0793
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.377,
  //   "time": "2023-02-06 05:04:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 23 km WSW of Pazarc?k, Turkey على عمق 37.377 كم بتاريخ 2023-02-06 05:04:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvb"
  // },
  // "1349": {
  //   "place": "12 km WSW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4609,
  //     37.1603
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.461,
  //   "time": "2023-02-06 04:56:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 12 km WSW of Pazarc?k, Turkey على عمق 37.461 كم بتاريخ 2023-02-06 04:56:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlnu"
  // },
  // "1350": {
  //   "place": "9 km SSW of Hassa, Turkey",
  //   "latLng": [
  //     36.7176,
  //     36.4733
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.718,
  //   "time": "2023-02-06 04:47:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 9 km SSW of Hassa, Turkey على عمق 36.718 كم بتاريخ 2023-02-06 04:47:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlns"
  // },
  // "1351": {
  //   "place": "2 km NE of Uzunkavak, Turkey",
  //   "latLng": [
  //     36.3649,
  //     36.4413
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.365,
  //   "time": "2023-02-06 04:31:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 2 km NE of Uzunkavak, Turkey على عمق 36.365 كم بتاريخ 2023-02-06 04:31:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsd"
  // },
  // "1352": {
  //   "place": "19 km NE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2919,
  //     36.8854
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.292,
  //   "time": "2023-02-06 04:31:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km NE of Nurda??, Turkey على عمق 37.292 كم بتاريخ 2023-02-06 04:31:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrs"
  // },
  // "1353": {
  //   "place": "11 km NW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.555,
  //     37.2001
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.555,
  //   "time": "2023-02-06 04:24:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 11 km NW of Pazarc?k, Turkey على عمق 37.555 كم بتاريخ 2023-02-06 04:24:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvd"
  // },
  // "1354": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.5236,
  //     37.2784
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.524,
  //   "time": "2023-02-06 04:16:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Central Turkey على عمق 37.524 كم بتاريخ 2023-02-06 04:16:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlnd#dyfi"
  // },
  // "1355": {
  //   "place": "18 km ESE of Nurda??, Turkey",
  //   "latLng": [
  //     37.0844,
  //     36.9133
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.084,
  //   "time": "2023-02-06 04:05:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 18 km ESE of Nurda??, Turkey على عمق 37.084 كم بتاريخ 2023-02-06 04:05:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrp"
  // },
  // "1356": {
  //   "place": "17 km NNE of K?r?khan, Turkey",
  //   "latLng": [
  //     36.6427,
  //     36.426
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.643,
  //   "time": "2023-02-06 03:58:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 17 km NNE of K?r?khan, Turkey على عمق 36.643 كم بتاريخ 2023-02-06 03:58:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrn#dyfi"
  // },
  // "1357": {
  //   "place": "20 km S of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.3982,
  //     36.8946
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.398,
  //   "time": "2023-02-06 03:55:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 20 km S of Kahramanmara?, Turkey على عمق 37.398 كم بتاريخ 2023-02-06 03:55:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnrr"
  // },
  // "1358": {
  //   "place": "30 km NW of Gaziantep, Turkey",
  //   "latLng": [
  //     37.2442,
  //     37.1335
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.244,
  //   "time": "2023-02-06 03:41:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km NW of Gaziantep, Turkey على عمق 37.244 كم بتاريخ 2023-02-06 03:41:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsv"
  // },
  // "1359": {
  //   "place": "15 km S of Nurda??, Turkey",
  //   "latLng": [
  //     37.0297,
  //     36.7506
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.03,
  //   "time": "2023-02-06 03:30:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 15 km S of Nurda??, Turkey على عمق 37.03 كم بتاريخ 2023-02-06 03:30:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnri"
  // },
  // "1360": {
  //   "place": "2 km ENE of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.5003,
  //     37.3267
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.5,
  //   "time": "2023-02-06 03:12:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 2 km ENE of Pazarc?k, Turkey على عمق 37.5 كم بتاريخ 2023-02-06 03:12:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jln3#dyfi"
  // },
  // "1361": {
  //   "place": "14 km ENE of Denizciler, Turkey",
  //   "latLng": [
  //     36.7084,
  //     36.3519
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.708,
  //   "time": "2023-02-06 02:54:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 14 km ENE of Denizciler, Turkey على عمق 36.708 كم بتاريخ 2023-02-06 02:54:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmv#dyfi"
  // },
  // "1362": {
  //   "place": "12 km WNW of Hassa, Turkey",
  //   "latLng": [
  //     36.8497,
  //     36.3895
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.85,
  //   "time": "2023-02-06 02:43:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 12 km WNW of Hassa, Turkey على عمق 36.85 كم بتاريخ 2023-02-06 02:43:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnvz"
  // },
  // "1363": {
  //   "place": "24 km NNE of Musabeyli, Turkey",
  //   "latLng": [
  //     37.0822,
  //     37.0363
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.082,
  //   "time": "2023-02-06 02:34:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 24 km NNE of Musabeyli, Turkey على عمق 37.082 كم بتاريخ 2023-02-06 02:34:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsj"
  // },
  // "1364": {
  //   "place": "6 km W of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4941,
  //     37.2266
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.494,
  //   "time": "2023-02-06 02:34:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 6 km W of Pazarc?k, Turkey على عمق 37.494 كم بتاريخ 2023-02-06 02:34:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnry"
  // },
  // "1365": {
  //   "place": "15 km WNW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.5639,
  //     37.1467
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.564,
  //   "time": "2023-02-06 02:32:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 15 km WNW of Pazarc?k, Turkey على عمق 37.564 كم بتاريخ 2023-02-06 02:32:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw0"
  // },
  // "1366": {
  //   "place": "21 km SSW of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4137,
  //     36.8216
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 37.414,
  //   "time": "2023-02-06 02:31:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 21 km SSW of Kahramanmara?, Turkey على عمق 37.414 كم بتاريخ 2023-02-06 02:31:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnsi"
  // },
  // "1367": {
  //   "place": "Central Turkey",
  //   "latLng": [
  //     37.4292,
  //     36.9502
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.429,
  //   "time": "2023-02-06 02:28:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Central Turkey على عمق 37.429 كم بتاريخ 2023-02-06 02:28:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnw1"
  // },
  // "1368": {
  //   "place": "20 km E of Nurda??, Turkey",
  //   "latLng": [
  //     37.1816,
  //     36.9658
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 37.182,
  //   "time": "2023-02-06 02:23:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 20 km E of Nurda??, Turkey على عمق 37.182 كم بتاريخ 2023-02-06 02:23:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmn#dyfi"
  // },
  // "1369": {
  //   "place": "20 km SE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4358,
  //     37.0658
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.436,
  //   "time": "2023-02-06 02:21:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 20 km SE of Kahramanmara?, Turkey على عمق 37.436 كم بتاريخ 2023-02-06 02:21:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmn5"
  // },
  // "1370": {
  //   "place": "7 km S of Nurda??, Turkey",
  //   "latLng": [
  //     37.1024,
  //     36.7301
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 37.102,
  //   "time": "2023-02-06 02:17:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 7 km S of Nurda??, Turkey على عمق 37.102 كم بتاريخ 2023-02-06 02:17:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmm"
  // },
  // "1371": {
  //   "place": "18 km SE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4468,
  //     37.0449
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.447,
  //   "time": "2023-02-06 02:16:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 18 km SE of Kahramanmara?, Turkey على عمق 37.447 كم بتاريخ 2023-02-06 02:16:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmn3"
  // },
  // "1372": {
  //   "place": "16 km NE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2863,
  //     36.8539
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.286,
  //   "time": "2023-02-06 02:13:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 16 km NE of Nurda??, Turkey على عمق 37.286 كم بتاريخ 2023-02-06 02:13:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnra"
  // },
  // "1373": {
  //   "place": "23 km SW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3512,
  //     37.095
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 37.351,
  //   "time": "2023-02-06 02:01:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 23 km SW of Pazarc?k, Turkey على عمق 37.351 كم بتاريخ 2023-02-06 02:01:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmy"
  // },
  // "1374": {
  //   "place": "12 km SSE of Hasanbeyli, Turkey",
  //   "latLng": [
  //     37.0302,
  //     36.6208
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 37.03,
  //   "time": "2023-02-06 01:58:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 12 km SSE of Hasanbeyli, Turkey على عمق 37.03 كم بتاريخ 2023-02-06 01:58:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlmf"
  // },
  // "1375": {
  //   "place": "57 km W of B?niy?s, Syria",
  //   "latLng": [
  //     35.1453,
  //     35.3142
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.145,
  //   "time": "2023-02-06 01:57:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 57 km W of B?niy?s, Syria على عمق 35.145 كم بتاريخ 2023-02-06 01:57:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnse"
  // },
  // "1376": {
  //   "place": "2 km ENE of Bahçe, Turkey",
  //   "latLng": [
  //     37.2073,
  //     36.5988
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 37.207,
  //   "time": "2023-02-06 01:55:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 2 km ENE of Bahçe, Turkey على عمق 37.207 كم بتاريخ 2023-02-06 01:55:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnru"
  // },
  // "1377": {
  //   "place": "3 km W of Serinyol, Turkey",
  //   "latLng": [
  //     36.3603,
  //     36.1708
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.36,
  //   "time": "2023-02-06 01:54:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 3 km W of Serinyol, Turkey على عمق 36.36 كم بتاريخ 2023-02-06 01:54:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr7"
  // },
  // "1378": {
  //   "place": "12 km W of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4756,
  //     37.1578
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.476,
  //   "time": "2023-02-06 01:51:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 12 km W of Pazarc?k, Turkey على عمق 37.476 كم بتاريخ 2023-02-06 01:51:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm4n"
  // },
  // "1379": {
  //   "place": "8 km SE of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.7205,
  //     36.6192
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.721,
  //   "time": "2023-02-06 01:51:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 8 km SE of A?a?? Karafak?l?, Turkey على عمق 36.721 كم بتاريخ 2023-02-06 01:51:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr6"
  // },
  // "1380": {
  //   "place": "14 km SSW of A?a?? Karafak?l?, Turkey",
  //   "latLng": [
  //     36.6696,
  //     36.4767
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.67,
  //   "time": "2023-02-06 01:40:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 14 km SSW of A?a?? Karafak?l?, Turkey على عمق 36.67 كم بتاريخ 2023-02-06 01:40:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jnr5"
  // },
  // "1381": {
  //   "place": "Turkey-Syria border region",
  //   "latLng": [
  //     36.9921,
  //     36.6832
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 36.992,
  //   "time": "2023-02-06 01:36:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في Turkey-Syria border region على عمق 36.992 كم بتاريخ 2023-02-06 01:36:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlm9#pager"
  // },
  // "1382": {
  //   "place": "14 km E of Nurda??, Turkey",
  //   "latLng": [
  //     37.1893,
  //     36.8929
  //   ],
  //   "magnitude": 6.7,
  //   "depth": 37.189,
  //   "time": "2023-02-06 01:28:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.7 درجة في 14 km E of Nurda??, Turkey على عمق 37.189 كم بتاريخ 2023-02-06 01:28:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlm1#pager"
  // },
  // "1383": {
  //   "place": "24 km ENE of Nurda??, Turkey",
  //   "latLng": [
  //     37.2252,
  //     37.0001
  //   ],
  //   "magnitude": 5.7,
  //   "depth": 37.225,
  //   "time": "2023-02-06 01:26:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.7 درجة في 24 km ENE of Nurda??, Turkey على عمق 37.225 كم بتاريخ 2023-02-06 01:26:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlnn#pager"
  // },
  // "1384": {
  //   "place": "Pazarcik earthquake, Kahramanmaras earthquake sequence",
  //   "latLng": [
  //     37.2256,
  //     37.0143
  //   ],
  //   "magnitude": 7.8,
  //   "depth": 37.226,
  //   "time": "2023-02-06 01:17:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 7.8 درجة في Pazarcik earthquake, Kahramanmaras earthquake sequence على عمق 37.226 كم بتاريخ 2023-02-06 01:17:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jllz#pager"
  // },
  // "1385": {
  //   "place": "20 km SW of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.3241,
  //     45.7059
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.324,
  //   "time": "2023-02-04 02:45:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 20 km SW of Sarpol-e Z?ah?b, Iran على عمق 34.324 كم بتاريخ 2023-02-04 02:45:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlbp#dyfi"
  // },
  // "1386": {
  //   "place": "6 km W of Bahçe, Turkey",
  //   "latLng": [
  //     37.2003,
  //     36.4998
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.2,
  //   "time": "2023-02-03 11:05:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 6 km W of Bahçe, Turkey على عمق 37.2 كم بتاريخ 2023-02-03 11:05:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jl5l"
  // },
  // "1387": {
  //   "place": "101 km NNW of Bela, Pakistan",
  //   "latLng": [
  //     27.0533,
  //     65.8629
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 27.053,
  //   "time": "2023-02-02 03:44:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 101 km NNW of Bela, Pakistan على عمق 27.053 كم بتاريخ 2023-02-02 03:44:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jkwt"
  // },
  // "1388": {
  //   "place": "Hindu Kush region, Afghanistan",
  //   "latLng": [
  //     36.2121,
  //     68.7661
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.212,
  //   "time": "2023-02-01 14:29:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في Hindu Kush region, Afghanistan على عمق 36.212 كم بتاريخ 2023-02-01 14:29:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jkru"
  // },
  // "1389": {
  //   "place": "27 km ENE of Kaka, Turkmenistan",
  //   "latLng": [
  //     37.4221,
  //     59.9086
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.422,
  //   "time": "2023-02-01 05:41:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 27 km ENE of Kaka, Turkmenistan على عمق 37.422 كم بتاريخ 2023-02-01 05:41:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jknr"
  // },
  // "1390": {
  //   "place": "26 km N of Latakia, Syria",
  //   "latLng": [
  //     35.7692,
  //     35.7431
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.769,
  //   "time": "2023-01-29 16:12:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 26 km N of Latakia, Syria على عمق 35.769 كم بتاريخ 2023-01-29 16:12:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jk69#dyfi"
  // },
  // "1391": {
  //   "place": "Southern Iran",
  //   "latLng": [
  //     30.6967,
  //     50.3487
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 30.697,
  //   "time": "2023-01-28 14:08:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Southern Iran على عمق 30.697 كم بتاريخ 2023-01-28 14:08:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jmw9"
  // },
  // "1392": {
  //   "place": "29 km SE of Mandal?, Iraq",
  //   "latLng": [
  //     33.5843,
  //     45.8112
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 33.584,
  //   "time": "2023-01-28 13:53:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 29 km SE of Mandal?, Iraq على عمق 33.584 كم بتاريخ 2023-01-28 13:53:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjzp"
  // },
  // "1393": {
  //   "place": "16 km E of Behbah?n, Iran",
  //   "latLng": [
  //     30.5806,
  //     50.4151
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 30.581,
  //   "time": "2023-01-27 09:36:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 16 km E of Behbah?n, Iran على عمق 30.581 كم بتاريخ 2023-01-27 09:36:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjmx"
  // },
  // "1394": {
  //   "place": "9 km NE of Bor?zj?n, Iran",
  //   "latLng": [
  //     29.3378,
  //     51.2763
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 29.338,
  //   "time": "2023-01-27 06:19:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 9 km NE of Bor?zj?n, Iran على عمق 29.338 كم بتاريخ 2023-01-27 06:19:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jm0s"
  // },
  // "1395": {
  //   "place": "10 km SW of Khulm, Afghanistan",
  //   "latLng": [
  //     36.6217,
  //     67.6255
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.622,
  //   "time": "2023-01-26 23:38:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 10 km SW of Khulm, Afghanistan على عمق 36.622 كم بتاريخ 2023-01-26 23:38:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjkl"
  // },
  // "1396": {
  //   "place": "76 km ENE of Loyada, Djibouti",
  //   "latLng": [
  //     11.6466,
  //     43.9274
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 11.647,
  //   "time": "2023-01-26 13:05:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 76 km ENE of Loyada, Djibouti على عمق 11.647 كم بتاريخ 2023-01-26 13:05:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjdl#dyfi"
  // },
  // "1397": {
  //   "place": "94 km NW of Semera, Ethiopia",
  //   "latLng": [
  //     12.5018,
  //     40.5205
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.502,
  //   "time": "2023-01-25 23:38:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 94 km NW of Semera, Ethiopia على عمق 12.502 كم بتاريخ 2023-01-25 23:38:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjan"
  // },
  // "1398": {
  //   "place": "60 km SE of Lárdos, Greece",
  //   "latLng": [
  //     35.7086,
  //     28.4965
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 35.709,
  //   "time": "2023-01-25 12:37:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.9 درجة في 60 km SE of Lárdos, Greece على عمق 35.709 كم بتاريخ 2023-01-25 12:37:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jj5k#pager"
  // },
  // "1399": {
  //   "place": "106 km WNW of Pégeia, Cyprus",
  //   "latLng": [
  //     35.1548,
  //     31.2583
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.155,
  //   "time": "2023-01-24 05:59:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 106 km WNW of Pégeia, Cyprus على عمق 35.155 كم بتاريخ 2023-01-24 05:59:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jlus"
  // },
  // "1400": {
  //   "place": "12 km ENE of Tallkalakh, Syria",
  //   "latLng": [
  //     34.7103,
  //     36.3823
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.71,
  //   "time": "2023-01-21 13:31:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 12 km ENE of Tallkalakh, Syria على عمق 34.71 كم بتاريخ 2023-01-21 13:31:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j62n#dyfi"
  // },
  // "1401": {
  //   "place": "58 km SSW of Türkler, Turkey",
  //   "latLng": [
  //     36.089,
  //     31.6537
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.089,
  //   "time": "2023-01-20 05:37:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 58 km SSW of Türkler, Turkey على عمق 36.089 كم بتاريخ 2023-01-20 05:37:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5ps"
  // },
  // "1402": {
  //   "place": "4 km WNW of Loyada, Djibouti",
  //   "latLng": [
  //     11.4722,
  //     43.2172
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 11.472,
  //   "time": "2023-01-18 19:28:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 4 km WNW of Loyada, Djibouti على عمق 11.472 كم بتاريخ 2023-01-18 19:28:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5bc"
  // },
  // "1403": {
  //   "place": "4 km NNW of Erzin, Turkey",
  //   "latLng": [
  //     36.9911,
  //     36.1694
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.991,
  //   "time": "2023-01-18 13:30:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 4 km NNW of Erzin, Turkey على عمق 36.991 كم بتاريخ 2023-01-18 13:30:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jjfc"
  // },
  // "1404": {
  //   "place": "20 km SW of Sari, Iran",
  //   "latLng": [
  //     36.4204,
  //     52.9186
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.42,
  //   "time": "2023-01-17 17:43:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 20 km SW of Sari, Iran على عمق 36.42 كم بتاريخ 2023-01-17 17:43:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j4y6#dyfi"
  // },
  // "1405": {
  //   "place": "6 km NNE of Kh?n Shaykh?n, Syria",
  //   "latLng": [
  //     35.5003,
  //     36.6702
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.5,
  //   "time": "2023-01-12 20:40:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 6 km NNE of Kh?n Shaykh?n, Syria على عمق 35.5 كم بتاريخ 2023-01-12 20:40:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j400"
  // },
  // "1406": {
  //   "place": "48 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8041,
  //     55.2808
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.804,
  //   "time": "2023-01-12 08:44:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 48 km NE of Bandar-e Lengeh, Iran على عمق 26.804 كم بتاريخ 2023-01-12 08:44:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5tr"
  // },
  // "1407": {
  //   "place": "37 km NW of K?sh, Iran",
  //   "latLng": [
  //     26.8052,
  //     53.7556
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.805,
  //   "time": "2023-01-12 01:22:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 37 km NW of K?sh, Iran على عمق 26.805 كم بتاريخ 2023-01-12 01:22:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5te"
  // },
  // "1408": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     6.2073,
  //     60.8238
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 6.207,
  //   "time": "2023-01-11 11:11:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Carlsberg Ridge على عمق 6.207 كم بتاريخ 2023-01-11 11:11:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5rb"
  // },
  // "1409": {
  //   "place": "54 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6733,
  //     56.1838
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.673,
  //   "time": "2023-01-10 16:17:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 54 km N of Bandar Abbas, Iran على عمق 27.673 كم بتاريخ 2023-01-10 16:17:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j3et"
  // },
  // "1410": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     6.0367,
  //     60.7381
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 6.037,
  //   "time": "2023-01-10 12:04:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Carlsberg Ridge على عمق 6.037 كم بتاريخ 2023-01-10 12:04:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j5jf"
  // },
  // "1411": {
  //   "place": "93 km SSW of Faras?n, Saudi Arabia",
  //   "latLng": [
  //     15.9298,
  //     41.7705
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 15.93,
  //   "time": "2023-01-09 21:28:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 93 km SSW of Faras?n, Saudi Arabia على عمق 15.93 كم بتاريخ 2023-01-09 21:28:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j3a6"
  // },
  // "1412": {
  //   "place": "90 km SSW of Faras?n, Saudi Arabia",
  //   "latLng": [
  //     15.9878,
  //     41.6999
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 15.988,
  //   "time": "2023-01-09 17:31:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 90 km SSW of Faras?n, Saudi Arabia على عمق 15.988 كم بتاريخ 2023-01-09 17:31:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j36e"
  // },
  // "1413": {
  //   "place": "218 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.266,
  //     51.7999
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.266,
  //   "time": "2023-01-06 17:14:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 218 km S of Al Ghayz?ah, Yemen على عمق 14.266 كم بتاريخ 2023-01-06 17:14:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j4w6"
  // },
  // "1414": {
  //   "place": "31 km SSW of Kunduz, Afghanistan",
  //   "latLng": [
  //     36.4511,
  //     68.7722
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.451,
  //   "time": "2023-01-05 22:45:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 31 km SSW of Kunduz, Afghanistan على عمق 36.451 كم بتاريخ 2023-01-05 22:45:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j2f5"
  // },
  // "1415": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8335,
  //     55.1568
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.834,
  //   "time": "2023-01-04 16:19:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في southern Iran على عمق 26.834 كم بتاريخ 2023-01-04 16:19:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j23c"
  // },
  // "1416": {
  //   "place": "6 km NNW of Khorramabad, Iran",
  //   "latLng": [
  //     33.5482,
  //     48.3346
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.548,
  //   "time": "2022-12-31 17:05:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 6 km NNW of Khorramabad, Iran على عمق 33.548 كم بتاريخ 2022-12-31 17:05:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j1a0"
  // },
  // "1417": {
  //   "place": "97 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.953,
  //     55.786
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.953,
  //   "time": "2022-12-28 16:51:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 97 km NNW of Bandar Abbas, Iran على عمق 27.953 كم بتاريخ 2022-12-28 16:51:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0nb"
  // },
  // "1418": {
  //   "place": "64 km NE of ?d?grat, Ethiopia",
  //   "latLng": [
  //     14.6191,
  //     39.9519
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 14.619,
  //   "time": "2022-12-28 16:14:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 64 km NE of ?d?grat, Ethiopia على عمق 14.619 كم بتاريخ 2022-12-28 16:14:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0n0"
  // },
  // "1419": {
  //   "place": "57 km ESE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     14.6695,
  //     39.8764
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.67,
  //   "time": "2022-12-28 14:35:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 57 km ESE of Adi Keyh, Eritrea على عمق 14.67 كم بتاريخ 2022-12-28 14:35:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0mq"
  // },
  // "1420": {
  //   "place": "61 km NE of ?d?grat, Ethiopia",
  //   "latLng": [
  //     14.6133,
  //     39.9196
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.613,
  //   "time": "2022-12-28 14:02:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 61 km NE of ?d?grat, Ethiopia على عمق 14.613 كم بتاريخ 2022-12-28 14:02:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0mg"
  // },
  // "1421": {
  //   "place": "23 km WSW of Chlórakas, Cyprus",
  //   "latLng": [
  //     34.7002,
  //     32.1847
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.7,
  //   "time": "2022-12-28 02:11:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 23 km WSW of Chlórakas, Cyprus على عمق 34.7 كم بتاريخ 2022-12-28 02:11:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j0k7#dyfi"
  // },
  // "1422": {
  //   "place": "Eritrea-Ethiopia border region",
  //   "latLng": [
  //     14.5572,
  //     39.8087
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.557,
  //   "time": "2022-12-28 02:00:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Eritrea-Ethiopia border region على عمق 14.557 كم بتاريخ 2022-12-28 02:00:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j3f1"
  // },
  // "1423": {
  //   "place": "28 km WSW of El-Tor, Egypt",
  //   "latLng": [
  //     28.1144,
  //     33.3703
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 28.114,
  //   "time": "2022-12-27 00:11:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 28 km WSW of El-Tor, Egypt على عمق 28.114 كم بتاريخ 2022-12-27 00:11:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbvn#dyfi"
  // },
  // "1424": {
  //   "place": "31 km ENE of ?d?grat, Ethiopia",
  //   "latLng": [
  //     14.3833,
  //     39.7343
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.383,
  //   "time": "2022-12-26 16:27:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 31 km ENE of ?d?grat, Ethiopia على عمق 14.383 كم بتاريخ 2022-12-26 16:27:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbtc"
  // },
  // "1425": {
  //   "place": "53 km ENE of ?d?grat, Ethiopia",
  //   "latLng": [
  //     14.5316,
  //     39.8811
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.532,
  //   "time": "2022-12-26 14:09:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 53 km ENE of ?d?grat, Ethiopia على عمق 14.532 كم بتاريخ 2022-12-26 14:09:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j2l0"
  // },
  // "1426": {
  //   "place": "66 km ENE of ?d?grat, Ethiopia",
  //   "latLng": [
  //     14.5212,
  //     40.0211
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 14.521,
  //   "time": "2022-12-26 12:21:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 66 km ENE of ?d?grat, Ethiopia على عمق 14.521 كم بتاريخ 2022-12-26 12:21:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbsk#pager"
  // },
  // "1427": {
  //   "place": "35 km SSE of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.5611,
  //     52.7403
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.561,
  //   "time": "2022-12-25 21:55:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 35 km SSE of F?r?z?b?d, Iran على عمق 28.561 كم بتاريخ 2022-12-25 21:55:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j2jz"
  // },
  // "1428": {
  //   "place": "Northeastern Iran",
  //   "latLng": [
  //     34.1297,
  //     57.1703
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.13,
  //   "time": "2022-12-25 17:49:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Northeastern Iran على عمق 34.13 كم بتاريخ 2022-12-25 17:49:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbmj"
  // },
  // "1429": {
  //   "place": "79 km SSE of Bor?zj?n, Iran",
  //   "latLng": [
  //     28.6564,
  //     51.6318
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.656,
  //   "time": "2022-12-25 16:48:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 79 km SSE of Bor?zj?n, Iran على عمق 28.656 كم بتاريخ 2022-12-25 16:48:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbma"
  // },
  // "1430": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     27.716,
  //     56.2185
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.716,
  //   "time": "2022-12-24 20:20:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في southern Iran على عمق 27.716 كم بتاريخ 2022-12-24 20:20:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000j2bq"
  // },
  // "1431": {
  //   "place": "53 km NNE of Tabas, Iran",
  //   "latLng": [
  //     34.0313,
  //     57.1703
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 34.031,
  //   "time": "2022-12-24 13:24:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 53 km NNE of Tabas, Iran على عمق 34.031 كم بتاريخ 2022-12-24 13:24:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbg1#dyfi"
  // },
  // "1432": {
  //   "place": "26 km W of Gaziantep, Turkey",
  //   "latLng": [
  //     37.1006,
  //     37.0917
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.101,
  //   "time": "2022-12-23 17:23:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 26 km W of Gaziantep, Turkey على عمق 37.101 كم بتاريخ 2022-12-23 17:23:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000jbbd"
  // },
  // "1433": {
  //   "place": "7 km NE of Uzunkavak, Turkey",
  //   "latLng": [
  //     36.392,
  //     36.4912
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.392,
  //   "time": "2022-12-18 18:13:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 7 km NE of Uzunkavak, Turkey على عمق 36.392 كم بتاريخ 2022-12-18 18:13:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ja6e#dyfi"
  // },
  // "1434": {
  //   "place": "46 km NNE of Tabas, Iran",
  //   "latLng": [
  //     33.9776,
  //     57.144
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 33.978,
  //   "time": "2022-12-13 14:14:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 46 km NNE of Tabas, Iran على عمق 33.978 كم بتاريخ 2022-12-13 14:14:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j8zz#dyfi"
  // },
  // "1435": {
  //   "place": "25 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.7486,
  //     55.0158
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.749,
  //   "time": "2022-12-12 03:57:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 25 km NNE of Bandar-e Lengeh, Iran على عمق 26.749 كم بتاريخ 2022-12-12 03:57:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j8ps#dyfi"
  // },
  // "1436": {
  //   "place": "western Iran",
  //   "latLng": [
  //     32.509,
  //     48.9717
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 32.509,
  //   "time": "2022-12-11 08:05:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في western Iran على عمق 32.509 كم بتاريخ 2022-12-11 08:05:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j8k2"
  // },
  // "1437": {
  //   "place": "10 km W of Ula, Turkey",
  //   "latLng": [
  //     37.0933,
  //     28.3024
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.093,
  //   "time": "2022-12-10 23:29:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 10 km W of Ula, Turkey على عمق 37.093 كم بتاريخ 2022-12-10 23:29:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j8ht"
  // },
  // "1438": {
  //   "place": "60 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.0737,
  //     27.0127
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.074,
  //   "time": "2022-12-09 18:44:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 60 km S of Mandráki, Greece على عمق 36.074 كم بتاريخ 2022-12-09 18:44:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j87w"
  // },
  // "1439": {
  //   "place": "20 km NE of Mohr, Iran",
  //   "latLng": [
  //     27.6687,
  //     53.0469
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.669,
  //   "time": "2022-12-08 05:13:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 20 km NE of Mohr, Iran على عمق 27.669 كم بتاريخ 2022-12-08 05:13:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j7u8"
  // },
  // "1440": {
  //   "place": "Turkmenistan",
  //   "latLng": [
  //     37.2873,
  //     62.376
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.287,
  //   "time": "2022-12-06 05:25:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Turkmenistan على عمق 37.287 كم بتاريخ 2022-12-06 05:25:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j77f"
  // },
  // "1441": {
  //   "place": "42 km WSW of N?r?b?d, Iran",
  //   "latLng": [
  //     29.9952,
  //     51.1002
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.995,
  //   "time": "2022-12-05 05:17:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 42 km WSW of N?r?b?d, Iran على عمق 29.995 كم بتاريخ 2022-12-05 05:17:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j85g"
  // },
  // "1442": {
  //   "place": "244 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.7053,
  //     54.8516
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.705,
  //   "time": "2022-12-02 23:58:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 244 km NNE of Hadibu, Yemen على عمق 14.705 كم بتاريخ 2022-12-02 23:58:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j7md"
  // },
  // "1443": {
  //   "place": "43 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8276,
  //     55.2041
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.828,
  //   "time": "2022-12-02 20:49:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 43 km NE of Bandar-e Lengeh, Iran على عمق 26.828 كم بتاريخ 2022-12-02 20:49:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j6fe"
  // },
  // "1444": {
  //   "place": "29 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.7394,
  //     55.1025
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.739,
  //   "time": "2022-12-02 06:43:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 29 km NE of Bandar-e Lengeh, Iran على عمق 26.739 كم بتاريخ 2022-12-02 06:43:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j68r#dyfi"
  // },
  // "1445": {
  //   "place": "45 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8687,
  //     55.1851
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.869,
  //   "time": "2022-12-01 23:29:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 45 km NE of Bandar-e Lengeh, Iran على عمق 26.869 كم بتاريخ 2022-12-01 23:29:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j66u"
  // },
  // "1446": {
  //   "place": "30 km WSW of F?rs?n, Iran",
  //   "latLng": [
  //     32.1274,
  //     50.2736
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.127,
  //   "time": "2022-12-01 18:54:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km WSW of F?rs?n, Iran على عمق 32.127 كم بتاريخ 2022-12-01 18:54:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j658"
  // },
  // "1447": {
  //   "place": "44 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8375,
  //     55.1998
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 26.838,
  //   "time": "2022-12-01 18:18:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 44 km NE of Bandar-e Lengeh, Iran على عمق 26.838 كم بتاريخ 2022-12-01 18:18:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j64v"
  // },
  // "1448": {
  //   "place": "40 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8076,
  //     55.1829
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.808,
  //   "time": "2022-11-30 22:19:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NE of Bandar-e Lengeh, Iran على عمق 26.808 كم بتاريخ 2022-11-30 22:19:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j5vx"
  // },
  // "1449": {
  //   "place": "43 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8456,
  //     55.1789
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.846,
  //   "time": "2022-11-30 17:18:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 43 km NE of Bandar-e Lengeh, Iran على عمق 26.846 كم بتاريخ 2022-11-30 17:18:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j5ua"
  // },
  // "1450": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8866,
  //     55.2391
  //   ],
  //   "magnitude": 5.7,
  //   "depth": 26.887,
  //   "time": "2022-11-30 15:17:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.7 درجة في southern Iran على عمق 26.887 كم بتاريخ 2022-11-30 15:17:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j5sn#pager"
  // },
  // "1451": {
  //   "place": "13 km N of Antalya, Turkey",
  //   "latLng": [
  //     37.0273,
  //     30.6936
  //   ],
  //   "magnitude": 3.1,
  //   "depth": 37.027,
  //   "time": "2022-11-29 21:29:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.1 درجة في 13 km N of Antalya, Turkey على عمق 37.027 كم بتاريخ 2022-11-29 21:29:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j5lr#dyfi"
  // },
  // "1452": {
  //   "place": "50 km ESE of Karpathos, Greece",
  //   "latLng": [
  //     35.3543,
  //     27.7429
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.354,
  //   "time": "2022-11-26 20:09:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 50 km ESE of Karpathos, Greece على عمق 35.354 كم بتاريخ 2022-11-26 20:09:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000isll"
  // },
  // "1453": {
  //   "place": "41 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.855,
  //     26.4373
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.855,
  //   "time": "2022-11-25 16:02:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 41 km SSE of Palekastro, Greece على عمق 34.855 كم بتاريخ 2022-11-25 16:02:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000j5tp"
  // },
  // "1454": {
  //   "place": "20 km ENE of Dehlor?n, Iran",
  //   "latLng": [
  //     32.7346,
  //     47.4777
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.735,
  //   "time": "2022-11-24 15:56:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 20 km ENE of Dehlor?n, Iran على عمق 32.735 كم بتاريخ 2022-11-24 15:56:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000is3z"
  // },
  // "1455": {
  //   "place": "Cyprus region",
  //   "latLng": [
  //     34.8439,
  //     32.6083
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.844,
  //   "time": "2022-11-24 00:33:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Cyprus region على عمق 34.844 كم بتاريخ 2022-11-24 00:33:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iryp#dyfi"
  // },
  // "1456": {
  //   "place": "Crete, Greece",
  //   "latLng": [
  //     35.8357,
  //     26.4319
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 35.836,
  //   "time": "2022-11-20 23:24:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في Crete, Greece على عمق 35.836 كم بتاريخ 2022-11-20 23:24:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ir86#pager"
  // },
  // "1457": {
  //   "place": "Cyprus region",
  //   "latLng": [
  //     34.8077,
  //     32.663
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.808,
  //   "time": "2022-11-19 07:16:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Cyprus region على عمق 34.808 كم بتاريخ 2022-11-19 07:16:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqy2#dyfi"
  // },
  // "1458": {
  //   "place": "32 km ESE of Harnai, Pakistan",
  //   "latLng": [
  //     29.9755,
  //     68.2441
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.976,
  //   "time": "2022-11-19 01:21:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 32 km ESE of Harnai, Pakistan على عمق 29.976 كم بتاريخ 2022-11-19 01:21:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqw2"
  // },
  // "1459": {
  //   "place": "100 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.3465,
  //     26.6162
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.347,
  //   "time": "2022-11-18 17:14:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 100 km SSE of Palekastro, Greece على عمق 34.347 كم بتاريخ 2022-11-18 17:14:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqsy"
  // },
  // "1460": {
  //   "place": "12 km SSE of Ula, Turkey",
  //   "latLng": [
  //     36.9992,
  //     28.4542
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.999,
  //   "time": "2022-11-18 04:26:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 12 km SSE of Ula, Turkey على عمق 36.999 كم بتاريخ 2022-11-18 04:26:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqln"
  // },
  // "1461": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.9637,
  //     55.2174
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 26.964,
  //   "time": "2022-11-17 13:59:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في southern Iran على عمق 26.964 كم بتاريخ 2022-11-17 13:59:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqen#dyfi"
  // },
  // "1462": {
  //   "place": "Gulf of Aden",
  //   "latLng": [
  //     13.1824,
  //     51.0627
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.182,
  //   "time": "2022-11-15 16:17:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Gulf of Aden على عمق 13.182 كم بتاريخ 2022-11-15 16:17:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqsa"
  // },
  // "1463": {
  //   "place": "64 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7191,
  //     56.0137
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.719,
  //   "time": "2022-11-15 15:02:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 64 km NNW of Bandar Abbas, Iran على عمق 27.719 كم بتاريخ 2022-11-15 15:02:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ipva"
  // },
  // "1464": {
  //   "place": "168 km SE of Zinjib?r, Yemen",
  //   "latLng": [
  //     12.1509,
  //     46.5755
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.151,
  //   "time": "2022-11-13 22:56:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 168 km SE of Zinjib?r, Yemen على عمق 12.151 كم بتاريخ 2022-11-13 22:56:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ipiv"
  // },
  // "1465": {
  //   "place": "164 km SSE of Mukalla, Yemen",
  //   "latLng": [
  //     13.1069,
  //     49.5212
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 13.107,
  //   "time": "2022-11-13 16:22:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 164 km SSE of Mukalla, Yemen على عمق 13.107 كم بتاريخ 2022-11-13 16:22:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iqhx"
  // },
  // "1466": {
  //   "place": "92 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.3958,
  //     26.5301
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 34.396,
  //   "time": "2022-11-13 02:08:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 92 km SSE of Palekastro, Greece على عمق 34.396 كم بتاريخ 2022-11-13 02:08:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ipe1#dyfi"
  // },
  // "1467": {
  //   "place": "46 km E of Kerman, Iran",
  //   "latLng": [
  //     30.2246,
  //     57.5544
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 30.225,
  //   "time": "2022-11-12 22:48:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 46 km E of Kerman, Iran على عمق 30.225 كم بتاريخ 2022-11-12 22:48:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ipd6#dyfi"
  // },
  // "1468": {
  //   "place": "43 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5471,
  //     56.1092
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.547,
  //   "time": "2022-11-11 18:44:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 43 km NNW of Bandar Abbas, Iran على عمق 27.547 كم بتاريخ 2022-11-11 18:44:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ip4k#dyfi"
  // },
  // "1469": {
  //   "place": "64 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7121,
  //     56.0058
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.712,
  //   "time": "2022-11-11 10:36:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 64 km NNW of Bandar Abbas, Iran على عمق 27.712 كم بتاريخ 2022-11-11 10:36:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ip0j"
  // },
  // "1470": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     7.3473,
  //     59.4712
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 7.347,
  //   "time": "2022-11-07 00:27:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Carlsberg Ridge على عمق 7.347 كم بتاريخ 2022-11-07 00:27:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ip25"
  // },
  // "1471": {
  //   "place": "38 km SW of Émponas, Greece",
  //   "latLng": [
  //     35.992,
  //     27.5486
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.992,
  //   "time": "2022-11-05 12:20:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 38 km SW of Émponas, Greece على عمق 35.992 كم بتاريخ 2022-11-05 12:20:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000impm"
  // },
  // "1472": {
  //   "place": "81 km NNE of M?n?b, Iran",
  //   "latLng": [
  //     27.7781,
  //     57.4801
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.778,
  //   "time": "2022-11-03 02:03:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 81 km NNE of M?n?b, Iran على عمق 27.778 كم بتاريخ 2022-11-03 02:03:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000im3g"
  // },
  // "1473": {
  //   "place": "eastern Mediterranean Sea",
  //   "latLng": [
  //     35.9595,
  //     30.9178
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 35.96,
  //   "time": "2022-11-02 17:41:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في eastern Mediterranean Sea على عمق 35.96 كم بتاريخ 2022-11-02 17:41:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000im0t#dyfi"
  // },
  // "1474": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.3522,
  //     54.8717
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.352,
  //   "time": "2022-11-02 08:07:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في southern Iran على عمق 26.352 كم بتاريخ 2022-11-02 08:07:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000in3t"
  // },
  // "1475": {
  //   "place": "34 km SSE of N?kshahr, Iran",
  //   "latLng": [
  //     25.9532,
  //     60.3815
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 25.953,
  //   "time": "2022-10-31 16:08:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 34 km SSE of N?kshahr, Iran على عمق 25.953 كم بتاريخ 2022-10-31 16:08:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000imhy"
  // },
  // "1476": {
  //   "place": "57 km ESE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     14.6283,
  //     39.8617
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.628,
  //   "time": "2022-10-31 00:28:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 57 km ESE of Adi Keyh, Eritrea على عمق 14.628 كم بتاريخ 2022-10-31 00:28:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000imhh"
  // },
  // "1477": {
  //   "place": "Pakistan",
  //   "latLng": [
  //     28.7382,
  //     66.667
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.738,
  //   "time": "2022-10-30 18:31:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Pakistan على عمق 28.738 كم بتاريخ 2022-10-30 18:31:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ilcs"
  // },
  // "1478": {
  //   "place": "66 km WNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.3165,
  //     55.6221
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.317,
  //   "time": "2022-10-30 00:49:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 66 km WNW of Bandar Abbas, Iran على عمق 27.317 كم بتاريخ 2022-10-30 00:49:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000im82"
  // },
  // "1479": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.945,
  //     57.8699
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 11.945,
  //   "time": "2022-10-26 23:00:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في Owen Fracture Zone region على عمق 11.945 كم بتاريخ 2022-10-26 23:00:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ikka"
  // },
  // "1480": {
  //   "place": "Pakistan",
  //   "latLng": [
  //     26.3746,
  //     67.4179
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.375,
  //   "time": "2022-10-25 16:54:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Pakistan على عمق 26.375 كم بتاريخ 2022-10-25 16:54:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iwfw"
  // },
  // "1481": {
  //   "place": "59 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8864,
  //     55.3557
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.886,
  //   "time": "2022-10-24 11:21:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 59 km NE of Bandar-e Lengeh, Iran على عمق 26.886 كم بتاريخ 2022-10-24 11:21:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iky6"
  // },
  // "1482": {
  //   "place": "10 km ESE of Dogonbadan, Iran",
  //   "latLng": [
  //     30.3303,
  //     50.8984
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 30.33,
  //   "time": "2022-10-23 01:55:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 10 km ESE of Dogonbadan, Iran على عمق 30.33 كم بتاريخ 2022-10-23 01:55:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ivup"
  // },
  // "1483": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.9114,
  //     57.9686
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 11.911,
  //   "time": "2022-10-21 20:19:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في Owen Fracture Zone region على عمق 11.911 كم بتاريخ 2022-10-21 20:19:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ivm2#dyfi"
  // },
  // "1484": {
  //   "place": "15 km WSW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.4183,
  //     37.142
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.418,
  //   "time": "2022-10-20 17:14:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 15 km WSW of Pazarc?k, Turkey على عمق 37.418 كم بتاريخ 2022-10-20 17:14:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ivav"
  // },
  // "1485": {
  //   "place": "13 km S of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.3677,
  //     37.2943
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.368,
  //   "time": "2022-10-20 11:34:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 13 km S of Pazarc?k, Turkey على عمق 37.368 كم بتاريخ 2022-10-20 11:34:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iv68#dyfi"
  // },
  // "1486": {
  //   "place": "55 km W of Al ?udaydah, Yemen",
  //   "latLng": [
  //     14.8239,
  //     42.4381
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.824,
  //   "time": "2022-10-16 23:08:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 55 km W of Al ?udaydah, Yemen على عمق 14.824 كم بتاريخ 2022-10-16 23:08:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iu72"
  // },
  // "1487": {
  //   "place": "195 km SSW of Ka?, Turkey",
  //   "latLng": [
  //     34.5088,
  //     29.0285
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.509,
  //   "time": "2022-10-12 23:09:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 195 km SSW of Ka?, Turkey على عمق 34.509 كم بتاريخ 2022-10-12 23:09:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000it5z#dyfi"
  // },
  // "1488": {
  //   "place": "17 km SE of Kadirli, Turkey",
  //   "latLng": [
  //     37.2612,
  //     36.2339
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 37.261,
  //   "time": "2022-10-11 15:48:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 17 km SE of Kadirli, Turkey على عمق 37.261 كم بتاريخ 2022-10-11 15:48:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000isrr#dyfi"
  // },
  // "1489": {
  //   "place": "6 km NNW of Balkh, Afghanistan",
  //   "latLng": [
  //     36.8088,
  //     66.8796
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.809,
  //   "time": "2022-10-11 08:10:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 6 km NNW of Balkh, Afghanistan على عمق 36.809 كم بتاريخ 2022-10-11 08:10:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000isnu"
  // },
  // "1490": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     37.0741,
  //     28.9243
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.074,
  //   "time": "2022-10-02 10:58:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Western Turkey على عمق 37.074 كم بتاريخ 2022-10-02 10:58:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iq6f#dyfi"
  // },
  // "1491": {
  //   "place": "89 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.2663,
  //     26.1135
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 34.266,
  //   "time": "2022-10-02 04:04:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في 89 km SSE of Ierápetra, Greece على عمق 34.266 كم بتاريخ 2022-10-02 04:04:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iq4q#pager"
  // },
  // "1492": {
  //   "place": "8 km ESE of Ger?sh, Iran",
  //   "latLng": [
  //     27.6447,
  //     54.2212
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 27.645,
  //   "time": "2022-09-28 18:03:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 8 km ESE of Ger?sh, Iran على عمق 27.645 كم بتاريخ 2022-09-28 18:03:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ip1l"
  // },
  // "1493": {
  //   "place": "47 km SE of ?l?m, Iran",
  //   "latLng": [
  //     33.3614,
  //     46.8173
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.361,
  //   "time": "2022-09-28 16:18:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 47 km SE of ?l?m, Iran على عمق 33.361 كم بتاريخ 2022-09-28 16:18:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ip18"
  // },
  // "1494": {
  //   "place": "53 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6273,
  //     56.4908
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.627,
  //   "time": "2022-09-27 21:50:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 53 km NNE of Bandar Abbas, Iran على عمق 27.627 كم بتاريخ 2022-09-27 21:50:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iqh5"
  // },
  // "1495": {
  //   "place": "19 km N of Datça, Turkey",
  //   "latLng": [
  //     36.9112,
  //     27.6954
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.911,
  //   "time": "2022-09-27 15:46:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 19 km N of Datça, Turkey على عمق 36.911 كم بتاريخ 2022-09-27 15:46:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000inpl"
  // },
  // "1496": {
  //   "place": "central Iran",
  //   "latLng": [
  //     32.3982,
  //     56.0284
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.398,
  //   "time": "2022-09-26 13:59:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في central Iran على عمق 32.398 كم بتاريخ 2022-09-26 13:59:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ippu"
  // },
  // "1497": {
  //   "place": "65 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6947,
  //     56.6185
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.695,
  //   "time": "2022-09-25 23:04:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 65 km NNE of Bandar Abbas, Iran على عمق 27.695 كم بتاريخ 2022-09-25 23:04:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ib08"
  // },
  // "1498": {
  //   "place": "59 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7017,
  //     56.4543
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 27.702,
  //   "time": "2022-09-25 15:25:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 59 km NNE of Bandar Abbas, Iran على عمق 27.702 كم بتاريخ 2022-09-25 15:25:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000iayf#dyfi"
  // },
  // "1499": {
  //   "place": "Near the coast of Oman",
  //   "latLng": [
  //     21.1335,
  //     59.5307
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 21.134,
  //   "time": "2022-09-19 04:26:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Near the coast of Oman على عمق 21.134 كم بتاريخ 2022-09-19 04:26:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i978"
  // },
  // "1500": {
  //   "place": "22 km W of P?geia, Cyprus",
  //   "latLng": [
  //     34.8834,
  //     32.131
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.883,
  //   "time": "2022-09-18 09:50:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 22 km W of P?geia, Cyprus على عمق 34.883 كم بتاريخ 2022-09-18 09:50:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i92c#dyfi"
  // },
  // "1501": {
  //   "place": "201 km N of Qalans?yah, Yemen",
  //   "latLng": [
  //     14.5098,
  //     53.6239
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 14.51,
  //   "time": "2022-09-16 12:33:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 201 km N of Qalans?yah, Yemen على عمق 14.51 كم بتاريخ 2022-09-16 12:33:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i8id"
  // },
  // "1502": {
  //   "place": "276 km NE of Hadibu, Yemen",
  //   "latLng": [
  //     14.4879,
  //     55.7462
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.488,
  //   "time": "2022-09-15 22:01:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 276 km NE of Hadibu, Yemen على عمق 14.488 كم بتاريخ 2022-09-15 22:01:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ia5t"
  // },
  // "1503": {
  //   "place": "13 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6505,
  //     54.1129
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.651,
  //   "time": "2022-09-14 01:54:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 13 km NE of K?sh, Iran على عمق 26.651 كم بتاريخ 2022-09-14 01:54:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i7ts"
  // },
  // "1504": {
  //   "place": "71 km NNW of Tabas, Iran",
  //   "latLng": [
  //     34.224,
  //     56.7628
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 34.224,
  //   "time": "2022-09-12 23:37:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 71 km NNW of Tabas, Iran على عمق 34.224 كم بتاريخ 2022-09-12 23:37:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i7hz"
  // },
  // "1505": {
  //   "place": "28 km S of Jong?yeh, Iran",
  //   "latLng": [
  //     31.0015,
  //     48.6419
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 31.002,
  //   "time": "2022-09-11 07:35:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 28 km S of Jong?yeh, Iran على عمق 31.002 كم بتاريخ 2022-09-11 07:35:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i75s#dyfi"
  // },
  // "1506": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     37.0733,
  //     28.6036
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.073,
  //   "time": "2022-09-05 13:45:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Western Turkey على عمق 37.073 كم بتاريخ 2022-09-05 13:45:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i7mw"
  // },
  // "1507": {
  //   "place": "55 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6592,
  //     56.0916
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 27.659,
  //   "time": "2022-09-05 09:14:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 55 km NNW of Bandar Abbas, Iran على عمق 27.659 كم بتاريخ 2022-09-05 09:14:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i5bu#pager"
  // },
  // "1508": {
  //   "place": "78 km SW of Fas?, Iran",
  //   "latLng": [
  //     28.3677,
  //     53.1721
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.368,
  //   "time": "2022-09-04 22:24:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 78 km SW of Fas?, Iran على عمق 28.368 كم بتاريخ 2022-09-04 22:24:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i7e8"
  // },
  // "1509": {
  //   "place": "8 km E of Ula, Turkey",
  //   "latLng": [
  //     37.093,
  //     28.5153
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.093,
  //   "time": "2022-09-04 17:47:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 8 km E of Ula, Turkey على عمق 37.093 كم بتاريخ 2022-09-04 17:47:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i55w"
  // },
  // "1510": {
  //   "place": "13 km SE of Palekastro, Greece",
  //   "latLng": [
  //     35.0971,
  //     26.3465
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 35.097,
  //   "time": "2022-09-03 04:13:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 13 km SE of Palekastro, Greece على عمق 35.097 كم بتاريخ 2022-09-03 04:13:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i4v6#dyfi"
  // },
  // "1511": {
  //   "place": "14 km ENE of Baghl?n, Afghanistan",
  //   "latLng": [
  //     36.1725,
  //     68.863
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.173,
  //   "time": "2022-09-02 17:00:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 14 km ENE of Baghl?n, Afghanistan على عمق 36.173 كم بتاريخ 2022-09-02 17:00:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i4qg"
  // },
  // "1512": {
  //   "place": "91 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.3876,
  //     26.4378
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.388,
  //   "time": "2022-09-02 06:49:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 91 km S of Palekastro, Greece على عمق 34.388 كم بتاريخ 2022-09-02 06:49:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i4kd#dyfi"
  // },
  // "1513": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.1209,
  //     57.7188
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 13.121,
  //   "time": "2022-09-01 07:02:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في Owen Fracture Zone region على عمق 13.121 كم بتاريخ 2022-09-01 07:02:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i48q#pager"
  // },
  // "1514": {
  //   "place": "149 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.8564,
  //     52.2515
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.856,
  //   "time": "2022-08-31 15:11:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 149 km S of Al Ghayz?ah, Yemen على عمق 14.856 كم بتاريخ 2022-08-31 15:11:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ii68"
  // },
  // "1515": {
  //   "place": "17 km WNW of Megálo Chorió, Greece",
  //   "latLng": [
  //     37.5368,
  //     26.8049
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 37.537,
  //   "time": "2022-08-31 14:02:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 17 km WNW of Megálo Chorió, Greece على عمق 37.537 كم بتاريخ 2022-08-31 14:02:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i40j"
  // },
  // "1516": {
  //   "place": "22 km WSW of Kalat, Pakistan",
  //   "latLng": [
  //     28.9851,
  //     66.3703
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 28.985,
  //   "time": "2022-08-31 12:36:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 22 km WSW of Kalat, Pakistan على عمق 28.985 كم بتاريخ 2022-08-31 12:36:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3zb"
  // },
  // "1517": {
  //   "place": "14 km NW of Megálo Chorió, Greece",
  //   "latLng": [
  //     37.5527,
  //     26.8515
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 37.553,
  //   "time": "2022-08-31 10:10:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في 14 km NW of Megálo Chorió, Greece على عمق 37.553 كم بتاريخ 2022-08-31 10:10:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3yp#pager"
  // },
  // "1518": {
  //   "place": "17 km SSW of Chóra, Greece",
  //   "latLng": [
  //     37.5649,
  //     26.8151
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 37.565,
  //   "time": "2022-08-31 09:56:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 17 km SSW of Chóra, Greece على عمق 37.565 كم بتاريخ 2022-08-31 09:56:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3ym#dyfi"
  // },
  // "1519": {
  //   "place": "42 km W of Pólis, Cyprus",
  //   "latLng": [
  //     35.0991,
  //     31.9644
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.099,
  //   "time": "2022-08-30 20:42:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 42 km W of Pólis, Cyprus على عمق 35.099 كم بتاريخ 2022-08-30 20:42:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3ss"
  // },
  // "1520": {
  //   "place": "289 km NE of Hadibu, Yemen",
  //   "latLng": [
  //     14.5371,
  //     55.8746
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.537,
  //   "time": "2022-08-30 10:57:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 289 km NE of Hadibu, Yemen على عمق 14.537 كم بتاريخ 2022-08-30 10:57:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i3n5"
  // },
  // "1521": {
  //   "place": "96 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.9731,
  //     56.6932
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.973,
  //   "time": "2022-08-27 15:24:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 96 km NNE of Bandar Abbas, Iran على عمق 27.973 كم بتاريخ 2022-08-27 15:24:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i4pq"
  // },
  // "1522": {
  //   "place": "67 km SSE of Demre, Turkey",
  //   "latLng": [
  //     35.6642,
  //     30.2271
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 35.664,
  //   "time": "2022-08-27 04:47:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 67 km SSE of Demre, Turkey على عمق 35.664 كم بتاريخ 2022-08-27 04:47:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i2vb"
  // },
  // "1523": {
  //   "place": "130 km SE of B?rjand, Iran",
  //   "latLng": [
  //     31.9227,
  //     60.0517
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 31.923,
  //   "time": "2022-08-26 09:50:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 130 km SE of B?rjand, Iran على عمق 31.923 كم بتاريخ 2022-08-26 09:50:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i2k0"
  // },
  // "1524": {
  //   "place": "58 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6726,
  //     56.0499
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.673,
  //   "time": "2022-08-26 03:05:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 58 km NNW of Bandar Abbas, Iran على عمق 27.673 كم بتاريخ 2022-08-26 03:05:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i2hs"
  // },
  // "1525": {
  //   "place": "60 km SSE of Ka?, Turkey",
  //   "latLng": [
  //     35.6825,
  //     29.8301
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.683,
  //   "time": "2022-08-24 05:30:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 60 km SSE of Ka?, Turkey على عمق 35.683 كم بتاريخ 2022-08-24 05:30:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i1y0"
  // },
  // "1526": {
  //   "place": "13 km NNE of Sitia, Greece",
  //   "latLng": [
  //     35.3183,
  //     26.1631
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.318,
  //   "time": "2022-08-24 03:44:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 13 km NNE of Sitia, Greece على عمق 35.318 كم بتاريخ 2022-08-24 03:44:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i1xl"
  // },
  // "1527": {
  //   "place": "13 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5784,
  //     54.1484
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.578,
  //   "time": "2022-08-17 07:03:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 13 km E of K?sh, Iran على عمق 26.578 كم بتاريخ 2022-08-17 07:03:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i2ku"
  // },
  // "1528": {
  //   "place": "23 km E of K?sh, Iran",
  //   "latLng": [
  //     26.595,
  //     54.2554
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.595,
  //   "time": "2022-08-17 06:57:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 23 km E of K?sh, Iran على عمق 26.595 كم بتاريخ 2022-08-17 06:57:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i2kv"
  // },
  // "1529": {
  //   "place": "45 km N of Bor?zj?n, Iran",
  //   "latLng": [
  //     29.6765,
  //     51.1637
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 29.677,
  //   "time": "2022-08-15 22:15:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 45 km N of Bor?zj?n, Iran على عمق 29.677 كم بتاريخ 2022-08-15 22:15:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ib6c"
  // },
  // "1530": {
  //   "place": "173 km NNW of Qalans?yah, Yemen",
  //   "latLng": [
  //     14.1882,
  //     52.9998
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.188,
  //   "time": "2022-08-15 07:01:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 173 km NNW of Qalans?yah, Yemen على عمق 14.188 كم بتاريخ 2022-08-15 07:01:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000i228"
  // },
  // "1531": {
  //   "place": "179 km NNW of Qalans?yah, Yemen",
  //   "latLng": [
  //     14.2366,
  //     52.9845
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.237,
  //   "time": "2022-08-15 06:58:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 179 km NNW of Qalans?yah, Yemen على عمق 14.237 كم بتاريخ 2022-08-15 06:58:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iay1"
  // },
  // "1532": {
  //   "place": "21 km W of Goth Phulji, Pakistan",
  //   "latLng": [
  //     26.8918,
  //     67.4689
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.892,
  //   "time": "2022-08-14 09:53:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 21 km W of Goth Phulji, Pakistan على عمق 26.892 كم بتاريخ 2022-08-14 09:53:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iar0"
  // },
  // "1533": {
  //   "place": "15 km SE of Kahramanmara?, Turkey",
  //   "latLng": [
  //     37.4826,
  //     37.0408
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.483,
  //   "time": "2022-08-13 03:50:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 15 km SE of Kahramanmara?, Turkey على عمق 37.483 كم بتاريخ 2022-08-13 03:50:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iafh"
  // },
  // "1534": {
  //   "place": "18 km SSW of Rasht, Iran",
  //   "latLng": [
  //     37.116,
  //     49.5328
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.116,
  //   "time": "2022-08-12 18:21:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 18 km SSW of Rasht, Iran على عمق 37.116 كم بتاريخ 2022-08-12 18:21:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000iabi#dyfi"
  // },
  // "1535": {
  //   "place": "175 km NNW of Bosaso, Somalia",
  //   "latLng": [
  //     12.7525,
  //     48.5611
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.753,
  //   "time": "2022-08-12 11:20:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 175 km NNW of Bosaso, Somalia على عمق 12.753 كم بتاريخ 2022-08-12 11:20:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000icsr"
  // },
  // "1536": {
  //   "place": "14 km SSE of Baynjiwayn, Iraq",
  //   "latLng": [
  //     35.4958,
  //     45.9901
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 35.496,
  //   "time": "2022-08-12 08:54:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 14 km SSE of Baynjiwayn, Iraq على عمق 35.496 كم بتاريخ 2022-08-12 08:54:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ia6d#dyfi"
  // },
  // "1537": {
  //   "place": "62 km ESE of Torbat-e ?eydar?yeh, Iran",
  //   "latLng": [
  //     35.0375,
  //     59.839
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.038,
  //   "time": "2022-08-08 07:45:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 62 km ESE of Torbat-e ?eydar?yeh, Iran على عمق 35.038 كم بتاريخ 2022-08-08 07:45:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i90u"
  // },
  // "1538": {
  //   "place": "8 km SE of Ka?, Turkey",
  //   "latLng": [
  //     36.1379,
  //     29.697
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.138,
  //   "time": "2022-08-07 08:02:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 8 km SE of Ka?, Turkey على عمق 36.138 كم بتاريخ 2022-08-07 08:02:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i8uh"
  // },
  // "1539": {
  //   "place": "4 km SE of Dehlor?n, Iran",
  //   "latLng": [
  //     32.6676,
  //     47.3048
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.668,
  //   "time": "2022-08-07 06:49:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 4 km SE of Dehlor?n, Iran على عمق 32.668 كم بتاريخ 2022-08-07 06:49:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i8u9"
  // },
  // "1540": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     7.4301,
  //     59.6338
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 7.43,
  //   "time": "2022-08-04 17:12:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Carlsberg Ridge على عمق 7.43 كم بتاريخ 2022-08-04 17:12:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ib2b"
  // },
  // "1541": {
  //   "place": "56 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8616,
  //     55.3421
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.862,
  //   "time": "2022-08-04 04:09:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 56 km NE of Bandar-e Lengeh, Iran على عمق 26.862 كم بتاريخ 2022-08-04 04:09:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7ym"
  // },
  // "1542": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     36.1028,
  //     30.9478
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.103,
  //   "time": "2022-08-03 10:05:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Western Turkey على عمق 36.103 كم بتاريخ 2022-08-03 10:05:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7q8"
  // },
  // "1543": {
  //   "place": "38 km NNE of Mandal?, Iraq",
  //   "latLng": [
  //     34.0557,
  //     45.7388
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.056,
  //   "time": "2022-08-02 17:10:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 38 km NNE of Mandal?, Iraq على عمق 34.056 كم بتاريخ 2022-08-02 17:10:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7ie"
  // },
  // "1544": {
  //   "place": "56 km NW of Wana, Pakistan",
  //   "latLng": [
  //     32.5867,
  //     69.0816
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.587,
  //   "time": "2022-08-02 13:42:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 56 km NW of Wana, Pakistan على عمق 32.587 كم بتاريخ 2022-08-02 13:42:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7g8"
  // },
  // "1545": {
  //   "place": "17 km S of Pasni, Pakistan",
  //   "latLng": [
  //     25.1097,
  //     63.4765
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 25.11,
  //   "time": "2022-07-31 13:52:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 17 km S of Pasni, Pakistan على عمق 25.11 كم بتاريخ 2022-07-31 13:52:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i6z0#dyfi"
  // },
  // "1546": {
  //   "place": "16 km SE of Pasni, Pakistan",
  //   "latLng": [
  //     25.1448,
  //     63.5694
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 25.145,
  //   "time": "2022-07-31 13:42:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في 16 km SE of Pasni, Pakistan على عمق 25.145 كم بتاريخ 2022-07-31 13:42:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i6yz#pager"
  // },
  // "1547": {
  //   "place": "35 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.7959,
  //     55.1207
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.796,
  //   "time": "2022-07-31 11:44:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 35 km NE of Bandar-e Lengeh, Iran على عمق 26.796 كم بتاريخ 2022-07-31 11:44:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i9px"
  // },
  // "1548": {
  //   "place": "57 km N of Tak?b, Iran",
  //   "latLng": [
  //     36.9219,
  //     47.1552
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 36.922,
  //   "time": "2022-07-30 00:46:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 57 km N of Tak?b, Iran على عمق 36.922 كم بتاريخ 2022-07-30 00:46:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i6pm"
  // },
  // "1549": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.7415,
  //     58.0138
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.742,
  //   "time": "2022-07-28 09:12:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Owen Fracture Zone region على عمق 14.742 كم بتاريخ 2022-07-28 09:12:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i64d"
  // },
  // "1550": {
  //   "place": "65 km W of Bojn?rd, Iran",
  //   "latLng": [
  //     37.5732,
  //     56.6019
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.573,
  //   "time": "2022-07-27 15:02:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 65 km W of Bojn?rd, Iran على عمق 37.573 كم بتاريخ 2022-07-27 15:02:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i8fb"
  // },
  // "1551": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     15.1251,
  //     59.4649
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 15.125,
  //   "time": "2022-07-26 09:34:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في Owen Fracture Zone region على عمق 15.125 كم بتاريخ 2022-07-26 09:34:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hti9"
  // },
  // "1552": {
  //   "place": "25 km WSW of Pazarc?k, Turkey",
  //   "latLng": [
  //     37.363,
  //     37.0592
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.363,
  //   "time": "2022-07-26 06:11:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 25 km WSW of Pazarc?k, Turkey على عمق 37.363 كم بتاريخ 2022-07-26 06:11:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hth8#dyfi"
  // },
  // "1553": {
  //   "place": "43 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8543,
  //     55.1598
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 26.854,
  //   "time": "2022-07-25 15:55:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 43 km NE of Bandar-e Lengeh, Iran على عمق 26.854 كم بتاريخ 2022-07-25 15:55:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000htc5#dyfi"
  // },
  // "1554": {
  //   "place": "97 km SE of D?r?b, Iran",
  //   "latLng": [
  //     28.1769,
  //     55.291
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 28.177,
  //   "time": "2022-07-25 13:39:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 97 km SE of D?r?b, Iran على عمق 28.177 كم بتاريخ 2022-07-25 13:39:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000htbd"
  // },
  // "1555": {
  //   "place": "29 km WNW of Pishin, Pakistan",
  //   "latLng": [
  //     30.6529,
  //     66.702
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 30.653,
  //   "time": "2022-07-25 12:03:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 29 km WNW of Pishin, Pakistan على عمق 30.653 كم بتاريخ 2022-07-25 12:03:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000htar"
  // },
  // "1556": {
  //   "place": "55 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9098,
  //     55.2757
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.91,
  //   "time": "2022-07-25 01:37:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 55 km NE of Bandar-e Lengeh, Iran على عمق 26.91 كم بتاريخ 2022-07-25 01:37:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i82b"
  // },
  // "1557": {
  //   "place": "56 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9496,
  //     55.2369
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.95,
  //   "time": "2022-07-24 08:51:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 56 km NE of Bandar-e Lengeh, Iran على عمق 26.95 كم بتاريخ 2022-07-24 08:51:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7rx"
  // },
  // "1558": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     28.3762,
  //     54.1108
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.376,
  //   "time": "2022-07-23 20:46:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في southern Iran على عمق 28.376 كم بتاريخ 2022-07-23 20:46:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i7gx"
  // },
  // "1559": {
  //   "place": "69 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9783,
  //     55.3932
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 26.978,
  //   "time": "2022-07-23 16:09:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في 69 km NE of Bandar-e Lengeh, Iran على عمق 26.978 كم بتاريخ 2022-07-23 16:09:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hszl#pager"
  // },
  // "1560": {
  //   "place": "47 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8637,
  //     55.2135
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 26.864,
  //   "time": "2022-07-23 16:07:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في 47 km NE of Bandar-e Lengeh, Iran على عمق 26.864 كم بتاريخ 2022-07-23 16:07:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hszk#pager"
  // },
  // "1561": {
  //   "place": "62 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.0889,
  //     53.2299
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.089,
  //   "time": "2022-07-22 18:18:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 62 km SSE of Mohr, Iran على عمق 27.089 كم بتاريخ 2022-07-22 18:18:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hssb#dyfi"
  // },
  // "1562": {
  //   "place": "54 km W of Sarakhs, Iran",
  //   "latLng": [
  //     36.4839,
  //     60.5499
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.484,
  //   "time": "2022-07-19 13:07:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 54 km W of Sarakhs, Iran على عمق 36.484 كم بتاريخ 2022-07-19 13:07:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i3md"
  // },
  // "1563": {
  //   "place": "41 km E of Kifr?, Iraq",
  //   "latLng": [
  //     34.6372,
  //     45.4058
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.637,
  //   "time": "2022-07-18 08:04:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 41 km E of Kifr?, Iraq على عمق 34.637 كم بتاريخ 2022-07-18 08:04:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i3dq"
  // },
  // "1564": {
  //   "place": "53 km ESE of Kerman, Iran",
  //   "latLng": [
  //     30.1078,
  //     57.5995
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 30.108,
  //   "time": "2022-07-17 03:50:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 53 km ESE of Kerman, Iran على عمق 30.108 كم بتاريخ 2022-07-17 03:50:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i35z"
  // },
  // "1565": {
  //   "place": "41 km S of Bo?azkent, Turkey",
  //   "latLng": [
  //     36.4826,
  //     31.0733
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.483,
  //   "time": "2022-07-16 20:44:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 41 km S of Bo?azkent, Turkey على عمق 36.483 كم بتاريخ 2022-07-16 20:44:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i33n"
  // },
  // "1566": {
  //   "place": "23 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5862,
  //     54.2553
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.586,
  //   "time": "2022-07-16 19:27:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 23 km E of K?sh, Iran على عمق 26.586 كم بتاريخ 2022-07-16 19:27:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i33d"
  // },
  // "1567": {
  //   "place": "60 km NW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.634,
  //     55.9372
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.634,
  //   "time": "2022-07-14 00:33:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 60 km NW of Bandar Abbas, Iran على عمق 27.634 كم بتاريخ 2022-07-14 00:33:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i298"
  // },
  // "1568": {
  //   "place": "155 km NNE of Caluula, Somalia",
  //   "latLng": [
  //     13.2923,
  //     51.2407
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.292,
  //   "time": "2022-07-13 11:16:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 155 km NNE of Caluula, Somalia على عمق 13.292 كم بتاريخ 2022-07-13 11:16:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i22e"
  // },
  // "1569": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8292,
  //     55.1385
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.829,
  //   "time": "2022-07-13 02:38:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في southern Iran على عمق 26.829 كم بتاريخ 2022-07-13 02:38:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hser"
  // },
  // "1570": {
  //   "place": "25 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5869,
  //     54.2687
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.587,
  //   "time": "2022-07-11 17:32:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 25 km E of K?sh, Iran على عمق 26.587 كم بتاريخ 2022-07-11 17:32:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i1l7"
  // },
  // "1571": {
  //   "place": "29 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6588,
  //     54.2887
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 26.659,
  //   "time": "2022-07-11 17:16:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 29 km ENE of K?sh, Iran على عمق 26.659 كم بتاريخ 2022-07-11 17:16:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i1l5#dyfi"
  // },
  // "1572": {
  //   "place": "174 km NW of Las Khorey, Somalia",
  //   "latLng": [
  //     12.1575,
  //     46.9584
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.158,
  //   "time": "2022-07-11 10:17:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 174 km NW of Las Khorey, Somalia على عمق 12.158 كم بتاريخ 2022-07-11 10:17:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i1je"
  // },
  // "1573": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.5189,
  //     54.1745
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.519,
  //   "time": "2022-07-08 20:28:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في southern Iran على عمق 26.519 كم بتاريخ 2022-07-08 20:28:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i2pg"
  // },
  // "1574": {
  //   "place": "46 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8802,
  //     55.1821
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.88,
  //   "time": "2022-07-07 19:08:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 46 km NE of Bandar-e Lengeh, Iran على عمق 26.88 كم بتاريخ 2022-07-07 19:08:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i23w"
  // },
  // "1575": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     12.0555,
  //     58.081
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.056,
  //   "time": "2022-07-06 22:09:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Owen Fracture Zone region على عمق 12.056 كم بتاريخ 2022-07-06 22:09:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i1uy"
  // },
  // "1576": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.896,
  //     55.1476
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.896,
  //   "time": "2022-07-06 03:05:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في southern Iran على عمق 26.896 كم بتاريخ 2022-07-06 03:05:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i1v3"
  // },
  // "1577": {
  //   "place": "22 km W of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.4971,
  //     45.6262
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 34.497,
  //   "time": "2022-07-05 13:43:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 22 km W of Sarpol-e Z?ah?b, Iran على عمق 34.497 كم بتاريخ 2022-07-05 13:43:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0y6"
  // },
  // "1578": {
  //   "place": "49 km ENE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.6989,
  //     55.3504
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.699,
  //   "time": "2022-07-05 10:30:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 49 km ENE of Bandar-e Lengeh, Iran على عمق 26.699 كم بتاريخ 2022-07-05 10:30:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0xv"
  // },
  // "1579": {
  //   "place": "45 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.7957,
  //     55.2514
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.796,
  //   "time": "2022-07-04 04:14:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 45 km NE of Bandar-e Lengeh, Iran على عمق 26.796 كم بتاريخ 2022-07-04 04:14:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hznl"
  // },
  // "1580": {
  //   "place": "52 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8813,
  //     55.2602
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.881,
  //   "time": "2022-07-03 18:41:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 52 km NE of Bandar-e Lengeh, Iran على عمق 26.881 كم بتاريخ 2022-07-03 18:41:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0lv"
  // },
  // "1581": {
  //   "place": "37 km N of ?st?neh-ye Ashraf?yeh, Iran",
  //   "latLng": [
  //     37.5957,
  //     49.9911
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.596,
  //   "time": "2022-07-03 14:05:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 37 km N of ?st?neh-ye Ashraf?yeh, Iran على عمق 37.596 كم بتاريخ 2022-07-03 14:05:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0lh#dyfi"
  // },
  // "1582": {
  //   "place": "54 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.9015,
  //     54.4111
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.902,
  //   "time": "2022-07-03 12:18:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 54 km NE of K?sh, Iran على عمق 26.902 كم بتاريخ 2022-07-03 12:18:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0l8"
  // },
  // "1583": {
  //   "place": "46 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8101,
  //     55.2587
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.81,
  //   "time": "2022-07-03 07:32:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 46 km NE of Bandar-e Lengeh, Iran على عمق 26.81 كم بتاريخ 2022-07-03 07:32:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0la"
  // },
  // "1584": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8832,
  //     55.2002
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.883,
  //   "time": "2022-07-02 19:29:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في southern Iran على عمق 26.883 كم بتاريخ 2022-07-02 19:29:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzfj"
  // },
  // "1585": {
  //   "place": "52 km SSE of K?sh, Iran",
  //   "latLng": [
  //     26.1322,
  //     54.2484
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.132,
  //   "time": "2022-07-02 14:44:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 52 km SSE of K?sh, Iran على عمق 26.132 كم بتاريخ 2022-07-02 14:44:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hze6"
  // },
  // "1586": {
  //   "place": "31 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8335,
  //     54.9731
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 26.834,
  //   "time": "2022-07-02 09:15:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 31 km NNE of Bandar-e Lengeh, Iran على عمق 26.834 كم بتاريخ 2022-07-02 09:15:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzd2#dyfi"
  // },
  // "1587": {
  //   "place": "48 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8795,
  //     55.2125
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.88,
  //   "time": "2022-07-02 05:06:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 48 km NE of Bandar-e Lengeh, Iran على عمق 26.88 كم بتاريخ 2022-07-02 05:06:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzc3#dyfi"
  // },
  // "1588": {
  //   "place": "48 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8968,
  //     55.1896
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.897,
  //   "time": "2022-07-02 03:47:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 48 km NE of Bandar-e Lengeh, Iran على عمق 26.897 كم بتاريخ 2022-07-02 03:47:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzbf"
  // },
  // "1589": {
  //   "place": "55 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8667,
  //     55.3162
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.867,
  //   "time": "2022-07-02 03:29:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 55 km NE of Bandar-e Lengeh, Iran على عمق 26.867 كم بتاريخ 2022-07-02 03:29:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzbc"
  // },
  // "1590": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8411,
  //     55.2203
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.841,
  //   "time": "2022-07-02 02:51:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في southern Iran على عمق 26.841 كم بتاريخ 2022-07-02 02:51:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzb3"
  // },
  // "1591": {
  //   "place": "50 km ENE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.7815,
  //     55.3215
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.782,
  //   "time": "2022-07-02 01:14:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 50 km ENE of Bandar-e Lengeh, Iran على عمق 26.782 كم بتاريخ 2022-07-02 01:14:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzaj#dyfi"
  // },
  // "1592": {
  //   "place": "43 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8389,
  //     55.1889
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.839,
  //   "time": "2022-07-02 00:37:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 43 km NE of Bandar-e Lengeh, Iran على عمق 26.839 كم بتاريخ 2022-07-02 00:37:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0js"
  // },
  // "1593": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.6327,
  //     57.1097
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.633,
  //   "time": "2022-07-02 00:34:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Owen Fracture Zone region على عمق 13.633 كم بتاريخ 2022-07-02 00:34:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0jr"
  // },
  // "1594": {
  //   "place": "48 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8957,
  //     55.1898
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.896,
  //   "time": "2022-07-01 23:49:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 48 km NE of Bandar-e Lengeh, Iran على عمق 26.896 كم بتاريخ 2022-07-01 23:49:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz9z#dyfi"
  // },
  // "1595": {
  //   "place": "57 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8878,
  //     55.3213
  //   ],
  //   "magnitude": 6.0,
  //   "depth": 26.888,
  //   "time": "2022-07-01 23:25:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.0 درجة في 57 km NE of Bandar-e Lengeh, Iran على عمق 26.888 كم بتاريخ 2022-07-01 23:25:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz9v#pager"
  // },
  // "1596": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8843,
  //     55.2572
  //   ],
  //   "magnitude": 5.7,
  //   "depth": 26.884,
  //   "time": "2022-07-01 23:24:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.7 درجة في southern Iran على عمق 26.884 كم بتاريخ 2022-07-01 23:24:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz9p#pager"
  // },
  // "1597": {
  //   "place": "56 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9054,
  //     55.2978
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.905,
  //   "time": "2022-07-01 23:13:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 56 km NE of Bandar-e Lengeh, Iran على عمق 26.905 كم بتاريخ 2022-07-01 23:13:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz9l"
  // },
  // "1598": {
  //   "place": "126 km N of Turbat, Pakistan",
  //   "latLng": [
  //     27.126,
  //     62.8188
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.126,
  //   "time": "2022-07-01 23:09:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 126 km N of Turbat, Pakistan على عمق 27.126 كم بتاريخ 2022-07-01 23:09:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0as"
  // },
  // "1599": {
  //   "place": "45 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8557,
  //     55.2013
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.856,
  //   "time": "2022-07-01 22:43:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 45 km NE of Bandar-e Lengeh, Iran على عمق 26.856 كم بتاريخ 2022-07-01 22:43:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz9h#dyfi"
  // },
  // "1600": {
  //   "place": "40 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8423,
  //     55.1355
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.842,
  //   "time": "2022-07-01 22:07:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NE of Bandar-e Lengeh, Iran على عمق 26.842 كم بتاريخ 2022-07-01 22:07:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz98#dyfi"
  // },
  // "1601": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     26.8923,
  //     55.2365
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 26.892,
  //   "time": "2022-07-01 21:47:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في southern Iran على عمق 26.892 كم بتاريخ 2022-07-01 21:47:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz94#dyfi"
  // },
  // "1602": {
  //   "place": "25 km SSE of Khasab, Oman",
  //   "latLng": [
  //     25.9617,
  //     56.3116
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 25.962,
  //   "time": "2022-07-01 21:41:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 25 km SSE of Khasab, Oman على عمق 25.962 كم بتاريخ 2022-07-01 21:41:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0ap#dyfi"
  // },
  // "1603": {
  //   "place": "48 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9773,
  //     55.0053
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 26.977,
  //   "time": "2022-07-01 21:39:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 48 km NNE of Bandar-e Lengeh, Iran على عمق 26.977 كم بتاريخ 2022-07-01 21:39:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000i0an#dyfi"
  // },
  // "1604": {
  //   "place": "52 km NE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9061,
  //     55.2389
  //   ],
  //   "magnitude": 6.0,
  //   "depth": 26.906,
  //   "time": "2022-07-01 21:32:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.0 درجة في 52 km NE of Bandar-e Lengeh, Iran على عمق 26.906 كم بتاريخ 2022-07-01 21:32:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz8x#pager"
  // },
  // "1605": {
  //   "place": "123 km NNE of M?n?b, Iran",
  //   "latLng": [
  //     28.2274,
  //     57.336
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.227,
  //   "time": "2022-07-01 19:28:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 123 km NNE of M?n?b, Iran على عمق 28.227 كم بتاريخ 2022-07-01 19:28:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz82#dyfi"
  // },
  // "1606": {
  //   "place": "82 km NNE of M?n?b, Iran",
  //   "latLng": [
  //     27.8272,
  //     57.3913
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.827,
  //   "time": "2022-07-01 14:04:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 82 km NNE of M?n?b, Iran على عمق 27.827 كم بتاريخ 2022-07-01 14:04:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hz4b"
  // },
  // "1607": {
  //   "place": "120 km SW of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.1218,
  //     51.6527
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.122,
  //   "time": "2022-06-29 00:01:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 120 km SW of F?r?z?b?d, Iran على عمق 28.122 كم بتاريخ 2022-06-29 00:01:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hzsl"
  // },
  // "1608": {
  //   "place": "79 km NE of R?var, Iran",
  //   "latLng": [
  //     31.8295,
  //     57.3244
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.83,
  //   "time": "2022-06-26 15:39:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 79 km NE of R?var, Iran على عمق 31.83 كم بتاريخ 2022-06-26 15:39:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hkeg"
  // },
  // "1609": {
  //   "place": "54 km NE of R?var, Iran",
  //   "latLng": [
  //     31.5851,
  //     57.2418
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 31.585,
  //   "time": "2022-06-26 13:07:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 54 km NE of R?var, Iran على عمق 31.585 كم بتاريخ 2022-06-26 13:07:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hkdl#dyfi"
  // },
  // "1610": {
  //   "place": "24 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5681,
  //     54.2627
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.568,
  //   "time": "2022-06-25 05:51:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 24 km E of K?sh, Iran على عمق 26.568 كم بتاريخ 2022-06-25 05:51:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hysw"
  // },
  // "1611": {
  //   "place": "21 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6924,
  //     54.1752
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.692,
  //   "time": "2022-06-25 05:50:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 21 km NE of K?sh, Iran على عمق 26.692 كم بتاريخ 2022-06-25 05:50:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hysv"
  // },
  // "1612": {
  //   "place": "31 km ESE of K?sh, Iran",
  //   "latLng": [
  //     26.4087,
  //     54.293
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.409,
  //   "time": "2022-06-25 03:43:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 31 km ESE of K?sh, Iran على عمق 26.409 كم بتاريخ 2022-06-25 03:43:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hyst#dyfi"
  // },
  // "1613": {
  //   "place": "31 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.7341,
  //     54.2683
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 26.734,
  //   "time": "2022-06-25 03:37:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في 31 km NE of K?sh, Iran على عمق 26.734 كم بتاريخ 2022-06-25 03:37:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hk3w#pager"
  // },
  // "1614": {
  //   "place": "15 km ESE of K?sh, Iran",
  //   "latLng": [
  //     26.4942,
  //     54.1624
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.494,
  //   "time": "2022-06-24 23:47:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 15 km ESE of K?sh, Iran على عمق 26.494 كم بتاريخ 2022-06-24 23:47:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hk35#dyfi"
  // },
  // "1615": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     7.4797,
  //     59.708
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 7.48,
  //   "time": "2022-06-24 13:44:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في Carlsberg Ridge على عمق 7.48 كم بتاريخ 2022-06-24 13:44:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjwr"
  // },
  // "1616": {
  //   "place": "23 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6697,
  //     54.22
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.67,
  //   "time": "2022-06-24 13:32:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 23 km ENE of K?sh, Iran على عمق 26.67 كم بتاريخ 2022-06-24 13:32:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hyl5"
  // },
  // "1617": {
  //   "place": "51 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.1775,
  //     53.1955
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.178,
  //   "time": "2022-06-24 05:36:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 51 km SE of Mohr, Iran على عمق 27.178 كم بتاريخ 2022-06-24 05:36:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hyku"
  // },
  // "1618": {
  //   "place": "11 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.5953,
  //     54.1246
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.595,
  //   "time": "2022-06-24 01:27:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 11 km ENE of K?sh, Iran على عمق 26.595 كم بتاريخ 2022-06-24 01:27:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjt1"
  // },
  // "1619": {
  //   "place": "203 km NNW of Kilmia, Yemen",
  //   "latLng": [
  //     13.9575,
  //     51.7317
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.958,
  //   "time": "2022-06-23 05:22:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 203 km NNW of Kilmia, Yemen على عمق 13.958 كم بتاريخ 2022-06-23 05:22:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hji1"
  // },
  // "1620": {
  //   "place": "53 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.1648,
  //     53.2063
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.165,
  //   "time": "2022-06-22 19:59:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 53 km SE of Mohr, Iran على عمق 27.165 كم بتاريخ 2022-06-22 19:59:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjdz"
  // },
  // "1621": {
  //   "place": "64 km SSE of Ger?sh, Iran",
  //   "latLng": [
  //     27.1207,
  //     54.3571
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.121,
  //   "time": "2022-06-22 18:13:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 64 km SSE of Ger?sh, Iran على عمق 27.121 كم بتاريخ 2022-06-22 18:13:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjd4"
  // },
  // "1622": {
  //   "place": "50 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.2177,
  //     53.221
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 27.218,
  //   "time": "2022-06-22 08:35:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 50 km SE of Mohr, Iran على عمق 27.218 كم بتاريخ 2022-06-22 08:35:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj9a"
  // },
  // "1623": {
  //   "place": "25 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5926,
  //     54.2709
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.593,
  //   "time": "2022-06-22 06:06:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 25 km E of K?sh, Iran على عمق 26.593 كم بتاريخ 2022-06-22 06:06:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hkkm"
  // },
  // "1624": {
  //   "place": "40 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.7734,
  //     54.3449
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.773,
  //   "time": "2022-06-22 02:38:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NE of K?sh, Iran على عمق 26.773 كم بتاريخ 2022-06-22 02:38:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj61#dyfi"
  // },
  // "1625": {
  //   "place": "54 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.2045,
  //     53.2628
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.205,
  //   "time": "2022-06-22 01:26:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 54 km SE of Mohr, Iran على عمق 27.205 كم بتاريخ 2022-06-22 01:26:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj5x"
  // },
  // "1626": {
  //   "place": "53 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.2359,
  //     53.2837
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 27.236,
  //   "time": "2022-06-21 21:09:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في 53 km SE of Mohr, Iran على عمق 27.236 كم بتاريخ 2022-06-21 21:09:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj3x#pager"
  // },
  // "1627": {
  //   "place": "21 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6386,
  //     54.2184
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.639,
  //   "time": "2022-06-21 07:05:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 21 km ENE of K?sh, Iran على عمق 26.639 كم بتاريخ 2022-06-21 07:05:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hiy7"
  // },
  // "1628": {
  //   "place": "34 km NNE of Langar?d, Iran",
  //   "latLng": [
  //     37.4916,
  //     50.2825
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.492,
  //   "time": "2022-06-21 03:49:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 34 km NNE of Langar?d, Iran على عمق 37.492 كم بتاريخ 2022-06-21 03:49:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjyt"
  // },
  // "1629": {
  //   "place": "59 km NW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9623,
  //     54.494
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.962,
  //   "time": "2022-06-20 22:00:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 59 km NW of Bandar-e Lengeh, Iran على عمق 26.962 كم بتاريخ 2022-06-20 22:00:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjy4"
  // },
  // "1630": {
  //   "place": "19 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6211,
  //     54.1969
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.621,
  //   "time": "2022-06-20 02:38:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km ENE of K?sh, Iran على عمق 26.621 كم بتاريخ 2022-06-20 02:38:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hjx6"
  // },
  // "1631": {
  //   "place": "20 km SSW of Karpathos, Greece",
  //   "latLng": [
  //     35.3307,
  //     27.1376
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 35.331,
  //   "time": "2022-06-19 23:24:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 20 km SSW of Karpathos, Greece على عمق 35.331 كم بتاريخ 2022-06-19 23:24:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hilt#dyfi"
  // },
  // "1632": {
  //   "place": "18 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.5991,
  //     54.1979
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.599,
  //   "time": "2022-06-18 17:01:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 18 km ENE of K?sh, Iran على عمق 26.599 كم بتاريخ 2022-06-18 17:01:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hiej"
  // },
  // "1633": {
  //   "place": "22 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.642,
  //     54.228
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 26.642,
  //   "time": "2022-06-18 16:44:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 22 km ENE of K?sh, Iran على عمق 26.642 كم بتاريخ 2022-06-18 16:44:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hied#dyfi"
  // },
  // "1634": {
  //   "place": "27 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.7099,
  //     54.2317
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.71,
  //   "time": "2022-06-18 00:03:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 27 km NE of K?sh, Iran على عمق 26.71 كم بتاريخ 2022-06-18 00:03:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hi9g"
  // },
  // "1635": {
  //   "place": "19 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6036,
  //     54.2059
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.604,
  //   "time": "2022-06-17 13:08:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km ENE of K?sh, Iran على عمق 26.604 كم بتاريخ 2022-06-17 13:08:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hi3t"
  // },
  // "1636": {
  //   "place": "26 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6947,
  //     54.235
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.695,
  //   "time": "2022-06-16 23:48:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 26 km NE of K?sh, Iran على عمق 26.695 كم بتاريخ 2022-06-16 23:48:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhzq"
  // },
  // "1637": {
  //   "place": "45 km SW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.3279,
  //     54.4996
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.328,
  //   "time": "2022-06-16 04:44:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 45 km SW of Bandar-e Lengeh, Iran على عمق 26.328 كم بتاريخ 2022-06-16 04:44:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj0w"
  // },
  // "1638": {
  //   "place": "35 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.671,
  //     54.353
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.671,
  //   "time": "2022-06-16 00:40:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 35 km ENE of K?sh, Iran على عمق 26.671 كم بتاريخ 2022-06-16 00:40:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhp7"
  // },
  // "1639": {
  //   "place": "26 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.7059,
  //     54.2298
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.706,
  //   "time": "2022-06-16 00:26:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 26 km NE of K?sh, Iran على عمق 26.706 كم بتاريخ 2022-06-16 00:26:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hj0x"
  // },
  // "1640": {
  //   "place": "26 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6148,
  //     54.2823
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.615,
  //   "time": "2022-06-16 00:23:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 26 km ENE of K?sh, Iran على عمق 26.615 كم بتاريخ 2022-06-16 00:23:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhp4"
  // },
  // "1641": {
  //   "place": "24 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6164,
  //     54.259
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.616,
  //   "time": "2022-06-15 23:52:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 24 km ENE of K?sh, Iran على عمق 26.616 كم بتاريخ 2022-06-15 23:52:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhnx"
  // },
  // "1642": {
  //   "place": "22 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6005,
  //     54.2381
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 26.601,
  //   "time": "2022-06-15 20:58:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 22 km ENE of K?sh, Iran على عمق 26.601 كم بتاريخ 2022-06-15 20:58:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhma"
  // },
  // "1643": {
  //   "place": "26 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.715,
  //     54.2223
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.715,
  //   "time": "2022-06-15 18:23:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 26 km NE of K?sh, Iran على عمق 26.715 كم بتاريخ 2022-06-15 18:23:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000his6"
  // },
  // "1644": {
  //   "place": "20 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5445,
  //     54.222
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 26.545,
  //   "time": "2022-06-15 18:07:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 20 km E of K?sh, Iran على عمق 26.545 كم بتاريخ 2022-06-15 18:07:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhl5"
  // },
  // "1645": {
  //   "place": "24 km ESE of K?sh, Iran",
  //   "latLng": [
  //     26.4707,
  //     54.2449
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.471,
  //   "time": "2022-06-15 14:32:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 24 km ESE of K?sh, Iran على عمق 26.471 كم بتاريخ 2022-06-15 14:32:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hirw"
  // },
  // "1646": {
  //   "place": "22 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6795,
  //     54.2001
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.68,
  //   "time": "2022-06-15 14:26:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 22 km NE of K?sh, Iran على عمق 26.68 كم بتاريخ 2022-06-15 14:26:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhjd"
  // },
  // "1647": {
  //   "place": "24 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6371,
  //     54.2492
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.637,
  //   "time": "2022-06-15 13:16:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 24 km ENE of K?sh, Iran على عمق 26.637 كم بتاريخ 2022-06-15 13:16:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhiz"
  // },
  // "1648": {
  //   "place": "12 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5655,
  //     54.1404
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 26.566,
  //   "time": "2022-06-15 11:50:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 12 km E of K?sh, Iran على عمق 26.566 كم بتاريخ 2022-06-15 11:50:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhij#dyfi"
  // },
  // "1649": {
  //   "place": "9 km ESE of K?sh, Iran",
  //   "latLng": [
  //     26.516,
  //     54.1052
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.516,
  //   "time": "2022-06-15 09:37:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 9 km ESE of K?sh, Iran على عمق 26.516 كم بتاريخ 2022-06-15 09:37:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhi3#dyfi"
  // },
  // "1650": {
  //   "place": "24 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6531,
  //     54.2387
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 26.653,
  //   "time": "2022-06-15 06:48:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 24 km ENE of K?sh, Iran على عمق 26.653 كم بتاريخ 2022-06-15 06:48:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhhk#dyfi"
  // },
  // "1651": {
  //   "place": "23 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6727,
  //     54.2211
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 26.673,
  //   "time": "2022-06-15 06:15:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 23 km ENE of K?sh, Iran على عمق 26.673 كم بتاريخ 2022-06-15 06:15:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hirf"
  // },
  // "1652": {
  //   "place": "23 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6789,
  //     54.212
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 26.679,
  //   "time": "2022-06-15 06:06:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 23 km NE of K?sh, Iran على عمق 26.679 كم بتاريخ 2022-06-15 06:06:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhhc#pager"
  // },
  // "1653": {
  //   "place": "18 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.6549,
  //     54.1714
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 26.655,
  //   "time": "2022-06-15 06:04:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 18 km NE of K?sh, Iran على عمق 26.655 كم بتاريخ 2022-06-15 06:04:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhhb"
  // },
  // "1654": {
  //   "place": "22 km ENE of K?sh, Iran",
  //   "latLng": [
  //     26.6258,
  //     54.2374
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 26.626,
  //   "time": "2022-06-15 05:59:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 22 km ENE of K?sh, Iran على عمق 26.626 كم بتاريخ 2022-06-15 05:59:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhha"
  // },
  // "1655": {
  //   "place": "15 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5657,
  //     54.1747
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 26.566,
  //   "time": "2022-06-15 05:55:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 15 km E of K?sh, Iran على عمق 26.566 كم بتاريخ 2022-06-15 05:55:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhh9#dyfi"
  // },
  // "1656": {
  //   "place": "Northern Iran",
  //   "latLng": [
  //     36.6708,
  //     49.7757
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.671,
  //   "time": "2022-06-14 15:30:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Northern Iran على عمق 36.671 كم بتاريخ 2022-06-14 15:30:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhd7#dyfi"
  // },
  // "1657": {
  //   "place": "15 km E of K?sh, Iran",
  //   "latLng": [
  //     26.5651,
  //     54.1698
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 26.565,
  //   "time": "2022-06-14 14:09:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 15 km E of K?sh, Iran على عمق 26.565 كم بتاريخ 2022-06-14 14:09:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhbb#dyfi"
  // },
  // "1658": {
  //   "place": "66 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7278,
  //     55.9837
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.728,
  //   "time": "2022-06-14 13:44:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 66 km NNW of Bandar Abbas, Iran على عمق 27.728 كم بتاريخ 2022-06-14 13:44:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hi5r"
  // },
  // "1659": {
  //   "place": "216 km SE of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.9738,
  //     53.7377
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.974,
  //   "time": "2022-06-14 02:38:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 216 km SE of Al Ghayz?ah, Yemen على عمق 14.974 كم بتاريخ 2022-06-14 02:38:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hh7y"
  // },
  // "1660": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     36.0321,
  //     31.4165
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.032,
  //   "time": "2022-06-11 02:05:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Western Turkey على عمق 36.032 كم بتاريخ 2022-06-11 02:05:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hgmy#dyfi"
  // },
  // "1661": {
  //   "place": "93 km W of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.2995,
  //     55.3408
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.3,
  //   "time": "2022-06-10 10:43:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 93 km W of Bandar Abbas, Iran على عمق 27.3 كم بتاريخ 2022-06-10 10:43:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hhk4"
  // },
  // "1662": {
  //   "place": "137 km SE of Karpathos, Greece",
  //   "latLng": [
  //     34.6157,
  //     28.2566
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.616,
  //   "time": "2022-06-10 03:23:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 137 km SE of Karpathos, Greece على عمق 34.616 كم بتاريخ 2022-06-10 03:23:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hgdq"
  // },
  // "1663": {
  //   "place": "15 km S of Xylofágou, Cyprus",
  //   "latLng": [
  //     34.8354,
  //     33.8695
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 34.835,
  //   "time": "2022-06-10 01:40:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 15 km S of Xylofágou, Cyprus على عمق 34.835 كم بتاريخ 2022-06-10 01:40:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hgcl#dyfi"
  // },
  // "1664": {
  //   "place": "52 km ENE of Adi Keyh, Eritrea",
  //   "latLng": [
  //     14.9667,
  //     39.8442
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.967,
  //   "time": "2022-06-05 12:38:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 52 km ENE of Adi Keyh, Eritrea على عمق 14.967 كم بتاريخ 2022-06-05 12:38:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hf59"
  // },
  // "1665": {
  //   "place": "31 km NW of ?l?m, Iran",
  //   "latLng": [
  //     33.8413,
  //     46.1799
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 33.841,
  //   "time": "2022-06-05 02:26:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 31 km NW of ?l?m, Iran على عمق 33.841 كم بتاريخ 2022-06-05 02:26:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hg81"
  // },
  // "1666": {
  //   "place": "37 km NNE of Behshahr, Iran",
  //   "latLng": [
  //     36.9938,
  //     53.7347
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.994,
  //   "time": "2022-06-04 11:47:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 37 km NNE of Behshahr, Iran على عمق 36.994 كم بتاريخ 2022-06-04 11:47:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hg75"
  // },
  // "1667": {
  //   "place": "71 km SE of Bor?zj?n, Iran",
  //   "latLng": [
  //     28.739,
  //     51.6285
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.739,
  //   "time": "2022-06-04 11:02:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 71 km SE of Bor?zj?n, Iran على عمق 28.739 كم بتاريخ 2022-06-04 11:02:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hg73"
  // },
  // "1668": {
  //   "place": "37 km NNE of Shahrak-e K?l?r?, Iran",
  //   "latLng": [
  //     32.6758,
  //     48.5694
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.676,
  //   "time": "2022-06-04 01:49:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 37 km NNE of Shahrak-e K?l?r?, Iran على عمق 32.676 كم بتاريخ 2022-06-04 01:49:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hety"
  // },
  // "1669": {
  //   "place": "21 km SSW of Al A?mad?, Kuwait",
  //   "latLng": [
  //     28.9103,
  //     47.972
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.91,
  //   "time": "2022-06-04 01:28:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 21 km SSW of Al A?mad?, Kuwait على عمق 28.91 كم بتاريخ 2022-06-04 01:28:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hets#dyfi"
  // },
  // "1670": {
  //   "place": "35 km WSW of Émponas, Greece",
  //   "latLng": [
  //     36.0633,
  //     27.5159
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 36.063,
  //   "time": "2022-06-03 16:05:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 35 km WSW of Émponas, Greece على عمق 36.063 كم بتاريخ 2022-06-03 16:05:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hepi#dyfi"
  // },
  // "1671": {
  //   "place": "39 km SE of Chabahar, Iran",
  //   "latLng": [
  //     25.0269,
  //     60.9101
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 25.027,
  //   "time": "2022-06-02 19:33:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 39 km SE of Chabahar, Iran على عمق 25.027 كم بتاريخ 2022-06-02 19:33:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hega"
  // },
  // "1672": {
  //   "place": "74 km SSW of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.2163,
  //     52.2839
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 28.216,
  //   "time": "2022-06-02 06:53:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 74 km SSW of F?r?z?b?d, Iran على عمق 28.216 كم بتاريخ 2022-06-02 06:53:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hflf"
  // },
  // "1673": {
  //   "place": "147 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     33.7566,
  //     26.2607
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 33.757,
  //   "time": "2022-06-02 04:58:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 147 km SSE of Ierápetra, Greece على عمق 33.757 كم بتاريخ 2022-06-02 04:58:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hflg"
  // },
  // "1674": {
  //   "place": "58 km N of K?sh, Iran",
  //   "latLng": [
  //     27.0796,
  //     53.9118
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.08,
  //   "time": "2022-06-01 07:49:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 58 km N of K?sh, Iran على عمق 27.08 كم بتاريخ 2022-06-01 07:49:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000he10"
  // },
  // "1675": {
  //   "place": "12 km SSE of Paghm?n, Afghanistan",
  //   "latLng": [
  //     34.4941,
  //     69.0207
  //   ],
  //   "magnitude": 2.7,
  //   "depth": 34.494,
  //   "time": "2022-05-31 20:51:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 2.7 درجة في 12 km SSE of Paghm?n, Afghanistan على عمق 34.494 كم بتاريخ 2022-05-31 20:51:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hdyh#dyfi"
  // },
  // "1676": {
  //   "place": "25 km WNW of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.5549,
  //     45.6113
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.555,
  //   "time": "2022-05-30 01:23:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 25 km WNW of Sarpol-e Z?ah?b, Iran على عمق 34.555 كم بتاريخ 2022-05-30 01:23:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hdik"
  // },
  // "1677": {
  //   "place": "Iran-Iraq border region",
  //   "latLng": [
  //     34.4945,
  //     45.419
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.495,
  //   "time": "2022-05-29 05:52:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Iran-Iraq border region على عمق 34.495 كم بتاريخ 2022-05-29 05:52:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hedi"
  // },
  // "1678": {
  //   "place": "24 km WNW of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.5478,
  //     45.6115
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.548,
  //   "time": "2022-05-29 05:50:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 24 km WNW of Sarpol-e Z?ah?b, Iran على عمق 34.548 كم بتاريخ 2022-05-29 05:50:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hedq"
  // },
  // "1679": {
  //   "place": "39 km SSW of Kaka, Turkmenistan",
  //   "latLng": [
  //     37.0382,
  //     59.3995
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.038,
  //   "time": "2022-05-25 04:52:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 39 km SSW of Kaka, Turkmenistan على عمق 37.038 كم بتاريخ 2022-05-25 04:52:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hdlw"
  // },
  // "1680": {
  //   "place": "45 km SSE of Mohr, Iran",
  //   "latLng": [
  //     27.1964,
  //     53.1071
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.196,
  //   "time": "2022-05-24 13:34:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 45 km SSE of Mohr, Iran على عمق 27.196 كم بتاريخ 2022-05-24 13:34:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000hd40"
  // },
  // "1681": {
  //   "place": "104 km S of No?rat?b?d, Iran",
  //   "latLng": [
  //     28.9568,
  //     59.9333
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 28.957,
  //   "time": "2022-05-23 07:36:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 104 km S of No?rat?b?d, Iran على عمق 28.957 كم بتاريخ 2022-05-23 07:36:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hn84"
  // },
  // "1682": {
  //   "place": "33 km SW of Mandráki, Greece",
  //   "latLng": [
  //     36.4323,
  //     26.8293
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.432,
  //   "time": "2022-05-18 17:21:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 33 km SW of Mandráki, Greece على عمق 36.432 كم بتاريخ 2022-05-18 17:21:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hm36"
  // },
  // "1683": {
  //   "place": "69 km SSW of F?rs?n, Iran",
  //   "latLng": [
  //     31.6426,
  //     50.4038
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.643,
  //   "time": "2022-05-17 22:56:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 69 km SSW of F?rs?n, Iran على عمق 31.643 كم بتاريخ 2022-05-17 22:56:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hlw7"
  // },
  // "1684": {
  //   "place": "13 km NNE of Bards?r, Iran",
  //   "latLng": [
  //     30.0322,
  //     56.6248
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 30.032,
  //   "time": "2022-05-17 21:35:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 13 km NNE of Bards?r, Iran على عمق 30.032 كم بتاريخ 2022-05-17 21:35:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hlvp#dyfi"
  // },
  // "1685": {
  //   "place": "70 km ENE of R?mhormoz, Iran",
  //   "latLng": [
  //     31.6062,
  //     50.239
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 31.606,
  //   "time": "2022-05-17 14:05:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 70 km ENE of R?mhormoz, Iran على عمق 31.606 كم بتاريخ 2022-05-17 14:05:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hlsd#dyfi"
  // },
  // "1686": {
  //   "place": "62 km SSW of F?rs?n, Iran",
  //   "latLng": [
  //     31.723,
  //     50.3645
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 31.723,
  //   "time": "2022-05-17 13:06:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 62 km SSW of F?rs?n, Iran على عمق 31.723 كم بتاريخ 2022-05-17 13:06:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hlrv"
  // },
  // "1687": {
  //   "place": "126 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     33.9649,
  //     26.2954
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 33.965,
  //   "time": "2022-05-16 21:23:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 126 km SSE of Ierápetra, Greece على عمق 33.965 كم بتاريخ 2022-05-16 21:23:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hmp0"
  // },
  // "1688": {
  //   "place": "25 km SSW of Sarigerme, Turkey",
  //   "latLng": [
  //     36.5108,
  //     28.5676
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.511,
  //   "time": "2022-05-15 21:49:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 25 km SSW of Sarigerme, Turkey على عمق 36.511 كم بتاريخ 2022-05-15 21:49:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hlcz"
  // },
  // "1689": {
  //   "place": "154 km NNW of Caluula, Somalia",
  //   "latLng": [
  //     13.3157,
  //     50.4083
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.316,
  //   "time": "2022-05-14 06:39:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 154 km NNW of Caluula, Somalia على عمق 13.316 كم بتاريخ 2022-05-14 06:39:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hmdj"
  // },
  // "1690": {
  //   "place": "95 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.2239,
  //     26.1526
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 34.224,
  //   "time": "2022-05-13 07:31:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 95 km SSE of Ierápetra, Greece على عمق 34.224 كم بتاريخ 2022-05-13 07:31:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hksp#dyfi"
  // },
  // "1691": {
  //   "place": "40 km NW of Shahrak-e P?bed?n?, Iran",
  //   "latLng": [
  //     31.3784,
  //     56.0822
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 31.378,
  //   "time": "2022-05-12 06:10:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 40 km NW of Shahrak-e P?bed?n?, Iran على عمق 31.378 كم بتاريخ 2022-05-12 06:10:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hm1z"
  // },
  // "1692": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.3014,
  //     57.4931
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.301,
  //   "time": "2022-05-07 08:39:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Owen Fracture Zone region على عمق 13.301 كم بتاريخ 2022-05-07 08:39:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hkvf"
  // },
  // "1693": {
  //   "place": "80 km N of Bela, Pakistan",
  //   "latLng": [
  //     26.9552,
  //     66.2726
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 26.955,
  //   "time": "2022-05-06 06:21:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 80 km N of Bela, Pakistan على عمق 26.955 كم بتاريخ 2022-05-06 06:21:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h7gi#dyfi"
  // },
  // "1694": {
  //   "place": "46 km S of Dalbandin, Pakistan",
  //   "latLng": [
  //     28.4676,
  //     64.35
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 28.468,
  //   "time": "2022-05-06 00:48:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 46 km S of Dalbandin, Pakistan على عمق 28.468 كم بتاريخ 2022-05-06 00:48:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h7er"
  // },
  // "1695": {
  //   "place": "78 km ENE of Ger?sh, Iran",
  //   "latLng": [
  //     28.0346,
  //     54.8189
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.035,
  //   "time": "2022-05-04 06:34:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 78 km ENE of Ger?sh, Iran على عمق 28.035 كم بتاريخ 2022-05-04 06:34:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h8m1"
  // },
  // "1696": {
  //   "place": "64 km W of Bojn?rd, Iran",
  //   "latLng": [
  //     37.4865,
  //     56.5986
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.487,
  //   "time": "2022-05-03 02:26:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 64 km W of Bojn?rd, Iran على عمق 37.487 كم بتاريخ 2022-05-03 02:26:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6qy"
  // },
  // "1697": {
  //   "place": "69 km SSE of Ger?sh, Iran",
  //   "latLng": [
  //     27.1228,
  //     54.4698
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.123,
  //   "time": "2022-04-30 20:05:50 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 69 km SSE of Ger?sh, Iran على عمق 27.123 كم بتاريخ 2022-04-30 20:05:50 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h64c"
  // },
  // "1698": {
  //   "place": "17 km WSW of Ula, Turkey",
  //   "latLng": [
  //     37.054,
  //     28.236
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.054,
  //   "time": "2022-04-29 17:35:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 17 km WSW of Ula, Turkey على عمق 37.054 كم بتاريخ 2022-04-29 17:35:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h5vf#dyfi"
  // },
  // "1699": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     10.0315,
  //     56.8229
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 10.032,
  //   "time": "2022-04-28 03:40:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Carlsberg Ridge على عمق 10.032 كم بتاريخ 2022-04-28 03:40:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h7al"
  // },
  // "1700": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.9719,
  //     56.7208
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 9.972,
  //   "time": "2022-04-27 10:24:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Carlsberg Ridge على عمق 9.972 كم بتاريخ 2022-04-27 10:24:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h70z"
  // },
  // "1701": {
  //   "place": "7 km E of Konia, Cyprus",
  //   "latLng": [
  //     34.7958,
  //     32.5434
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.796,
  //   "time": "2022-04-26 20:02:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 7 km E of Konia, Cyprus على عمق 34.796 كم بتاريخ 2022-04-26 20:02:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hgid#dyfi"
  // },
  // "1702": {
  //   "place": "1 km SW of Geroskipou, Cyprus",
  //   "latLng": [
  //     34.7493,
  //     32.4322
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 34.749,
  //   "time": "2022-04-26 19:11:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 1 km SW of Geroskipou, Cyprus على عمق 34.749 كم بتاريخ 2022-04-26 19:11:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hght#dyfi"
  // },
  // "1703": {
  //   "place": "13 km W of Khulm, Afghanistan",
  //   "latLng": [
  //     36.6853,
  //     67.5509
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.685,
  //   "time": "2022-04-24 09:34:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 13 km W of Khulm, Afghanistan على عمق 36.685 كم بتاريخ 2022-04-24 09:34:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hg12"
  // },
  // "1704": {
  //   "place": "29 km S of Fry, Greece",
  //   "latLng": [
  //     35.1556,
  //     26.9705
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.156,
  //   "time": "2022-04-24 04:14:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 29 km S of Fry, Greece على عمق 35.156 كم بتاريخ 2022-04-24 04:14:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hfzb#dyfi"
  // },
  // "1705": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     29.6602,
  //     51.9671
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 29.66,
  //   "time": "2022-04-23 13:14:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في southern Iran على عمق 29.66 كم بتاريخ 2022-04-23 13:14:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hfuh#dyfi"
  // },
  // "1706": {
  //   "place": "216 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.262,
  //     51.9336
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.262,
  //   "time": "2022-04-22 14:18:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 216 km S of Al Ghayz?ah, Yemen على عمق 14.262 كم بتاريخ 2022-04-22 14:18:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6j7"
  // },
  // "1707": {
  //   "place": "199 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.4247,
  //     51.8718
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.425,
  //   "time": "2022-04-22 13:38:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 199 km S of Al Ghayz?ah, Yemen على عمق 14.425 كم بتاريخ 2022-04-22 13:38:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6j6"
  // },
  // "1708": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.6018,
  //     57.6959
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 11.602,
  //   "time": "2022-04-21 06:27:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في Owen Fracture Zone region على عمق 11.602 كم بتاريخ 2022-04-21 06:27:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h6hp"
  // },
  // "1709": {
  //   "place": "33 km NNW of Tejen, Turkmenistan",
  //   "latLng": [
  //     37.6463,
  //     60.3201
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 37.646,
  //   "time": "2022-04-18 04:48:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 33 km NNW of Tejen, Turkmenistan على عمق 37.646 كم بتاريخ 2022-04-18 04:48:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hfn4"
  // },
  // "1710": {
  //   "place": "5 km ESE of Om?d?yeh, Iran",
  //   "latLng": [
  //     30.7384,
  //     49.747
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 30.738,
  //   "time": "2022-04-18 03:13:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 5 km ESE of Om?d?yeh, Iran على عمق 30.738 كم بتاريخ 2022-04-18 03:13:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hfn1"
  // },
  // "1711": {
  //   "place": "40 km N of B?fq, Iran",
  //   "latLng": [
  //     31.9679,
  //     55.4202
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.968,
  //   "time": "2022-04-17 17:54:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 40 km N of B?fq, Iran على عمق 31.968 كم بتاريخ 2022-04-17 17:54:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h2xe"
  // },
  // "1712": {
  //   "place": "119 km NNE of Caluula, Somalia",
  //   "latLng": [
  //     13.0087,
  //     51.031
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.009,
  //   "time": "2022-04-17 08:01:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 119 km NNE of Caluula, Somalia على عمق 13.009 كم بتاريخ 2022-04-17 08:01:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000hfjx"
  // },
  // "1713": {
  //   "place": "59 km S of Demre, Turkey",
  //   "latLng": [
  //     35.7114,
  //     30.0192
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.711,
  //   "time": "2022-04-14 13:36:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 59 km S of Demre, Turkey على عمق 35.711 كم بتاريخ 2022-04-14 13:36:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h26u"
  // },
  // "1714": {
  //   "place": "65 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7448,
  //     56.0737
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.745,
  //   "time": "2022-04-14 07:41:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 65 km NNW of Bandar Abbas, Iran على عمق 27.745 كم بتاريخ 2022-04-14 07:41:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h23u#dyfi"
  // },
  // "1715": {
  //   "place": "65 km NNW of Fry, Greece",
  //   "latLng": [
  //     35.9646,
  //     26.6515
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.965,
  //   "time": "2022-04-11 18:01:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 65 km NNW of Fry, Greece على عمق 35.965 كم بتاريخ 2022-04-11 18:01:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h289"
  // },
  // "1716": {
  //   "place": "89 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.2747,
  //     55.296
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.275,
  //   "time": "2022-04-09 04:38:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 89 km NNE of Bandar-e Lengeh, Iran على عمق 27.275 كم بتاريخ 2022-04-09 04:38:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h1v2"
  // },
  // "1717": {
  //   "place": "Iran-Iraq border region",
  //   "latLng": [
  //     33.0903,
  //     45.9118
  //   ],
  //   "magnitude": 3.6,
  //   "depth": 33.09,
  //   "time": "2022-04-08 06:20:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.6 درجة في Iran-Iraq border region على عمق 33.09 كم بتاريخ 2022-04-08 06:20:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h1u9#dyfi"
  // },
  // "1718": {
  //   "place": "54 km SSW of Fry, Greece",
  //   "latLng": [
  //     34.9394,
  //     26.7671
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.939,
  //   "time": "2022-04-07 21:53:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 54 km SSW of Fry, Greece على عمق 34.939 كم بتاريخ 2022-04-07 21:53:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h1tm"
  // },
  // "1719": {
  //   "place": "159 km NNW of Caluula, Somalia",
  //   "latLng": [
  //     13.3524,
  //     50.354
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 13.352,
  //   "time": "2022-04-06 23:21:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 159 km NNW of Caluula, Somalia على عمق 13.352 كم بتاريخ 2022-04-06 23:21:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000h1sh"
  // },
  // "1720": {
  //   "place": "49 km ESE of Palekastro, Greece",
  //   "latLng": [
  //     34.9577,
  //     26.7052
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.958,
  //   "time": "2022-04-05 16:18:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 49 km ESE of Palekastro, Greece على عمق 34.958 كم بتاريخ 2022-04-05 16:18:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gzup"
  // },
  // "1721": {
  //   "place": "17 km NNE of Karaisal?, Turkey",
  //   "latLng": [
  //     37.4062,
  //     35.1184
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.406,
  //   "time": "2022-04-01 05:34:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 17 km NNE of Karaisal?, Turkey على عمق 37.406 كم بتاريخ 2022-04-01 05:34:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gyvy"
  // },
  // "1722": {
  //   "place": "175 km NNW of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5298,
  //     47.3867
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.53,
  //   "time": "2022-03-31 13:34:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 175 km NNW of Las Khorey, Somalia على عمق 12.53 كم بتاريخ 2022-03-31 13:34:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gzw0"
  // },
  // "1723": {
  //   "place": "40 km NNW of Shahrak-e K?l?r?, Iran",
  //   "latLng": [
  //     32.688,
  //     48.3012
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.688,
  //   "time": "2022-03-31 08:21:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NNW of Shahrak-e K?l?r?, Iran على عمق 32.688 كم بتاريخ 2022-03-31 08:21:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gzvg"
  // },
  // "1724": {
  //   "place": "western Iran",
  //   "latLng": [
  //     30.5893,
  //     49.9703
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 30.589,
  //   "time": "2022-03-31 04:09:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في western Iran على عمق 30.589 كم بتاريخ 2022-03-31 04:09:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gym3#dyfi"
  // },
  // "1725": {
  //   "place": "70 km SE of Tekirova, Turkey",
  //   "latLng": [
  //     36.0814,
  //     31.1221
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.081,
  //   "time": "2022-03-28 05:39:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 70 km SE of Tekirova, Turkey على عمق 36.081 كم بتاريخ 2022-03-28 05:39:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gyzr"
  // },
  // "1726": {
  //   "place": "48 km SSW of Jiwani, Pakistan",
  //   "latLng": [
  //     24.66,
  //     61.5204
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 24.66,
  //   "time": "2022-03-25 10:51:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 48 km SSW of Jiwani, Pakistan على عمق 24.66 كم بتاريخ 2022-03-25 10:51:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gyhc"
  // },
  // "1727": {
  //   "place": "93 km S of Fry, Greece",
  //   "latLng": [
  //     34.575,
  //     26.9485
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.575,
  //   "time": "2022-03-22 15:25:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 93 km S of Fry, Greece على عمق 34.575 كم بتاريخ 2022-03-22 15:25:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h6n1"
  // },
  // "1728": {
  //   "place": "115 km SSE of K?h Sef?d, Iran",
  //   "latLng": [
  //     28.3484,
  //     57.3409
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.348,
  //   "time": "2022-03-22 08:02:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 115 km SSE of K?h Sef?d, Iran على عمق 28.348 كم بتاريخ 2022-03-22 08:02:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gxbf"
  // },
  // "1729": {
  //   "place": "31 km E of Zarand, Iran",
  //   "latLng": [
  //     30.8499,
  //     56.8872
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 30.85,
  //   "time": "2022-03-20 12:20:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 31 km E of Zarand, Iran على عمق 30.85 كم بتاريخ 2022-03-20 12:20:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h66e"
  // },
  // "1730": {
  //   "place": "25 km WNW of Kahr?z, Iran",
  //   "latLng": [
  //     34.4673,
  //     46.7939
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.467,
  //   "time": "2022-03-19 18:47:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 25 km WNW of Kahr?z, Iran على عمق 34.467 كم بتاريخ 2022-03-19 18:47:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h62f"
  // },
  // "1731": {
  //   "place": "95 km SE of D?r?b, Iran",
  //   "latLng": [
  //     28.2227,
  //     55.3094
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 28.223,
  //   "time": "2022-03-19 12:25:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 95 km SE of D?r?b, Iran على عمق 28.223 كم بتاريخ 2022-03-19 12:25:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gwu4"
  // },
  // "1732": {
  //   "place": "90 km SE of D?r?b, Iran",
  //   "latLng": [
  //     28.2577,
  //     55.2753
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 28.258,
  //   "time": "2022-03-19 12:25:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 90 km SE of D?r?b, Iran على عمق 28.258 كم بتاريخ 2022-03-19 12:25:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h60f#dyfi"
  // },
  // "1733": {
  //   "place": "128 km SW of Jeddah, Saudi Arabia",
  //   "latLng": [
  //     20.777,
  //     38.2049
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 20.777,
  //   "time": "2022-03-18 17:37:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 128 km SW of Jeddah, Saudi Arabia على عمق 20.777 كم بتاريخ 2022-03-18 17:37:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gwp0"
  // },
  // "1734": {
  //   "place": "62 km NE of K?sh, Iran",
  //   "latLng": [
  //     26.971,
  //     54.4447
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.971,
  //   "time": "2022-03-17 02:48:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 62 km NE of K?sh, Iran على عمق 26.971 كم بتاريخ 2022-03-17 02:48:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h6pl"
  // },
  // "1735": {
  //   "place": "45 km NW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.8796,
  //     54.5923
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 26.88,
  //   "time": "2022-03-17 02:45:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 45 km NW of Bandar-e Lengeh, Iran على عمق 26.88 كم بتاريخ 2022-03-17 02:45:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h6pk"
  // },
  // "1736": {
  //   "place": "58 km NW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     26.9646,
  //     54.5095
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 26.965,
  //   "time": "2022-03-16 23:34:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 58 km NW of Bandar-e Lengeh, Iran على عمق 26.965 كم بتاريخ 2022-03-16 23:34:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h6gw"
  // },
  // "1737": {
  //   "place": "60 km NNW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.026,
  //     54.5754
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.026,
  //   "time": "2022-03-16 23:27:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 60 km NNW of Bandar-e Lengeh, Iran على عمق 27.026 كم بتاريخ 2022-03-16 23:27:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h5a6#dyfi"
  // },
  // "1738": {
  //   "place": "59 km NNW of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.0219,
  //     54.5843
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 27.022,
  //   "time": "2022-03-16 23:15:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.9 درجة في 59 km NNW of Bandar-e Lengeh, Iran على عمق 27.022 كم بتاريخ 2022-03-16 23:15:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h58x#pager"
  // },
  // "1739": {
  //   "place": "19 km SSW of Qal?t, Afghanistan",
  //   "latLng": [
  //     31.945,
  //     66.8343
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 31.945,
  //   "time": "2022-03-16 12:02:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 19 km SSW of Qal?t, Afghanistan على عمق 31.945 كم بتاريخ 2022-03-16 12:02:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h50p"
  // },
  // "1740": {
  //   "place": "63 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6989,
  //     56.5596
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.699,
  //   "time": "2022-03-15 15:43:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 63 km NNE of Bandar Abbas, Iran على عمق 27.699 كم بتاريخ 2022-03-15 15:43:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h5ti"
  // },
  // "1741": {
  //   "place": "18 km NNW of Datça, Turkey",
  //   "latLng": [
  //     36.8988,
  //     27.6253
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.899,
  //   "time": "2022-03-14 01:05:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 18 km NNW of Datça, Turkey على عمق 36.899 كم بتاريخ 2022-03-14 01:05:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h4bw"
  // },
  // "1742": {
  //   "place": "39 km ESE of Kifr?, Iraq",
  //   "latLng": [
  //     34.5734,
  //     45.3696
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.573,
  //   "time": "2022-03-13 05:04:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 39 km ESE of Kifr?, Iraq على عمق 34.573 كم بتاريخ 2022-03-13 05:04:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h5g3"
  // },
  // "1743": {
  //   "place": "63 km S of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.2742,
  //     52.6628
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.274,
  //   "time": "2022-03-10 04:41:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 63 km S of F?r?z?b?d, Iran على عمق 28.274 كم بتاريخ 2022-03-10 04:41:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h53x"
  // },
  // "1744": {
  //   "place": "35 km S of Sari, Iran",
  //   "latLng": [
  //     36.2465,
  //     53.0916
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.247,
  //   "time": "2022-03-10 02:58:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 35 km S of Sari, Iran على عمق 36.247 كم بتاريخ 2022-03-10 02:58:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h3gm#dyfi"
  // },
  // "1745": {
  //   "place": "48 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5532,
  //     56.0105
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.553,
  //   "time": "2022-03-08 23:21:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 48 km NNW of Bandar Abbas, Iran على عمق 27.553 كم بتاريخ 2022-03-08 23:21:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h36i"
  // },
  // "1746": {
  //   "place": "70 km NNW of Dire Dawa, Ethiopia",
  //   "latLng": [
  //     10.1608,
  //     41.5797
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 10.161,
  //   "time": "2022-03-08 19:51:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 70 km NNW of Dire Dawa, Ethiopia على عمق 10.161 كم بتاريخ 2022-03-08 19:51:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h3uj"
  // },
  // "1747": {
  //   "place": "56 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.2012,
  //     53.2979
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 27.201,
  //   "time": "2022-03-07 23:30:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 56 km SE of Mohr, Iran على عمق 27.201 كم بتاريخ 2022-03-07 23:30:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h2x1"
  // },
  // "1748": {
  //   "place": "36 km S of Fry, Greece",
  //   "latLng": [
  //     35.0934,
  //     26.9839
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.093,
  //   "time": "2022-03-07 01:59:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 36 km S of Fry, Greece على عمق 35.093 كم بتاريخ 2022-03-07 01:59:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h2mx"
  // },
  // "1749": {
  //   "place": "37 km WSW of F?rs?n, Iran",
  //   "latLng": [
  //     32.0854,
  //     50.2177
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.085,
  //   "time": "2022-03-04 17:55:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 37 km WSW of F?rs?n, Iran على عمق 32.085 كم بتاريخ 2022-03-04 17:55:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h23l"
  // },
  // "1750": {
  //   "place": "57 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.1518,
  //     53.2501
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.152,
  //   "time": "2022-03-04 10:46:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 57 km SE of Mohr, Iran على عمق 27.152 كم بتاريخ 2022-03-04 10:46:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h20t"
  // },
  // "1751": {
  //   "place": "119 km SW of Bam, Iran",
  //   "latLng": [
  //     28.2601,
  //     57.5922
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 28.26,
  //   "time": "2022-03-02 03:06:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 119 km SW of Bam, Iran على عمق 28.26 كم بتاريخ 2022-03-02 03:06:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h19y"
  // },
  // "1752": {
  //   "place": "34 km N of Palekastro, Greece",
  //   "latLng": [
  //     35.5067,
  //     26.3136
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.507,
  //   "time": "2022-02-27 05:04:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 34 km N of Palekastro, Greece على عمق 35.507 كم بتاريخ 2022-02-27 05:04:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h0gf"
  // },
  // "1753": {
  //   "place": "61 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7333,
  //     56.19
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.733,
  //   "time": "2022-02-24 03:30:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 61 km N of Bandar Abbas, Iran على عمق 27.733 كم بتاريخ 2022-02-24 03:30:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gzpb"
  // },
  // "1754": {
  //   "place": "231 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.6095,
  //     54.7571
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 14.61,
  //   "time": "2022-02-22 23:16:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 231 km NNE of Hadibu, Yemen على عمق 14.61 كم بتاريخ 2022-02-22 23:16:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gn2w"
  // },
  // "1755": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     11.6164,
  //     57.4981
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 11.616,
  //   "time": "2022-02-22 19:57:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 11.616 كم بتاريخ 2022-02-22 19:57:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000h04t"
  // },
  // "1756": {
  //   "place": "46 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6007,
  //     56.3352
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.601,
  //   "time": "2022-02-22 19:55:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 46 km N of Bandar Abbas, Iran على عمق 27.601 كم بتاريخ 2022-02-22 19:55:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gn1e#dyfi"
  // },
  // "1757": {
  //   "place": "12 km NW of Baghl?n, Afghanistan",
  //   "latLng": [
  //     36.1973,
  //     68.6023
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.197,
  //   "time": "2022-02-22 14:59:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 12 km NW of Baghl?n, Afghanistan على عمق 36.197 كم بتاريخ 2022-02-22 14:59:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gmyp"
  // },
  // "1758": {
  //   "place": "32 km NE of Al K?t, Iraq",
  //   "latLng": [
  //     32.6877,
  //     46.1011
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 32.688,
  //   "time": "2022-02-20 12:45:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 32 km NE of Al K?t, Iraq على عمق 32.688 كم بتاريخ 2022-02-20 12:45:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gmf6"
  // },
  // "1759": {
  //   "place": "85 km SE of Bushehr, Iran",
  //   "latLng": [
  //     28.5112,
  //     51.5435
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.511,
  //   "time": "2022-02-20 06:50:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 85 km SE of Bushehr, Iran على عمق 28.511 كم بتاريخ 2022-02-20 06:50:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gzts"
  // },
  // "1760": {
  //   "place": "67 km WNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.3465,
  //     55.6258
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.347,
  //   "time": "2022-02-16 04:39:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 67 km WNW of Bandar Abbas, Iran على عمق 27.347 كم بتاريخ 2022-02-16 04:39:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gmta"
  // },
  // "1761": {
  //   "place": "45 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5803,
  //     56.1635
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.58,
  //   "time": "2022-02-16 02:09:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 45 km NNW of Bandar Abbas, Iran على عمق 27.58 كم بتاريخ 2022-02-16 02:09:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gl6t"
  // },
  // "1762": {
  //   "place": "73 km WNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.3279,
  //     55.5554
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.328,
  //   "time": "2022-02-16 00:49:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 73 km WNW of Bandar Abbas, Iran على عمق 27.328 كم بتاريخ 2022-02-16 00:49:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gl6b"
  // },
  // "1763": {
  //   "place": "19 km SSE of Güvercinlik, Turkey",
  //   "latLng": [
  //     36.9648,
  //     27.641
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.965,
  //   "time": "2022-02-11 16:18:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 19 km SSE of Güvercinlik, Turkey على عمق 36.965 كم بتاريخ 2022-02-11 16:18:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gk05"
  // },
  // "1764": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.3229,
  //     56.6603
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.323,
  //   "time": "2022-02-08 15:12:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Owen Fracture Zone region على عمق 14.323 كم بتاريخ 2022-02-08 15:12:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gk23"
  // },
  // "1765": {
  //   "place": "48 km ENE of Mohr, Iran",
  //   "latLng": [
  //     27.7125,
  //     53.3455
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.713,
  //   "time": "2022-02-05 05:34:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 48 km ENE of Mohr, Iran على عمق 27.713 كم بتاريخ 2022-02-05 05:34:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gjp7"
  // },
  // "1766": {
  //   "place": "9 km S of Darz?b, Afghanistan",
  //   "latLng": [
  //     35.8923,
  //     65.3793
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 35.892,
  //   "time": "2022-02-03 16:29:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 9 km S of Darz?b, Afghanistan على عمق 35.892 كم بتاريخ 2022-02-03 16:29:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ghmf"
  // },
  // "1767": {
  //   "place": "55 km WNW of P?geia, Cyprus",
  //   "latLng": [
  //     35.0634,
  //     31.8203
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 35.063,
  //   "time": "2022-02-02 21:03:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 55 km WNW of P?geia, Cyprus على عمق 35.063 كم بتاريخ 2022-02-02 21:03:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ghf9#dyfi"
  // },
  // "1768": {
  //   "place": "10 km NE of K?zer?n, Iran",
  //   "latLng": [
  //     29.6736,
  //     51.7369
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 29.674,
  //   "time": "2022-02-02 02:49:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 10 km NE of K?zer?n, Iran على عمق 29.674 كم بتاريخ 2022-02-02 02:49:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gh74"
  // },
  // "1769": {
  //   "place": "33 km E of Al W?si?ah, Egypt",
  //   "latLng": [
  //     29.3644,
  //     31.5521
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 29.364,
  //   "time": "2022-02-01 09:01:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 33 km E of Al W?si?ah, Egypt على عمق 29.364 كم بتاريخ 2022-02-01 09:01:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ggx5#dyfi"
  // },
  // "1770": {
  //   "place": "47 km SW of Kohlu, Pakistan",
  //   "latLng": [
  //     29.5941,
  //     68.9004
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 29.594,
  //   "time": "2022-01-31 17:03:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 47 km SW of Kohlu, Pakistan على عمق 29.594 كم بتاريخ 2022-01-31 17:03:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ggpl"
  // },
  // "1771": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.2747,
  //     56.3762
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.275,
  //   "time": "2022-01-31 13:45:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 14.275 كم بتاريخ 2022-01-31 13:45:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gi0d"
  // },
  // "1772": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4513,
  //     56.3826
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 14.451,
  //   "time": "2022-01-31 12:42:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في Owen Fracture Zone region على عمق 14.451 كم بتاريخ 2022-01-31 12:42:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gglq"
  // },
  // "1773": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4413,
  //     56.3354
  //   ],
  //   "magnitude": 5.4,
  //   "depth": 14.441,
  //   "time": "2022-01-31 12:38:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.4 درجة في Owen Fracture Zone region على عمق 14.441 كم بتاريخ 2022-01-31 12:38:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gglp#pager"
  // },
  // "1774": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.3531,
  //     56.2208
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.353,
  //   "time": "2022-01-31 12:14:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 14.353 كم بتاريخ 2022-01-31 12:14:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ghzz"
  // },
  // "1775": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     14.4867,
  //     56.401
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 14.487,
  //   "time": "2022-01-31 11:56:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في Owen Fracture Zone region على عمق 14.487 كم بتاريخ 2022-01-31 11:56:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ggl9"
  // },
  // "1776": {
  //   "place": "19 km NW of Bandar-e Gen?veh, Iran",
  //   "latLng": [
  //     29.6987,
  //     50.3717
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.699,
  //   "time": "2022-01-30 23:47:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 19 km NW of Bandar-e Gen?veh, Iran على عمق 29.699 كم بتاريخ 2022-01-30 23:47:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ghz5"
  // },
  // "1777": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.9408,
  //     56.9995
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 9.941,
  //   "time": "2022-01-29 00:58:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Carlsberg Ridge على عمق 9.941 كم بتاريخ 2022-01-29 00:58:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gg3d"
  // },
  // "1778": {
  //   "place": "45 km W of Pólis, Cyprus",
  //   "latLng": [
  //     35.0789,
  //     31.9346
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 35.079,
  //   "time": "2022-01-28 03:57:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 45 km W of Pólis, Cyprus على عمق 35.079 كم بتاريخ 2022-01-28 03:57:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gfrj#dyfi"
  // },
  // "1779": {
  //   "place": "4 km ENE of Kafr Mi?r, Israel",
  //   "latLng": [
  //     32.6567,
  //     35.4637
  //   ],
  //   "magnitude": 3.7,
  //   "depth": 32.657,
  //   "time": "2022-01-23 10:28:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.7 درجة في 4 km ENE of Kafr Mi?r, Israel على عمق 32.657 كم بتاريخ 2022-01-23 10:28:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gefv#dyfi"
  // },
  // "1780": {
  //   "place": "69 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.5687,
  //     26.3018
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.569,
  //   "time": "2022-01-23 00:45:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 69 km S of Palekastro, Greece على عمق 34.569 كم بتاريخ 2022-01-23 00:45:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000geaw#dyfi"
  // },
  // "1781": {
  //   "place": "73 km NW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5807,
  //     55.689
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.581,
  //   "time": "2022-01-22 21:54:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 73 km NW of Bandar Abbas, Iran على عمق 27.581 كم بتاريخ 2022-01-22 21:54:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gfy2"
  // },
  // "1782": {
  //   "place": "4 km E of Taiyiba, Israel",
  //   "latLng": [
  //     32.6069,
  //     35.494
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.607,
  //   "time": "2022-01-22 21:36:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 4 km E of Taiyiba, Israel على عمق 32.607 كم بتاريخ 2022-01-22 21:36:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000geaf#dyfi"
  // },
  // "1783": {
  //   "place": "91 km SSW of F?r?z?b?d, Iran",
  //   "latLng": [
  //     28.1076,
  //     52.1553
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.108,
  //   "time": "2022-01-21 13:32:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 91 km SSW of F?r?z?b?d, Iran على عمق 28.108 كم بتاريخ 2022-01-21 13:32:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gduy#dyfi"
  // },
  // "1784": {
  //   "place": "93 km NW of Mohr, Iran",
  //   "latLng": [
  //     28.071,
  //     52.1299
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.071,
  //   "time": "2022-01-21 12:49:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 93 km NW of Mohr, Iran على عمق 28.071 كم بتاريخ 2022-01-21 12:49:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gfvx"
  // },
  // "1785": {
  //   "place": "140 km SSE of Mukalla, Yemen",
  //   "latLng": [
  //     13.3464,
  //     49.5623
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 13.346,
  //   "time": "2022-01-20 15:23:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 140 km SSE of Mukalla, Yemen على عمق 13.346 كم بتاريخ 2022-01-20 15:23:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gfus"
  // },
  // "1786": {
  //   "place": "96 km ESE of Qom, Iran",
  //   "latLng": [
  //     34.2067,
  //     51.786
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 34.207,
  //   "time": "2022-01-20 01:37:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 96 km ESE of Qom, Iran على عمق 34.207 كم بتاريخ 2022-01-20 01:37:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gde3#dyfi"
  // },
  // "1787": {
  //   "place": "23 km E of Khulm, Afghanistan",
  //   "latLng": [
  //     36.6984,
  //     67.9575
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.698,
  //   "time": "2022-01-19 06:23:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 23 km E of Khulm, Afghanistan على عمق 36.698 كم بتاريخ 2022-01-19 06:23:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd3v"
  // },
  // "1788": {
  //   "place": "27 km S of Dehdasht, Iran",
  //   "latLng": [
  //     30.5469,
  //     50.5909
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 30.547,
  //   "time": "2022-01-19 06:05:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 27 km S of Dehdasht, Iran على عمق 30.547 كم بتاريخ 2022-01-19 06:05:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd3t"
  // },
  // "1789": {
  //   "place": "40 km S of Fry, Greece",
  //   "latLng": [
  //     35.0569,
  //     26.994
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.057,
  //   "time": "2022-01-17 22:28:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 40 km S of Fry, Greece على عمق 35.057 كم بتاريخ 2022-01-17 22:28:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gf20"
  // },
  // "1790": {
  //   "place": "45 km E of Qala i Naw, Afghanistan",
  //   "latLng": [
  //     34.9289,
  //     63.6208
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 34.929,
  //   "time": "2022-01-17 11:40:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 45 km E of Qala i Naw, Afghanistan على عمق 34.929 كم بتاريخ 2022-01-17 11:40:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gclu#pager"
  // },
  // "1791": {
  //   "place": "49 km E of Qala i Naw, Afghanistan",
  //   "latLng": [
  //     34.9362,
  //     63.6666
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 34.936,
  //   "time": "2022-01-17 09:35:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 49 km E of Qala i Naw, Afghanistan على عمق 34.936 كم بتاريخ 2022-01-17 09:35:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gcle"
  // },
  // "1792": {
  //   "place": "41 km SW of Ölüdeniz, Turkey",
  //   "latLng": [
  //     36.261,
  //     28.8712
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.261,
  //   "time": "2022-01-16 22:16:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 41 km SW of Ölüdeniz, Turkey على عمق 36.261 كم بتاريخ 2022-01-16 22:16:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gciz#dyfi"
  // },
  // "1793": {
  //   "place": "15 km SW of Kh?rk, Iran",
  //   "latLng": [
  //     29.1548,
  //     50.2316
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 29.155,
  //   "time": "2022-01-16 04:25:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 15 km SW of Kh?rk, Iran على عمق 29.155 كم بتاريخ 2022-01-16 04:25:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gcd5#dyfi"
  // },
  // "1794": {
  //   "place": "7 km SSW of Kh?rk, Iran",
  //   "latLng": [
  //     29.194,
  //     50.3094
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 29.194,
  //   "time": "2022-01-16 02:49:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 7 km SSW of Kh?rk, Iran على عمق 29.194 كم بتاريخ 2022-01-16 02:49:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gccw#dyfi"
  // },
  // "1795": {
  //   "place": "Kerman, Iran",
  //   "latLng": [
  //     30.4586,
  //     57.3407
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 30.459,
  //   "time": "2022-01-15 13:35:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في Kerman, Iran على عمق 30.459 كم بتاريخ 2022-01-15 13:35:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gc8m#dyfi"
  // },
  // "1796": {
  //   "place": "17 km S of Kh?rk, Iran",
  //   "latLng": [
  //     29.1072,
  //     50.3238
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 29.107,
  //   "time": "2022-01-15 12:25:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 17 km S of Kh?rk, Iran على عمق 29.107 كم بتاريخ 2022-01-15 12:25:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gc8a"
  // },
  // "1797": {
  //   "place": "39 km NNE of Gwadar, Pakistan",
  //   "latLng": [
  //     25.4644,
  //     62.4473
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 25.464,
  //   "time": "2022-01-11 21:21:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 39 km NNE of Gwadar, Pakistan على عمق 25.464 كم بتاريخ 2022-01-11 21:21:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gb39"
  // },
  // "1798": {
  //   "place": "48 km WNW of Pólis, Cyprus",
  //   "latLng": [
  //     35.2267,
  //     31.9435
  //   ],
  //   "magnitude": 6.6,
  //   "depth": 35.227,
  //   "time": "2022-01-11 01:07:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.6 درجة في 48 km WNW of Pólis, Cyprus على عمق 35.227 كم بتاريخ 2022-01-11 01:07:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gaqu#pager"
  // },
  // "1799": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     12.7171,
  //     58.2785
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 12.717,
  //   "time": "2022-01-10 23:34:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Owen Fracture Zone region على عمق 12.717 كم بتاريخ 2022-01-10 23:34:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd7g"
  // },
  // "1800": {
  //   "place": "10 km SE of Jamjam?l, Iraq",
  //   "latLng": [
  //     35.4789,
  //     44.9228
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 35.479,
  //   "time": "2022-01-10 20:11:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 10 km SE of Jamjam?l, Iraq على عمق 35.479 كم بتاريخ 2022-01-10 20:11:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd7k"
  // },
  // "1801": {
  //   "place": "8 km E of Jamjam?l, Iraq",
  //   "latLng": [
  //     35.5272,
  //     44.9269
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 35.527,
  //   "time": "2022-01-10 18:29:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 8 km E of Jamjam?l, Iraq على عمق 35.527 كم بتاريخ 2022-01-10 18:29:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gamy#dyfi"
  // },
  // "1802": {
  //   "place": "49 km ENE of Bandar-e Gen?veh, Iran",
  //   "latLng": [
  //     29.7699,
  //     50.9831
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 29.77,
  //   "time": "2022-01-10 18:07:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 49 km ENE of Bandar-e Gen?veh, Iran على عمق 29.77 كم بتاريخ 2022-01-10 18:07:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gd79"
  // },
  // "1803": {
  //   "place": "44 km NNW of Bor?zj?n, Iran",
  //   "latLng": [
  //     29.6652,
  //     51.1191
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 29.665,
  //   "time": "2022-01-10 17:58:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 44 km NNW of Bor?zj?n, Iran على عمق 29.665 كم بتاريخ 2022-01-10 17:58:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gamp"
  // },
  // "1804": {
  //   "place": "119 km SSE of K?h Sef?d, Iran",
  //   "latLng": [
  //     28.2228,
  //     57.0811
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 28.223,
  //   "time": "2022-01-10 17:46:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 119 km SSE of K?h Sef?d, Iran على عمق 28.223 كم بتاريخ 2022-01-10 17:46:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gamg"
  // },
  // "1805": {
  //   "place": "108 km NNE of Caluula, Somalia",
  //   "latLng": [
  //     12.9297,
  //     50.9603
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 12.93,
  //   "time": "2022-01-06 23:47:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 108 km NNE of Caluula, Somalia على عمق 12.93 كم بتاريخ 2022-01-06 23:47:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gc21"
  // },
  // "1806": {
  //   "place": "137 km N of Caluula, Somalia",
  //   "latLng": [
  //     13.1884,
  //     50.9694
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 13.188,
  //   "time": "2022-01-06 23:24:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 137 km N of Caluula, Somalia على عمق 13.188 كم بتاريخ 2022-01-06 23:24:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g9rx"
  // },
  // "1807": {
  //   "place": "150 km N of Caluula, Somalia",
  //   "latLng": [
  //     13.3185,
  //     50.9276
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.319,
  //   "time": "2022-01-06 23:23:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 150 km N of Caluula, Somalia على عمق 13.319 كم بتاريخ 2022-01-06 23:23:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gc20"
  // },
  // "1808": {
  //   "place": "67 km SSW of Okurcalar, Turkey",
  //   "latLng": [
  //     36.1445,
  //     31.2928
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 36.145,
  //   "time": "2022-01-05 03:21:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 67 km SSW of Okurcalar, Turkey على عمق 36.145 كم بتاريخ 2022-01-05 03:21:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g94d#dyfi"
  // },
  // "1809": {
  //   "place": "23 km W of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.4811,
  //     45.6028
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.481,
  //   "time": "2022-01-05 01:09:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 23 km W of Sarpol-e Z?ah?b, Iran على عمق 34.481 كم بتاريخ 2022-01-05 01:09:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000gbzd"
  // },
  // "1810": {
  //   "place": "294 km SE of Hadibu, Yemen",
  //   "latLng": [
  //     10.7326,
  //     55.898
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 10.733,
  //   "time": "2021-12-31 02:41:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 294 km SE of Hadibu, Yemen على عمق 10.733 كم بتاريخ 2021-12-31 02:41:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g83r"
  // },
  // "1811": {
  //   "place": "106 km NNE of Bandar Abbas, Iran",
  //   "latLng": [
  //     28.0725,
  //     56.6978
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.073,
  //   "time": "2021-12-30 01:15:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 106 km NNE of Bandar Abbas, Iran على عمق 28.073 كم بتاريخ 2021-12-30 01:15:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g7vf"
  // },
  // "1812": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.9615,
  //     57.1801
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.962,
  //   "time": "2021-12-29 03:15:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في Owen Fracture Zone region على عمق 13.962 كم بتاريخ 2021-12-29 03:15:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gfzz"
  // },
  // "1813": {
  //   "place": "58 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.711,
  //     56.2104
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 27.711,
  //   "time": "2021-12-27 07:31:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 58 km N of Bandar Abbas, Iran على عمق 27.711 كم بتاريخ 2021-12-27 07:31:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gfkh#dyfi"
  // },
  // "1814": {
  //   "place": "35 km S of Fry, Greece",
  //   "latLng": [
  //     35.102,
  //     26.9943
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.102,
  //   "time": "2021-12-26 22:02:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 35 km S of Fry, Greece على عمق 35.102 كم بتاريخ 2021-12-26 22:02:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gfim"
  // },
  // "1815": {
  //   "place": "39 km S of Fry, Greece",
  //   "latLng": [
  //     35.056,
  //     26.9226
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.056,
  //   "time": "2021-12-26 19:01:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 39 km S of Fry, Greece على عمق 35.056 كم بتاريخ 2021-12-26 19:01:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g9ms"
  // },
  // "1816": {
  //   "place": "25 km S of Fry, Greece",
  //   "latLng": [
  //     35.1923,
  //     26.9659
  //   ],
  //   "magnitude": 5.6,
  //   "depth": 35.192,
  //   "time": "2021-12-26 18:59:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.6 درجة في 25 km S of Fry, Greece على عمق 35.192 كم بتاريخ 2021-12-26 18:59:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gfhq#pager"
  // },
  // "1817": {
  //   "place": "30 km S of Fry, Greece",
  //   "latLng": [
  //     35.1452,
  //     26.8939
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 35.145,
  //   "time": "2021-12-26 15:15:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 30 km S of Fry, Greece على عمق 35.145 كم بتاريخ 2021-12-26 15:15:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gffm#dyfi"
  // },
  // "1818": {
  //   "place": "5 km WSW of Mandráki, Greece",
  //   "latLng": [
  //     36.5925,
  //     27.0733
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.593,
  //   "time": "2021-12-25 12:19:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 5 km WSW of Mandráki, Greece على عمق 36.593 كم بتاريخ 2021-12-25 12:19:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gf7n"
  // },
  // "1819": {
  //   "place": "22 km SSW of Alik Ghund, Pakistan",
  //   "latLng": [
  //     30.314,
  //     67.4107
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 30.314,
  //   "time": "2021-12-25 06:39:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 22 km SSW of Alik Ghund, Pakistan على عمق 30.314 كم بتاريخ 2021-12-25 06:39:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gf61#dyfi"
  // },
  // "1820": {
  //   "place": "53 km WNW of K?zer?n, Iran",
  //   "latLng": [
  //     29.7481,
  //     51.1246
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 29.748,
  //   "time": "2021-12-24 21:39:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 53 km WNW of K?zer?n, Iran على عمق 29.748 كم بتاريخ 2021-12-24 21:39:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000g9jz"
  // },
  // "1821": {
  //   "place": "149 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.858,
  //     52.1551
  //   ],
  //   "magnitude": 5.3,
  //   "depth": 14.858,
  //   "time": "2021-12-24 10:57:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.3 درجة في 149 km S of Al Ghayz?ah, Yemen على عمق 14.858 كم بتاريخ 2021-12-24 10:57:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gf1c#dyfi"
  // },
  // "1822": {
  //   "place": "56 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6775,
  //     56.114
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.678,
  //   "time": "2021-12-21 16:36:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 56 km NNW of Bandar Abbas, Iran على عمق 27.678 كم بتاريخ 2021-12-21 16:36:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ge6h"
  // },
  // "1823": {
  //   "place": "78 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.5574,
  //     26.6257
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.557,
  //   "time": "2021-12-19 07:23:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 78 km SSE of Palekastro, Greece على عمق 34.557 كم بتاريخ 2021-12-19 07:23:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gdjm"
  // },
  // "1824": {
  //   "place": "158 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.59,
  //     48.0763
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 12.59,
  //   "time": "2021-12-18 21:02:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 158 km N of Las Khorey, Somalia على عمق 12.59 كم بتاريخ 2021-12-18 21:02:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gekk"
  // },
  // "1825": {
  //   "place": "33 km NE of Chabahar, Iran",
  //   "latLng": [
  //     25.5047,
  //     60.8744
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 25.505,
  //   "time": "2021-12-18 19:40:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 33 km NE of Chabahar, Iran على عمق 25.505 كم بتاريخ 2021-12-18 19:40:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gekf"
  // },
  // "1826": {
  //   "place": "162 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.6192,
  //     48.052
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 12.619,
  //   "time": "2021-12-17 02:48:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 162 km N of Las Khorey, Somalia على عمق 12.619 كم بتاريخ 2021-12-17 02:48:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gehq"
  // },
  // "1827": {
  //   "place": "151 km N of Las Khorey, Somalia",
  //   "latLng": [
  //     12.5247,
  //     48.3
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 12.525,
  //   "time": "2021-12-17 01:35:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 151 km N of Las Khorey, Somalia على عمق 12.525 كم بتاريخ 2021-12-17 01:35:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gd0b"
  // },
  // "1828": {
  //   "place": "150 km NNW of Caluula, Somalia",
  //   "latLng": [
  //     13.2657,
  //     50.3363
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 13.266,
  //   "time": "2021-12-15 17:33:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 150 km NNW of Caluula, Somalia على عمق 13.266 كم بتاريخ 2021-12-15 17:33:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gch1"
  // },
  // "1829": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     8.7058,
  //     58.3167
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 8.706,
  //   "time": "2021-12-15 10:02:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في Carlsberg Ridge على عمق 8.706 كم بتاريخ 2021-12-15 10:02:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gdus"
  // },
  // "1830": {
  //   "place": "55 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.3102,
  //     49.693
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 32.31,
  //   "time": "2021-12-15 08:21:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 55 km NE of Masjed Soleym?n, Iran على عمق 32.31 كم بتاريخ 2021-12-15 08:21:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gccv#dyfi"
  // },
  // "1831": {
  //   "place": "105 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.2646,
  //     26.4859
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.265,
  //   "time": "2021-12-15 03:43:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 105 km SSE of Palekastro, Greece على عمق 34.265 كم بتاريخ 2021-12-15 03:43:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gcbq"
  // },
  // "1832": {
  //   "place": "49 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6327,
  //     56.2227
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.633,
  //   "time": "2021-12-15 00:55:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 49 km N of Bandar Abbas, Iran على عمق 27.633 كم بتاريخ 2021-12-15 00:55:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gcb6"
  // },
  // "1833": {
  //   "place": "55 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.3119,
  //     49.6937
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 32.312,
  //   "time": "2021-12-14 21:23:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 55 km NE of Masjed Soleym?n, Iran على عمق 32.312 كم بتاريخ 2021-12-14 21:23:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gc9g"
  // },
  // "1834": {
  //   "place": "58 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6688,
  //     56.0484
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.669,
  //   "time": "2021-12-14 15:34:53 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 58 km NNW of Bandar Abbas, Iran على عمق 27.669 كم بتاريخ 2021-12-14 15:34:53 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gc6k"
  // },
  // "1835": {
  //   "place": "51 km SW of N?r?b?d, Iran",
  //   "latLng": [
  //     29.7974,
  //     51.1265
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 29.797,
  //   "time": "2021-12-14 09:12:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 51 km SW of N?r?b?d, Iran على عمق 29.797 كم بتاريخ 2021-12-14 09:12:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gc4v"
  // },
  // "1836": {
  //   "place": "48 km WNW of Kotri, Pakistan",
  //   "latLng": [
  //     25.4558,
  //     67.8352
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 25.456,
  //   "time": "2021-12-12 00:27:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 48 km WNW of Kotri, Pakistan على عمق 25.456 كم بتاريخ 2021-12-12 00:27:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gbiy#dyfi"
  // },
  // "1837": {
  //   "place": "28 km E of Zarand, Iran",
  //   "latLng": [
  //     30.8043,
  //     56.8578
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 30.804,
  //   "time": "2021-12-11 18:56:06 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 28 km E of Zarand, Iran على عمق 30.804 كم بتاريخ 2021-12-11 18:56:06 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gbgn#dyfi"
  // },
  // "1838": {
  //   "place": "54 km WSW of Khuzdar, Pakistan",
  //   "latLng": [
  //     27.6367,
  //     66.0912
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.637,
  //   "time": "2021-12-11 15:30:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 54 km WSW of Khuzdar, Pakistan على عمق 27.637 كم بتاريخ 2021-12-11 15:30:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gbfp"
  // },
  // "1839": {
  //   "place": "45 km W of Khuzdar, Pakistan",
  //   "latLng": [
  //     27.889,
  //     66.1589
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.889,
  //   "time": "2021-12-11 13:43:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 45 km W of Khuzdar, Pakistan على عمق 27.889 كم بتاريخ 2021-12-11 13:43:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gchn"
  // },
  // "1840": {
  //   "place": "54 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6582,
  //     56.1216
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.658,
  //   "time": "2021-12-10 17:33:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 54 km NNW of Bandar Abbas, Iran على عمق 27.658 كم بتاريخ 2021-12-10 17:33:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gb96#dyfi"
  // },
  // "1841": {
  //   "place": "27 km N of Gharo, Pakistan",
  //   "latLng": [
  //     24.9902,
  //     67.5668
  //   ],
  //   "magnitude": 3.9,
  //   "depth": 24.99,
  //   "time": "2021-12-08 17:16:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 3.9 درجة في 27 km N of Gharo, Pakistan على عمق 24.99 كم بتاريخ 2021-12-08 17:16:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gan6#dyfi"
  // },
  // "1842": {
  //   "place": "63 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7371,
  //     56.1076
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.737,
  //   "time": "2021-12-07 23:07:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 63 km NNW of Bandar Abbas, Iran على عمق 27.737 كم بتاريخ 2021-12-07 23:07:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gb8d"
  // },
  // "1843": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.6618,
  //     57.394
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 13.662,
  //   "time": "2021-12-04 09:47:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في Owen Fracture Zone region على عمق 13.662 كم بتاريخ 2021-12-04 09:47:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000gajw"
  // },
  // "1844": {
  //   "place": "Carlsberg Ridge",
  //   "latLng": [
  //     9.9668,
  //     57.0915
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 9.967,
  //   "time": "2021-12-03 21:16:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في Carlsberg Ridge على عمق 9.967 كم بتاريخ 2021-12-03 21:16:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8uz"
  // },
  // "1845": {
  //   "place": "25 km NW of Baghl?n, Afghanistan",
  //   "latLng": [
  //     36.2637,
  //     68.4836
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.264,
  //   "time": "2021-12-02 17:57:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 25 km NW of Baghl?n, Afghanistan على عمق 36.264 كم بتاريخ 2021-12-02 17:57:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8i3"
  // },
  // "1846": {
  //   "place": "55 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6346,
  //     56.0251
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.635,
  //   "time": "2021-12-01 01:42:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 55 km NNW of Bandar Abbas, Iran على عمق 27.635 كم بتاريخ 2021-12-01 01:42:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ga0l"
  // },
  // "1847": {
  //   "place": "58 km SE of Mohr, Iran",
  //   "latLng": [
  //     27.173,
  //     53.2896
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.173,
  //   "time": "2021-11-30 22:20:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 58 km SE of Mohr, Iran على عمق 27.173 كم بتاريخ 2021-11-30 22:20:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g817"
  // },
  // "1848": {
  //   "place": "62 km SW of Abhar, Iran",
  //   "latLng": [
  //     35.7324,
  //     48.7548
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 35.732,
  //   "time": "2021-11-30 15:06:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 62 km SW of Abhar, Iran على عمق 35.732 كم بتاريخ 2021-11-30 15:06:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8sz"
  // },
  // "1849": {
  //   "place": "65 km SW of Abhar, Iran",
  //   "latLng": [
  //     35.7388,
  //     48.7006
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.739,
  //   "time": "2021-11-30 15:04:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 65 km SW of Abhar, Iran على عمق 35.739 كم بتاريخ 2021-11-30 15:04:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8sm"
  // },
  // "1850": {
  //   "place": "16 km WNW of Agios Kirykos, Greece",
  //   "latLng": [
  //     37.6558,
  //     26.1139
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 37.656,
  //   "time": "2021-11-30 04:09:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 16 km WNW of Agios Kirykos, Greece على عمق 37.656 كم بتاريخ 2021-11-30 04:09:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8rw"
  // },
  // "1851": {
  //   "place": "74 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.8245,
  //     56.0317
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.825,
  //   "time": "2021-11-30 03:47:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 74 km NNW of Bandar Abbas, Iran على عمق 27.825 كم بتاريخ 2021-11-30 03:47:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8s6"
  // },
  // "1852": {
  //   "place": "93 km S of K?h Sef?d, Iran",
  //   "latLng": [
  //     28.4298,
  //     56.7841
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 28.43,
  //   "time": "2021-11-30 03:35:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 93 km S of K?h Sef?d, Iran على عمق 28.43 كم بتاريخ 2021-11-30 03:35:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8ru"
  // },
  // "1853": {
  //   "place": "101 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.4017,
  //     26.7963
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.402,
  //   "time": "2021-11-29 01:36:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 101 km SSE of Palekastro, Greece على عمق 34.402 كم بتاريخ 2021-11-29 01:36:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8qr"
  // },
  // "1854": {
  //   "place": "62 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.706,
  //     56.0408
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.706,
  //   "time": "2021-11-28 17:14:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 62 km NNW of Bandar Abbas, Iran على عمق 27.706 كم بتاريخ 2021-11-28 17:14:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g8gs"
  // },
  // "1855": {
  //   "place": "13 km WSW of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.3978,
  //     45.7435
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.398,
  //   "time": "2021-11-28 16:11:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 13 km WSW of Sarpol-e Z?ah?b, Iran على عمق 34.398 كم بتاريخ 2021-11-28 16:11:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fxrx"
  // },
  // "1856": {
  //   "place": "49 km SW of Q?’en, Iran",
  //   "latLng": [
  //     33.402,
  //     58.8122
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 33.402,
  //   "time": "2021-11-28 01:38:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 49 km SW of Q?’en, Iran على عمق 33.402 كم بتاريخ 2021-11-28 01:38:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fxlh"
  // },
  // "1857": {
  //   "place": "108 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.1,
  //     26.1711
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.1,
  //   "time": "2021-11-27 05:14:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 108 km SSE of Ierápetra, Greece على عمق 34.1 كم بتاريخ 2021-11-27 05:14:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fxep"
  // },
  // "1858": {
  //   "place": "244 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.7711,
  //     54.6492
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 14.771,
  //   "time": "2021-11-26 12:41:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 244 km NNE of Hadibu, Yemen على عمق 14.771 كم بتاريخ 2021-11-26 12:41:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g885"
  // },
  // "1859": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     27.7213,
  //     56.0741
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.721,
  //   "time": "2021-11-26 05:57:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في southern Iran على عمق 27.721 كم بتاريخ 2021-11-26 05:57:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000g87u"
  // },
  // "1860": {
  //   "place": "148 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.8819,
  //     52.3669
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.882,
  //   "time": "2021-11-25 01:36:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 148 km S of Al Ghayz?ah, Yemen على عمق 14.882 كم بتاريخ 2021-11-25 01:36:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fwxc"
  // },
  // "1861": {
  //   "place": "162 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.7391,
  //     52.271
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.739,
  //   "time": "2021-11-25 01:25:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 162 km S of Al Ghayz?ah, Yemen على عمق 14.739 كم بتاريخ 2021-11-25 01:25:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fwx3"
  // },
  // "1862": {
  //   "place": "136 km SE of Bam, Iran",
  //   "latLng": [
  //     28.2034,
  //     59.3097
  //   ],
  //   "magnitude": 5.0,
  //   "depth": 28.203,
  //   "time": "2021-11-23 21:46:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.0 درجة في 136 km SE of Bam, Iran على عمق 28.203 كم بتاريخ 2021-11-23 21:46:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fwjt"
  // },
  // "1863": {
  //   "place": "64 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.73,
  //     56.0517
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.73,
  //   "time": "2021-11-23 16:49:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 64 km NNW of Bandar Abbas, Iran على عمق 27.73 كم بتاريخ 2021-11-23 16:49:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fxaf"
  // },
  // "1864": {
  //   "place": "38 km S of Fry, Greece",
  //   "latLng": [
  //     35.0739,
  //     26.96
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.074,
  //   "time": "2021-11-23 14:06:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 38 km S of Fry, Greece على عمق 35.074 كم بتاريخ 2021-11-23 14:06:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fxa9"
  // },
  // "1865": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     27.6863,
  //     56.0947
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.686,
  //   "time": "2021-11-20 18:44:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في southern Iran على عمق 27.686 كم بتاريخ 2021-11-20 18:44:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvsz"
  // },
  // "1866": {
  //   "place": "64 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7406,
  //     56.0937
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.741,
  //   "time": "2021-11-19 18:52:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 64 km NNW of Bandar Abbas, Iran على عمق 27.741 كم بتاريخ 2021-11-19 18:52:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvjk"
  // },
  // "1867": {
  //   "place": "30 km ENE of A?bak, Afghanistan",
  //   "latLng": [
  //     36.3825,
  //     68.3175
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.383,
  //   "time": "2021-11-19 10:39:47 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 30 km ENE of A?bak, Afghanistan على عمق 36.383 كم بتاريخ 2021-11-19 10:39:47 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvez"
  // },
  // "1868": {
  //   "place": "61 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6808,
  //     55.9991
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.681,
  //   "time": "2021-11-18 16:10:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 61 km NNW of Bandar Abbas, Iran على عمق 27.681 كم بتاريخ 2021-11-18 16:10:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv4g"
  // },
  // "1869": {
  //   "place": "65 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6969,
  //     55.9527
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.697,
  //   "time": "2021-11-17 02:51:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 65 km NNW of Bandar Abbas, Iran على عمق 27.697 كم بتاريخ 2021-11-17 02:51:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fw8c"
  // },
  // "1870": {
  //   "place": "55 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6726,
  //     56.1636
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.673,
  //   "time": "2021-11-17 01:59:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 55 km NNW of Bandar Abbas, Iran على عمق 27.673 كم بتاريخ 2021-11-17 01:59:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fw7q"
  // },
  // "1871": {
  //   "place": "64 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6779,
  //     55.9361
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.678,
  //   "time": "2021-11-16 19:27:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 64 km NNW of Bandar Abbas, Iran على عمق 27.678 كم بتاريخ 2021-11-16 19:27:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvik"
  // },
  // "1872": {
  //   "place": "69 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7778,
  //     56.0412
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.778,
  //   "time": "2021-11-16 10:37:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 69 km NNW of Bandar Abbas, Iran على عمق 27.778 كم بتاريخ 2021-11-16 10:37:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvid"
  // },
  // "1873": {
  //   "place": "60 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6766,
  //     56.0208
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.677,
  //   "time": "2021-11-16 05:12:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 60 km NNW of Bandar Abbas, Iran على عمق 27.677 كم بتاريخ 2021-11-16 05:12:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fuhb"
  // },
  // "1874": {
  //   "place": "56 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6784,
  //     56.1235
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.678,
  //   "time": "2021-11-15 18:05:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 56 km NNW of Bandar Abbas, Iran على عمق 27.678 كم بتاريخ 2021-11-15 18:05:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fudm"
  // },
  // "1875": {
  //   "place": "57 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6644,
  //     56.0463
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.664,
  //   "time": "2021-11-15 16:42:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 57 km NNW of Bandar Abbas, Iran على عمق 27.664 كم بتاريخ 2021-11-15 16:42:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fubv#dyfi"
  // },
  // "1876": {
  //   "place": "62 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7069,
  //     56.0307
  //   ],
  //   "magnitude": 5.2,
  //   "depth": 27.707,
  //   "time": "2021-11-15 13:36:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.2 درجة في 62 km NNW of Bandar Abbas, Iran على عمق 27.707 كم بتاريخ 2021-11-15 13:36:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fuaz#dyfi"
  // },
  // "1877": {
  //   "place": "40 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5018,
  //     56.0706
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.502,
  //   "time": "2021-11-15 03:14:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 40 km NNW of Bandar Abbas, Iran على عمق 27.502 كم بتاريخ 2021-11-15 03:14:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu5r"
  // },
  // "1878": {
  //   "place": "61 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6686,
  //     55.9639
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.669,
  //   "time": "2021-11-15 03:04:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 61 km NNW of Bandar Abbas, Iran على عمق 27.669 كم بتاريخ 2021-11-15 03:04:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fvgb"
  // },
  // "1879": {
  //   "place": "54 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6366,
  //     56.0484
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.637,
  //   "time": "2021-11-15 02:53:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 54 km NNW of Bandar Abbas, Iran على عمق 27.637 كم بتاريخ 2021-11-15 02:53:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu5m"
  // },
  // "1880": {
  //   "place": "57 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6625,
  //     56.0431
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.663,
  //   "time": "2021-11-15 02:02:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 57 km NNW of Bandar Abbas, Iran على عمق 27.663 كم بتاريخ 2021-11-15 02:02:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu5f#dyfi"
  // },
  // "1881": {
  //   "place": "54 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6268,
  //     56.0383
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.627,
  //   "time": "2021-11-14 22:48:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 54 km NNW of Bandar Abbas, Iran على عمق 27.627 كم بتاريخ 2021-11-14 22:48:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv85"
  // },
  // "1882": {
  //   "place": "58 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7176,
  //     56.2546
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.718,
  //   "time": "2021-11-14 21:33:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 58 km N of Bandar Abbas, Iran على عمق 27.718 كم بتاريخ 2021-11-14 21:33:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv82"
  // },
  // "1883": {
  //   "place": "53 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6406,
  //     56.1044
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 27.641,
  //   "time": "2021-11-14 16:19:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 53 km NNW of Bandar Abbas, Iran على عمق 27.641 كم بتاريخ 2021-11-14 16:19:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu2u"
  // },
  // "1884": {
  //   "place": "33 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.4901,
  //     56.2629
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.49,
  //   "time": "2021-11-14 16:10:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 33 km N of Bandar Abbas, Iran على عمق 27.49 كم بتاريخ 2021-11-14 16:10:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7h"
  // },
  // "1885": {
  //   "place": "57 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6388,
  //     55.9951
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.639,
  //   "time": "2021-11-14 15:59:11 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 57 km NNW of Bandar Abbas, Iran على عمق 27.639 كم بتاريخ 2021-11-14 15:59:11 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7g"
  // },
  // "1886": {
  //   "place": "53 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6415,
  //     56.0867
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 27.642,
  //   "time": "2021-11-14 15:22:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 53 km NNW of Bandar Abbas, Iran على عمق 27.642 كم بتاريخ 2021-11-14 15:22:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu2l#dyfi"
  // },
  // "1887": {
  //   "place": "54 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6574,
  //     56.1168
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.657,
  //   "time": "2021-11-14 15:12:07 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 54 km NNW of Bandar Abbas, Iran على عمق 27.657 كم بتاريخ 2021-11-14 15:12:07 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu2k"
  // },
  // "1888": {
  //   "place": "24 km ENE of Shahrak-e K?l?r?, Iran",
  //   "latLng": [
  //     32.4433,
  //     48.7095
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.443,
  //   "time": "2021-11-14 14:47:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 24 km ENE of Shahrak-e K?l?r?, Iran على عمق 32.443 كم بتاريخ 2021-11-14 14:47:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7q"
  // },
  // "1889": {
  //   "place": "51 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6456,
  //     56.3559
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.646,
  //   "time": "2021-11-14 14:39:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 51 km N of Bandar Abbas, Iran على عمق 27.646 كم بتاريخ 2021-11-14 14:39:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv8c"
  // },
  // "1890": {
  //   "place": "51 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6548,
  //     56.2813
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.655,
  //   "time": "2021-11-14 14:24:13 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 51 km N of Bandar Abbas, Iran على عمق 27.655 كم بتاريخ 2021-11-14 14:24:13 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7d"
  // },
  // "1891": {
  //   "place": "63 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7003,
  //     55.9879
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 27.7,
  //   "time": "2021-11-14 14:02:56 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 63 km NNW of Bandar Abbas, Iran على عمق 27.7 كم بتاريخ 2021-11-14 14:02:56 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu2c"
  // },
  // "1892": {
  //   "place": "58 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7176,
  //     56.2945
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 27.718,
  //   "time": "2021-11-14 13:51:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 58 km N of Bandar Abbas, Iran على عمق 27.718 كم بتاريخ 2021-11-14 13:51:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv8b"
  // },
  // "1893": {
  //   "place": "37 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5187,
  //     56.2302
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.519,
  //   "time": "2021-11-14 13:45:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 37 km N of Bandar Abbas, Iran على عمق 27.519 كم بتاريخ 2021-11-14 13:45:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu2a"
  // },
  // "1894": {
  //   "place": "48 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6145,
  //     56.1613
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 27.615,
  //   "time": "2021-11-14 13:13:43 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 48 km NNW of Bandar Abbas, Iran على عمق 27.615 كم بتاريخ 2021-11-14 13:13:43 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7m"
  // },
  // "1895": {
  //   "place": "60 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7261,
  //     56.204
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.726,
  //   "time": "2021-11-14 13:05:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 60 km N of Bandar Abbas, Iran على عمق 27.726 كم بتاريخ 2021-11-14 13:05:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7a"
  // },
  // "1896": {
  //   "place": "58 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6797,
  //     56.0652
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.68,
  //   "time": "2021-11-14 13:01:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 58 km NNW of Bandar Abbas, Iran على عمق 27.68 كم بتاريخ 2021-11-14 13:01:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv7k"
  // },
  // "1897": {
  //   "place": "37 km N of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.528,
  //     56.2921
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 27.528,
  //   "time": "2021-11-14 12:52:37 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 37 km N of Bandar Abbas, Iran على عمق 27.528 كم بتاريخ 2021-11-14 12:52:37 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu1r#dyfi"
  // },
  // "1898": {
  //   "place": "59 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.6758,
  //     56.0278
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.676,
  //   "time": "2021-11-14 12:40:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 59 km NNW of Bandar Abbas, Iran على عمق 27.676 كم بتاريخ 2021-11-14 12:40:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu1n#dyfi"
  // },
  // "1899": {
  //   "place": "49 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.5823,
  //     56.0395
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.582,
  //   "time": "2021-11-14 12:23:46 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 49 km NNW of Bandar Abbas, Iran على عمق 27.582 كم بتاريخ 2021-11-14 12:23:46 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv87"
  // },
  // "1900": {
  //   "place": "63 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7266,
  //     56.0716
  //   ],
  //   "magnitude": 6.4,
  //   "depth": 27.727,
  //   "time": "2021-11-14 12:08:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.4 درجة في 63 km NNW of Bandar Abbas, Iran على عمق 27.727 كم بتاريخ 2021-11-14 12:08:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu12#pager"
  // },
  // "1901": {
  //   "place": "62 km NNW of Bandar Abbas, Iran",
  //   "latLng": [
  //     27.7158,
  //     56.0743
  //   ],
  //   "magnitude": 6.0,
  //   "depth": 27.716,
  //   "time": "2021-11-14 12:07:03 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.0 درجة في 62 km NNW of Bandar Abbas, Iran على عمق 27.716 كم بتاريخ 2021-11-14 12:07:03 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fu0x#pager"
  // },
  // "1902": {
  //   "place": "73 km W of Wana, Pakistan",
  //   "latLng": [
  //     32.202,
  //     68.7997
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 32.202,
  //   "time": "2021-11-13 21:42:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 73 km W of Wana, Pakistan على عمق 32.202 كم بتاريخ 2021-11-13 21:42:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ftwp"
  // },
  // "1903": {
  //   "place": "southern Iran",
  //   "latLng": [
  //     28.4267,
  //     54.084
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 28.427,
  //   "time": "2021-11-13 20:52:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في southern Iran على عمق 28.427 كم بتاريخ 2021-11-13 20:52:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ftw8#dyfi"
  // },
  // "1904": {
  //   "place": "88 km NW of Mohr, Iran",
  //   "latLng": [
  //     28.0751,
  //     52.2074
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.075,
  //   "time": "2021-11-13 10:19:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 88 km NW of Mohr, Iran على عمق 28.075 كم بتاريخ 2021-11-13 10:19:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ftt0"
  // },
  // "1905": {
  //   "place": "84 km NW of Mohr, Iran",
  //   "latLng": [
  //     28.0568,
  //     52.2321
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 28.057,
  //   "time": "2021-11-13 01:43:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 84 km NW of Mohr, Iran على عمق 28.057 كم بتاريخ 2021-11-13 01:43:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fv4p"
  // },
  // "1906": {
  //   "place": "off the coast of Pakistan",
  //   "latLng": [
  //     24.6025,
  //     62.3405
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 24.603,
  //   "time": "2021-11-12 03:39:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في off the coast of Pakistan على عمق 24.603 كم بتاريخ 2021-11-12 03:39:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fuuj"
  // },
  // "1907": {
  //   "place": "37 km N of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.2746,
  //     49.3612
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.275,
  //   "time": "2021-11-11 21:42:30 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 37 km N of Masjed Soleym?n, Iran على عمق 32.275 كم بتاريخ 2021-11-11 21:42:30 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ftcv"
  // },
  // "1908": {
  //   "place": "13 km NW of Azn?, Iran",
  //   "latLng": [
  //     33.6951,
  //     48.8223
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 33.695,
  //   "time": "2021-11-11 08:24:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 13 km NW of Azn?, Iran على عمق 33.695 كم بتاريخ 2021-11-11 08:24:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fulp"
  // },
  // "1909": {
  //   "place": "27 km S of Karpathos, Greece",
  //   "latLng": [
  //     35.2571,
  //     27.2162
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.257,
  //   "time": "2021-11-06 10:40:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 27 km S of Karpathos, Greece على عمق 35.257 كم بتاريخ 2021-11-06 10:40:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ft75"
  // },
  // "1910": {
  //   "place": "98 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.3671,
  //     26.6222
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.367,
  //   "time": "2021-11-05 04:28:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 98 km SSE of Palekastro, Greece على عمق 34.367 كم بتاريخ 2021-11-05 04:28:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000frlk"
  // },
  // "1911": {
  //   "place": "22 km SE of Jati, Pakistan",
  //   "latLng": [
  //     24.2251,
  //     68.4329
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 24.225,
  //   "time": "2021-11-04 09:45:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 22 km SE of Jati, Pakistan على عمق 24.225 كم بتاريخ 2021-11-04 09:45:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000frd2#dyfi"
  // },
  // "1912": {
  //   "place": "22 km S of Palekastro, Greece",
  //   "latLng": [
  //     34.9928,
  //     26.2579
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 34.993,
  //   "time": "2021-11-02 09:14:49 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 22 km S of Palekastro, Greece على عمق 34.993 كم بتاريخ 2021-11-02 09:14:49 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fqsw"
  // },
  // "1913": {
  //   "place": "87 km S of Mukalla, Yemen",
  //   "latLng": [
  //     13.7512,
  //     49.1688
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 13.751,
  //   "time": "2021-11-02 00:35:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 87 km S of Mukalla, Yemen على عمق 13.751 كم بتاريخ 2021-11-02 00:35:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fqns"
  // },
  // "1914": {
  //   "place": "33 km WSW of Mohr, Iran",
  //   "latLng": [
  //     27.4853,
  //     52.5486
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.485,
  //   "time": "2021-10-31 07:49:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 33 km WSW of Mohr, Iran على عمق 27.485 كم بتاريخ 2021-10-31 07:49:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000frgu"
  // },
  // "1915": {
  //   "place": "47 km SE of Kharan, Pakistan",
  //   "latLng": [
  //     28.2806,
  //     65.7619
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 28.281,
  //   "time": "2021-10-30 13:09:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 47 km SE of Kharan, Pakistan على عمق 28.281 كم بتاريخ 2021-10-30 13:09:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fq38"
  // },
  // "1916": {
  //   "place": "232 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.5774,
  //     54.8761
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 14.577,
  //   "time": "2021-10-29 10:10:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 232 km NNE of Hadibu, Yemen على عمق 14.577 كم بتاريخ 2021-10-29 10:10:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr6c"
  // },
  // "1917": {
  //   "place": "251 km SSE of ?al?lah, Oman",
  //   "latLng": [
  //     14.8891,
  //     54.9113
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.889,
  //   "time": "2021-10-29 10:06:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 251 km SSE of ?al?lah, Oman على عمق 14.889 كم بتاريخ 2021-10-29 10:06:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fpq4#dyfi"
  // },
  // "1918": {
  //   "place": "259 km SSE of ?al?lah, Oman",
  //   "latLng": [
  //     14.8206,
  //     54.9557
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.821,
  //   "time": "2021-10-29 08:35:35 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 259 km SSE of ?al?lah, Oman على عمق 14.821 كم بتاريخ 2021-10-29 08:35:35 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr69"
  // },
  // "1919": {
  //   "place": "255 km SSE of ?al?lah, Oman",
  //   "latLng": [
  //     14.8386,
  //     54.8819
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 14.839,
  //   "time": "2021-10-29 07:38:55 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 255 km SSE of ?al?lah, Oman على عمق 14.839 كم بتاريخ 2021-10-29 07:38:55 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr65"
  // },
  // "1920": {
  //   "place": "245 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.6431,
  //     55.0195
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 14.643,
  //   "time": "2021-10-29 06:12:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 245 km NNE of Hadibu, Yemen على عمق 14.643 كم بتاريخ 2021-10-29 06:12:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fpqz"
  // },
  // "1921": {
  //   "place": "235 km NNE of Hadibu, Yemen",
  //   "latLng": [
  //     14.616,
  //     54.8586
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 14.616,
  //   "time": "2021-10-29 01:06:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 235 km NNE of Hadibu, Yemen على عمق 14.616 كم بتاريخ 2021-10-29 01:06:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fr5y"
  // },
  // "1922": {
  //   "place": "101 km ENE of Gewan?, Ethiopia",
  //   "latLng": [
  //     10.4691,
  //     41.519
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 10.469,
  //   "time": "2021-10-27 00:35:58 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 101 km ENE of Gewan?, Ethiopia على عمق 10.469 كم بتاريخ 2021-10-27 00:35:58 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fqsq"
  // },
  // "1923": {
  //   "place": "14 km SW of Qarch? Gak, Afghanistan",
  //   "latLng": [
  //     36.9327,
  //     66.6992
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.933,
  //   "time": "2021-10-25 14:47:20 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 14 km SW of Qarch? Gak, Afghanistan على عمق 36.933 كم بتاريخ 2021-10-25 14:47:20 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fxeb#dyfi"
  // },
  // "1924": {
  //   "place": "Ethiopia",
  //   "latLng": [
  //     10.1505,
  //     41.4644
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 10.151,
  //   "time": "2021-10-24 14:26:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Ethiopia على عمق 10.151 كم بتاريخ 2021-10-24 14:26:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fprs"
  // },
  // "1925": {
  //   "place": "41 km NNE of Massawa, Eritrea",
  //   "latLng": [
  //     15.9647,
  //     39.6016
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 15.965,
  //   "time": "2021-10-23 14:20:24 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 41 km NNE of Massawa, Eritrea على عمق 15.965 كم بتاريخ 2021-10-23 14:20:24 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fph3#dyfi"
  // },
  // "1926": {
  //   "place": "294 km NE of Hadibu, Yemen",
  //   "latLng": [
  //     14.3425,
  //     56.1171
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.343,
  //   "time": "2021-10-21 23:05:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 294 km NE of Hadibu, Yemen على عمق 14.343 كم بتاريخ 2021-10-21 23:05:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fp8j"
  // },
  // "1927": {
  //   "place": "140 km ENE of M?n?b, Iran",
  //   "latLng": [
  //     27.6655,
  //     58.3738
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 27.666,
  //   "time": "2021-10-21 06:05:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 140 km ENE of M?n?b, Iran على عمق 27.666 كم بتاريخ 2021-10-21 06:05:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fwcg"
  // },
  // "1928": {
  //   "place": "149 km SE of Karpathos, Greece",
  //   "latLng": [
  //     34.576,
  //     28.3953
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 34.576,
  //   "time": "2021-10-19 05:32:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.9 درجة في 149 km SE of Karpathos, Greece على عمق 34.576 كم بتاريخ 2021-10-19 05:32:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fvtm#pager"
  // },
  // "1929": {
  //   "place": "68 km NW of Dire Dawa, Ethiopia",
  //   "latLng": [
  //     10.1039,
  //     41.5128
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 10.104,
  //   "time": "2021-10-18 22:21:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 68 km NW of Dire Dawa, Ethiopia على عمق 10.104 كم بتاريخ 2021-10-18 22:21:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fwqs"
  // },
  // "1930": {
  //   "place": "35 km SW of Duki, Pakistan",
  //   "latLng": [
  //     29.9492,
  //     68.2934
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 29.949,
  //   "time": "2021-10-17 21:56:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 35 km SW of Duki, Pakistan على عمق 29.949 كم بتاريخ 2021-10-17 21:56:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fvi8"
  // },
  // "1931": {
  //   "place": "16 km S of Shahrak-e P?bed?n?, Iran",
  //   "latLng": [
  //     30.9874,
  //     56.4161
  //   ],
  //   "magnitude": 4.8,
  //   "depth": 30.987,
  //   "time": "2021-10-16 11:46:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.8 درجة في 16 km S of Shahrak-e P?bed?n?, Iran على عمق 30.987 كم بتاريخ 2021-10-16 11:46:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fv7j"
  // },
  // "1932": {
  //   "place": "37 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.8736,
  //     26.3494
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 34.874,
  //   "time": "2021-10-15 23:25:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 37 km SSE of Palekastro, Greece على عمق 34.874 كم بتاريخ 2021-10-15 23:25:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fv2i#dyfi"
  // },
  // "1933": {
  //   "place": "52 km NNW of Dire Dawa, Ethiopia",
  //   "latLng": [
  //     9.9993,
  //     41.614
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 9.999,
  //   "time": "2021-10-15 17:42:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 52 km NNW of Dire Dawa, Ethiopia على عمق 9.999 كم بتاريخ 2021-10-15 17:42:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fuzi#dyfi"
  // },
  // "1934": {
  //   "place": "24 km ESE of Shahrak-e K?l?r?, Iran",
  //   "latLng": [
  //     32.2652,
  //     48.7062
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 32.265,
  //   "time": "2021-10-14 01:17:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 24 km ESE of Shahrak-e K?l?r?, Iran على عمق 32.265 كم بتاريخ 2021-10-14 01:17:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fvwq"
  // },
  // "1935": {
  //   "place": "41 km SSE of Palekastro, Greece",
  //   "latLng": [
  //     34.8373,
  //     26.3556
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 34.837,
  //   "time": "2021-10-12 09:36:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 41 km SSE of Palekastro, Greece على عمق 34.837 كم بتاريخ 2021-10-12 09:36:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fuy1"
  // },
  // "1936": {
  //   "place": "4 km SW of Palekastro, Greece",
  //   "latLng": [
  //     35.1691,
  //     26.2152
  //   ],
  //   "magnitude": 6.4,
  //   "depth": 35.169,
  //   "time": "2021-10-12 09:24:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 6.4 درجة في 4 km SW of Palekastro, Greece على عمق 35.169 كم بتاريخ 2021-10-12 09:24:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ftxu#pager"
  // },
  // "1937": {
  //   "place": "79 km WSW of Bojn?rd, Iran",
  //   "latLng": [
  //     37.1971,
  //     56.5032
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 37.197,
  //   "time": "2021-10-11 13:13:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 79 km WSW of Bojn?rd, Iran على عمق 37.197 كم بتاريخ 2021-10-11 13:13:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fuwe"
  // },
  // "1938": {
  //   "place": "western Iran",
  //   "latLng": [
  //     32.29,
  //     49.6449
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 32.29,
  //   "time": "2021-10-10 21:52:04 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في western Iran على عمق 32.29 كم بتاريخ 2021-10-10 21:52:04 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ftkb"
  // },
  // "1939": {
  //   "place": "104 km NNE of Bandar-e Lengeh, Iran",
  //   "latLng": [
  //     27.4482,
  //     55.2274
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 27.448,
  //   "time": "2021-10-10 16:11:25 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 104 km NNE of Bandar-e Lengeh, Iran على عمق 27.448 كم بتاريخ 2021-10-10 16:11:25 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ftj0"
  // },
  // "1940": {
  //   "place": "5 km S of Harnai, Pakistan",
  //   "latLng": [
  //     30.0547,
  //     67.9369
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 30.055,
  //   "time": "2021-10-10 15:02:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 5 km S of Harnai, Pakistan على عمق 30.055 كم بتاريخ 2021-10-10 15:02:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ftip#dyfi"
  // },
  // "1941": {
  //   "place": "59 km S of B?rjand, Iran",
  //   "latLng": [
  //     32.3323,
  //     59.1266
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 32.332,
  //   "time": "2021-10-09 20:37:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 59 km S of B?rjand, Iran على عمق 32.332 كم بتاريخ 2021-10-09 20:37:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fuk1"
  // },
  // "1942": {
  //   "place": "64 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.3765,
  //     49.7486
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 32.377,
  //   "time": "2021-10-09 06:05:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 64 km NE of Masjed Soleym?n, Iran على عمق 32.377 كم بتاريخ 2021-10-09 06:05:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ft7j"
  // },
  // "1943": {
  //   "place": "59 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.3379,
  //     49.7282
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 32.338,
  //   "time": "2021-10-08 23:16:26 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 59 km NE of Masjed Soleym?n, Iran على عمق 32.338 كم بتاريخ 2021-10-08 23:16:26 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000ft57#dyfi"
  // },
  // "1944": {
  //   "place": "166 km S of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     14.6989,
  //     52.2011
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 14.699,
  //   "time": "2021-10-07 18:21:34 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 166 km S of Al Ghayz?ah, Yemen على عمق 14.699 كم بتاريخ 2021-10-07 18:21:34 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fu15"
  // },
  // "1945": {
  //   "place": "55 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.2998,
  //     49.7087
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 32.3,
  //   "time": "2021-10-07 17:31:14 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 55 km NE of Masjed Soleym?n, Iran على عمق 32.3 كم بتاريخ 2021-10-07 17:31:14 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fu13"
  // },
  // "1946": {
  //   "place": "9 km ESE of Harnai, Pakistan",
  //   "latLng": [
  //     30.0779,
  //     68.0339
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 30.078,
  //   "time": "2021-10-07 00:00:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 9 km ESE of Harnai, Pakistan على عمق 30.078 كم بتاريخ 2021-10-07 00:00:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fshe#dyfi"
  // },
  // "1947": {
  //   "place": "11 km NNE of Harnai, Pakistan",
  //   "latLng": [
  //     30.1933,
  //     67.9948
  //   ],
  //   "magnitude": 5.9,
  //   "depth": 30.193,
  //   "time": "2021-10-06 22:01:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.9 درجة في 11 km NNE of Harnai, Pakistan على عمق 30.193 كم بتاريخ 2021-10-06 22:01:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fsg9#pager"
  // },
  // "1948": {
  //   "place": "Central Afghanistan",
  //   "latLng": [
  //     36.8392,
  //     66.6469
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 36.839,
  //   "time": "2021-10-05 07:59:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في Central Afghanistan على عمق 36.839 كم بتاريخ 2021-10-05 07:59:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000frum#dyfi"
  // },
  // "1949": {
  //   "place": "28 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.3625,
  //     27.1864
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.363,
  //   "time": "2021-10-05 07:54:08 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 28 km S of Mandráki, Greece على عمق 36.363 كم بتاريخ 2021-10-05 07:54:08 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fruj"
  // },
  // "1950": {
  //   "place": "Dodecanese Islands, Greece",
  //   "latLng": [
  //     36.4451,
  //     27.1903
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.445,
  //   "time": "2021-10-04 14:03:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في Dodecanese Islands, Greece على عمق 36.445 كم بتاريخ 2021-10-04 14:03:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000frk1#dyfi"
  // },
  // "1951": {
  //   "place": "61 km NE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     32.335,
  //     49.7618
  //   ],
  //   "magnitude": 5.5,
  //   "depth": 32.335,
  //   "time": "2021-10-04 02:39:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.5 درجة في 61 km NE of Masjed Soleym?n, Iran على عمق 32.335 كم بتاريخ 2021-10-04 02:39:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000frf2#pager"
  // },
  // "1952": {
  //   "place": "20 km SW of A?lasun, Turkey",
  //   "latLng": [
  //     37.528,
  //     30.3663
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 37.528,
  //   "time": "2021-10-03 07:15:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 20 km SW of A?lasun, Turkey على عمق 37.528 كم بتاريخ 2021-10-03 07:15:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fr9q#dyfi"
  // },
  // "1953": {
  //   "place": "58 km SE of Karpathos, Greece",
  //   "latLng": [
  //     35.2165,
  //     27.7464
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 35.217,
  //   "time": "2021-10-02 07:45:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 58 km SE of Karpathos, Greece على عمق 35.217 كم بتاريخ 2021-10-02 07:45:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fr20"
  // },
  // "1954": {
  //   "place": "25 km N of Bandar-e Gen?veh, Iran",
  //   "latLng": [
  //     29.8075,
  //     50.5453
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 29.808,
  //   "time": "2021-10-01 02:33:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 25 km N of Bandar-e Gen?veh, Iran على عمق 29.808 كم بتاريخ 2021-10-01 02:33:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqmi"
  // },
  // "1955": {
  //   "place": "24 km N of Bandar-e Gen?veh, Iran",
  //   "latLng": [
  //     29.8002,
  //     50.4937
  //   ],
  //   "magnitude": 4.9,
  //   "depth": 29.8,
  //   "time": "2021-10-01 01:15:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.9 درجة في 24 km N of Bandar-e Gen?veh, Iran على عمق 29.8 كم بتاريخ 2021-10-01 01:15:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqma#dyfi"
  // },
  // "1956": {
  //   "place": "16 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.4671,
  //     27.1622
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.467,
  //   "time": "2021-09-29 23:27:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 16 km S of Mandráki, Greece على عمق 36.467 كم بتاريخ 2021-09-29 23:27:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqa5"
  // },
  // "1957": {
  //   "place": "12 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.5029,
  //     27.1495
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.503,
  //   "time": "2021-09-29 22:22:59 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 12 km S of Mandráki, Greece على عمق 36.503 كم بتاريخ 2021-09-29 22:22:59 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fq9n"
  // },
  // "1958": {
  //   "place": "13 km SSE of Mandráki, Greece",
  //   "latLng": [
  //     36.4896,
  //     27.1703
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.49,
  //   "time": "2021-09-29 22:22:17 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 13 km SSE of Mandráki, Greece على عمق 36.49 كم بتاريخ 2021-09-29 22:22:17 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fq9m"
  // },
  // "1959": {
  //   "place": "19 km WSW of Mohr, Iran",
  //   "latLng": [
  //     27.5144,
  //     52.6885
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.514,
  //   "time": "2021-09-28 16:52:44 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 19 km WSW of Mohr, Iran على عمق 27.514 كم بتاريخ 2021-09-28 16:52:44 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqtv"
  // },
  // "1960": {
  //   "place": "41 km ESE of Kifr?, Iraq",
  //   "latLng": [
  //     34.5294,
  //     45.3747
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.529,
  //   "time": "2021-09-28 11:46:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 41 km ESE of Kifr?, Iraq على عمق 34.529 كم بتاريخ 2021-09-28 11:46:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqtc"
  // },
  // "1961": {
  //   "place": "30 km W of Sarpol-e Z?ah?b, Iran",
  //   "latLng": [
  //     34.4735,
  //     45.5293
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 34.474,
  //   "time": "2021-09-28 08:58:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km W of Sarpol-e Z?ah?b, Iran على عمق 34.474 كم بتاريخ 2021-09-28 08:58:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000fqtd"
  // },
  // "1962": {
  //   "place": "19 km E of Ródos, Greece",
  //   "latLng": [
  //     36.4251,
  //     28.4345
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.425,
  //   "time": "2021-09-28 06:01:05 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 19 km E of Ródos, Greece على عمق 36.425 كم بتاريخ 2021-09-28 06:01:05 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000ff3t"
  // },
  // "1963": {
  //   "place": "31 km SSE of Mandráki, Greece",
  //   "latLng": [
  //     36.3523,
  //     27.2673
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 36.352,
  //   "time": "2021-09-27 15:04:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 31 km SSE of Mandráki, Greece على عمق 36.352 كم بتاريخ 2021-09-27 15:04:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000feuq"
  // },
  // "1964": {
  //   "place": "19 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.4387,
  //     27.1385
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.439,
  //   "time": "2021-09-26 04:40:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 19 km S of Mandráki, Greece على عمق 36.439 كم بتاريخ 2021-09-26 04:40:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fein#dyfi"
  // },
  // "1965": {
  //   "place": "102 km N of M?n?b, Iran",
  //   "latLng": [
  //     28.0556,
  //     57.0196
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 28.056,
  //   "time": "2021-09-26 00:14:16 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 102 km N of M?n?b, Iran على عمق 28.056 كم بتاريخ 2021-09-26 00:14:16 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fegz#dyfi"
  // },
  // "1966": {
  //   "place": "51 km S of Çiftlikköyü, Turkey",
  //   "latLng": [
  //     36.7164,
  //     42.4005
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 36.716,
  //   "time": "2021-09-24 23:43:12 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 51 km S of Çiftlikköyü, Turkey على عمق 36.716 كم بتاريخ 2021-09-24 23:43:12 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fe95#dyfi"
  // },
  // "1967": {
  //   "place": "33 km S of Mohr, Iran",
  //   "latLng": [
  //     27.2526,
  //     52.9044
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.253,
  //   "time": "2021-09-21 01:24:38 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 33 km S of Mohr, Iran على عمق 27.253 كم بتاريخ 2021-09-21 01:24:38 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fe44"
  // },
  // "1968": {
  //   "place": "46 km WSW of Mohr, Iran",
  //   "latLng": [
  //     27.3459,
  //     52.4711
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.346,
  //   "time": "2021-09-19 22:11:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 46 km WSW of Mohr, Iran على عمق 27.346 كم بتاريخ 2021-09-19 22:11:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fduw"
  // },
  // "1969": {
  //   "place": "41 km NW of Yasuj, Iran",
  //   "latLng": [
  //     30.8962,
  //     51.2407
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 30.896,
  //   "time": "2021-09-19 09:08:57 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 41 km NW of Yasuj, Iran على عمق 30.896 كم بتاريخ 2021-09-19 09:08:57 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fcm8#dyfi"
  // },
  // "1970": {
  //   "place": "78 km WSW of Kh?rk, Iran",
  //   "latLng": [
  //     28.9103,
  //     49.6258
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 28.91,
  //   "time": "2021-09-14 04:48:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 78 km WSW of Kh?rk, Iran على عمق 28.91 كم بتاريخ 2021-09-14 04:48:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fcwm"
  // },
  // "1971": {
  //   "place": "42 km ESE of Palekastro, Greece",
  //   "latLng": [
  //     35.0109,
  //     26.6577
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.011,
  //   "time": "2021-09-13 08:01:09 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 42 km ESE of Palekastro, Greece على عمق 35.011 كم بتاريخ 2021-09-13 08:01:09 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000faq3"
  // },
  // "1972": {
  //   "place": "39 km ENE of Q?ch?n, Iran",
  //   "latLng": [
  //     37.289,
  //     58.8939
  //   ],
  //   "magnitude": 5.1,
  //   "depth": 37.289,
  //   "time": "2021-09-13 04:02:32 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 5.1 درجة في 39 km ENE of Q?ch?n, Iran على عمق 37.289 كم بتاريخ 2021-09-13 04:02:32 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fans#dyfi"
  // },
  // "1973": {
  //   "place": "52 km ESE of Ger?sh, Iran",
  //   "latLng": [
  //     27.4119,
  //     54.5778
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 27.412,
  //   "time": "2021-09-11 22:45:19 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 52 km ESE of Ger?sh, Iran على عمق 27.412 كم بتاريخ 2021-09-11 22:45:19 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000faeg#dyfi"
  // },
  // "1974": {
  //   "place": "49 km SE of Ger?sh, Iran",
  //   "latLng": [
  //     27.3885,
  //     54.524
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 27.389,
  //   "time": "2021-09-11 21:20:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 49 km SE of Ger?sh, Iran على عمق 27.389 كم بتاريخ 2021-09-11 21:20:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fadv#dyfi"
  // },
  // "1975": {
  //   "place": "58 km ESE of Ger?sh, Iran",
  //   "latLng": [
  //     27.3933,
  //     54.6446
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 27.393,
  //   "time": "2021-09-11 20:55:22 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 58 km ESE of Ger?sh, Iran على عمق 27.393 كم بتاريخ 2021-09-11 20:55:22 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fadr"
  // },
  // "1976": {
  //   "place": "32 km SSW of Mandráki, Greece",
  //   "latLng": [
  //     36.333,
  //     27.0088
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.333,
  //   "time": "2021-09-11 13:31:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 32 km SSW of Mandráki, Greece على عمق 36.333 كم بتاريخ 2021-09-11 13:31:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000fabg"
  // },
  // "1977": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     13.0006,
  //     57.5577
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 13.001,
  //   "time": "2021-09-09 06:40:42 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Owen Fracture Zone region على عمق 13.001 كم بتاريخ 2021-09-09 06:40:42 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9m6"
  // },
  // "1978": {
  //   "place": "26 km WNW of Toygarl?, Turkey",
  //   "latLng": [
  //     36.2823,
  //     35.7899
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.282,
  //   "time": "2021-09-09 01:42:40 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 26 km WNW of Toygarl?, Turkey على عمق 36.282 كم بتاريخ 2021-09-09 01:42:40 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9iu"
  // },
  // "1979": {
  //   "place": "35 km E of Kifr?, Iraq",
  //   "latLng": [
  //     34.6514,
  //     45.35
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.651,
  //   "time": "2021-09-08 15:43:01 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 35 km E of Kifr?, Iraq على عمق 34.651 كم بتاريخ 2021-09-08 15:43:01 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9ah"
  // },
  // "1980": {
  //   "place": "15 km SSE of Mandráki, Greece",
  //   "latLng": [
  //     36.4786,
  //     27.1703
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 36.479,
  //   "time": "2021-09-08 01:40:02 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 15 km SSE of Mandráki, Greece على عمق 36.479 كم بتاريخ 2021-09-08 01:40:02 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f93t#dyfi"
  // },
  // "1981": {
  //   "place": "22 km SSE of Mandráki, Greece",
  //   "latLng": [
  //     36.4181,
  //     27.2005
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.418,
  //   "time": "2021-09-07 21:55:23 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 22 km SSE of Mandráki, Greece على عمق 36.418 كم بتاريخ 2021-09-07 21:55:23 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f92g"
  // },
  // "1982": {
  //   "place": "Western Turkey",
  //   "latLng": [
  //     36.1165,
  //     31.0332
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.117,
  //   "time": "2021-09-07 11:15:00 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في Western Turkey على عمق 36.117 كم بتاريخ 2021-09-07 11:15:00 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f8tq"
  // },
  // "1983": {
  //   "place": "34 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.2989,
  //     27.1498
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 36.299,
  //   "time": "2021-09-06 15:04:39 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 34 km S of Mandráki, Greece على عمق 36.299 كم بتاريخ 2021-09-06 15:04:39 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f8ku"
  // },
  // "1984": {
  //   "place": "44 km SW of Émponas, Greece",
  //   "latLng": [
  //     35.9687,
  //     27.4849
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 35.969,
  //   "time": "2021-09-05 21:27:51 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 44 km SW of Émponas, Greece على عمق 35.969 كم بتاريخ 2021-09-05 21:27:51 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f8cs#dyfi"
  // },
  // "1985": {
  //   "place": "152 km N of Caluula, Somalia",
  //   "latLng": [
  //     13.3447,
  //     50.7099
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 13.345,
  //   "time": "2021-09-03 07:46:27 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 152 km N of Caluula, Somalia على عمق 13.345 كم بتاريخ 2021-09-03 07:46:27 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9ym"
  // },
  // "1986": {
  //   "place": "32 km SSW of Mandráki, Greece",
  //   "latLng": [
  //     36.3356,
  //     27.0107
  //   ],
  //   "magnitude": 4.2,
  //   "depth": 36.336,
  //   "time": "2021-09-02 21:12:52 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.2 درجة في 32 km SSW of Mandráki, Greece على عمق 36.336 كم بتاريخ 2021-09-02 21:12:52 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f788"
  // },
  // "1987": {
  //   "place": "134 km ESE of Al Ghayz?ah, Yemen",
  //   "latLng": [
  //     15.8446,
  //     53.3708
  //   ],
  //   "magnitude": 4.6,
  //   "depth": 15.845,
  //   "time": "2021-09-01 02:52:28 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.6 درجة في 134 km ESE of Al Ghayz?ah, Yemen على عمق 15.845 كم بتاريخ 2021-09-01 02:52:28 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f9pe"
  // },
  // "1988": {
  //   "place": "46 km SE of Ghormach, Afghanistan",
  //   "latLng": [
  //     35.4088,
  //     64.1087
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 35.409,
  //   "time": "2021-08-28 03:57:36 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 46 km SE of Ghormach, Afghanistan على عمق 35.409 كم بتاريخ 2021-08-28 03:57:36 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f54d"
  // },
  // "1989": {
  //   "place": "39 km SSE of Masjed Soleym?n, Iran",
  //   "latLng": [
  //     31.6393,
  //     49.5329
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 31.639,
  //   "time": "2021-08-27 11:04:45 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 39 km SSE of Masjed Soleym?n, Iran على عمق 31.639 كم بتاريخ 2021-08-27 11:04:45 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f4m9"
  // },
  // "1990": {
  //   "place": "Owen Fracture Zone region",
  //   "latLng": [
  //     12.9785,
  //     57.1069
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 12.979,
  //   "time": "2021-08-26 02:13:41 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في Owen Fracture Zone region على عمق 12.979 كم بتاريخ 2021-08-26 02:13:41 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f7hx"
  // },
  // "1991": {
  //   "place": "37 km W of Jiwani, Pakistan",
  //   "latLng": [
  //     25.0595,
  //     61.3743
  //   ],
  //   "magnitude": 4.1,
  //   "depth": 25.06,
  //   "time": "2021-08-26 00:07:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.1 درجة في 37 km W of Jiwani, Pakistan على عمق 25.06 كم بتاريخ 2021-08-26 00:07:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f3y2"
  // },
  // "1992": {
  //   "place": "16 km NNW of Zindah J?n, Afghanistan",
  //   "latLng": [
  //     34.491,
  //     61.7066
  //   ],
  //   "magnitude": 4.5,
  //   "depth": 34.491,
  //   "time": "2021-08-23 13:28:54 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.5 درجة في 16 km NNW of Zindah J?n, Afghanistan على عمق 34.491 كم بتاريخ 2021-08-23 13:28:54 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f739"
  // },
  // "1993": {
  //   "place": "102 km SSE of Ierápetra, Greece",
  //   "latLng": [
  //     34.1681,
  //     26.1973
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 34.168,
  //   "time": "2021-08-23 07:19:31 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 102 km SSE of Ierápetra, Greece على عمق 34.168 كم بتاريخ 2021-08-23 07:19:31 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f9z1#dyfi"
  // },
  // "1994": {
  //   "place": "115 km SE of D?r?b, Iran",
  //   "latLng": [
  //     28.1304,
  //     55.4812
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 28.13,
  //   "time": "2021-08-22 22:27:48 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 115 km SE of D?r?b, Iran على عمق 28.13 كم بتاريخ 2021-08-22 22:27:48 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f9v7"
  // },
  // "1995": {
  //   "place": "30 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.342,
  //     27.0888
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.342,
  //   "time": "2021-08-21 13:21:21 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 30 km S of Mandráki, Greece على عمق 36.342 كم بتاريخ 2021-08-21 13:21:21 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f9br"
  // },
  // "1996": {
  //   "place": "30 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.3354,
  //     27.1198
  //   ],
  //   "magnitude": 4.7,
  //   "depth": 36.335,
  //   "time": "2021-08-19 11:26:33 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.7 درجة في 30 km S of Mandráki, Greece على عمق 36.335 كم بتاريخ 2021-08-19 11:26:33 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f8b9#dyfi"
  // },
  // "1997": {
  //   "place": "47 km S of Mandráki, Greece",
  //   "latLng": [
  //     36.1814,
  //     27.1131
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 36.181,
  //   "time": "2021-08-19 11:06:15 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 47 km S of Mandráki, Greece على عمق 36.181 كم بتاريخ 2021-08-19 11:06:15 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f8b2"
  // },
  // "1998": {
  //   "place": "81 km SSW of Maymana, Afghanistan",
  //   "latLng": [
  //     35.2083,
  //     64.5691
  //   ],
  //   "magnitude": 4.3,
  //   "depth": 35.208,
  //   "time": "2021-08-17 15:39:29 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.3 درجة في 81 km SSW of Maymana, Afghanistan على عمق 35.208 كم بتاريخ 2021-08-17 15:39:29 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f4tk"
  // },
  // "1999": {
  //   "place": "13 km SSE of ?uk?mat? Dahanah-ye Gh?r?, Afghanistan",
  //   "latLng": [
  //     35.7887,
  //     68.5348
  //   ],
  //   "magnitude": 4.4,
  //   "depth": 35.789,
  //   "time": "2021-08-16 07:31:10 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.4 درجة في 13 km SSE of ?uk?mat? Dahanah-ye Gh?r?, Afghanistan على عمق 35.789 كم بتاريخ 2021-08-16 07:31:10 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us7000f4mz"
  // },
  // "2000": {
  //   "place": "47 km SSW of Mandráki, Greece",
  //   "latLng": [
  //     36.1895,
  //     27.0206
  //   ],
  //   "magnitude": 4.0,
  //   "depth": 36.19,
  //   "time": "2021-08-15 14:34:18 UTC",
  //   "region": "",
  //   "info": "زلزال بقوة 4.0 درجة في 47 km SSW of Mandráki, Greece على عمق 36.19 كم بتاريخ 2021-08-15 14:34:18 UTC.",
  //   "link": "https://earthquake.usgs.gov/earthquakes/eventpage/us6000f6lv"
  // }
};
